(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[751],{

/***/ 20318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GradientBgBlock; }
/* harmony export */ });
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92777);
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82262);
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45959);
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _gradientBgWithSymbol_jpg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(227);
/* harmony import */ var _gradientBgWithSymbol_jpg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_gradientBgWithSymbol_jpg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _GradientBgBlock_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68173);
/* harmony import */ var _GradientBgBlock_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_GradientBgBlock_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var GradientBgBlock = /*#__PURE__*/function (_Component) {
  (0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GradientBgBlock, _Component);

  var _super = _createSuper(GradientBgBlock);

  function GradientBgBlock() {
    (0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, GradientBgBlock);

    return _super.apply(this, arguments);
  }

  (0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(GradientBgBlock, [{
    key: "getBgStyle",
    value: function getBgStyle() {
      if (this.props.isBf) {
        return ' linear-gradient(225deg, #002847 0%, #001129 100%)';
      }

      if (this.props.hasSymbol) {
        return "url(\"".concat((_gradientBgWithSymbol_jpg__WEBPACK_IMPORTED_MODULE_3___default()), "\")");
      }

      if (this.props.isOrange) {
        return 'linear-gradient(225deg, #FFBA00 0%, #FF4D00 100%)';
      }

      return 'linear-gradient(45deg, rgba(58,123,213,1) 0%,rgba(0,186,255,1) 100%)';
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_GradientBgBlock_module_scss__WEBPACK_IMPORTED_MODULE_8___default().block),
        style: {
          backgroundImage: this.getBgStyle()
        },
        children: this.props.children
      });
    }
  }]);

  return GradientBgBlock;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);



/***/ }),

/***/ 84366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81680);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Heading = function Heading(_ref) {
  var tag = _ref.tag,
      level = _ref.level,
      size = _ref.size,
      children = _ref.children,
      className = _ref.className;
  var HTag = tag ? tag : "h".concat(level);
  var classNameString;

  switch (size) {
    case 'sm':
      classNameString = (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pageHeadlineSm);
      break;

    case 'lg':
      classNameString = (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pageHeadlineLg);
      break;

    case 'lgSmaller':
      classNameString = (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pageHeadlineLgSmaller);
      break;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HTag, {
    className: "".concat(classNameString, " ").concat(className ? className : undefined),
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Heading);

/***/ }),

/***/ 54180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Icons_Icon; }
});

// UNUSED EXPORTS: camelize, capitalize

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Base/Icons/Icons.module.scss
var Icons_module = __webpack_require__(76483);
var Icons_module_default = /*#__PURE__*/__webpack_require__.n(Icons_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Base/Icons/General/AlignBottom.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgAlignBottom = function SvgAlignBottom(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M0 13v-1h14v1z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#00BAFF",
        fillRule: "nonzero",
        d: "M2 10V1h4v9z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M3 9V2h2v7z"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#00BAFF",
          fillRule: "nonzero",
          d: "M8 10V5h4v5z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#FFF",
          d: "M9 9V6h2v3z"
        })]
      })]
    })
  }));
};

/* harmony default export */ var AlignBottom = (SvgAlignBottom);
;// CONCATENATED MODULE: ./components/Base/Icons/General/AlignBottomLeft.js


function AlignBottomLeft_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AlignBottomLeft_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AlignBottomLeft_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AlignBottomLeft_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgAlignBottomLeft = function SvgAlignBottomLeft(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", AlignBottomLeft_objectSpread(AlignBottomLeft_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 2.5h11v9h-11z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M.5 1.5h3v3h-3zM10.5 1.5h3v3h-3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M.5 9.5h3v3h-3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M10.5 9.5h3v3h-3z"
      })]
    })
  }));
};

/* harmony default export */ var AlignBottomLeft = (SvgAlignBottomLeft);
;// CONCATENATED MODULE: ./components/Base/Icons/General/AlignTopLeft.js


function AlignTopLeft_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AlignTopLeft_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AlignTopLeft_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AlignTopLeft_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgAlignTopLeft = function SvgAlignTopLeft(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", AlignTopLeft_objectSpread(AlignTopLeft_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 2.5h11v9h-11z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M.5 1.5h3v3h-3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M10.5 1.5h3v3h-3zM.5 9.5h3v3h-3zM10.5 9.5h3v3h-3z"
      })]
    })
  }));
};

/* harmony default export */ var AlignTopLeft = (SvgAlignTopLeft);
;// CONCATENATED MODULE: ./components/Base/Icons/General/AlignTopRight.js


function AlignTopRight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AlignTopRight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AlignTopRight_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AlignTopRight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgAlignTopRight = function SvgAlignTopRight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", AlignTopRight_objectSpread(AlignTopRight_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 2.5h11v9h-11z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M.5 1.5h3v3h-3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M10.5 1.5h3v3h-3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M.5 9.5h3v3h-3zM10.5 9.5h3v3h-3z"
      })]
    })
  }));
};

/* harmony default export */ var AlignTopRight = (SvgAlignTopRight);
;// CONCATENATED MODULE: ./components/Base/Icons/General/AlignBottomRight.js


function AlignBottomRight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AlignBottomRight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AlignBottomRight_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AlignBottomRight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgAlignBottomRight = function SvgAlignBottomRight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", AlignBottomRight_objectSpread(AlignBottomRight_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 2.5h11v9h-11z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M.5 1.5h3v3h-3zM10.5 1.5h3v3h-3zM.5 9.5h3v3h-3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M10.5 9.5h3v3h-3z"
      })]
    })
  }));
};

/* harmony default export */ var AlignBottomRight = (SvgAlignBottomRight);
;// CONCATENATED MODULE: ./components/Base/Icons/General/AlignCenter.js


function AlignCenter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AlignCenter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AlignCenter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AlignCenter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function SvgAlignCenter(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", AlignCenter_objectSpread(AlignCenter_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 2.5h11v9h-11z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M5.5 5.5h3v3h-3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M.5 1.5h3v3h-3zM10.5 1.5h3v3h-3zM.5 9.5h3v3h-3zM10.5 9.5h3v3h-3z"
      })]
    })
  }));
}

/* harmony default export */ var AlignCenter = (SvgAlignCenter);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Apparel.js


function Apparel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Apparel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Apparel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Apparel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgApparel = function SvgApparel(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Apparel_objectSpread(Apparel_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6.536.5H2A1.5 1.5 0 00.5 2v12A1.5 1.5 0 002 15.5h16a1.5 1.5 0 001.5-1.5V2A1.5 1.5 0 0018 .5h-4.536a3.5 3.5 0 11-6.929 0z",
        stroke: "#000"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        stroke: "#000",
        x: 3.5,
        y: 8.5,
        width: 13,
        height: 11,
        rx: 1
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M4 8h12v1H4zM4 15h12v1H4z"
      })]
    })
  }));
};

/* harmony default export */ var Apparel = (SvgApparel);
;// CONCATENATED MODULE: ./components/Base/Icons/General/ArrowDown.js


function ArrowDown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ArrowDown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ArrowDown_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ArrowDown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ArrowDown_objectSpread(ArrowDown_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.7 5H4.3a.302.302 0 00-.269.158.275.275 0 00.029.3l2.7 3.428A.305.305 0 007 9a.305.305 0 00.24-.114l2.7-3.429a.274.274 0 00.028-.299A.302.302 0 009.7 5z",
      fill: "#F60",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var ArrowDown = (SvgArrowDown);
;// CONCATENATED MODULE: ./components/Base/Icons/General/ArrowLongLeft.js


function ArrowLongLeft_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ArrowLongLeft_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ArrowLongLeft_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ArrowLongLeft_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgArrowLongLeft = function SvgArrowLongLeft(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ArrowLongLeft_objectSpread(ArrowLongLeft_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 7.5L6.25 3 5 6.857h8.375c.346 0 .625.288.625.643 0 .355-.28.643-.625.643H5L6.25 12 0 7.5z",
      fill: "#4FCA33",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var ArrowLongLeft = (SvgArrowLongLeft);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Billing.js


function Billing_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Billing_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Billing_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Billing_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgBilling = function SvgBilling(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Billing_objectSpread(Billing_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.142.001H1.858a.8.8 0 00-.62.241A.837.837 0 001 .877v13.125l2.571-1.75 1.714 1.75L7 12.252l1.714 1.75 1.714-1.75 2.57 1.75V.877a.837.837 0 00-.235-.635.8.8 0 00-.621-.24zM7 8.751H3.572v-1.75H7v1.75zm0-3.5H3.572v-1.75H7v1.75zm2.57 3.5a.866.866 0 01-.856-.874c0-.484.384-.875.857-.875s.857.391.857.875a.866.866 0 01-.857.875zm0-3.5a.866.866 0 01-.856-.874c0-.484.384-.875.857-.875s.857.391.857.875a.866.866 0 01-.857.875z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Billing = (SvgBilling);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Blog.js


function Blog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Blog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Blog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Blog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgBlog = function SvgBlog(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Blog_objectSpread(Blog_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.375 4.5h-.625V2.625A.625.625 0 0018.125 2c-4.802 0-7.19 1.467-8.128 2.257C9.05 3.47 6.646 2 1.875 2a.625.625 0 00-.625.625V4.5H.625A.625.625 0 000 5.125v13.75c0 .346.28.625.625.625h18.75c.345 0 .625-.28.625-.625V5.125a.625.625 0 00-.625-.625zM2.5 3.26c4.435.131 6.378 1.65 6.875 2.118v7.247h1.25V5.374c.485-.465 2.4-1.983 6.875-2.115v11.875c-4.357.121-6.593 1.497-7.497 2.248-.896-.755-3.117-2.128-7.503-2.248V3.259z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Blog = (SvgBlog);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Check.js


function Check_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Check_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Check_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Check_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Check_objectSpread(Check_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#4FCA33",
      fillRule: "nonzero",
      d: "M1 7.2L2.2 6l3 1.8L11.8 3 13 4.2 5.2 12z"
    })
  }));
};

/* harmony default export */ var Check = (SvgCheck);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Close.js


function Close_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Close_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Close_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Close_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Close_objectSpread(Close_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10 19a9 9 0 110-18 9 9 0 010 18zm3.766-12.766a.799.799 0 00-1.13 0l-2.631 2.631-2.631-2.631a.799.799 0 00-1.13 1.13l2.631 2.631-2.631 2.631a.799.799 0 101.13 1.13l2.631-2.631 2.631 2.631a.799.799 0 001.13-1.13l-2.631-2.631 2.631-2.631a.799.799 0 000-1.13z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Close = (SvgClose);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Crop.js


function Crop_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Crop_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Crop_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Crop_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgCrop = function SvgCrop(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Crop_objectSpread(Crop_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.182 8.91h1.273V3.817c0-.7-.573-1.273-1.273-1.273H5.09v1.273h5.09V8.91zm-6.364 1.272V0H2.545v2.545H0v1.273h2.545v6.364c0 .7.573 1.273 1.273 1.273h6.364V14h1.273v-2.545H14v-1.273H3.818z",
      fill: "#111",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Crop = (SvgCrop);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Color.js


function Color_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Color_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Color_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Color_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgColor = function SvgColor(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Color_objectSpread(Color_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 4.136l-.707.707a1 1 0 000 1.414l1.414 1.414L.479 9.4c-.513.512-.637 1.33-.23 1.93a1.502 1.502 0 002.312.23l1.768-1.768 1.413 1.415a1 1 0 001.415 0l.707-.707L1.5 4.136zM11.4 6.965a.5.5 0 000-.707l-1.061-1.061-2.122.707.707-2.121L5.744.6a.5.5 0 00-.708 0L2.208 3.43l6.364 6.364L11.4 6.965z"
      })
    })
  }));
};

/* harmony default export */ var Color = (SvgColor);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Customizations.js


function Customizations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Customizations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Customizations_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Customizations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgCustomizations = function SvgCustomizations(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Customizations_objectSpread(Customizations_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.9 2.742c-.642-.292-1.283-.467-1.983-.467-.934 0-1.75.292-2.509.525-.466.175-.933.292-1.283.292-.233 0-.35-.059-.408-.175 0-.059.058-.35.116-.525.175-.525.35-1.167-.116-1.809A1.671 1.671 0 004.433 0c-.525 0-.991.175-1.458.467C1.108 1.75 0 3.908 0 6.183c0 3.85 3.15 7 7 7 3.092 0 5.892-2.1 6.767-5.133.058-.35.875-3.967-1.867-5.308zM1.75 6.183a1.17 1.17 0 011.167-1.166 1.17 1.17 0 011.166 1.166A1.17 1.17 0 012.917 7.35 1.17 1.17 0 011.75 6.183zm2.625 4.084A1.17 1.17 0 013.208 9.1a1.17 1.17 0 011.167-1.167A1.17 1.17 0 015.542 9.1a1.17 1.17 0 01-1.167 1.167zm3.208 1.166a1.17 1.17 0 01-1.166-1.166A1.17 1.17 0 017.583 9.1a1.17 1.17 0 011.167 1.167 1.17 1.17 0 01-1.167 1.166zm2.334-3.5c-.992 0-1.75-.758-1.75-1.75 0-.991.758-1.75 1.75-1.75.991 0 1.75.759 1.75 1.75 0 .992-.759 1.75-1.75 1.75z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Customizations = (SvgCustomizations);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Digital.js


function Digital_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Digital_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Digital_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Digital_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDigital = function SvgDigital(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Digital_objectSpread(Digital_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        stroke: "#000",
        x: 0.5,
        y: 1.5,
        width: 19,
        height: 13,
        rx: 1
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M4 16h12v1H4z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        stroke: "#000",
        fill: "#FFF",
        x: 3.5,
        y: 5.5,
        width: 8,
        height: 13,
        rx: 1
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M7 16h1v1H7z"
      })]
    })
  }));
};

/* harmony default export */ var Digital = (SvgDigital);
;// CONCATENATED MODULE: ./components/Base/Icons/General/DeleteCircle.js


function DeleteCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DeleteCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeleteCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeleteCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDeleteCircle = function SvgDeleteCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", DeleteCircle_objectSpread(DeleteCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#FFF",
        cx: 9,
        cy: 9,
        r: 9
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.766 5.234a.799.799 0 00-1.13 0L9.005 7.865 6.374 5.234a.799.799 0 00-1.13 1.13l2.631 2.631-2.631 2.631a.799.799 0 101.13 1.13l2.631-2.631 2.631 2.631a.799.799 0 001.13-1.13l-2.631-2.631 2.631-2.631a.799.799 0 000-1.13z",
        fill: "#000"
      })]
    })
  }));
};

/* harmony default export */ var DeleteCircle = (SvgDeleteCircle);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Download.js


function Download_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Download_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Download_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Download_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Download_objectSpread(Download_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.167 3.333c.46 0 .833.373.833.834v15c0 .46-.372.833-.833.833H.833A.833.833 0 010 19.167V.833C0 .373.372 0 .833 0H7.5c.262 0 .51.123.667.333l2.25 3h8.75zm-5.834 7.155l-2.5 2.5V6.666H9.167v6.322l-2.5-2.5-1.179 1.178 3.923 3.923a.832.832 0 001.178 0l3.923-3.923-1.179-1.178z",
      fill: "#00BAFF",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Download = (SvgDownload);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Dribbble.js


function Dribbble_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Dribbble_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Dribbble_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Dribbble_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgDribbble = function SvgDribbble(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Dribbble_objectSpread(Dribbble_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7 0C3.15 0 0 3.15 0 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm1.925 6.475s-.175-.525-.263-.7c1.488-.7 2.45-1.488 2.8-1.925.613.788.963 1.75 1.05 2.8-.7-.175-2.274-.438-3.587-.175zm-.963-2.012c-.7-1.226-1.487-2.276-1.837-2.888 1.662-.438 3.15.088 4.287 1.137-.35.438-1.05 1.138-2.45 1.75zm-3.5-2.276c.35.438 1.05 1.488 1.75 2.8a21.508 21.508 0 01-4.462.526c.35-1.4 1.4-2.625 2.713-3.325zM7 6.388c.088.176.175.35.263.438-2.45.787-4.026 2.8-4.55 3.587-.7-.962-1.138-2.1-1.138-3.237C2.362 7.088 4.638 7 7 6.388zm.875 1.926c.613 1.75.963 3.15 1.05 3.85-1.838.612-3.938.262-5.075-.7.35-.613 1.488-2.188 4.025-3.15zm2.537 2.974c-.175-.7-.437-1.925-.962-3.412.963-.175 2.363 0 2.888.175a5.597 5.597 0 01-1.925 3.237z",
      fill: "#EA4C89",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Dribbble = (SvgDribbble);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Edit.js


function Edit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Edit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Edit_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Edit_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Edit_objectSpread(Edit_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10 11V9h2v3a1 1 0 01-1 1H2a1 1 0 01-1-1V3a1 1 0 011-1h3v2H3v7h7zm2.581-9.587l.006.006a1.409 1.409 0 010 1.994L8 8 5 9l1-3 4.587-4.587a1.409 1.409 0 011.994 0z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Edit = (SvgEdit);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Error.js


function Error_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Error_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Error_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Error_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgError = function SvgError(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Error_objectSpread(Error_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 2 12"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#FF001F",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h2v8H0zM0 10h2v2H0z"
      })
    })
  }));
};

/* harmony default export */ var Error = (SvgError);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Eye.js


function Eye_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Eye_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Eye_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Eye_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Eye_objectSpread(Eye_objectSpread({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.3545 7.18208C13.2469 7.01128 10.6799 3 6.72014 3C2.76038 3 0.193343 7.01128 0.0858232 7.18208C-0.0286077 7.36421 -0.0286077 7.59579 0.0858232 7.77792C0.193343 7.94872 2.76038 11.96 6.72014 11.96C10.6799 11.96 13.2469 7.94872 13.3545 7.77792C13.4689 7.59579 13.4689 7.36421 13.3545 7.18208ZM6.72014 9.72C5.48303 9.72 4.48014 8.71712 4.48014 7.48C4.48014 6.24288 5.48303 5.24 6.72014 5.24C7.95726 5.24 8.96014 6.24288 8.96014 7.48C8.96014 8.07408 8.72414 8.64384 8.30406 9.06392C7.88398 9.484 7.31423 9.72 6.72014 9.72Z",
      fill: "#A7A7A7"
    })
  }));
};

/* harmony default export */ var Eye = (SvgEye);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Facebook.js


function Facebook_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Facebook_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Facebook_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Facebook_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Facebook_objectSpread(Facebook_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.387 0H.614A.598.598 0 000 .613v12.862c0 .263.263.525.613.525H7V9.625H5.25V7H7V5.25c0-1.837 1.05-2.625 2.625-2.625h1.75V5.25H10.5c-.525 0-.875.35-.875.875V7H11.9l-.525 2.625h-1.75V14h3.762c.35 0 .613-.262.613-.613V.614A.598.598 0 0013.387 0z",
      fill: "#4267B2",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Facebook = (SvgFacebook);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Frame.js


function Frame_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Frame_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Frame_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Frame_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgFrame = function SvgFrame(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Frame_objectSpread(Frame_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.001 17v-4H19v5.416c0 .473-.111.584-.584.584H13v-2h4.001zm-13.948.022H7V19H1.584C1.111 19 1 18.889 1 18.416V13h2.053v4.022zM17 3.037h-4V1h5.416c.473 0 .584.111.584.584V7h-2V3.037zm-13.978-.02V7H1V1.584C1 1.111 1.111 1 1.584 1H7v2.017H3.022zM6 5h8a1 1 0 011 1v8a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1z",
      fill: "#9BD0C3",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Frame = (SvgFrame);
;// CONCATENATED MODULE: ./components/Base/Icons/General/FourToThree.js


function FourToThree_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FourToThree_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FourToThree_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FourToThree_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgFourToThree = function SvgFourToThree(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", FourToThree_objectSpread(FourToThree_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 2.5h11v9h-11z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M.5 1.5h3v3h-3zM10.5 1.5h3v3h-3zM.5 9.5h3v3h-3zM10.5 9.5h3v3h-3z"
      })]
    })
  }));
};

/* harmony default export */ var FourToThree = (SvgFourToThree);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Google.js


function Google_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Google_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Google_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Google_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Google_objectSpread(Google_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    version: "1.1",
    "aria-hidden": "true",
    focusable: "false"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.68,8.18181818 C15.68,7.61454546 15.6290909,7.06909091 15.5345454,6.54545454 L8,6.54545454 L8,9.64 L12.3054546,9.64 C12.12,10.64 11.5563636,11.4872727 10.7090909,12.0545454 L10.7090909,14.0618182 L13.2945454,14.0618182 C14.8072727,12.6690909 15.68,10.6181818 15.68,8.18181818 L15.68,8.18181818 Z",
        id: "Shape",
        fill: "#4285F4",
        fillRule: "nonzero"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8,16 C10.16,16 11.9709091,15.2836364 13.2945454,14.0618182 L10.7090909,12.0545454 C9.99272729,12.5345454 9.07636364,12.8181818 8,12.8181818 C5.91636364,12.8181818 4.15272727,11.4109091 3.52363636,9.52 L0.850909091,9.52 L0.850909091,11.5927273 C2.16727273,14.2072727 4.87272727,16 8,16 L8,16 Z",
        id: "Shape",
        fill: "#34A853",
        fillRule: "nonzero"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M3.52363636,9.52 C3.36363636,9.04 3.27272727,8.52727273 3.27272727,8 C3.27272727,7.47272727 3.36363636,6.96 3.52363636,6.48 L3.52363636,4.40727273 L0.850909091,4.40727273 C0.309090909,5.48727273 0,6.70909091 0,8 C0,9.29090907 0.309090909,10.5127273 0.850909091,11.5927273 L3.52363636,9.52 L3.52363636,9.52 Z",
        id: "Shape",
        fill: "#FBBC05",
        fillRule: "nonzero"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8,3.18181818 C9.17454542,3.18181818 10.2290909,3.58545454 11.0581818,4.37818182 L13.3527273,2.08363636 C11.9672727,0.792727273 10.1563636,0 8,0 C4.87272727,0 2.16727273,1.79272727 0.850909091,4.40727273 L3.52363636,6.48 C4.15272727,4.58909091 5.91636364,3.18181818 8,3.18181818 L8,3.18181818 Z",
        id: "Shape",
        fill: "#EA4335",
        fillRule: "nonzero"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("polygon", {
        id: "Shape",
        points: "0 0 16 0 16 16 0 16"
      })]
    })
  }));
};

/* harmony default export */ var Google = (SvgGoogle);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Image.js


function Image_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Image_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Image_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Image_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Image_objectSpread(Image_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M16.667 1.667H3.333V.833c0-.46.373-.833.834-.833h11.666c.46 0 .834.373.834.833v.834zm2.5 1.666c.46 0 .833.373.833.834v15c0 .46-.373.833-.833.833H.833A.833.833 0 010 19.167v-15c0-.46.373-.834.833-.834h18.334zM5.833 6.667a1.667 1.667 0 100 3.333 1.667 1.667 0 000-3.333zm-1.666 9.166h12.5l-4.167-7.5-8.333 7.5z",
      fill: "#B96DD7",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Image = (SvgImage);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Inactive.js


function Inactive_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Inactive_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Inactive_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Inactive_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgInactive = function SvgInactive(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Inactive_objectSpread(Inactive_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.5 6.217c0 1.722 1.5 2.14 1.5 3.13 0 .888-1.95 1.566-5 1.566s-5-.678-5-1.565c0-.991 1.5-1.409 1.5-3.13V4.651C3.5 2.617 5.05 1 7 1s3.5 1.617 3.5 3.652v1.565zM7 11.957c.65 0 1.2-.053 1.75-.105C8.45 12.53 7.75 13 7 13s-1.4-.47-1.75-1.148c.55.052 1.1.105 1.75.105z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Inactive = (SvgInactive);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Integration.js


function Integration_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Integration_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Integration_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Integration_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgIntegration = function SvgIntegration(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Integration_objectSpread(Integration_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.583 6.417h2.334V3.5L14 7l-4.083 3.5V7.583H4.083V10.5L0 7l4.083-3.5v2.917h2.334V.583a.583.583 0 111.166 0v5.834zM7 14a.583.583 0 01-.583-.583V8.75h1.166v4.667A.583.583 0 017 14z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Integration = (SvgIntegration);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Instagram.js


function Instagram_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Instagram_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Instagram_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Instagram_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Instagram_objectSpread(Instagram_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.627 4.245a.84.84 0 110-1.68.84.84 0 010 1.68zM7 10.5c-1.93 0-3.5-1.57-3.5-3.5S5.07 3.5 7 3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm0-5.25c-.965 0-1.75.785-1.75 1.75S6.035 8.75 7 8.75 8.75 7.965 8.75 7 7.965 5.25 7 5.25zM10.5 14h-7C1.701 14 0 12.299 0 10.5v-7C0 1.701 1.701 0 3.5 0h7C12.299 0 14 1.701 14 3.5v7c0 1.799-1.701 3.5-3.5 3.5zm-7-12.25c-.818 0-1.75.932-1.75 1.75v7c0 .834.916 1.75 1.75 1.75h7c.818 0 1.75-.932 1.75-1.75v-7c0-.818-.932-1.75-1.75-1.75h-7z",
      fill: "#E1306C",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Instagram = (SvgInstagram);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Lock.js


function Lock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Lock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Lock_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Lock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Lock_objectSpread(Lock_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h14v14H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.75 6.257V3.5C10.75 1.57 9.068 0 7 0S3.25 1.57 3.25 3.5v2.757C2.474 7.079 2 8.154 2 9.333 2 11.906 4.243 14 7 14s5-2.094 5-4.667c0-1.179-.474-2.254-1.25-3.076zm-3.194 4.378V12H6.444v-1.365c-.645-.259-1.11-.946-1.11-1.76C5.333 7.841 6.08 7 7 7c.919 0 1.667.841 1.667 1.875 0 .814-.466 1.501-1.111 1.76zM9.778 5A6.508 6.508 0 007 4.389c-1.013 0-1.96.225-2.778.611V3.26C4.222 2.012 5.468 1 7 1s2.778 1.013 2.778 2.26V5z",
        fill: "#C8C8C8"
      })]
    })
  }));
};

/* harmony default export */ var Lock = (SvgLock);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Linkedin.js


function Linkedin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Linkedin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Linkedin_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Linkedin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Linkedin_objectSpread(Linkedin_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.3875 0H0.6125C0.2625 0 0 0.2625 0 0.6125V13.475C0 13.7375 0.2625 14 0.6125 14H13.475C13.825 14 14.0875 13.7375 14.0875 13.3875V0.6125C14 0.2625 13.7375 0 13.3875 0ZM4.1125 11.9H2.1V5.25H4.2V11.9H4.1125ZM3.15 4.375C2.45 4.375 1.925 3.7625 1.925 3.15C1.925 2.45 2.45 1.925 3.15 1.925C3.85 1.925 4.375 2.45 4.375 3.15C4.2875 3.7625 3.7625 4.375 3.15 4.375ZM11.9 11.9H9.8V8.6625C9.8 7.875 9.8 6.9125 8.75 6.9125C7.7 6.9125 7.525 7.7875 7.525 8.6625V11.9875H5.425V5.25H7.4375V6.125C7.7 5.6 8.4 5.075 9.3625 5.075C11.4625 5.075 11.8125 6.475 11.8125 8.225V11.9H11.9Z",
      fill: "black",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Linkedin = (SvgLinkedin);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Mail.js


function Mail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Mail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Mail_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Mail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Mail_objectSpread(Mail_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h14v14H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.218 6.346l1.406 1.065L7.532 5.23l-3.805 3v3.68c0 .51.635.741.963.352l1.707-2.029 3.546 2.66c.321.24.783.064.862-.33l2.184-10.908a.546.546 0 00-.737-.614L1.343 5.403a.546.546 0 00-.125.943z",
        fill: "#C8C8C8"
      })]
    })
  }));
};

/* harmony default export */ var Mail = (SvgMail);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Menu.js


function Menu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Menu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Menu_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Menu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Menu_objectSpread(Menu_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#C8C8C8",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M13.533 8H.467C.209 8 0 7.777 0 7.5S.21 7 .467 7h13.066c.258 0 .467.223.467.5s-.21.5-.467.5zM13.533 4H.467C.209 4 0 3.776 0 3.5S.21 3 .467 3h13.066c.258 0 .467.224.467.5s-.21.5-.467.5zM7.5 12h-7a.5.5 0 110-1h7a.5.5 0 110 1z"
      })
    })
  }));
};

/* harmony default export */ var Menu = (SvgMenu);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Minus.js


function Minus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Minus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Minus_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Minus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Minus_objectSpread(Minus_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#000",
      fillRule: "nonzero",
      d: "M2 6v2h10V6z"
    })
  }));
};

/* harmony default export */ var Minus = (SvgMinus);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Move.js


function Move_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Move_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Move_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Move_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Move_objectSpread(Move_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.75 5.25h-3v-3h1.5L6 0 3.75 2.25h1.5v3h-3v-1.5L0 6l2.25 2.25v-1.5h3v3h-1.5L6 12l2.25-2.25h-1.5v-3h3v1.5L12 6 9.75 3.75z",
      fill: "#111",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Move = (SvgMove);
;// CONCATENATED MODULE: ./components/Base/Icons/General/None.js


function None_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function None_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? None_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : None_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgNone = function SvgNone(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", None_objectSpread(None_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7 1a6 6 0 106 6 6.006 6.006 0 00-6-6zm0 1.5c.934 0 1.844.292 2.603.836L3.336 9.603A4.493 4.493 0 017 2.5zm0 9a4.471 4.471 0 01-2.603-.836l6.267-6.267A4.493 4.493 0 017 11.5z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var None = (SvgNone);
;// CONCATENATED MODULE: ./components/Base/Icons/General/OneToOne.js


function OneToOne_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OneToOne_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OneToOne_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OneToOne_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgOneToOne = function SvgOneToOne(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", OneToOne_objectSpread(OneToOne_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#000",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M2.5 2.5h9v9h-9z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M1.5 1.5h3v3h-3zM9.5 1.5h3v3h-3zM1.5 9.5h3v3h-3zM9.5 9.5h3v3h-3z"
      })]
    })
  }));
};

/* harmony default export */ var OneToOne = (SvgOneToOne);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Payment.js


function Payment_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Payment_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Payment_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Payment_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPayment = function SvgPayment(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Payment_objectSpread(Payment_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#C8C8C8",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "square",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1 3.294h12M1 5.588h12M5.364 9.898H2.09C1.488 9.898 1 9.401 1 8.786V2.112C1 1.498 1.488 1 2.09 1H11.91C12.512 1 13 1.498 13 2.112v5.562M3.25 7.882h2.727M7.75 9.412h4.364v3.893H7.75z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8.5 9.342V8.23c0-.612.49-1.112 1.09-1.112.6 0 1.092.5 1.092 1.112v1.112M10 10.941v.556"
      })]
    })
  }));
};

/* harmony default export */ var Payment = (SvgPayment);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Password.js


function Password_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Password_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Password_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Password_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPassword = function SvgPassword(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Password_objectSpread(Password_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h14v14H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.75 6.257V3.5C10.75 1.57 9.068 0 7 0S3.25 1.57 3.25 3.5v2.757C2.474 7.079 2 8.154 2 9.333 2 11.906 4.243 14 7 14s5-2.094 5-4.667c0-1.179-.474-2.254-1.25-3.076zm-3.194 4.378V12H6.444v-1.365c-.645-.259-1.11-.946-1.11-1.76C5.333 7.841 6.08 7 7 7c.919 0 1.667.841 1.667 1.875 0 .814-.466 1.501-1.111 1.76zM9.778 5A6.508 6.508 0 007 4.389c-1.013 0-1.96.225-2.778.611V3.26C4.222 2.012 5.468 1 7 1s2.778 1.013 2.778 2.26V5z",
        fill: "#C8C8C8"
      })]
    })
  }));
};

/* harmony default export */ var Password = (SvgPassword);
;// CONCATENATED MODULE: ./components/Base/Icons/General/People.js


function People_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function People_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? People_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : People_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", People_objectSpread(People_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4.167 15.015c0-1.161.705-2.198 1.796-2.64 1.157-.47 2.515-.708 4.037-.708 1.522 0 2.88.238 4.037.709a2.845 2.845 0 011.796 2.64v1.65H4.167v-1.65zm6.25-4.182a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm-8.75-9.166V5H0V.833C0 .373.372 0 .833 0H5v1.667H1.667zM19.167 0c.46 0 .833.372.833.833V5h-1.667V1.667H15V0h4.167zm-17.5 15v3.333H5V20H.833A.833.833 0 010 19.167V15h1.667zm16.666 3.333V15H20v4.167c0 .46-.372.833-.833.833H15v-1.667h3.333z",
      fill: "#00BAFF",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var People = (SvgPeople);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Play.js


function Play_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Play_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Play_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Play_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Play_objectSpread(Play_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#00BAFF",
        fillRule: "nonzero",
        cx: 10,
        cy: 10,
        r: 10
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M14 10l-6 4V6z"
      })]
    })
  }));
};

/* harmony default export */ var Play = (SvgPlay);
;// CONCATENATED MODULE: ./components/Base/Icons/General/PlayVideo.js


function PlayVideo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlayVideo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlayVideo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlayVideo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgPlay2 = function SvgPlay2(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", PlayVideo_objectSpread(PlayVideo_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 10"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.28452 0.129262L7.59879 4.14671C7.99521 4.39893 8.11881 4.93566 7.87486 5.34552C7.80571 5.46169 7.71115 5.55946 7.59879 5.63095L1.28452 9.64839C0.888098 9.90062 0.368974 9.77282 0.125023 9.36296C0.0432801 9.22563 0 9.06753 0 8.90627V0.871381C0 0.390131 0.377337 0 0.842806 0C0.998776 0 1.15169 0.0447474 1.28452 0.129262Z"
    })
  }));
};

/* harmony default export */ var PlayVideo = (SvgPlay2);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Plus.js


function Plus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Plus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Plus_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Plus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Plus_objectSpread(Plus_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6 6V2h2v4h4v2H8v4H6V8H2V6h4z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Plus = (SvgPlus);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Premium.js


function Premium_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Premium_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Premium_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Premium_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgPremium = function SvgPremium(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Premium_objectSpread(Premium_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.412 3.99l-.982 1.603a1 1 0 01-1.706 0L7.761 2.386a1 1 0 00-1.706 0L4.092 5.593a1 1 0 01-1.706 0l-.981-1.604a.758.758 0 00-1.4.49l.788 6.298c0 .675.41 1.223.917 1.223h10.396c.507 0 .917-.548.917-1.223l.788-6.298a.758.758 0 00-1.4-.49z",
      fill: "#F6C423",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Premium = (SvgPremium);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Preferences.js


function Preferences_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Preferences_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Preferences_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Preferences_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgPreferences = function SvgPreferences(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Preferences_objectSpread(Preferences_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4.167 9.167H2.5V.833a.834.834 0 011.667 0v8.334zM10.833 2.5H9.167V.833a.834.834 0 011.666 0V2.5zM17.5 9.167h-1.667V.833a.834.834 0 011.667 0v8.334zM3.333 10.833a3.337 3.337 0 013.334 3.334 3.33 3.33 0 01-2.5 3.215v1.785a.834.834 0 01-1.667 0v-1.785A3.33 3.33 0 010 14.167a3.337 3.337 0 013.333-3.334zm10-3.333a3.33 3.33 0 01-2.5 3.215v8.452a.834.834 0 01-1.666 0v-8.452a3.33 3.33 0 01-2.5-3.215A3.337 3.337 0 0110 4.167 3.337 3.337 0 0113.333 7.5zM20 14.167a3.33 3.33 0 01-2.5 3.215v1.785a.834.834 0 01-1.667 0v-1.785a3.33 3.33 0 01-2.5-3.215 3.337 3.337 0 013.334-3.334A3.337 3.337 0 0120 14.167z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Preferences = (SvgPreferences);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Pro.js


function Pro_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Pro_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Pro_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Pro_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgPro = function SvgPro(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Pro_objectSpread(Pro_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 11"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.8281 3.87175C13.936 2.98663 12.7578 2.58345 12.3008 3.34908L11.1973 5.19776C10.9839 5.55521 10.4661 5.55521 10.2527 5.19776L7.85839 1.1867C7.53832 0.650515 6.76168 0.650517 6.44161 1.1867L4.04726 5.19776C3.83388 5.55521 3.31612 5.55521 3.10274 5.19776L1.9992 3.34908C1.54216 2.58345 0.363996 2.98663 0.47187 3.87175L1.19167 9.77778C1.19167 10.4528 1.59181 11 2.08542 11H12.2146C12.7082 11 13.1083 10.4528 13.1083 9.77778L13.8281 3.87175Z",
      fill: "#F6C423"
    })
  }));
};

/* harmony default export */ var Pro = (SvgPro);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Print.js


function Print_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Print_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Print_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Print_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Print_objectSpread(Print_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M3 19h14v1H3z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M17.5 19.5a2 2 0 002-2c0-.105.001-.196.004-.341.011-.492.005-.52-.014-.53-.18-.092-.68-.129-1.99-.129-1.1 0-1.698.107-1.919.271-.083.062-.097.127-.086.501.004.107.005.16.005.228 0 .76 1.077 2 2 2z",
        stroke: "#000"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        fill: "#FFF",
        x: 11,
        y: 11,
        width: 8,
        height: 8,
        rx: 2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M6 16h14v1H6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M4.507 16.992l.008-.492H15a1.5 1.5 0 001.5-1.5V2A1.5 1.5 0 0015 .5H2A1.5 1.5 0 00.5 2L.499 16.526c-.01.152-.01.283-.003.613.003.172.004.257.004.361a2 2 0 104 0c0-.104.001-.19.004-.36l.003-.148z",
        stroke: "#000"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#000",
        d: "M4 11h9v1H4zM4 8h9v1H4zM4 5h9v1H4z"
      })]
    })
  }));
};

/* harmony default export */ var Print = (SvgPrint);
;// CONCATENATED MODULE: ./components/Base/Icons/General/ProBadgeLeft.js


function ProBadgeLeft_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProBadgeLeft_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProBadgeLeft_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProBadgeLeft_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgProBadgeLeft = function SvgProBadgeLeft(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ProBadgeLeft_objectSpread(ProBadgeLeft_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 51 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      stroke: "none",
      fill: "none",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          id: "Rectangle",
          fill: "#F6C423",
          x: "0",
          y: "0",
          width: "48",
          height: "20",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M48.0001,14.2426 C47.3701,14.8726 46.293,14.4264 46.293,13.5355 L46.293,7.05021 C46.293,6.15931 47.3701,5.71314 48.0001,6.34311 L51.2427,9.58575 C51.6332,9.97627 51.6332,10.6094 51.2427,11 L48.0001,14.2426 Z",
          id: "Path",
          fill: "#F6C423"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M16.604,8.24902 C16.6945,7.50627 15.7059,7.16793 15.3224,7.81042 L14.3963,9.36175 C14.2172,9.66172 13.7828,9.66172 13.6037,9.36175 L11.5945,5.99583 C11.3259,5.54589 10.6741,5.54589 10.4056,5.99583 L8.3963,9.36175 C8.21724,9.66172 7.78276,9.66172 7.6037,9.36175 L6.67765,7.81042 C6.29412,7.16793 5.30545,7.50627 5.39597,8.24902 L6,13.2051 C6,13.7716 6.33579,14.2308 6.75,14.2308 L15.25,14.2308 C15.6642,14.2308 16,13.7716 16,13.2051 L16.604,8.24902 Z",
          id: "Path",
          fill: "#FFFFFF"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M23.82,7 C24.4267,7 24.9533,7.1 25.4,7.3 C25.8533,7.5 26.2,7.78667 26.44,8.16 C26.68,8.53333 26.8,8.97667 26.8,9.49 C26.8,9.99667 26.68,10.44 26.44,10.82 C26.2,11.1933 25.8533,11.48 25.4,11.68 C24.9533,11.88 24.4267,11.98 23.82,11.98 L22.24,11.98 L22.24,14 L20.94,14 L20.94,7 L23.82,7 Z M23.76,10.88 C24.3267,10.88 24.7567,10.76 25.05,10.52 C25.3433,10.28 25.49,9.93667 25.49,9.49 C25.49,9.04333 25.3433,8.7 25.05,8.46 C24.7567,8.22 24.3267,8.1 23.76,8.1 L22.24,8.1 L22.24,10.88 L23.76,10.88 Z M32.6782,14 L31.2482,11.95 C31.1882,11.9567 31.0982,11.96 30.9782,11.96 L29.3982,11.96 L29.3982,14 L28.0982,14 L28.0982,7 L30.9782,7 C31.5849,7 32.1115,7.1 32.5582,7.3 C33.0115,7.5 33.3582,7.78667 33.5982,8.16 C33.8382,8.53333 33.9582,8.97667 33.9582,9.49 C33.9582,10.0167 33.8282,10.47 33.5682,10.85 C33.3149,11.23 32.9482,11.5133 32.4682,11.7 L34.0782,14 L32.6782,14 Z M32.6482,9.49 C32.6482,9.04333 32.5015,8.7 32.2082,8.46 C31.9149,8.22 31.4849,8.1 30.9182,8.1 L29.3982,8.1 L29.3982,10.89 L30.9182,10.89 C31.4849,10.89 31.9149,10.77 32.2082,10.53 C32.5015,10.2833 32.6482,9.93667 32.6482,9.49 Z M38.6827,14.1 C37.9693,14.1 37.326,13.9467 36.7527,13.64 C36.1793,13.3267 35.7293,12.8967 35.4027,12.35 C35.076,11.7967 34.9127,11.18 34.9127,10.5 C34.9127,9.82 35.076,9.20667 35.4027,8.66 C35.7293,8.10667 36.1793,7.67667 36.7527,7.37 C37.326,7.05667 37.9693,6.9 38.6827,6.9 C39.396,6.9 40.0393,7.05667 40.6127,7.37 C41.186,7.67667 41.636,8.10333 41.9627,8.65 C42.2893,9.19667 42.4527,9.81333 42.4527,10.5 C42.4527,11.1867 42.2893,11.8033 41.9627,12.35 C41.636,12.8967 41.186,13.3267 40.6127,13.64 C40.0393,13.9467 39.396,14.1 38.6827,14.1 Z M38.6827,12.96 C39.1493,12.96 39.5693,12.8567 39.9427,12.65 C40.316,12.4367 40.6093,12.1433 40.8227,11.77 C41.036,11.39 41.1427,10.9667 41.1427,10.5 C41.1427,10.0333 41.036,9.61333 40.8227,9.24 C40.6093,8.86 40.316,8.56667 39.9427,8.36 C39.5693,8.14667 39.1493,8.04 38.6827,8.04 C38.216,8.04 37.796,8.14667 37.4227,8.36 C37.0493,8.56667 36.756,8.86 36.5427,9.24 C36.3293,9.61333 36.2227,10.0333 36.2227,10.5 C36.2227,10.9667 36.3293,11.39 36.5427,11.77 C36.756,12.1433 37.0493,12.4367 37.4227,12.65 C37.796,12.8567 38.216,12.96 38.6827,12.96 Z",
          id: "Shape",
          fill: "#FFFFFF"
        })]
      })
    })
  }));
};

/* harmony default export */ var ProBadgeLeft = (SvgProBadgeLeft);
;// CONCATENATED MODULE: ./components/Base/Icons/General/ProBadgeRight.js


function ProBadgeRight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProBadgeRight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProBadgeRight_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProBadgeRight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgProBadgeRight = function SvgProBadgeRight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ProBadgeRight_objectSpread(ProBadgeRight_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "none",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          id: "Rectangle",
          fill: "#F6C423",
          x: "3",
          y: "0",
          width: "48",
          height: "20",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M1.7071,14.1943909 C1.0771,14.8243909 0,14.3781909 0,13.4872909 L0,7.00200089 C0,6.11110089 1.0771,5.66493089 1.7071,6.29490089 L4.9497,9.53754089 C5.3402,9.92806089 5.3402,10.5611909 4.9497,10.9517909 L1.7071,14.1943909 Z",
          id: "Path",
          fill: "#F6C423",
          transform: "translate(2.621288, 10.244653) scale(-1, 1) translate(-2.621288, -10.244653) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M19.604,8.24902 C19.6945,7.50627 18.7059,7.16793 18.3224,7.81042 L17.3963,9.36175 C17.2172,9.66172 16.7828,9.66172 16.6037,9.36175 L14.5945,5.99583 C14.3259,5.54589 13.6741,5.54589 13.4056,5.99583 L11.3963,9.36175 C11.21724,9.66172 10.78276,9.66172 10.6037,9.36175 L9.67765,7.81042 C9.29412,7.16793 8.30545,7.50627 8.39597,8.24902 L9,13.2051 C9,13.7716 9.33579,14.2308 9.75,14.2308 L18.25,14.2308 C18.6642,14.2308 19,13.7716 19,13.2051 L19.604,8.24902 Z",
          id: "Path",
          fill: "#FFFFFF"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M26.82,7 C27.4267,7 27.9533,7.1 28.4,7.3 C28.8533,7.5 29.2,7.78667 29.44,8.16 C29.68,8.53333 29.8,8.97667 29.8,9.49 C29.8,9.99667 29.68,10.44 29.44,10.82 C29.2,11.1933 28.8533,11.48 28.4,11.68 C27.9533,11.88 27.4267,11.98 26.82,11.98 L25.24,11.98 L25.24,14 L23.94,14 L23.94,7 L26.82,7 Z M26.76,10.88 C27.3267,10.88 27.7567,10.76 28.05,10.52 C28.3433,10.28 28.49,9.93667 28.49,9.49 C28.49,9.04333 28.3433,8.7 28.05,8.46 C27.7567,8.22 27.3267,8.1 26.76,8.1 L25.24,8.1 L25.24,10.88 L26.76,10.88 Z M35.6782,14 L34.2482,11.95 C34.1882,11.9567 34.0982,11.96 33.9782,11.96 L32.3982,11.96 L32.3982,14 L31.0982,14 L31.0982,7 L33.9782,7 C34.5849,7 35.1115,7.1 35.5582,7.3 C36.0115,7.5 36.3582,7.78667 36.5982,8.16 C36.8382,8.53333 36.9582,8.97667 36.9582,9.49 C36.9582,10.0167 36.8282,10.47 36.5682,10.85 C36.3149,11.23 35.9482,11.5133 35.4682,11.7 L37.0782,14 L35.6782,14 Z M35.6482,9.49 C35.6482,9.04333 35.5015,8.7 35.2082,8.46 C34.9149,8.22 34.4849,8.1 33.9182,8.1 L32.3982,8.1 L32.3982,10.89 L33.9182,10.89 C34.4849,10.89 34.9149,10.77 35.2082,10.53 C35.5015,10.2833 35.6482,9.93667 35.6482,9.49 Z M41.6827,14.1 C40.9693,14.1 40.326,13.9467 39.7527,13.64 C39.1793,13.3267 38.7293,12.8967 38.4027,12.35 C38.076,11.7967 37.9127,11.18 37.9127,10.5 C37.9127,9.82 38.076,9.20667 38.4027,8.66 C38.7293,8.10667 39.1793,7.67667 39.7527,7.37 C40.326,7.05667 40.9693,6.9 41.6827,6.9 C42.396,6.9 43.0393,7.05667 43.6127,7.37 C44.186,7.67667 44.636,8.10333 44.9627,8.65 C45.2893,9.19667 45.4527,9.81333 45.4527,10.5 C45.4527,11.1867 45.2893,11.8033 44.9627,12.35 C44.636,12.8967 44.186,13.3267 43.6127,13.64 C43.0393,13.9467 42.396,14.1 41.6827,14.1 Z M41.6827,12.96 C42.1493,12.96 42.5693,12.8567 42.9427,12.65 C43.316,12.4367 43.6093,12.1433 43.8227,11.77 C44.036,11.39 44.1427,10.9667 44.1427,10.5 C44.1427,10.0333 44.036,9.61333 43.8227,9.24 C43.6093,8.86 43.316,8.56667 42.9427,8.36 C42.5693,8.14667 42.1493,8.04 41.6827,8.04 C41.216,8.04 40.796,8.14667 40.4227,8.36 C40.0493,8.56667 39.756,8.86 39.5427,9.24 C39.3293,9.61333 39.2227,10.0333 39.2227,10.5 C39.2227,10.9667 39.3293,11.39 39.5427,11.77 C39.756,12.1433 40.0493,12.4367 40.4227,12.65 C40.796,12.8567 41.216,12.96 41.6827,12.96 Z",
          id: "Shape",
          fill: "#FFFFFF"
        })]
      })
    })
  }));
};

/* harmony default export */ var ProBadgeRight = (SvgProBadgeRight);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Rotate.js


function Rotate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Rotate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Rotate_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Rotate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Rotate_objectSpread(Rotate_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 11"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.866 8.981A5.414 5.414 0 01.727 6.493l1.6-.26c.112.645.392 1.26.813 1.775l-1.274.973zM5.38 11a5.786 5.786 0 01-2.413-.989l.962-1.266c.506.361 1.1.605 1.72.706L5.378 11zm1.89 0L7 9.45a4.112 4.112 0 001.791-.757l.989 1.246A5.766 5.766 0 017.269 11zM6.324.079C9.454.079 12 2.545 12 5.577A5.354 5.354 0 0110.925 8.8L9.61 7.877a3.814 3.814 0 00.767-2.3c0-2.165-1.818-3.927-4.054-3.927A4.14 4.14 0 003.458 2.8L5.19 4.478 0 5.028.568 0l1.744 1.69A5.79 5.79 0 016.324.08z",
      fill: "#111",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Rotate = (SvgRotate);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Question.js


function Question_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Question_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Question_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Question_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Question_objectSpread(Question_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7 0C3.15 0 0 3.15 0 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm0 11.375c-.525 0-.875-.35-.875-.875s.35-.875.875-.875.875.35.875.875-.35.875-.875.875zM8.313 7.35c-.438.263-.438.35-.438.525v.875h-1.75v-.875c0-1.138.7-1.662 1.225-2.013.438-.262.525-.35.525-.612 0-.525-.35-.875-.875-.875-.35 0-.612.175-.787.438l-.438.787-1.488-.875.438-.787C5.163 3.15 6.038 2.625 7 2.625c1.488 0 2.625 1.138 2.625 2.625 0 1.225-.787 1.75-1.313 2.1z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Question = (SvgQuestion);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Search.js


function Search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Search_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Search_objectSpread(Search_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.459 9.306a5.639 5.639 0 001.153-3.459C11.612 2.635 9.059 0 5.847 0 2.635 0 0 2.635 0 5.847c0 3.212 2.635 5.847 5.847 5.847 1.318 0 2.553-.412 3.459-1.153l2.47 2.47a.89.89 0 00.577.248.89.89 0 00.576-.247.796.796 0 000-1.153l-2.47-2.553zm-4.612.659c-2.306 0-4.2-1.812-4.2-4.118s1.894-4.2 4.2-4.2 4.2 1.894 4.2 4.2-1.894 4.118-4.2 4.118z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Search = (SvgSearch);
;// CONCATENATED MODULE: ./components/Base/Icons/General/SixttenToNine.js


function SixttenToNine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SixttenToNine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SixttenToNine_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SixttenToNine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgSixttenToNine = function SvgSixttenToNine(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", SixttenToNine_objectSpread(SixttenToNine_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.5 3.5h11v7h-11z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M.5 2.5h3v3h-3zM10.5 2.5h3v3h-3zM.5 8.5h3v3h-3zM10.5 8.5h3v3h-3z"
      })]
    })
  }));
};

/* harmony default export */ var SixttenToNine = (SvgSixttenToNine);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Thumb.js


function Thumb_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Thumb_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Thumb_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Thumb_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgThumb = function SvgThumb(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Thumb_objectSpread(Thumb_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M2.375 8.044c.437 0 .791.35.791.782V19H.792A.787.787 0 010 18.217v-9.39c0-.433.354-.783.792-.783h1.583zm14.947-.679a2.369 2.369 0 011.401 1.145c.295.55.357 1.194.172 1.79l-2.192 7.042A2.36 2.36 0 0114.431 19H4.75V9.17l3.166-3.757v-3.63c0-.214.088-.418.244-.566A.81.81 0 018.741 1c1.084.046 3.133.92 3.133 3.913v2.348h4.75c.237 0 .472.035.698.104z",
      fill: "#C8C8C8",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Thumb = (SvgThumb);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Team.js


function Team_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Team_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Team_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Team_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Team_objectSpread(Team_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.01 8.9c.582.143.99.657.99 1.247v2.424a.432.432 0 01-.436.429H9.561c.052-.137.079-.282.08-.429v-2.03a2.157 2.157 0 00-1.58-2.062l-.12-.034c.31-.173.536-.463.624-.803.088-.34.03-.7-.158-.997a3.584 3.584 0 01-.51-2.106A3.57 3.57 0 007 2.195a2.627 2.627 0 012.286-1.194c1.438.08 2.557 1.263 2.535 2.68v1.177a2.57 2.57 0 01-1.528 2.336l.166.826a.432.432 0 00.322.332l2.229.548zm-5.992.406c.507.157.857.661.857 1.235v2.03c0 .237-.176.429-.394.429H.394C.176 13 0 12.808 0 12.572v-2.03c0-.576.352-1.08.86-1.236l1.699-.528a.41.41 0 00.266-.279l.134-.447a3.62 3.62 0 01-1.812-.343.423.423 0 01-.199-.268.461.461 0 01.047-.341c.438-.805.64-1.737.58-2.67 0-.7.261-1.37.725-1.855A2.259 2.259 0 014.03 1.86C5.322 1.956 6.32 3.134 6.3 4.542A4.8 4.8 0 006.882 7.1a.46.46 0 01.048.341.423.423 0 01-.2.269 3.62 3.62 0 01-1.81.343l.133.447c.041.135.14.24.267.279l1.698.528z",
      fill: "#4FCA33",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Team = (SvgTeam);
;// CONCATENATED MODULE: ./components/Base/Icons/General/TeamBadgeLeft.js


function TeamBadgeLeft_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TeamBadgeLeft_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TeamBadgeLeft_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TeamBadgeLeft_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgTeamBadgeLeft = function SvgTeamBadgeLeft(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", TeamBadgeLeft_objectSpread(TeamBadgeLeft_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 57 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          fill: "#4FCA33",
          fillRule: "nonzero",
          width: 53,
          height: 20,
          rx: 2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M14.293 11.357c.415.102.707.47.707.89v1.733c0 .169-.14.306-.311.306h-2.86a.894.894 0 00.058-.306v-1.45a1.54 1.54 0 00-1.13-1.474l-.085-.024a.92.92 0 00.446-.573.905.905 0 00-.113-.713 2.56 2.56 0 01-.364-1.504A2.55 2.55 0 0010 6.568a1.877 1.877 0 011.633-.853c1.027.058 1.826.902 1.81 1.914v.84c0 .72-.427 1.371-1.091 1.67l.119.59a.308.308 0 00.23.237l1.592.391zm-4.28.29c.362.112.612.473.612.883v1.45c0 .169-.126.306-.281.306H5.28c-.155 0-.281-.137-.281-.306v-1.45c0-.411.251-.772.614-.883l1.214-.377a.293.293 0 00.19-.2l.095-.319a2.585 2.585 0 01-1.293-.245.302.302 0 01-.143-.191.33.33 0 01.034-.244c.313-.575.457-1.24.414-1.907 0-.5.187-.978.518-1.325a1.613 1.613 0 011.236-.511c.923.069 1.635.91 1.621 1.917-.032.64.112 1.276.416 1.826a.33.33 0 01.034.243.302.302 0 01-.142.192c-.407.193-.851.277-1.294.245l.096.32c.029.096.1.17.19.199l1.213.377zM20.09 7h5.61v1.06h-2.22V14H22.3V8.06h-2.21V7zm8.04 1.64c1.87 0 2.63 1.22 2.49 3.14H26.6c.18.82.81 1.33 1.65 1.33.58 0 1.11-.22 1.5-.62l.61.65c-.52.57-1.28.9-2.2.9-1.64 0-2.72-1.09-2.72-2.69 0-1.61 1.11-2.7 2.69-2.71zm-1.55 2.3h3.04c-.04-.86-.61-1.38-1.48-1.38-.84 0-1.44.53-1.56 1.38zM36.14 14h-1.13v-.65c-.38.47-.99.7-1.76.7-1.15 0-1.87-.71-1.87-1.65 0-.97.73-1.59 2.01-1.6H35v-.16c0-.67-.43-1.07-1.27-1.07-.51 0-1.04.18-1.57.54l-.47-.8c.74-.44 1.28-.67 2.29-.67 1.37 0 2.14.7 2.15 1.87l.01 3.49zm-2.65-.86c.82 0 1.45-.43 1.51-1.01v-.49h-1.44c-.75 0-1.1.2-1.1.71 0 .48.39.79 1.03.79zm11.13-4.5c1.22 0 1.95.78 1.95 2.05V14h-1.15v-2.99c0-.81-.48-1.3-1.26-1.3-.91.03-1.46.73-1.46 1.66V14h-1.15v-2.99c0-.81-.47-1.3-1.25-1.3-.92.03-1.48.73-1.48 1.66V14h-1.14V8.68h1.14v1.03c.37-.75 1.05-1.07 1.93-1.07.95 0 1.6.47 1.85 1.28.34-.89 1.05-1.28 2.02-1.28z",
          fill: "#FFF"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M51 6.757v6.486a1 1 0 001.707.707l3.243-3.243a1 1 0 000-1.414L52.707 6.05A1 1 0 0051 6.757z",
        fill: "#4FCA33",
        fillRule: "nonzero"
      })]
    })
  }));
};

/* harmony default export */ var TeamBadgeLeft = (SvgTeamBadgeLeft);
;// CONCATENATED MODULE: ./components/Base/Icons/General/TeamBadgeRight.js


function TeamBadgeRight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TeamBadgeRight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TeamBadgeRight_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TeamBadgeRight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgTeamBadgeRight = function SvgTeamBadgeRight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", TeamBadgeRight_objectSpread(TeamBadgeRight_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 57 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(4)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          fill: "#4FCA33",
          fillRule: "nonzero",
          width: 53,
          height: 20,
          rx: 2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M14.293 11.357c.415.102.707.47.707.89v1.733c0 .169-.14.306-.311.306h-2.86a.894.894 0 00.058-.306v-1.45a1.54 1.54 0 00-1.13-1.474l-.085-.024a.92.92 0 00.446-.573.905.905 0 00-.113-.713 2.56 2.56 0 01-.364-1.504A2.55 2.55 0 0010 6.568a1.877 1.877 0 011.633-.853c1.027.058 1.826.902 1.81 1.914v.84c0 .72-.427 1.371-1.091 1.67l.119.59a.308.308 0 00.23.237l1.592.391zm-4.28.29c.362.112.612.473.612.883v1.45c0 .169-.126.306-.281.306H5.28c-.155 0-.281-.137-.281-.306v-1.45c0-.411.251-.772.614-.883l1.214-.377a.293.293 0 00.19-.2l.095-.319a2.585 2.585 0 01-1.293-.245.302.302 0 01-.143-.191.33.33 0 01.034-.244c.313-.575.457-1.24.414-1.907 0-.5.187-.978.518-1.325a1.613 1.613 0 011.236-.511c.923.069 1.635.91 1.621 1.917-.032.64.112 1.276.416 1.826a.33.33 0 01.034.243.302.302 0 01-.142.192c-.407.193-.851.277-1.294.245l.096.32c.029.096.1.17.19.199l1.213.377zM20.09 7h5.61v1.06h-2.22V14H22.3V8.06h-2.21V7zm8.04 1.64c1.87 0 2.63 1.22 2.49 3.14H26.6c.18.82.81 1.33 1.65 1.33.58 0 1.11-.22 1.5-.62l.61.65c-.52.57-1.28.9-2.2.9-1.64 0-2.72-1.09-2.72-2.69 0-1.61 1.11-2.7 2.69-2.71zm-1.55 2.3h3.04c-.04-.86-.61-1.38-1.48-1.38-.84 0-1.44.53-1.56 1.38zM36.14 14h-1.13v-.65c-.38.47-.99.7-1.76.7-1.15 0-1.87-.71-1.87-1.65 0-.97.73-1.59 2.01-1.6H35v-.16c0-.67-.43-1.07-1.27-1.07-.51 0-1.04.18-1.57.54l-.47-.8c.74-.44 1.28-.67 2.29-.67 1.37 0 2.14.7 2.15 1.87l.01 3.49zm-2.65-.86c.82 0 1.45-.43 1.51-1.01v-.49h-1.44c-.75 0-1.1.2-1.1.71 0 .48.39.79 1.03.79zm11.13-4.5c1.22 0 1.95.78 1.95 2.05V14h-1.15v-2.99c0-.81-.48-1.3-1.26-1.3-.91.03-1.46.73-1.46 1.66V14h-1.15v-2.99c0-.81-.47-1.3-1.25-1.3-.92.03-1.48.73-1.48 1.66V14h-1.14V8.68h1.14v1.03c.37-.75 1.05-1.07 1.93-1.07.95 0 1.6.47 1.85 1.28.34-.89 1.05-1.28 2.02-1.28z",
          fill: "#FFF"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6 6.757v6.486a1 1 0 01-1.707.707L1.05 10.707a1 1 0 010-1.414L4.293 6.05A1 1 0 016 6.757z",
        fill: "#4FCA33",
        fillRule: "nonzero"
      })]
    })
  }));
};

/* harmony default export */ var TeamBadgeRight = (SvgTeamBadgeRight);
;// CONCATENATED MODULE: ./components/Base/Icons/General/TransformVertical.js


function TransformVertical_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TransformVertical_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TransformVertical_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TransformVertical_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgTransformVertical = function SvgTransformVertical(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", TransformVertical_objectSpread(TransformVertical_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M3 8h6.959a1 1 0 0 1 .484 1.875l-5.958 3.302A1 1 0 0 1 3 12.302V8z",
        fill: "#000"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M3 6h6.959a1 1 0 0 0 .484-1.875L4.485.823A1 1 0 0 0 3 1.698V6z",
        fill: "#00BAFF"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#FFF",
        d: "M4 9h6l-6 3zM4 2v3h6z"
      })]
    })
  }));
};

/* harmony default export */ var TransformVertical = (SvgTransformVertical);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Transparent.js


function Transparent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Transparent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Transparent_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Transparent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgTransparent = function SvgTransparent(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Transparent_objectSpread(Transparent_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.75 1H7v6H1V1.75A.75.75 0 011.75 1zM7 7h6v6H7V7zm6-6h5.25a.75.75 0 01.75.75V7h-6V1zM1 13h6v6H1.75a.75.75 0 01-.75-.75V13zm12 0h6v5.25a.75.75 0 01-.75.75H13v-6z",
      fill: "#B96DD7",
      fillRule: "evenodd"
    })
  }));
};

/* harmony default export */ var Transparent = (SvgTransparent);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Trash.js


function Trash_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Trash_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Trash_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Trash_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Trash_objectSpread(Trash_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4 6h6v4.8c0 .66-.45 1.2-1 1.2H5c-.55 0-1-.54-1-1.2V6zm5.5-2.2H11V5H3V3.8h1.5V2.6c0-.36.25-.6.625-.6h3.75c.375 0 .625.24.625.6v1.2zm-1.25 0v-.6h-2.5v.6h2.5z",
      fill: "red",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Trash = (SvgTrash);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Twitter.js


function Twitter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Twitter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Twitter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Twitter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Twitter_objectSpread(Twitter_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14 3.27c-.525.253-1.05.338-1.662.422.612-.338 1.05-.846 1.225-1.523-.526.339-1.138.508-1.838.677A3.109 3.109 0 009.625 2c-1.488 0-2.8 1.27-2.8 2.792 0 .254 0 .423.087.593C4.55 5.3 2.362 4.2.962 2.508c-.262.423-.35.846-.35 1.438 0 .93.525 1.777 1.313 2.285-.438 0-.875-.17-1.313-.339 0 1.354.963 2.454 2.276 2.708-.263.085-.526.085-.788.085-.175 0-.35 0-.525-.085.35 1.1 1.4 1.946 2.712 1.946-.962.762-2.187 1.185-3.587 1.185H0C1.313 12.492 2.8 13 4.375 13c5.25 0 8.137-4.23 8.137-7.87v-.338c.613-.423 1.138-.93 1.488-1.523z",
      fill: "#1C94E0",
      fillRule: "nonzero"
    })
  }));
};

/* harmony default export */ var Twitter = (SvgTwitter);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Unlock.js


function Unlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Unlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Unlock_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Unlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Unlock_objectSpread(Unlock_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h14v14H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7 4.667c-.911 0-1.764.232-2.5.63V3.5c0-1.287 1.121-2.333 2.5-2.333S9.5 2.213 9.5 3.5h1.25C10.75 1.57 9.068 0 7 0S3.25 1.57 3.25 3.5v2.757C2.474 7.079 2 8.154 2 9.333 2 11.906 4.243 14 7 14s5-2.094 5-4.667-2.243-4.666-5-4.666zm.625 5.726v1.274h-1.25v-1.274c-.726-.242-1.25-.884-1.25-1.643C5.125 7.785 5.966 7 7 7s1.875.785 1.875 1.75c0 .76-.524 1.401-1.25 1.643z",
        fill: "#C8C8C8"
      })]
    })
  }));
};

/* harmony default export */ var Unlock = (SvgUnlock);
;// CONCATENATED MODULE: ./components/Base/Icons/General/Url.js


function Url_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Url_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Url_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Url_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUrl = function SvgUrl(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Url_objectSpread(Url_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "#C8C8C8",
      fillRule: "nonzero",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.133 6.867l-.707-.707L7.84 4.746l.707.707a3.97 3.97 0 010 5.674l-1.68 1.68a3.97 3.97 0 01-5.674 0c-1.59-1.59-1.59-4.084.014-5.688L3.43 4.986 4.814 6.43l-.721.692-1.486 1.426c-.81.81-.81 2.036 0 2.846s2.036.81 2.846 0l1.68-1.68c.81-.81.81-2.036 0-2.846z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6.867 7.133l.707.707L6.16 9.254l-.707-.707a3.97 3.97 0 010-5.674l1.68-1.68a3.97 3.97 0 015.674 0c1.59 1.59 1.59 4.084-.014 5.688L10.57 9.014 9.186 7.57l.721-.692 1.486-1.426c.81-.81.81-2.036 0-2.846s-2.036-.81-2.846 0l-1.68 1.68c-.81.81-.81 2.036 0 2.846z"
      })]
    })
  }));
};

/* harmony default export */ var Url = (SvgUrl);
;// CONCATENATED MODULE: ./components/Base/Icons/General/User.js


function User_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function User_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? User_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : User_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", User_objectSpread(User_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.76 10.161l-3.124-.73V8.378c.978-.68 1.637-1.894 1.637-3.026V3.564c0-.841-.733-1.53-1.637-1.53h-.204l-.43-.803a.462.462 0 00-.561-.202l-2.574.962c-.63.235-1.14.94-1.14 1.573v1.788c0 1.132.66 2.346 1.637 3.026v1.053l-3.125.73c-.728.17-1.239.782-1.239 1.484V13h12v-1.355c0-.702-.511-1.313-1.24-1.484z",
      fill: "#C8C8C8"
    })
  }));
};

/* harmony default export */ var User = (SvgUser);
;// CONCATENATED MODULE: ./components/Base/Icons/Icon.js


function Icon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Icon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Icon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Icon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






































































function camelize(str) {
  str = str.replace('-', ' ');
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces

    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}
function capitalize(str) {
  return str[0].toUpperCase() + str.substring(1);
}

var Icon = function Icon(props) {
  var width = 14;
  var height = 14;

  if (props.size === 'md') {
    width = 20;
  }

  if (props.width) {
    width = props.width;
  }

  if (props.height) {
    height = props.height;
  } else {
    height = width;
  }

  var className = props.className ? props.className : '';

  if (props.color) {
    var color = "color".concat(capitalize(camelize(props.color)));
    className = (Icons_module_default())[color];
  }

  switch (props.name) {
    case 'AlignBottom':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AlignBottom, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'AlignBottomLeft':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AlignBottomLeft, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'AlignBottomRight':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AlignBottomRight, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'AlignTopLeft':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AlignTopLeft, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'AlignTopRight':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AlignTopRight, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'AlignCenter':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(AlignCenter, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Apparel':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Apparel, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'ArrowDown':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowDown, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'ArrowLongLeft':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowLongLeft, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Billing':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Billing, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Blog':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Blog, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Check':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Check, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Close':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Close, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Color':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Color, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Crop':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Crop, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Customizations':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Customizations, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'DeleteCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DeleteCircle, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Digital':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Digital, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Download':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Download, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Dribbble':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Dribbble, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Edit':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Edit, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Error':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Error, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Eye':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Eye, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Facebook':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Facebook, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Frame':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Frame, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'FourToThree':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FourToThree, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Google':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Google, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Image':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Image, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Inactive':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Inactive, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Integration':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Integration, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Instagram':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Instagram, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Lock':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Lock, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Linkedin':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Linkedin, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Mail':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Mail, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Menu':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Menu, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Minus':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Minus, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Move':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Move, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Payment':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Payment, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Password':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Password, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'People':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(People, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Play':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Play, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Play2':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PlayVideo, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Plus':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Plus, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Premium':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Premium, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Preferences':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Preferences, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Print':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Print, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Pro':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Pro, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'ProBadgeLeft':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProBadgeLeft, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'ProBadgeRight':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProBadgeRight, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Rotate':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Rotate, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'None':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(None, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'OneToOne':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(OneToOne, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Question':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Question, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'SixttenToNine':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SixttenToNine, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Search':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Search, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Thumb':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Thumb, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Team':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Team, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'TeamBadgeLeft':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TeamBadgeLeft, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'TeamBadgeRight':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TeamBadgeRight, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Trash':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Trash, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'TransformVertical':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TransformVertical, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Transparent':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Transparent, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Twitter':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Twitter, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Unlock':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Unlock, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Url':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Url, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'User':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(User, Icon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {});
  }
};

/* harmony default export */ var Icons_Icon = (Icon);

/***/ }),

/***/ 96673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TV": function() { return /* reexport */ Modal_ModalScroll; },
  "ZP": function() { return /* binding */ Modal_Modal; }
});

// UNUSED EXPORTS: ModalSplitContent

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Base/Modal/Modal.module.scss
var Modal_module = __webpack_require__(34875);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./components/Base/Icons/Icon.js + 66 modules
var Icon = __webpack_require__(54180);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/Base/Modal/ModalScroll.module.scss
var ModalScroll_module = __webpack_require__(18035);
var ModalScroll_module_default = /*#__PURE__*/__webpack_require__.n(ModalScroll_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Base/Modal/ModalScroll.js




var ModalScroll = function ModalScroll(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat(props.isPaddingDisabled ? (ModalScroll_module_default()).wrapperNoPadding : (ModalScroll_module_default()).wrapper, " ").concat(props.className && props.className),
    children: props.children
  });
};

/* harmony default export */ var Modal_ModalScroll = (ModalScroll);
;// CONCATENATED MODULE: ./components/Base/Modal/ModalSplitContent.js





var ModalSplitContent = function ModalSplitContent(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.left,
      children: props.imageComponent
    }), /*#__PURE__*/_jsx("div", {
      className: styles.right,
      children: props.children
    })]
  });
};

/* harmony default export */ var Modal_ModalSplitContent = ((/* unused pure expression or super */ null && (ModalSplitContent)));
;// CONCATENATED MODULE: ./components/Base/Modal/Modal.js









var Modal = function Modal(props) {
  var _useState = (0,react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  var _useState2 = (0,react.useState)(0),
      scrollbarWidth = _useState2[0],
      setScrollbarWidth = _useState2[1];

  (0,react.useEffect)(function () {
    setScrollbarWidth(getScrollbarWidth());

    if (props.isOpen) {
      setMounted(true);
      addBodyStyle();
    }

    return function () {
      removeBody();
    };
  }, [props.isOpen]);

  function getScrollbarWidth() {
    var _document = document,
        body = _document.body;
    var scrollDiv = document.createElement('div');
    var width = scrollbarWidth; // do this only if scrollbar is not already used

    if (body.offsetHeight < window.innerHeight) {
      // Append element with defined styling
      scrollDiv.setAttribute('style', 'width: 1337px; height: 1337px; position: absolute; left: -9999px; overflow: scroll;');
      body.appendChild(scrollDiv); // Collect width & height of scrollbar

      var calculateValue = function calculateValue(type) {
        return scrollDiv["offset".concat(type)] - scrollDiv["client".concat(type)];
      };

      width = calculateValue('Width'); // Remove element

      body.removeChild(scrollDiv);
    }

    return width;
  }

  var handleRequestClose = function handleRequestClose() {
    if (props.isOverlayClickDisabled) {
      return;
    }

    props.onClose();
  };

  function addBodyStyle() {
    document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
    document.body.style.overflow = 'hidden';
  }

  function removeBody() {
    document.body.style.paddingRight = '0';
    document.body.style.overflow = 'auto';
  }

  if (!mounted) return null;
  var modalClass;

  switch (props.size) {
    case "full":
      modalClass = (Modal_module_default()).modalFull;
      break;

    case "large":
      modalClass = (Modal_module_default()).modalLarge;
      break;

    case "medium":
      modalClass = (Modal_module_default()).modalMedium;
      break;

    case "small":
      modalClass = (Modal_module_default()).modalSmall;
      break;

    case "extraSmall":
      modalClass = (Modal_module_default()).modalExtraSmall;
      break;

    default:
      modalClass = (Modal_module_default()).modalMedium;
  }

  var bgClass = (Modal_module_default()).modalWhite;

  if (props.bg === 'black') {
    bgClass = (Modal_module_default()).modalBlack;
  }

  var modalCentered;
  var modalPushed;

  if (props.isCentered) {
    modalCentered = (Modal_module_default()).modalCentered;
    modalPushed = (Modal_module_default()).modalPushed;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((lib_default()), {
    appElement: document.body,
    isOpen: props.isOpen,
    contentLabel: props.modalLabel,
    onRequestClose: handleRequestClose,
    className: "".concat(modalClass, " ").concat(bgClass, " ").concat(modalPushed, " ").concat(props.className),
    overlayClassName: "".concat((Modal_module_default()).overlay, " ").concat(modalCentered),
    closeTimeoutMS: 300,
    style: {
      overlay: {
        paddingRight: "".concat(scrollbarWidth + 10, "px"),
        paddingLeft: "".concat(10, "px")
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: (Modal_module_default()).close,
      onClick: props.onClose,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "Close",
        size: "md"
      })
    }), props.children]
  });
};


/* harmony default export */ var Modal_Modal = (Modal);

/***/ }),

/***/ 58734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Headline_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58721);
/* harmony import */ var _Headline_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Headline_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_languageHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60540);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var Headline = function Headline(props) {
  var isSmallerHeadline = _utils_languageHelpers__WEBPACK_IMPORTED_MODULE_1__/* .SHORTER_LOCALES.indexOf */ .vS.indexOf(props.intl.locale) === -1;
  var titleClassName = "page-headline-sm";
  var subtitleClassName = "page-headline-lg ".concat((_Headline_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle));

  if (props.design === 'blue') {
    titleClassName = "page-headline-sm ".concat((_Headline_module_scss__WEBPACK_IMPORTED_MODULE_3___default().titleBlue));
    subtitleClassName = "page-headline-lg ".concat((_Headline_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitleBlue));
  }

  if (props.design === 'inverse') {
    titleClassName = "page-headline-sm ".concat((_Headline_module_scss__WEBPACK_IMPORTED_MODULE_3___default().titleInverse));
    subtitleClassName = "page-headline-lg ".concat((_Headline_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitleInverse));
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h3", {
      className: titleClassName,
      children: props.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
      className: "".concat(subtitleClassName, " ").concat(isSmallerHeadline ? "page-headline-lg-smaller" : ''),
      children: props.subtitle
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Headline));

/***/ }),

/***/ 50226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MarketingIcon_MarketingIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/FeatureList.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgFeatureList = function SvgFeatureList(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#A2E6FF",
        opacity: 0.2,
        cx: 10,
        cy: 10,
        r: 10
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M4.857 10.171l1.029-1.028 2.571 1.543 5.657-4.115L15.143 7.6l-6.686 6.686z",
        fill: "#F60",
        fillRule: "nonzero"
      })]
    })
  }));
};

/* harmony default export */ var FeatureList = (SvgFeatureList);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/FeatureListNotAvailable.js


function FeatureListNotAvailable_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FeatureListNotAvailable_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FeatureListNotAvailable_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FeatureListNotAvailable_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgFeatureListNotAvailable = function SvgFeatureListNotAvailable(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", FeatureListNotAvailable_objectSpread(FeatureListNotAvailable_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#F2F2F2",
        cx: 15,
        cy: 15,
        r: 15
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M19.035 10.965a.856.856 0 00-1.21 0l-2.82 2.82-2.819-2.82a.856.856 0 00-1.21 1.21l2.819 2.82-2.82 2.819a.856.856 0 101.211 1.21l2.82-2.819 2.819 2.82a.856.856 0 001.21-1.211l-2.82-2.82 2.82-2.819a.856.856 0 000-1.21z",
        fill: "#FF001F"
      })]
    })
  }));
};

/* harmony default export */ var FeatureListNotAvailable = (SvgFeatureListNotAvailable);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/CanvaCircle.js


function CanvaCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CanvaCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CanvaCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CanvaCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCanvaCircle = function SvgCanvaCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", CanvaCircle_objectSpread(CanvaCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "10 0 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      id: "Canva",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "60",
        cy: "50",
        r: "55",
        fill: "#ECFAFF",
        stroke: "white",
        strokeWidth: "10"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
        fill: "#7D2AE7"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
        fill: "url(#paint0_radial_1_594)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
        fill: "url(#paint1_radial_1_594)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
        fill: "url(#paint2_radial_1_594)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
        fill: "url(#paint3_radial_1_594)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M75.9523 51.0964C75.8986 51.0964 75.8508 51.1324 75.827 51.2039C75.5026 52.1273 75.0647 52.6785 74.7045 52.6785C74.4976 52.6785 74.414 52.4477 74.414 52.0854C74.414 51.182 74.9573 49.2636 75.2279 48.388C75.2599 48.2977 75.278 48.2031 75.2818 48.1074C75.2818 47.8527 75.1424 47.7273 74.7982 47.7273C74.4538 47.7273 74.026 47.8746 73.6399 48.5552C73.5045 47.9542 73.0986 47.6915 72.5315 47.6915C71.8767 47.6915 71.2439 48.1134 70.7224 48.796C70.2011 49.4785 69.5902 49.7054 69.1285 49.594C69.4607 48.784 69.5822 48.177 69.5822 47.7273C69.5822 47.0208 69.234 46.595 68.6708 46.595C67.8129 46.595 67.3194 47.4129 67.3194 48.2726C67.3194 48.9372 67.6201 49.6218 68.2847 49.9542C67.7293 51.2098 66.9175 52.3462 66.6091 52.3462C66.211 52.3462 66.0935 50.3999 66.1175 49.0069C66.1293 48.2089 66.1971 48.1671 66.1971 47.9243C66.1971 47.787 66.1055 47.6915 65.7453 47.6915C64.9036 47.6915 64.6409 48.4059 64.603 49.2258C64.5885 49.5367 64.5399 49.845 64.4578 50.1452C64.1036 51.4029 63.3792 52.3561 62.9055 52.3561C62.6847 52.3561 62.627 52.1353 62.627 51.8488C62.627 50.9452 63.1325 49.8129 63.1325 48.8497C63.1325 48.1392 62.822 47.6915 62.2348 47.6915C61.5464 47.6915 60.6329 48.5134 59.7692 50.0497C60.0538 48.8736 60.1692 47.7333 59.3294 47.7333C59.1467 47.7361 58.9672 47.7825 58.806 47.8686C58.6906 47.9283 58.6289 48.0357 58.6369 48.1552C58.7165 49.4109 57.6259 52.6208 56.5911 52.6208C56.4021 52.6208 56.3125 52.4178 56.3125 52.0875C56.3125 51.1839 56.8518 49.2696 57.1225 48.392C57.1554 48.2965 57.1736 48.1965 57.1762 48.0954C57.1762 47.8566 57.0289 47.7333 56.6926 47.7333C56.3225 47.7333 55.9225 47.8746 55.5344 48.5552C55.3991 47.9542 54.9931 47.6915 54.4279 47.6915C53.4986 47.6915 52.4578 48.6746 52.002 49.9581C51.3911 51.6696 50.1592 53.3214 48.5015 53.3214C46.9971 53.3214 46.203 52.0696 46.203 50.0935C46.203 47.2357 48.3005 44.9034 49.8548 44.9034C50.5991 44.9034 50.9533 45.377 50.9533 46.1034C50.9533 46.983 50.4637 47.391 50.4637 47.7253C50.4637 47.8268 50.5473 47.9283 50.7165 47.9283C51.3931 47.9283 52.1871 47.1343 52.1871 46.0517C52.1871 44.9691 51.3095 44.175 49.7533 44.175C47.1841 44.175 44.597 46.7621 44.597 50.0756C44.597 52.7124 45.8985 54.3025 48.1473 54.3025C49.6816 54.3025 51.0229 53.1105 51.7473 51.7153C51.8289 52.8715 52.3523 53.4726 53.1503 53.4726C53.8607 53.4726 54.4359 53.0507 54.8757 52.3065C55.0448 53.0846 55.4926 53.4667 56.0757 53.4667C56.7443 53.4667 57.3016 53.0427 57.8329 52.2566C57.8249 52.8736 57.9662 53.4547 58.5016 53.4547C58.7543 53.4547 59.0568 53.397 59.1105 53.1761C59.6717 50.8457 61.0668 48.9432 61.4927 48.9432C61.618 48.9432 61.6519 49.0626 61.6519 49.2079C61.6519 49.8407 61.206 51.1382 61.206 51.966C61.206 52.8635 61.5862 53.4547 62.3723 53.4547C63.2439 53.4547 64.1293 52.3879 64.7205 50.8278C64.9055 52.2846 65.3055 53.4606 65.9285 53.4606C66.6965 53.4606 68.0599 51.8467 68.8856 50.1353C69.2081 50.177 69.6957 50.1671 70.1613 49.8368C69.9643 50.3402 69.8468 50.8915 69.8468 51.4408C69.8468 53.0288 70.603 53.4726 71.2559 53.4726C71.9662 53.4726 72.5413 53.0507 72.9811 52.3065C73.1264 52.977 73.4965 53.4646 74.1792 53.4646C75.2458 53.4646 76.1731 52.374 76.1731 51.4785C76.1731 51.2418 76.0717 51.0964 75.9523 51.0964ZM53.803 52.5949C53.3712 52.5949 53.202 52.1591 53.202 51.5124C53.202 50.39 53.9702 48.5114 54.7841 48.5114C55.1384 48.5114 55.2737 48.9313 55.2737 49.4427C55.2737 50.583 54.5433 52.5949 53.803 52.5949ZM68.5653 49.2397C68.3085 48.9333 68.215 48.5154 68.215 48.1452C68.215 47.6875 68.3822 47.3014 68.5832 47.3014C68.7841 47.3014 68.8439 47.4984 68.8439 47.7731C68.8439 48.2308 68.6807 48.9034 68.5653 49.2397ZM71.9066 52.5949C71.4767 52.5949 71.3074 52.0955 71.3074 51.5124C71.3074 50.4278 72.0757 48.5114 72.8957 48.5114C73.2498 48.5114 73.3771 48.9253 73.3771 49.4427C73.3771 50.583 72.6588 52.5949 71.9066 52.5949Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
          id: "paint0_radial_1_594",
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(47.7263 65.4526) rotate(-49.4156) scale(30.9366)",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            stopColor: "#6420FF"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            offset: "1",
            stopColor: "#6420FF",
            stopOpacity: "0"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
          id: "paint1_radial_1_594",
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(50.5895 34.5474) rotate(54.7035) scale(34.8867)",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            stopColor: "#00C4CC"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            offset: "1",
            stopColor: "#00C4CC",
            stopOpacity: "0"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
          id: "paint2_radial_1_594",
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(47.7263 65.4526) rotate(-45.1954) scale(30.5621 14.0559)",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            stopColor: "#6420FF"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            offset: "1",
            stopColor: "#6420FF",
            stopOpacity: "0"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
          id: "paint3_radial_1_594",
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(56.3579 35.3895) rotate(66.5198) scale(31.4918 52.7558)",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            stopColor: "#00C4CC",
            stopOpacity: "0.725916"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            offset: "0.0001",
            stopColor: "#00C4CC"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            offset: "1",
            stopColor: "#00C4CC",
            stopOpacity: "0"
          })]
        })]
      })]
    })
  }));
};

/* harmony default export */ var CanvaCircle = (SvgCanvaCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Canva.js


function Canva_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Canva_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Canva_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Canva_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCanva = function SvgCanva(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Canva_objectSpread(Canva_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 -1 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 50,
        cy: 50,
        r: 49,
        fill: "#20C4CB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M62.65 58.163c-1.986 2.176-4.772 3.278-6.078 3.278-1.509 0-2.334-.926-2.504-2.315a5.73 5.73 0 01.056-1.6c.499-3.115 1.645-5.051 1.574-5.64-.021-.169-.116-.253-.241-.253-.965 0-4.352 3.494-4.866 5.81l-.4 1.852c-.262 1.305-1.542 2.146-2.421 2.146-.42 0-.74-.21-.796-.673a1.998 1.998 0 01.05-.632l.188-.976c-1.826 1.365-3.796 2.287-4.718 2.287-1.258 0-1.968-.673-2.217-1.684-.831 1.095-1.932 1.684-3.106 1.684-1.498 0-2.94-.99-3.634-2.458-.987 1.109-2.158 2.193-3.556 3.09-2.062 1.305-4.364 2.357-7.088 2.357-2.516 0-4.651-1.347-5.832-2.441-1.752-1.642-2.679-4.084-2.951-6.315-.86-7.03 3.42-16.25 10.051-20.29 1.522-.927 3.226-1.39 4.776-1.39 3.186 0 5.564 2.28 5.897 5.003.3 2.455-.682 4.574-3.402 5.947-1.39.703-2.078.67-2.295.335-.145-.224-.063-.602.217-.836 2.558-2.138 2.607-3.892 2.305-6.366-.195-1.59-1.242-2.61-2.415-2.61-5.03 0-12.243 11.282-11.24 19.491.391 3.2 2.353 6.904 6.377 6.904 1.341 0 2.762-.379 4.026-1.01 2.207-1.128 3.454-2.02 4.708-3.48-.307-3.796 2.95-8.56 7.794-8.56 2.095 0 3.833.842 4.039 2.526.257 2.104-1.536 2.526-2.207 2.526-.587 0-1.53-.169-1.596-.716-.072-.59 1.269-.252 1.104-1.6-.103-.841-.977-1.136-1.816-1.136-3.018 0-4.683 4.21-4.364 6.82.144 1.179.75 2.357 1.84 2.357.88 0 2.15-1.263 2.636-3.115.307-1.263 1.504-2.105 2.384-2.105.461 0 .78.21.837.673.02.169.004.38-.049.632-.1.547-.52 2.368-.501 2.746.015.329.204.78.774.78.453 0 2.115-.898 3.655-2.28.484-2.501 1.081-5.591 1.127-5.835.188-1.013.551-2.056 2.605-2.056.42 0 .739.21.8.715.02.168.005.38-.048.631l-.574 2.599c1.802-2.4 4.604-4.167 6.28-4.167.714 0 1.263.378 1.356 1.136.051.421-.071 1.137-.35 1.937-.597 1.641-1.268 4.107-1.712 6.23-.095.45.062 1.132.887 1.132.658 0 2.774-.806 4.482-3.062a28.27 28.27 0 01-.016-.97c0-1.768.125-3.199.46-4.251.335-1.095 1.72-2.146 2.641-2.146.462 0 .797.252.797.757 0 .169-.042.38-.126.589-.629 1.852-.964 3.579-.964 5.305 0 .968.21 2.526.42 3.325.041.169.082.337.25.337.294 0 2.264-1.936 3.689-4.294-1.258-.8-1.97-2.273-1.97-4.084 0-3.03 1.803-4.588 3.563-4.588 1.384 0 2.641 1.01 2.641 3.03 0 1.264-.503 2.695-1.215 4.085 0 0 .293.042.418.042 1.09 0 1.928-.506 2.39-1.053.21-.237.404-.425.591-.532 1.404-1.696 3.46-2.92 5.874-2.92 2.054 0 3.828.8 4.033 2.484.263 2.146-1.57 2.568-2.2 2.568-.628 0-1.572-.169-1.638-.716-.067-.547 1.31-.252 1.15-1.557-.102-.843-.981-1.179-1.82-1.179-2.809 0-4.74 3.746-4.369 6.778.149 1.22.712 2.4 1.802 2.4.88 0 2.194-1.264 2.68-3.116.312-1.221 1.502-2.105 2.383-2.105.419 0 .78.21.842.716.031.253-.07.8-.54 2.778-.191.842-.23 1.558-.158 2.147.15 1.22.709 2.02 1.226 2.484.189.168.298.378.314.505.04.336-.216.631-.636.631-.126 0-.293 0-.43-.084-2.16-.884-3.054-2.357-3.308-3.746-.834 1.052-1.937 1.641-3.068 1.641-1.929 0-3.812-1.684-4.079-3.873-.11-.9-.001-1.865.293-2.815-.782.484-1.625.752-2.38.752-.252 0-.46 0-.712-.041-1.886 2.735-3.857 4.63-5.366 5.472-.628.337-1.214.505-1.634.505-.336 0-.713-.083-.88-.379-.384-.65-.644-1.687-.797-2.905zm6.832-8.966c0 1.18.586 2.4 1.34 3.2.295-.8.462-1.6.462-2.4 0-1.516-.587-2.19-1.048-2.19-.545 0-.754.758-.754 1.39z",
        fill: "#FFF"
      })]
    })
  }));
};

/* harmony default export */ var Canva = (SvgCanva);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/DropboxCircle.js


function DropboxCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DropboxCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DropboxCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DropboxCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDropboxCircle = function SvgDropboxCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", DropboxCircle_objectSpread(DropboxCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#A2E6FF",
        opacity: 0.2,
        cx: 50,
        cy: 50,
        r: 50
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M50 40.5L40 47l10 6.5L40 60l-10-6.554 10-6.5L30 40.5 40 34l10 6.5zM40 62l10-6 10 6-10 6-10-6zm10-8.554l10.027-6.5L50 40.5l9.973-6.5L70 40.5 59.973 47 70 53.5 59.973 60 50 53.446z",
        fill: "#0061FF",
        fillRule: "nonzero"
      })]
    })
  }));
};

/* harmony default export */ var DropboxCircle = (SvgDropboxCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Dropbox.js


function Dropbox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Dropbox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Dropbox_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Dropbox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDropbox = function SvgDropbox(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Dropbox_objectSpread(Dropbox_objectSpread({
    id: "Dropbox_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 235.45 200",
    width: "1em",
    height: "1em"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("style", {
        children: '.Dropbox_svg__cls-1{fill:#0061ff}'
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "Dropbox_svg__cls-1",
      d: "M58.86 0L0 37.5 58.86 75l58.87-37.5L58.86 0zM176.59 0l-58.86 37.5L176.59 75l58.86-37.5L176.59 0zM0 112.5L58.86 150l58.87-37.5L58.86 75 0 112.5zM176.59 75l-58.86 37.5 58.86 37.5 58.86-37.5L176.59 75zM58.86 162.5l58.87 37.5 58.86-37.5-58.86-37.5-58.87 37.5z"
    })]
  }));
};

/* harmony default export */ var Dropbox = (SvgDropbox);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/UnsplashCircle.js


function UnsplashCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UnsplashCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UnsplashCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UnsplashCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUnsplashCircle = function SvgUnsplashCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", UnsplashCircle_objectSpread(UnsplashCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#A2E6FF",
        opacity: 0.2,
        cx: 50,
        cy: 50,
        r: 50
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M68 47.1V68H30V47.1h11.4v11.4h15.205V47.1H68zM56.6 30h-.047v9.5H41.4V30h15.2z",
        fill: "#000"
      })]
    })
  }));
};

/* harmony default export */ var UnsplashCircle = (SvgUnsplashCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/SoonCircle.js


function SoonCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SoonCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SoonCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SoonCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgSoonCircle = function SvgSoonCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", SoonCircle_objectSpread(SoonCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 102 102"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M51 101c27.614 0 50-22.386 50-50S78.614 1 51 1 1 23.386 1 51s22.386 50 50 50z",
        stroke: "#C8C8C8",
        fill: "#FFF",
        strokeDasharray: "10,10"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M49.429 49.429v-6.286h3.142v6.286h6.286v3.142h-6.286v6.286H49.43v-6.286h-6.286V49.43h6.286z",
        fill: "#C8C8C8"
      })]
    })
  }));
};

/* harmony default export */ var SoonCircle = (SvgSoonCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/DownloadCircle.js


function DownloadCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DownloadCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DownloadCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DownloadCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDownloadCircle = function SvgDownloadCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", DownloadCircle_objectSpread(DownloadCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#A2E6FF",
        opacity: 0.2,
        cx: 50,
        cy: 50,
        r: 50
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M63.75 40c.691 0 1.25.559 1.25 1.25v22.5c0 .691-.559 1.25-1.25 1.25h-27.5c-.691 0-1.25-.559-1.25-1.25v-27.5c0-.691.559-1.25 1.25-1.25h10c.393 0 .764.185 1 .5l3.375 4.5H63.75zM55 50.732l-3.75 3.75V45h-2.5v9.482L45 50.732 43.232 52.5l5.884 5.883a1.249 1.249 0 001.768 0l5.883-5.883L55 50.732z",
        fillRule: "nonzero",
        fill: "#00BAFF"
      })]
    })
  }));
};

/* harmony default export */ var DownloadCircle = (SvgDownloadCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/PlaceholderCircle.js


function PlaceholderCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlaceholderCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlaceholderCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlaceholderCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPlaceholderCircle = function SvgPlaceholderCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", PlaceholderCircle_objectSpread(PlaceholderCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#A2E6FF",
        opacity: 0.2,
        cx: 50,
        cy: 50,
        r: 50
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M63.75 55.786h-1.975l-2.25-11.572H60c.69 0 1.25-.575 1.25-1.285v-5.143c0-.71-.56-1.286-1.25-1.286h-5c-.69 0-1.25.576-1.25 1.286v1.285h-7.5v-1.285c0-.71-.56-1.286-1.25-1.286h-5c-.69 0-1.25.576-1.25 1.286v5.143c0 .71.56 1.285 1.25 1.285h.475l-2.25 11.572H36.25c-.69 0-1.25.575-1.25 1.285v5.143c0 .71.56 1.286 1.25 1.286h5c.69 0 1.25-.576 1.25-1.286V60.93h15v1.285c0 .71.56 1.286 1.25 1.286h5c.69 0 1.25-.576 1.25-1.286v-5.143c0-.71-.56-1.285-1.25-1.285zM42.5 58.357v-1.286c0-.71-.56-1.285-1.25-1.285h-.475l2.25-11.572H45c.69 0 1.25-.575 1.25-1.285v-1.286h7.5v1.286c0 .71.56 1.285 1.25 1.285h1.975l2.25 11.572h-.475c-.69 0-1.25.575-1.25 1.285v1.286h-15z",
        fill: "#00BAFF",
        fillRule: "nonzero"
      })]
    })
  }));
};

/* harmony default export */ var PlaceholderCircle = (SvgPlaceholderCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/SettingsCircle.js


function SettingsCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SettingsCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SettingsCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SettingsCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgSettingsCircle = function SvgSettingsCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", SettingsCircle_objectSpread(SettingsCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#A2E6FF",
        opacity: 0.2,
        cx: 50,
        cy: 50,
        r: 50
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M41.25 48.75h-2.5v-12.5a1.25 1.25 0 012.5 0v12.5zm10-10h-2.5v-2.5a1.25 1.25 0 012.5 0v2.5zm10 10h-2.5v-12.5a1.25 1.25 0 012.5 0v12.5zM40 51.25c2.758 0 5 2.242 5 5 0 2.323-1.6 4.264-3.75 4.823v2.677a1.25 1.25 0 01-2.5 0v-2.677c-2.15-.56-3.75-2.5-3.75-4.823 0-2.758 2.242-5 5-5zm15-5c0 2.322-1.6 4.264-3.75 4.823V63.75a1.25 1.25 0 01-2.5 0V51.073c-2.15-.56-3.75-2.5-3.75-4.823 0-2.758 2.242-5 5-5s5 2.242 5 5zm10 10c0 2.323-1.6 4.264-3.75 4.823v2.677a1.25 1.25 0 01-2.5 0v-2.677c-2.15-.56-3.75-2.5-3.75-4.823 0-2.758 2.242-5 5-5s5 2.242 5 5z",
        fillRule: "nonzero",
        fill: "#00BAFF"
      })]
    })
  }));
};

/* harmony default export */ var SettingsCircle = (SvgSettingsCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/DragCircle.js


function DragCircle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DragCircle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DragCircle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DragCircle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDragCircle = function SvgDragCircle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", DragCircle_objectSpread(DragCircle_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#A2E6FF",
        opacity: 0.2,
        cx: 50,
        cy: 50,
        r: 50
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M37.823 43.056H35V36h7.056v2.823h-4.233v4.233zm4.233 21.17H35v-7.057h2.823v4.234h4.233v2.823zm21.17-21.17h-2.823v-4.233H56.17V36h7.057v7.056zM46.29 36h5.645v2.823H46.29V36zm0 25.403h5.645v2.823H46.29v-2.823zM60.403 47.29h2.823v5.645h-2.823V47.29zM35 47.29h2.823v5.645H35V47.29zm35 12.42l-5.645 2.822L70 68.177 67.177 71l-5.645-5.645L58.71 71l-4.234-15.524L70 59.71z",
        fillRule: "nonzero",
        fill: "#00BAFF"
      })]
    })
  }));
};

/* harmony default export */ var DragCircle = (SvgDragCircle);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Branding.js


function Branding_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Branding_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Branding_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Branding_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgBranding = function SvgBranding(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Branding_objectSpread(Branding_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "35.976%",
        y1: "0%",
        x2: "100%",
        y2: "100%",
        id: "Branding_svg__a",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FFF",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#DCDCDC",
          offset: "100%"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "100%",
        id: "Branding_svg__b",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#3023AE",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#B96DD7",
          offset: "100%"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        fill: "url(#Branding_svg__a)",
        fillRule: "nonzero",
        x: 3,
        y: 42,
        width: 54,
        height: 18,
        rx: 4
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5.306 43.552l31.886-31.887a4 4 0 015.657 0l8.48 8.48a4 4 0 01-.006 5.663L21.106 55.903a4 4 0 01-5.024.506L5.933 49.72a4 4 0 01-.627-6.168z",
        fill: "#C8C8C8",
        fillRule: "nonzero",
        opacity: 0.5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        fill: "#FFF",
        fillRule: "nonzero",
        transform: "rotate(-45 28 32)",
        x: 1,
        y: 22,
        width: 54,
        height: 20,
        rx: 4
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "rotate(-45 52.97 -3.314)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          fill: "#4335B5",
          x: 24,
          width: 8,
          height: 8,
          rx: 2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          fill: "#9A61CB",
          x: 12,
          width: 8,
          height: 8,
          rx: 2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          fill: "#B069D5",
          width: 8,
          height: 8,
          rx: 2
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        fill: "url(#Branding_svg__b)",
        fillRule: "nonzero",
        x: 3,
        y: 6,
        width: 20,
        height: 54,
        rx: 4
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9.616 41.5v-1.604h5.492v-3.475h1.276V41.5H9.616zm6.884-9.218c0 .72-.151 1.368-.454 1.946a3.42 3.42 0 01-1.252 1.356c-.532.327-1.13.49-1.794.49a3.357 3.357 0 01-1.794-.49 3.42 3.42 0 01-1.252-1.356c-.303-.578-.454-1.226-.454-1.946s.151-1.366.454-1.94a3.465 3.465 0 011.252-1.357A3.332 3.332 0 0113 28.49c.664 0 1.262.165 1.794.495.531.33.949.782 1.252 1.357.303.574.454 1.22.454 1.94zm-1.334 0c0-.41-.092-.779-.276-1.109-.184-.33-.44-.589-.768-.777A2.217 2.217 0 0013 30.114c-.419 0-.793.094-1.122.282a2.001 2.001 0 00-.768.777c-.184.33-.276.7-.276 1.11 0 .408.092.778.276 1.108.184.33.44.59.768.777.33.188.703.282 1.122.282.419 0 .793-.094 1.122-.282.328-.188.584-.447.768-.777.184-.33.276-.7.276-1.109zM12.894 22.6v-1.465h2.746c.277.376.49.812.638 1.307.148.495.222.993.222 1.495 0 .72-.15 1.366-.45 1.94a3.395 3.395 0 01-1.247 1.352 3.375 3.375 0 01-1.803.49c-.67 0-1.271-.164-1.803-.49a3.379 3.379 0 01-1.247-1.362c-.3-.58-.45-1.234-.45-1.96 0-.607.1-1.158.3-1.654.2-.495.49-.91.87-1.247l.928 1.03a2.408 2.408 0 00-.764 1.792c0 .442.09.835.271 1.178.18.343.435.61.764.802.329.191.706.287 1.131.287.419 0 .793-.096 1.122-.287.328-.191.584-.457.768-.797.184-.34.276-.728.276-1.163a2.65 2.65 0 00-.29-1.248h-1.982zm3.606-6.307c0 .72-.151 1.368-.454 1.946a3.42 3.42 0 01-1.252 1.356c-.532.327-1.13.49-1.794.49a3.357 3.357 0 01-1.794-.49 3.42 3.42 0 01-1.252-1.356c-.303-.578-.454-1.226-.454-1.946s.151-1.366.454-1.94a3.465 3.465 0 011.252-1.357A3.332 3.332 0 0113 12.5c.664 0 1.262.165 1.794.495.531.33.949.782 1.252 1.356.303.575.454 1.222.454 1.941zm-1.334 0c0-.41-.092-.779-.276-1.109-.184-.33-.44-.589-.768-.777A2.217 2.217 0 0013 14.124c-.419 0-.793.094-1.122.282a2.001 2.001 0 00-.768.777c-.184.33-.276.7-.276 1.11 0 .408.092.778.276 1.108.184.33.44.59.768.777.33.188.703.282 1.122.282.419 0 .793-.094 1.122-.282.328-.188.584-.447.768-.777.184-.33.276-.7.276-1.109z",
        fill: "#FFF",
        fillRule: "nonzero"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#FFF",
        cx: 13,
        cy: 50,
        r: 3
      })]
    })]
  }));
};

/* harmony default export */ var Branding = (SvgBranding);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Custom.js


function Custom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Custom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Custom_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Custom_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCustom = function SvgCustom(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Custom_objectSpread(Custom_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "100%",
        y1: "100%",
        x2: "0%",
        y2: "0%",
        id: "Custom_svg__a",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FFF",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#DCDCDC",
          offset: "100%"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "0%",
        y1: "100%",
        x2: "80.957%",
        y2: "19.043%",
        id: "Custom_svg__b",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#0034F2",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#00BAFF",
          offset: "100%"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        id: "Custom_svg__c",
        x: 16,
        y: 16,
        width: 26,
        height: 39,
        rx: 2
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(8 2)",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        fill: "url(#Custom_svg__a)",
        fillRule: "nonzero",
        width: 26,
        height: 39,
        rx: 2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
        fill: "url(#Custom_svg__b)",
        style: {
          mixBlendMode: 'multiply'
        },
        xlinkHref: "#Custom_svg__c"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        stroke: "#FFF",
        strokeWidth: 3,
        x: 14.5,
        y: 14.5,
        width: 29,
        height: 42,
        rx: 2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        stroke: "#FFF",
        strokeWidth: 3,
        fill: "#00BAFF",
        fillRule: "nonzero",
        cx: 42,
        cy: 16,
        r: 4.5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        stroke: "#FFF",
        strokeWidth: 3,
        fill: "#00BAFF",
        fillRule: "nonzero",
        cx: 42,
        cy: 55,
        r: 4.5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        stroke: "#FFF",
        strokeWidth: 3,
        fill: "#00BAFF",
        fillRule: "nonzero",
        cx: 16,
        cy: 16,
        r: 4.5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        stroke: "#FFF",
        strokeWidth: 3,
        fill: "#00BAFF",
        fillRule: "nonzero",
        cx: 16,
        cy: 55,
        r: 4.5
      })]
    })]
  }));
};

/* harmony default export */ var Custom = (SvgCustom);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Expire.js


function Expire_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Expire_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Expire_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Expire_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgExpire = function SvgExpire(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Expire_objectSpread(Expire_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("text", {
      fill: "#000",
      fillRule: "evenodd",
      fontFamily: "AppleColorEmoji, Apple Color Emoji",
      fontSize: 50,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("tspan", {
        x: 5,
        y: 50,
        children: "\uD83D\uDE80"
      })
    })
  }));
};

/* harmony default export */ var Expire = (SvgExpire);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Logo.js


function Logo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Logo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Logo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Logo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Logo_objectSpread(Logo_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "46.851%",
        y1: "85.476%",
        x2: "55.078%",
        y2: "16.671%",
        id: "Logo_svg__a",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#626262",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "100%"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "46.851%",
        y1: "85.476%",
        x2: "55.078%",
        y2: "16.671%",
        id: "Logo_svg__b",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#00BAFF",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#009AD3",
          offset: "100%"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "46.851%",
        y1: "85.476%",
        x2: "55.078%",
        y2: "16.671%",
        id: "Logo_svg__c",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FFF",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#DCDCDC",
          offset: "100%"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M2.043 34.063l23.023-9.639c2.724-1.296 7.142-1.296 9.866 0l23.022 9.639c2.725 1.296 2.725 4.714 0 6.01L34.932 51.027c-2.724 1.296-7.142 1.296-9.866 0L2.043 40.073c-2.724-1.296-2.724-4.714 0-6.01z",
        fill: "url(#Logo_svg__a)",
        style: {
          mixBlendMode: 'multiply'
        },
        transform: "translate(0 8)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M2.043 22.337l23.023-9.639c2.724-1.296 7.142-1.296 9.866 0l23.022 9.639c2.725 1.296 2.725 4.714 0 6.01L34.932 39.301c-2.724 1.296-7.142 1.296-9.866 0L2.043 28.347c-2.724-1.296-2.724-4.714 0-6.01z",
        fill: "url(#Logo_svg__b)",
        transform: "translate(0 8)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M2.043 10.611L25.066.972c2.724-1.296 7.142-1.296 9.866 0l23.022 9.64c2.725 1.295 2.725 4.713 0 6.009L34.932 27.575c-2.724 1.297-7.142 1.297-9.866 0L2.043 16.621c-2.724-1.296-2.724-4.714 0-6.01z",
        fill: "url(#Logo_svg__c)",
        opacity: 0.169,
        transform: "translate(0 8)"
      })]
    })]
  }));
};

/* harmony default export */ var Logo = (SvgLogo);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Premium.js


function Premium_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Premium_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Premium_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Premium_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPremium = function SvgPremium(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Premium_objectSpread(Premium_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "100%",
        y1: "0%",
        x2: "0%",
        y2: "100%",
        id: "Premium_svg__a",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FFCB72",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#7E4E13",
          offset: "100%"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M54.687 11.262h-.001A5.234 5.234 0 0160 16.516c0 2.918-2.367 5.253-5.217 5.253-.242 0-.435 0-.628-.048l-1.981 19.555A3.002 3.002 0 0149.179 44H10.82a3.002 3.002 0 01-2.995-2.724L5.846 21.72c-.194.048-.435.048-.629.048C2.32 21.77 0 19.386 0 16.516c0-2.968 2.367-5.303 5.314-5.254 2.85.049 5.17 2.578 5.073 5.448-.049 1.557-.822 2.968-1.981 3.892 5.99 8.075 12.078 8.707 19.13-4.67-2.511-1.265-3.912-4.476-2.077-7.686.918-1.557 2.657-2.287 4.445-2.238h.193c1.787-.097 3.575.681 4.444 2.238 1.836 3.21.435 6.421-2.077 7.686 7.054 13.377 13.14 12.745 19.131 4.67-1.16-.924-1.932-2.286-1.98-3.892-.146-2.87 2.221-5.4 5.072-5.448zM11 47h38a2 2 0 012 2v2a2 2 0 01-2 2H11a2 2 0 01-2-2v-2a2 2 0 012-2z",
      fill: "url(#Premium_svg__a)",
      fillRule: "evenodd"
    })]
  }));
};

/* harmony default export */ var Premium = (SvgPremium);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/Icons/Video.js


function Video_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Video_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Video_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Video_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Video_objectSpread(Video_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M54 18H6v-2.4c0-1.988 1.79-3.6 4-3.6h40c2.21 0 4 1.612 4 3.6V18z",
        fill: "#0061FF",
        opacity: 0.5
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M48 12H12v-2c0-1.657 1.727-3 3.857-3h28.286C46.273 7 48 8.343 48 10v2z",
        fill: "#0061FF",
        opacity: 0.2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M55.91 18H4.09C1.833 18 0 19.763 0 21.938v34.124C0 58.237 1.832 60 4.09 60h51.82c2.258 0 4.09-1.763 4.09-3.938V21.938C60 19.762 58.168 18 55.91 18z",
        fill: "#0061FF"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M39.393 40.63L27.12 48.771a1.37 1.37 0 01-1.4.068 1.356 1.356 0 01-.72-1.197V31.357c0-.5.277-.96.72-1.196a1.37 1.37 0 011.4.067l12.273 8.143a1.355 1.355 0 010 2.258z",
        fill: "#FFF"
      })]
    })
  }));
};

/* harmony default export */ var Video = (SvgVideo);
;// CONCATENATED MODULE: ./components/Marketing/MarketingIcon/MarketingIcon.js


function MarketingIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MarketingIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MarketingIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MarketingIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var MarketingIcon = function MarketingIcon(props) {
  var width = 20;
  var height = 20;

  if (props.width) {
    width = props.width;
  }

  if (props.height) {
    height = props.height;
  } else {
    height = width;
  }

  var className = props.className ? props.className : '';

  switch (props.name) {
    case 'Branding':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Branding, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'CanvaCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CanvaCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Canva':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Canva, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'CustomMockups':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Custom, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'DownloadCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'DragCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DragCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'DropboxCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DropboxCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Dropbox':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Dropbox, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Expire':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Expire, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'FeatureList':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureList, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'FeatureListNotAvailable':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureListNotAvailable, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Logo':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Premium':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Premium, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'PlaceholderCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PlaceholderCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'SoonCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SoonCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'SettingsCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SettingsCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'UnsplashCircle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(UnsplashCircle, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Url':
      return /*#__PURE__*/(0,jsx_runtime.jsx)("url", MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    case 'Video':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Video, MarketingIcon_objectSpread({
        width: width,
        height: height,
        className: className
      }, props));

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {});
  }
};

/* harmony default export */ var MarketingIcon_MarketingIcon = (MarketingIcon);

/***/ }),

/***/ 10405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var TrustpilotWidget = function TrustpilotWidget(props) {
  var type = props.type;
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var widgetType = {
    microCombo: {
      id: "5419b6ffb0d04a076446a9af",
      height: "20px"
    },
    horizontal: {
      id: "5406e65db0d04a09e042d5fc",
      height: "28px"
    },
    carousel: {
      id: "53aa8912dec7e10d38f59f36",
      height: "140px"
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      ref: ref,
      className: "trustpilot-widget",
      "data-locale": "en-US",
      "data-template-id": widgetType[type].id,
      "data-businessunit-id": "5def7326490bc20001d76883",
      "data-style-height": widgetType[type].height,
      "data-style-width": "100%",
      "data-theme": "light",
      "data-tags": "SelectedReview",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        href: "https://www.trustpilot.com/review/smartmockups.com",
        target: "_blank",
        rel: "noreferrer",
        children: "Trustpilot"
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TrustpilotWidget);

/***/ }),

/***/ 25030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Login_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72961);
/* harmony import */ var _Login_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Login_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Base_Icons_Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54180);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var PasswordInput = function PasswordInput(props) {
  var _props$name;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isPasswordShown = _useState[0],
      setPasswordShown = _useState[1];

  var handleShowPassword = function handleShowPassword(e) {
    e.preventDefault();
    setPasswordShown(!isPasswordShown);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_Login_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputIcon),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Base_Icons_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
        name: "Password",
        size: "sm"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", {
      name: (_props$name = props.name) !== null && _props$name !== void 0 ? _props$name : 'password',
      type: isPasswordShown ? 'text' : 'password',
      autoComplete: props.autoComplete,
      className: (_Login_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputLarge),
      placeholder: props.placeholder,
      value: props.value,
      onChange: props.onChange
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
      tabIndex: "-1",
      className: (_Login_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputIconRight),
      type: "button",
      onClick: handleShowPassword,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Base_Icons_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
        name: "Eye",
        size: "sm",
        color: isPasswordShown ? 'black' : 'grey'
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_Login_module_scss__WEBPACK_IMPORTED_MODULE_3___default().errorIcon),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Base_Icons_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
        name: "Error",
        size: "sm"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PasswordInput);

/***/ }),

/***/ 31730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Base_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31385);
/* harmony import */ var _Base_Icons_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54180);
/* harmony import */ var _Login_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72961);
/* harmony import */ var _Login_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Login_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var SignInButton = function SignInButton(props) {
  var handleConfirm = function handleConfirm() {
    props.onFederatedSignIn(props.provider);
  };

  var renderTitle = function renderTitle() {
    var _props$title;

    return (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      id: "CRDuCX",
      defaultMessage: [{
        "type": 0,
        "value": "Sign in with "
      }, {
        "type": 1,
        "value": "provider"
      }],
      values: {
        provider: props.provider
      }
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_Base_Button_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    design: props.design || 'confirm',
    size: "xlarge",
    isFull: true,
    isLoading: props.isLoading,
    onClick: handleConfirm,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      className: (_Login_module_scss__WEBPACK_IMPORTED_MODULE_5___default().iconRight),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Base_Icons_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        name: props.provider,
        size: "sm"
      })
    }), renderTitle()]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SignInButton);

/***/ }),

/***/ 85155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_Login; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Base/Icons/Icon.js + 66 modules
var Icon = __webpack_require__(54180);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(54490);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(74806);
// EXTERNAL MODULE: ./components/Layout/Headline/Headline.js
var Headline = __webpack_require__(58734);
// EXTERNAL MODULE: ./components/Base/Button/Button.js
var Button = __webpack_require__(31385);
// EXTERNAL MODULE: ./components/User/LoginComponents/Login.module.scss
var Login_module = __webpack_require__(72961);
var Login_module_default = /*#__PURE__*/__webpack_require__.n(Login_module);
// EXTERNAL MODULE: ./components/User/LoginComponents/Parts/PasswordInput.js
var PasswordInput = __webpack_require__(25030);
// EXTERNAL MODULE: ./components/User/LoginComponents/Parts/SignInButton.js
var SignInButton = __webpack_require__(31730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/User/LoginComponents/LoginForm.js







 // because input is in child component

/* eslint-disable jsx-a11y/label-has-associated-control */





var LoginForm = function LoginForm(props) {
  var messages = (0,lib/* defineMessages */.vU)({
    emailPlaceholder: {
      id: "global.forms.emailPlaceholder",
      defaultMessage: [{
        "type": 0,
        "value": "Your e-mail address"
      }]
    },
    passwordPlaceholder: {
      id: "global.forms.passwordPlaceholder",
      defaultMessage: [{
        "type": 0,
        "value": "Your password"
      }]
    }
  });

  var handleFederatedSignIn = function handleFederatedSignIn(provider) {
    props.onFederatedSignIn({
      provider: provider
    });
  };

  function renderError() {
    if (!props.errorMessage || props.errorMessage.length === 0) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Login_module_default()).loginError,
      children: props.errorMessage
    });
  }

  function renderFields() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: (Login_module_default()).inputLabel,
      htmlFor: "password",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        defaultMessage: [{
          "type": 0,
          "value": "Password"
        }],
        id: "global.forms.passwordLabel"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Login_module_default()).inputIconWrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordInput/* default */.Z, {
          name: "password",
          placeholder: props.intl.formatMessage(messages.passwordPlaceholder),
          value: props.password,
          onChange: props.onPasswordChange,
          autoComplete: "current-password"
        })
      })]
    });
  }

  function renderButtons() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Login_module_default()).loginButton,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          type: "submit",
          isLoading: props.isLoading,
          design: "confirm",
          size: "xlarge",
          isFull: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "Ewzk28",
            defaultMessage: [{
              "type": 0,
              "value": "Sign into your account"
            }]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Login_module_default()).devider
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Login_module_default()).federatedLoginButton,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SignInButton/* default */.Z, {
          onFederatedSignIn: handleFederatedSignIn,
          provider: "Google",
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "Op5EHr",
            defaultMessage: [{
              "type": 0,
              "value": "Sign in with Google"
            }]
          }),
          icon: "Google",
          design: "default"
        })
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    method: "POST",
    onSubmit: props.onFormSubmit,
    className: "".concat((Login_module_default()).fullPageFormArea, " ").concat((Login_module_default()).loginFormWrapper),
    children: [props.isHeadline && /*#__PURE__*/(0,jsx_runtime.jsx)(Headline/* default */.Z, {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "SQJto2",
        defaultMessage: [{
          "type": 0,
          "value": "Sign in"
        }]
      }),
      subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "RrgvXt",
        defaultMessage: [{
          "type": 0,
          "value": "Welcome back! "
        }, {
          "type": 1,
          "value": "newLine"
        }, {
          "type": 0,
          "value": " Sign into your account"
        }],
        values: {
          newLine: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        className: (Login_module_default()).inputLabel,
        htmlFor: "email",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          defaultMessage: [{
            "type": 0,
            "value": "E-mail address"
          }],
          id: "global.forms.emailLabel"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((Login_module_default()).inputIconWrapper, " ").concat(props.hasEmailError ? 'error' : ''),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Login_module_default()).inputIcon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: "Mail",
              size: "sm"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "email",
            className: (Login_module_default()).inputLarge,
            autoFocus: true,
            autoComplete: "username",
            placeholder: props.intl.formatMessage(messages.emailPlaceholder),
            onChange: props.onEmailChange,
            value: props.email,
            name: "email"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Login_module_default()).errorIcon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: "Error",
              size: "sm"
            })
          })]
        })]
      }), renderFields()]
    }), renderButtons(), renderError()]
  });
};

/* harmony default export */ var LoginComponents_LoginForm = ((0,injectIntl/* default */.ZP)(LoginForm));
// EXTERNAL MODULE: ./node_modules/email-validator/index.js
var email_validator = __webpack_require__(83999);
// EXTERNAL MODULE: ./utils/trackingParty.js
var trackingParty = __webpack_require__(10037);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./containers/Common/Login/LoginMessages.js

var messages = (0,lib/* defineMessages */.vU)({
  alertPasswordLength: {
    id: "global.alertPasswordLength",
    defaultMessage: [{
      "type": 0,
      "value": "Password has to be at least 7 characters long"
    }]
  },
  alertPasswordTooMany: {
    id: "global.alertPasswordTooMany",
    defaultMessage: [{
      "type": 0,
      "value": "You made too many password change requests, please try again later"
    }]
  },
  alertEmailInvalid: {
    id: "global.alertEmailInvalid",
    defaultMessage: [{
      "type": 0,
      "value": "Please enter a valid email address"
    }]
  },
  alertNoUserFound: {
    id: "global.alertNoUserFound",
    defaultMessage: [{
      "type": 0,
      "value": "No user found with email"
    }]
  },
  alertResetRequired: {
    id: "global.alertSetRequired",
    defaultMessage: [{
      "type": 0,
      "value": "Password reset required. Please set your new password"
    }]
  },
  alertCorrectPassword: {
    id: "global.alertCorrectPassword",
    defaultMessage: [{
      "type": 0,
      "value": "Invalid username or password."
    }]
  },
  alertPasswordMatch: {
    id: "global.alertPasswordMatch",
    defaultMessage: [{
      "type": 0,
      "value": "Passwords do not match"
    }]
  },
  alertPasswordUnknown: {
    id: "global.alertPasswordUnknown",
    defaultMessage: [{
      "type": 0,
      "value": "Unable to set password. Please try again"
    }]
  },
  alertUserNotConfirmed: {
    id: "global.alertUserNotConfirmed",
    defaultMessage: [{
      "type": 0,
      "value": "User account has not been confirmed yet. Please use Sign Up form again."
    }]
  }
});
/* harmony default export */ var LoginMessages = (messages);
// EXTERNAL MODULE: ./actions/authActions.js + 1 modules
var authActions = __webpack_require__(31672);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
;// CONCATENATED MODULE: ./components/User/LoginComponents/NewPasswordForm.js









var NewPasswordForm = function NewPasswordForm(props) {
  var messages = (0,lib/* defineMessages */.vU)({
    emailPlaceholder: {
      id: "global.forms.emailPlaceholder",
      defaultMessage: [{
        "type": 0,
        "value": "Your e-mail address"
      }]
    },
    confirmPasswordPlaceholder: {
      id: "global.forms.confirmPasswordPlaceholder",
      defaultMessage: [{
        "type": 0,
        "value": "Confirm new password"
      }]
    },
    newPasswordPlaceholder: {
      id: "global.forms.newPasswordPlaceholder",
      defaultMessage: [{
        "type": 0,
        "value": "Your new Password"
      }]
    }
  });

  function renderError() {
    if (!props.errorMessage || props.errorMessage.length === 0) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Login_module_default()).loginError,
      children: props.errorMessage
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    onSubmit: props.onFormSubmit,
    className: (Login_module_default()).fullPageFormArea,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Headline/* default */.Z, {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "Bk6B6r",
        defaultMessage: [{
          "type": 0,
          "value": "Almost there"
        }]
      }),
      subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        defaultMessage: [{
          "type": 0,
          "value": "Set your new password"
        }],
        id: "global.forms.newPasswordTitle"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: (Login_module_default()).inputLabel,
      htmlFor: "newPassword",
      children: [props.intl.formatMessage(messages.newPasswordPlaceholder), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((Login_module_default()).inputIconWrapper, " ").concat(props.hasPasswordError ? 'error' : ''),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          type: "password",
          name: "newPassword",
          className: (Login_module_default()).inputLarge,
          placeholder: props.intl.formatMessage(messages.newPasswordPlaceholder),
          autoFocus: true,
          value: props.password,
          onChange: props.onPasswordChange
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Login_module_default()).errorIcon,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "Error",
            size: "sm"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: (Login_module_default()).inputLabel,
      htmlFor: "passwordRepeat",
      children: [props.intl.formatMessage(messages.confirmPasswordPlaceholder), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((Login_module_default()).inputIconWrapper, " ").concat(props.hasPasswordError ? 'error' : ''),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          type: "password",
          name: "passwordRepeat",
          className: (Login_module_default()).inputLarge,
          placeholder: props.intl.formatMessage(messages.confirmPasswordPlaceholder),
          value: props.passwordRepeat,
          onChange: props.onPasswordRepeatChange
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Login_module_default()).errorIcon,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "Error",
            size: "sm"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      type: "submit",
      design: "confirm",
      size: "xlarge",
      isFull: true,
      isLoading: props.isLoading,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "8MYA1z",
        defaultMessage: [{
          "type": 0,
          "value": "Continue and log in"
        }]
      })
    }), renderError()]
  });
};

/* harmony default export */ var LoginComponents_NewPasswordForm = ((0,injectIntl/* default */.ZP)(NewPasswordForm));
;// CONCATENATED MODULE: ./containers/Common/Login/index.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var Login = function Login(props) {
  var intl = (0,useIntl/* default */.Z)();
  var initialState = {
    isLoading: false,
    email: '',
    emailError: false,
    errorMessage: null,
    password: '',
    newPassword: '',
    newPasswordRepeat: '',
    passwordError: false,
    isSubmitted: false
  };

  var _useReducer = (0,react.useReducer)(function (localState, newState) {
    return _objectSpread(_objectSpread({}, localState), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1];

  var dispatch = (0,es/* useDispatch */.I0)();
  var auth = (0,es/* useSelector */.v9)(function (state) {
    return state.auth;
  });
  (0,react.useEffect)(function () {
    // prefill email
    if (props.prefillEmail) {
      setState({
        email: props.prefillEmail
      });
    }
  }, [props.prefillEmail]);
  (0,react.useEffect)(function () {
    if (!state.isSubmitted) return;

    if (auth.authenticated === true) {
      if (props.onLoginSuccess) {
        props.onLoginSuccess(auth.user);
      }
    } else if (auth.changePassword === true) {
      setState({
        isLoading: false,
        errorMessage: intl.formatMessage(LoginMessages.alertResetRequired)
      });
    } else {
      var error = auth.error;
      (0,trackingParty/* trackEvent */.L9)('Login error', {
        code: error.code,
        message: error.message
      });

      if (error.name === 'UserNotFoundException') {
        setState({
          isLoading: false,
          errorMessage: intl.formatMessage(LoginMessages.alertNoUserFound)
        });
      } else {
        setState({
          isLoading: false,
          errorMessage: intl.formatMessage(LoginMessages.alertCorrectPassword)
        });
      }
    }
  }, [auth]);

  var handleLoginSubmit = function handleLoginSubmit() {
    setState({
      isSubmitted: true
    });
  };

  var submitLoginForm = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setState({
                isLoading: true,
                emailError: false
              });

              if (!(state.email.length === 0 || !email_validator.validate(state.email))) {
                _context.next = 5;
                break;
              }

              setState({
                isLoading: false,
                emailError: true,
                errorMessage: intl.formatMessage(LoginMessages.alertEmailInvalid)
              });
              return _context.abrupt("return", false);

            case 5:
              dispatch((0,authActions.signIn)(state.email.toLowerCase(), state.password)); // console.log('SUBMIT LOGIN');

              handleLoginSubmit();
              return _context.abrupt("return", false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submitLoginForm(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleEmailChange = function handleEmailChange(e) {
    e.preventDefault();
    setState({
      email: e.target.value
    });
  };

  var handlePasswordChange = function handlePasswordChange(e) {
    e.preventDefault();
    setState({
      password: e.target.value
    });
  };

  var handleNewPasswordChange = function handleNewPasswordChange(e) {
    e.preventDefault();
    setState({
      newPassword: e.target.value
    });
  };

  var handleNewPasswordRepeatChange = function handleNewPasswordRepeatChange(e) {
    e.preventDefault();
    setState({
      newPasswordRepeat: e.target.value
    });
  };

  var submitNewPasswordForm = function submitNewPasswordForm(e) {
    e.preventDefault();

    if (state.newPassword.length < 7) {
      setState({
        passwordError: true,
        errorMessage: props.intl.formatMessage(LoginMessages.alertPasswordLength)
      });
      return false;
    }

    if (state.newPassword !== state.newPasswordRepeat) {
      setState({
        passwordError: true,
        errorMessage: props.intl.formatMessage(LoginMessages.alertPasswordMatch)
      });
      return false;
    }

    setState({
      loading: true,
      passwordError: false
    });
    dispatch((0,authActions.setNewPassword)(auth.cognitoUser, state.newPassword, handleLoginSuccess)); // cancel page refresh

    return false;
  };

  var handleLoginSuccess = function handleLoginSuccess(user) {
    setState({
      loading: false
    });
    props.onLoginSuccess(user);
  };

  var handleFederatedSignIn = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref2) {
      var provider;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              provider = _ref2.provider;
              _context2.next = 3;
              return (0,authActions.federatedSignIn)({
                provider: provider
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleFederatedSignIn(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  function renderSuccess() {
    if (props.query && props.query.open === 'password-success') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "color-green",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "F7qPSY",
          defaultMessage: [{
            "type": 0,
            "value": "Your password has been changed successfuly!"
          }]
        })
      });
    }

    return null;
  }

  function renderForm() {
    if (auth.changePassword) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LoginComponents_NewPasswordForm, {
        password: state.newPassword,
        onPasswordChange: handleNewPasswordChange,
        onFormSubmit: submitNewPasswordForm,
        onPasswordRepeatChange: handleNewPasswordRepeatChange,
        passwordRepeat: state.newPasswordRepeat,
        hasPasswordError: state.passwordError,
        errorMessage: state.errorMessage,
        isLoading: state.isLoading
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(LoginComponents_LoginForm, {
      password: state.password,
      onPasswordChange: handlePasswordChange,
      onEmailChange: handleEmailChange,
      email: state.email,
      onFormSubmit: submitLoginForm,
      onFederatedSignIn: handleFederatedSignIn,
      errorMessage: state.errorMessage,
      hasEmailError: state.emailError,
      isLoading: state.isLoading,
      isHeadline: props.isHeadline
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [renderForm(), renderSuccess()]
  });
};

/* harmony default export */ var Common_Login = (Login);

/***/ }),

/***/ 57734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(791);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36456);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var usePlan = function usePlan(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      plan = _useState2[0],
      setPlan = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      planId = _useState3[0],
      setPlanId = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      planAmount = _useState4[0],
      setPlanAmount = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      planSymbol = _useState5[0],
      setPlanSymbol = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      planCurrency = _useState6[0],
      setPlanCurrency = _useState6[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setPlanId(getPlanId(props.planType, props.frequency));
    setPlan(planTypeWithoutSeats(props.planType));
  }, [props.frequency, props.planType]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (!planId) return;
    setPlanAmount(getPlanAmount(planId));
    setPlanSymbol(getPlanSymbol(planId));
    setPlanCurrency(getPlanCurrency(planId));
    setIsLoaded(true);
  }, [planId]);
  var planPrices = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.server.planPrices;
  });

  function getPlanId(planType) {
    if (!planPrices || !props.frequency) return '';
    return _utils_variables__WEBPACK_IMPORTED_MODULE_0__/* .PLANS */ .Xf[props.frequency][planType];
  }

  function getPlanAmount(planType) {
    if (planType === 'free') return 0;
    var planId = getPlanId(planType);
    if (!planPrices[planId]) return '';
    return planPrices[planId].amount;
  }

  function getPlanSymbol(planType) {
    var planId = getPlanId(planType);
    if (!planPrices[planId]) return '';
    return planPrices[planId].symbol;
  }

  function getPlanCurrency(planId) {
    if (!planPrices[planId]) return '';
    return planPrices[planId].currency;
  }

  function isCurrentPlan(currentPlan) {
    return getPlanId(props.planType) === currentPlan;
  }

  function planTypeWithoutSeats(planType) {
    return planType.replace(/[0-9]/g, '');
  }

  return {
    isLoaded: isLoaded,
    plan: plan,
    planId: planId,
    planAmount: planAmount,
    planCurrency: planCurrency,
    planSymbol: planSymbol,
    planPrices: planPrices,
    getPlanId: getPlanId,
    getPlanAmount: getPlanAmount,
    getPlanCurrency: getPlanCurrency,
    getPlanSymbol: getPlanSymbol,
    isCurrentPlan: isCurrentPlan,
    planTypeWithoutSeats: planTypeWithoutSeats
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (usePlan);

/***/ }),

/***/ 20941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_HomePage; }
});

// NAMESPACE OBJECT: ./actions/mockupList.js
var mockupList_namespaceObject = {};
__webpack_require__.r(mockupList_namespaceObject);
__webpack_require__.d(mockupList_namespaceObject, {
  "deleteHistory": function() { return deleteHistory; },
  "duplicateHistory": function() { return duplicateHistory; },
  "fetchHistoryList": function() { return fetchHistoryList; },
  "fetchHistoryListPage": function() { return fetchHistoryListPage; },
  "fetchMockupsForBundle": function() { return fetchMockupsForBundle; },
  "fetchMockupsForCategory": function() { return fetchMockupsForCategory; },
  "fetchMockupsForCategoryServer": function() { return fetchMockupsForCategoryServer; },
  "getSearchResults": function() { return getSearchResults; },
  "setActiveTags": function() { return setActiveTags; },
  "setLastVisitedCollection": function() { return setLastVisitedCollection; },
  "setLivePreview": function() { return setLivePreview; },
  "setOrder": function() { return setOrder; }
});

// NAMESPACE OBJECT: ./actions/userCollectionsAction.js
var userCollectionsAction_namespaceObject = {};
__webpack_require__.r(userCollectionsAction_namespaceObject);
__webpack_require__.d(userCollectionsAction_namespaceObject, {
  "addUserCollection": function() { return addUserCollection; },
  "editUserCollection": function() { return editUserCollection; },
  "fetchUserCollectionMockups": function() { return fetchUserCollectionMockups; },
  "fetchUserCollections": function() { return fetchUserCollections; },
  "removeUserCollection": function() { return removeUserCollection; },
  "updateMockupsCollection": function() { return updateMockupsCollection; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Marketing/HomePageHeader/HomepageHeader.module.scss
var HomepageHeader_module = __webpack_require__(26865);
var HomepageHeader_module_default = /*#__PURE__*/__webpack_require__.n(HomepageHeader_module);
// EXTERNAL MODULE: ./components/Base/Container/Container.module.scss
var Container_module = __webpack_require__(6778);
var Container_module_default = /*#__PURE__*/__webpack_require__.n(Container_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Base/Container/Container.js




var Container = function Container(props) {
  var className = (Container_module_default()).container;

  if (props.size === 'lg') {
    className = (Container_module_default()).containerLarge;
  }

  if (props.size === 'sm') {
    className = (Container_module_default()).containerSmall;
  }

  if (props.isPaddingDisabled) {
    className += " ".concat((Container_module_default()).noPadding);
  }

  if (props.className) {
    className += " ".concat(props.className);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: className,
    children: props.children
  });
};

/* harmony default export */ var Container_Container = (Container);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var components_message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(74806);
;// CONCATENATED MODULE: ./components/Marketing/HomePageHeader/HeaderTitle.js






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var HeaderTitle = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(HeaderTitle, _Component);

  var _super = _createSuper(HeaderTitle);

  function HeaderTitle() {
    (0,classCallCheck/* default */.Z)(this, HeaderTitle);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(HeaderTitle, [{
    key: "renderTitle",
    value: function renderTitle(className) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: className,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "J9TGay",
          defaultMessage: [{
            "type": 0,
            "value": "Create stunning "
          }, {
            "type": 1,
            "value": "newLine"
          }, {
            "type": 0,
            "value": " product mockups easily and online"
          }],
          values: {
            newLine: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
          }
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var intl = this.props.intl;
      var titleClassName = "font-bold ".concat((HomepageHeader_module_default()).title);

      if (intl.locale !== 'en') {
        titleClassName = "font-bold ".concat((HomepageHeader_module_default()).titleSmaller);
      }

      if (intl.locale === 'ru') {
        titleClassName = "font-bold ".concat((HomepageHeader_module_default()).titleSmallest);
      }

      return this.renderTitle(titleClassName);
    }
  }]);

  return HeaderTitle;
}(react.Component);

/* harmony default export */ var HomePageHeader_HeaderTitle = ((0,injectIntl/* default */.ZP)(HeaderTitle));
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./components/Base/Heading/Heading.js
var Heading = __webpack_require__(84366);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/List/Searchbar/Searchbar.module.scss
var Searchbar_module = __webpack_require__(17763);
var Searchbar_module_default = /*#__PURE__*/__webpack_require__.n(Searchbar_module);
// EXTERNAL MODULE: ./node_modules/react-debounce-input/lib/index.js
var lib = __webpack_require__(775);
// EXTERNAL MODULE: ./components/Base/Icons/Icon.js + 66 modules
var Icon = __webpack_require__(54180);
// EXTERNAL MODULE: ./components/Base/Button/Button.js
var Button = __webpack_require__(31385);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(54490);
// EXTERNAL MODULE: ./components/Base/LinkLocalised/LinkLocalised.js
var LinkLocalised = __webpack_require__(9070);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./utils/trackingParty.js
var trackingParty = __webpack_require__(10037);
// EXTERNAL MODULE: ./public/mockups.json
var mockups = __webpack_require__(38126);
// EXTERNAL MODULE: ./utils/locale/localeVariables.js
var localeVariables = __webpack_require__(94178);
;// CONCATENATED MODULE: ./utils/locale/getLocaleCodeLong.js


var getLocaleCodeLong = function getLocaleCodeLong(lang) {
  return localeVariables.SUPPORTED_LOCALES_LONG.filter(function (code) {
    return code.startsWith(lang);
  });
};

/* harmony default export */ var locale_getLocaleCodeLong = (getLocaleCodeLong);
;// CONCATENATED MODULE: ./components/List/Searchbar/Searchbar.js
















var algoliasearch = __webpack_require__(24955);

var client = algoliasearch('CHOYNIXSLK', '137a0fb339d1422645b68c2d1eaafd20');
var index = client.initIndex('collections');

var Searchbar = function Searchbar(props) {
  var messages = (0,react_intl_lib/* defineMessages */.vU)({
    placeholder: {
      id: "components.SearchBar.placeholder",
      defaultMessage: [{
        "type": 0,
        "value": "Search "
      }, {
        "type": 1,
        "value": "count"
      }, {
        "type": 0,
        "value": "+ online mockups"
      }]
    }
  });

  var _useState = (0,react.useState)([]),
      searchResults = _useState[0],
      setSearchResults = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      selectedSuggestion = _useState3[0],
      setSelectedSuggestion = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      notResults = _useState4[0],
      setNotResults = _useState4[1];

  var setSelectedSuggestionClamped = function setSelectedSuggestionClamped(val) {
    val = Math.max(0, Math.min(val, searchResults.length));
    setSelectedSuggestion(val);
  };

  var _ref2 = (0,react.useRef)();

  var searchRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    searchRef.current = props.value;
    setOpen(false);
  }, [props]);
  (0,react.useEffect)(function () {
    var onWindowClick = function onWindowClick(e) {
      if (!_ref2.current.contains(e.target)) {
        handleClickOutside();
      }
    };

    window.addEventListener('mousedown', onWindowClick);
    window.addEventListener('touchstart', onWindowClick);
    return function () {
      window.removeEventListener('mousedown', onWindowClick);
      window.removeEventListener('touchstart', onWindowClick);
    };
  }, []);

  var handleKeyPress = function handleKeyPress(e) {
    switch (e.keyCode) {
      // Enter pressed, confirm search
      case 13:
        return handleEnterPress();
      // arrow up

      case 38:
        return setSelectedSuggestionClamped(selectedSuggestion - 1);
      // arrow down

      case 40:
        return setSelectedSuggestionClamped(selectedSuggestion + 1);
      // left

      case 37:
        return;
      // right

      case 39:
        return;
      // reset

      default:
        return setSelectedSuggestion(0);
    }
  };

  var handleClickOutside = function handleClickOutside() {
    setOpen(false);
  };

  var handleChange = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var shortTerms, value, results, filtered;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              shortTerms = ['tv', 'cd'];
              value = e.target.value.replace(/\s\s+/g, ' ').trim(); // skip most of double letter words

              if (!(value.length === 2 && shortTerms.indexOf(value) === -1 || onlySpaces(value) === true)) {
                _context.next = 7;
                break;
              }

              setSearchResults([]);
              searchRef.current = null;
              setOpen(false);
              return _context.abrupt("return");

            case 7:
              searchRef.current = value;
              _context.next = 10;
              return index.search(value, {
                hitsPerPage: 10
              });

            case 10:
              results = _context.sent;
              filtered = results.hits.filter(function (item) {
                return item.isActive !== false && item.isRoot !== true;
              });

              if (filtered.length > 0) {
                setSearchResults(filtered);
                setNotResults(false);
              } else {
                setSearchResults([]);
                setNotResults(true);
              }

              setOpen(true); // we do not want to redirect to results page immediately after search
              // we just use the results to the search suggestions on the page
              // instead log the search event right here

              (0,trackingParty/* trackEvent */.L9)('Search', {
                query: value
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleCloseClick = function handleCloseClick() {
    searchRef.current = null;
    setOpen(false);
    router_default().push('/mockups');
  };

  var getHighlightedTitle = function getHighlightedTitle(collection) {
    var localisedResultValue = collection._highlightResult["collectionTitle-".concat(locale_getLocaleCodeLong(props.intl.locale))];
    /* eslint no-underscore-dangle: 0 */


    return "".concat(props.intl.locale !== 'en' && localisedResultValue ? localisedResultValue.value : collection._highlightResult.collectionTitle.value);
  };

  var getCollectionUrl = function getCollectionUrl(collection) {
    return "/mockups/".concat(collection.slug);
  };

  var handleEnterPress = function handleEnterPress() {
    if (selectedSuggestion !== -1 && selectedSuggestion < searchResults.length && searchRef.current) {
      var collection = searchResults[selectedSuggestion];
      var url = getCollectionUrl(collection);
      router_default().push(url, url);
    }
    /*
    else {
    handleSearch();
    }
      */

  }; // we redirect to root mockups page
  // we do not keep the path in current collection
  // as we search within whole mockups database

  /*
  const handleSearch = () => {
   if(searchRef.current) {
          const { query } = Router.router;
       delete query.slug;
      const urlParams = new URLSearchParams(query);
      urlParams.delete('page');
           urlParams.set('search', searchRef.current);
          const q = `?${urlParams.toString()}`;
           const href = `/mockups/${q}`;
          const as = `/mockups/${q}`;
           Router.push(href, as);
      }
  };
    */


  var handleFocus = function handleFocus() {
    if (searchRef.current) setOpen(true);
  };

  function onlySpaces(str) {
    return /^\s*$/.test(str);
  }

  var value = props.value,
      intl = props.intl;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((Searchbar_module_default()).searchContainer, " ").concat(open ? (Searchbar_module_default()).open : undefined),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Searchbar_module_default()).wrapper,
      ref: function ref(node) {
        return _ref2.current = node;
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Searchbar_module_default()).selector,
        children: [value && value.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          className: (Searchbar_module_default()).close,
          design: "text",
          onClick: handleCloseClick,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "Close"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib.DebounceInput, {
          className: (Searchbar_module_default()).input,
          minLength: 2,
          maxLength: 30,
          debounceTimeout: 400,
          onChange: handleChange,
          placeholder: intl.formatMessage(messages.placeholder, {
            count: mockups/* roundedCount */.o_
          }),
          value: value || '',
          onClick: handleFocus,
          onKeyDown: handleKeyPress,
          ref: searchRef
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Searchbar_module_default()).icon,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "Search",
            width: 15,
            height: 15
          })
        })]
      }), open && searchRef.current && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Searchbar_module_default()).selectOptions,
        onMouseLeave: function onMouseLeave() {
          return setSelectedSuggestion(-1);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Searchbar_module_default()).divider
        }), searchResults.map(function (collection, i) {
          return collection._highlightResult.collectionTitle && collection.isActive && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Searchbar_module_default()).selectOption,
            onMouseEnter: function onMouseEnter() {
              return setSelectedSuggestion(i);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
              to: getCollectionUrl(collection),
              className: selectedSuggestion === i ? (Searchbar_module_default()).selected : undefined,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                /* eslint react/no-danger: 0 */
                dangerouslySetInnerHTML: {
                  __html: getHighlightedTitle(collection)
                }
              })
            })
          }, collection.slug);
        }), notResults && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((Searchbar_module_default()).searchOption, " ").concat((Searchbar_module_default()).notResults),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "S6euzE",
              defaultMessage: [{
                "type": 0,
                "value": "Sorry we couldn't find any matching mockups... Please adjust your search and try again."
              }]
            })
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var Searchbar_Searchbar = ((0,injectIntl/* default */.ZP)(Searchbar));
// EXTERNAL MODULE: ./components/Base/SlideBar/SlideBar.module.scss
var SlideBar_module = __webpack_require__(73300);
var SlideBar_module_default = /*#__PURE__*/__webpack_require__.n(SlideBar_module);
;// CONCATENATED MODULE: ./components/Base/SlideBar/useSlider.js


var useSlider = function useSlider(sliderRef, wrapperRef) {
  // to set the movement offset
  var _useState = (0,react.useState)(0),
      currentOffset = _useState[0],
      setCurrentOffset = _useState[1]; // maximum movement offset to right side


  var _useState2 = (0,react.useState)(-1),
      maxOffset = _useState2[0],
      setMaxOffset = _useState2[1]; // meant to hide arrows controls for touch devices
  // Note: not used currently, control arrows should be accessible correctly
  // even by touch events
  // const canHover = () => {
  //     if (typeof window === 'undefined') return false;
  //     return !window.matchMedia('(hover: none)').matches;
  // };

  /**
   * Reset slider
   * 1] set slider to start -> current offset to zero
   * 2] set new max offset from current slider DOM elemenets sizes & positions
   */


  var resetOffset = function resetOffset() {
    setCurrentOffset(0);
    var newMaxOffset = calculateMaxOffset();
    setMaxOffset(newMaxOffset);
  };
  /**
   * Calculates maximal movement as difference between
   * right position of slider wrapper minus slider fullwidth
   * Note: is calculated freshly during next button click to ensure
   * having always current viewport data (e.g. if window has been resized)
   * @returns {number}
   */


  function calculateMaxOffset() {
    var slider = sliderRef.current.getBoundingClientRect();
    var wrapper = wrapperRef.current.getBoundingClientRect();
    var newMaxOffset = Math.floor(slider.width - wrapper.width);
    return newMaxOffset;
  }
  /**
   * Handle click on previous Icon
   * set new movement offset
   * with check - cant be higher > 0
   */


  var handlePrev = function handlePrev() {
    var wrapper = wrapperRef.current.getBoundingClientRect();
    var movement = wrapper.width / 2;
    var newCurrentOffset = Math.max(currentOffset - movement, 0);
    setSliderScrollPosition(newCurrentOffset);
  };
  /**
   * Handle click on next Icon
   * set new movement offset
   * check for possible movement limit, set eventually maximal available offset
   */


  var handleNext = function handleNext() {
    var wrapper = wrapperRef.current.getBoundingClientRect();
    var movement = Math.floor(wrapper.width / 2);
    var newMaxOffset = calculateMaxOffset();
    var newCurrentOffset = Math.min(currentOffset + movement, newMaxOffset);
    setMaxOffset(newMaxOffset);
    setSliderScrollPosition(newCurrentOffset);
  };
  /**
   * Set a new scroll position of slidebar
   * @param scrollToLeft
   */


  var setSliderScrollPosition = function setSliderScrollPosition(scrollToLeft) {
    wrapperRef.current.scrollTo({
      left: scrollToLeft,
      behavior: 'smooth'
    });
  };

  var handleOnScroll = function handleOnScroll() {
    setCurrentOffset(wrapperRef.current.scrollLeft);
  };

  return {
    maxOffset: maxOffset,
    currentOffset: currentOffset,
    handleNext: handleNext,
    handlePrev: handlePrev,
    resetOffset: resetOffset,
    handleOnScroll: handleOnScroll
  };
};

/* harmony default export */ var SlideBar_useSlider = (useSlider);
;// CONCATENATED MODULE: ./components/Base/SlideBar/SlideBar.js






var ControlArrows = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 244).then(__webpack_require__.bind(__webpack_require__, 68244));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(68244)];
    }
  }
});

var SlideBar = function SlideBar(props) {
  // slider bar ref - to know the full bar width
  var sliderRef = (0,react.useRef)(null); // slider wrapper ref - to know the visible slider width

  var wrapperRef = (0,react.useRef)(null);

  var _useSlider = SlideBar_useSlider(sliderRef, wrapperRef),
      maxOffset = _useSlider.maxOffset,
      currentOffset = _useSlider.currentOffset,
      handleNext = _useSlider.handleNext,
      handlePrev = _useSlider.handlePrev,
      resetOffset = _useSlider.resetOffset,
      handleOnScroll = _useSlider.handleOnScroll; // We need to reset current offset during rerender


  (0,react.useEffect)(function () {
    resetOffset();
  }, [props]);
  /**
   * Set initial max offset - this indicates if arrows should be shown
   * Set the listener for window resize to update the max offset, for arrows to show/hide
   */

  (0,react.useEffect)(function () {
    resetOffset();
    window.addEventListener('resize', resetOffset);
    return function () {
      return window.removeEventListener('resize', resetOffset);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SlideBar_module_default()).outerContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ControlArrows, {
      onNext: handleNext,
      onPrev: handlePrev,
      maxOffset: maxOffset,
      currentOffset: currentOffset,
      isEnabled: true,
      arrowsPosition: props.arrowsPosition
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      onScroll: handleOnScroll,
      className: "".concat((SlideBar_module_default()).sliderWrapper),
      ref: wrapperRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SlideBar_module_default()).container,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: sliderRef,
          className: (SlideBar_module_default()).slidebar,
          children: props.children
        })
      })
    })]
  });
};

/* harmony default export */ var SlideBar_SlideBar = (SlideBar);
// EXTERNAL MODULE: ./components/List/Filters/filter.module.scss
var filter_module = __webpack_require__(42345);
var filter_module_default = /*#__PURE__*/__webpack_require__.n(filter_module);
;// CONCATENATED MODULE: ./components/List/Filters/Filter.js







var Filter = function Filter(props) {
  var filters = props.filters,
      active = props.active,
      onFilterChange = props.onFilterChange,
      filtersUrls = props.filtersUrls,
      hideAllOption = props.hideAllOption;

  var getFilterUrl = function getFilterUrl(slug) {
    return filtersUrls(slug);
  };

  var isAnyItemActive = function isAnyItemActive() {
    var result = false;
    filters.map(function (item) {
      if (isActive(item.slug)) {
        result = true;
      }

      return null;
    });
    return result;
  };

  var isActive = function isActive(slug) {
    if (!active) return false;
    return active.indexOf(slug) > -1;
  };

  var renderButtons = function renderButtons() {
    return filters.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (filter_module_default()).filterItem,
        role: "menuitem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
          to: getFilterUrl(item.slug),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: isActive(item.slug) ? "font-bold ".concat((filter_module_default()).filterButtonActive) : "font-regular ".concat((filter_module_default()).filterButton),
            value: item.slug,
            onClick: onFilterChange,
            children: item.menuTitle ? item.menuTitle : item.title
          })
        })
      }, item.slug);
    });
  };

  if (!filters || filters.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: (filter_module_default()).filter,
    role: "menubar",
    children: [!hideAllOption && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (filter_module_default()).filterItem,
      role: "menuitem",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
        to: getFilterUrl(""),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: !isAnyItemActive() ? "font-bold ".concat((filter_module_default()).filterButtonActive) : "font-regular ".concat((filter_module_default()).filterButton),
          value: "",
          onClick: onFilterChange,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "All"
            }],
            id: "global.filter.all"
          })
        })
      })
    }), renderButtons()]
  });
};

/* harmony default export */ var Filters_Filter = (Filter);
;// CONCATENATED MODULE: ./components/List/Filters/FilterGroup.js





var FilterGroup = function FilterGroup(props) {
  var filters = props.filters,
      active = props.active,
      filtersUrls = props.filtersUrls,
      onFiltersChange = props.onFiltersChange,
      hideAllOption = props.hideAllOption,
      isPrimary = props.isPrimary;

  var getFiltersUrls = function getFiltersUrls(tag, index) {
    var active = getAllActiveFilters();
    active[index] = tag;
    active = active.filter(function (item) {
      return item !== '';
    });
    return filtersUrls(active);
  };

  var getActiveFilterForGroup = function getActiveFilterForGroup(filter) {
    var found = filter.find(function (item) {
      return active.indexOf(item.slug) > -1;
    });
    return found ? found.slug : '';
  };

  var getAllActiveFilters = function getAllActiveFilters() {
    return filters.map(function (filter) {
      return getActiveFilterForGroup(filter);
    });
  };

  var renderFilters = function renderFilters() {
    return filters.map(function (tagGroup, index) {
      var tagKey = tagGroup.length - index;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Filters_Filter, {
        filters: tagGroup,
        active: active,
        hideAllOption: hideAllOption,
        onFilterChange: onFiltersChange,
        filtersUrls: function filtersUrls(tag) {
          return getFiltersUrls(tag, index);
        }
      }, "filtergroup-".concat(tagKey));
    });
  };

  if (!filters || filters.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((filter_module_default()).filters, " ").concat(isPrimary ? (filter_module_default()).filterWrapper : null),
    children: renderFilters()
  });
};

/* harmony default export */ var Filters_FilterGroup = (FilterGroup);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./utils/toQueryString.js
/**
 *
 * @param obj
 * @param obj
 */
function toQueryString(obj) {
  var qs = [];
  Object.keys(obj).map(function (key) {
    if (obj[key]) {
      var keyName = encodeURIComponent(key);
      var value = Array.isArray(obj[key]) ? obj[key].toString() : obj[key];

      if (value && (Number.isInteger(value) && value > 0 || value.length > 0)) {
        qs.push(keyName + '=' + value);
      }
    }
  });
  if (qs.length === 0) return '';
  return '?' + qs.join('&');
}
;// CONCATENATED MODULE: ./hooks/useQueryUrl.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var useQueryUrl = function useQueryUrl() {
  var router = (0,next_router.useRouter)();

  var makeFilter = function makeFilter(items) {
    var setQuery = _objectSpread({}, router.query);

    delete setQuery.slug;
    delete setQuery.page;
    var result = {
      qs: toQueryString(_objectSpread(_objectSpread({}, setQuery), {}, {
        filter: items
      }))
    };

    if (router.asPath.includes('?')) {
      var pathArray = router.asPath.split('?');
      pathArray.pop();
      result.rootPath = pathArray.join('/');
    } else {
      result.rootPath = router.asPath;
    }

    return result;
  };

  var makeCategory = function makeCategory(items, pathname) {
    var pathArray = pathname ? [pathname] : router.pathname.split('/');

    var setQuery = _objectSpread({}, router.query);

    delete setQuery.slug;
    delete setQuery.page;
    delete setQuery.filter;
    delete setQuery.search;
    var result = {
      qs: toQueryString(_objectSpread({}, setQuery))
    };

    if (pathArray.length > 2) {
      pathArray.pop();
    }

    result.rootPath = "".concat(pathArray.join('/'), "/").concat(items);
    return result;
  };

  var makePage = function makePage(items) {
    var asPath = router.asPath;

    var setQuery = _objectSpread({}, router.query);

    delete setQuery.slug;
    var result = {
      qs: toQueryString(_objectSpread(_objectSpread({}, setQuery), {}, {
        page: items
      }))
    };

    if (asPath.includes('?')) {
      var pathArray = asPath.split('?');
      pathArray.pop();
      result.rootPath = pathArray.join('/');
    } else {
      result.rootPath = asPath;
    }

    return result;
  };

  return {
    makeQueryUrl: function makeQueryUrl(items, type, pathname) {
      if (!type) {
        throw new Error('the parameter "type" is required and expects a value "filter" || "category" || "page"!');
      }

      var urlByType = {
        filter: makeFilter(items),
        category: makeCategory(items, pathname),
        page: makePage(items)
      };
      var res = urlByType[type];
      return !res.qs ? res.rootPath : "".concat(res.rootPath).concat(res.qs);
    }
  };
};

/* harmony default export */ var hooks_useQueryUrl = (useQueryUrl);
;// CONCATENATED MODULE: ./utils/favoriteCollections.js
var favoriteCollections = [{
  slug: 'tshirts',
  menuTitle: 'T-Shirts',
  intlId: 'collection.tshirts'
}, {
  slug: 'smartphone',
  menuTitle: 'Smartphone',
  intlId: 'collection.smartphone'
}, {
  slug: 'magazines',
  menuTitle: 'Magazines',
  intlId: 'collection.magazines'
}, {
  slug: 'books',
  menuTitle: 'Books',
  intlId: 'collection.books'
}, {
  slug: 'laptop',
  menuTitle: 'Laptop',
  intlId: 'collection.laptop'
}, {
  slug: 'frames',
  menuTitle: 'Frames',
  intlId: 'collection.frames'
}, {
  slug: 'mugs',
  menuTitle: 'Mugs',
  intlId: 'collection.mugs'
}, {
  slug: 'face-masks',
  menuTitle: 'Face Masks',
  intlId: 'collection.facemasks'
}, {
  slug: 'tablet',
  menuTitle: 'Tablet',
  intlId: 'collection.tablet'
}, {
  slug: 'desktop',
  menuTitle: 'Desktop',
  intlId: 'collection.desktop'
}];
/* harmony default export */ var utils_favoriteCollections = (favoriteCollections);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
;// CONCATENATED MODULE: ./utils/mockupListFiltering.js

// Class for manipulation with the mockup list
function filterMockups() {
  var mockups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var category = arguments.length > 2 ? arguments[2] : undefined;
  if (!Array.isArray(mockups)) return null;
  var activeFilters = filters;
  var filteredMockups = []; // find matching mockups

  mockups.map(function (mockup) {
    if (collectionMatch(category, mockup) && allFiltersMatch(activeFilters, mockup)) {
      return filteredMockups.push(mockup);
    }

    return null;
  });
  return filteredMockups;
}

function collectionMatch(category, mockup) {
  return !category || mockup.category === category;
}

function allFiltersMatch(filters, mockup) {
  if (!filters || filters.length === 0) return true;
  var defaultTags = ['photo', 'isolated', 'free', 'pro'];
  var matching = 0; // check if mockup has all the selected tags

  filters.map(function (tag) {
    if (tag === 'photo' && !mockup.hasBackground) {
      matching++;
    }

    if (tag === 'isolated' && mockup.hasBackground) {
      matching++;
    }

    if (tag === 'free' && !mockup.isPremium) {
      matching++;
    }

    if (tag === 'pro' && mockup.isPremium) {
      matching++;
    }

    if (defaultTags.indexOf(tag) === -1 && mockup.tags && mockup.tags.indexOf(tag) > -1) {
      matching++;
    }

    return null;
  });
  return matching === filters.length;
}
/**
 * function that orders all the mockups by release date
 * @param mockups
 * @param property
 */


function orderMockups() {
  var mockups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var property = arguments.length > 1 ? arguments[1] : undefined;
  var showFreeFirst = arguments.length > 2 ? arguments[2] : undefined;

  var mockupList = (0,toConsumableArray/* default */.Z)(mockups);

  var collator = null;

  try {
    collator = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  } catch (e) {
    return null;
  }

  if (property === 'publishDate') {
    mockupList.sort(function (a, b) {
      var x = a.publishDate;
      var y = b.publishDate;
      var n = y - x;

      if (n !== 0) {
        return n;
      }

      if (collator) {
        return collator.compare(a.id, b.id);
      }

      return a.id - b.id;
    });
  }

  mockupList.sort(function (a, b) {
    var x = a[property] ? a[property] : 0;
    var y = b[property] ? b[property] : 0;
    var n = y - x;

    if (n !== 0) {
      return n;
    }

    if (collator) {
      return collator.compare(a.id, b.id);
    }

    return a.id - b.id;
  });

  if (showFreeFirst) {
    return putFreeMockupsOnTop(mockupList);
  }

  return mockupList;
}

function putFreeMockupsOnTop(mockups) {
  var free = [];
  var premium = [];
  mockups.map(function (mockup) {
    if (mockup.isPremium) {
      premium.push(mockup);
    } else {
      free.push(mockup);
    }

    return null;
  });

  if (free.length < 12) {
    return [].concat(free, premium);
  }

  var result = [];

  for (var i = 0; i < free.length; i++) {
    result.push(free[i]);
    var coef = getFreeOrderCoef();

    if (i % coef === 0 && premium.length > 0) {
      result.push(premium[0]);
      premium.shift();
    }
  }

  return [].concat(result, premium);
}

function getFreeOrderCoef() {
  return Math.floor(Math.random() * Math.floor(2)) + 4;
}
/**
 * function that orders all the mockups by release date
 * @param mockups
 * @param property
 */


function paginateMockups() {
  var mockups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var page = arguments.length > 1 ? arguments[1] : undefined;
  var perPage = arguments.length > 2 ? arguments[2] : undefined;

  var mockupList = (0,toConsumableArray/* default */.Z)(mockups);

  var start = 0;
  var end = perPage;

  if (page || parseInt(page) > 0) {
    start = parseInt(page) * perPage - perPage;
  }

  return mockupList.splice(start, end);
}
// EXTERNAL MODULE: ./components/List/MockupPreview/MockupPreview.module.scss
var MockupPreview_module = __webpack_require__(47041);
var MockupPreview_module_default = /*#__PURE__*/__webpack_require__.n(MockupPreview_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
;// CONCATENATED MODULE: ./utils/hashString.js
/* eslint-disable */
function hashString(str) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var h1 = 0xdeadbeef ^ seed,
      h2 = 0x41c6ce57 ^ seed;

  for (var i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }

  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var react_html_parser_lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/Base/SsrFormattedMessage/SsrFormattedMessage.js




var SsrFormattedMessage = function SsrFormattedMessage(props) {
  var defaultMessage = props.defaultMessage,
      values = props.values;
  var rewrittenTittle = defaultMessage;

  if (values) {
    Object.keys(values).forEach(function (key) {
      if (values[key] instanceof Object) {
        throw TypeError("HTML element must be written like string in props: ".concat(key));
      }

      rewrittenTittle = rewrittenTittle.replace("{".concat(key, "}"), values[key]);
    });
  }

  return (0,react_html_parser_lib/* default */.ZP)(browser_default().sanitize(rewrittenTittle));
};

SsrFormattedMessage.propTypes = {
  defaultMessage: (prop_types_default()).string.isRequired,
  values: (prop_types_default()).object
};
/* harmony default export */ var SsrFormattedMessage_SsrFormattedMessage = (SsrFormattedMessage);
;// CONCATENATED MODULE: ./components/Base/LocalisedTitle/LocalisedTitle.js


function LocalisedTitle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocalisedTitle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocalisedTitle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocalisedTitle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var LocalisedTitle = function LocalisedTitle(props) {
  if (props.values && !props.intlId) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SsrFormattedMessage_SsrFormattedMessage, {
      defaultMessage: props.title,
      values: props.values
    });
  }

  if (props.intlId) {
    var message = {
      id: props.intlId,
      defaultMessage: props.title,
      values: props.values ? props.values : {}
    };
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, LocalisedTitle_objectSpread({}, message));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: props.title
  });
};

/* harmony default export */ var LocalisedTitle_LocalisedTitle = (LocalisedTitle);
;// CONCATENATED MODULE: ./components/List/MockupPreview/parts/MockupPreviewTitle.js








function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function MockupPreviewTitle_createSuper(Derived) { var hasNativeReflectConstruct = MockupPreviewTitle_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function MockupPreviewTitle_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var MockupPreviewTitle = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(MockupPreviewTitle, _Component);

  var _super = MockupPreviewTitle_createSuper(MockupPreviewTitle);

  function MockupPreviewTitle() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MockupPreviewTitle);

    _this = _super.call(this);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleMouseOver", function () {
      _this.countTitleWidth();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleMouseLeave", function () {
      _this.setState({
        offset: 0
      });

      setTimeout(function () {
        if (_this.wrapper) {
          _this.setState({
            textOverflow: 'ellipsis'
          });
        }
      }, 500);
    });

    _this.state = {
      offset: 0,
      textOverflow: 'ellipsis'
    };
    _this.wrapper = null;
    _this.text = null;
    return _this;
  }

  (0,createClass/* default */.Z)(MockupPreviewTitle, [{
    key: "countTitleWidth",
    value: function countTitleWidth() {
      if (!this.wrapper || !this.text) return;
      var wrapperWidth = this.wrapper.getBoundingClientRect().width - 10; // padding;

      var textWidth = this.text.getBoundingClientRect().width;
      if (textWidth <= wrapperWidth) return;
      this.setState({
        textOverflow: 'clip'
      });
      this.setState({
        offset: wrapperWidth - textWidth
      });
    }
  }, {
    key: "renderScrollingPreviewTitle",
    value: function renderScrollingPreviewTitle() {
      var _this2 = this;

      var mockup = this.props.mockup;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: mockup.hasBackground ? (MockupPreview_module_default()).previewTitleInverse : (MockupPreview_module_default()).previewTitle,
        ref: function ref(c) {
          _this2.wrapper = c;
        },
        onMouseEnter: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave,
        style: {
          textOverflow: this.state.textOverflow
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          style: {
            transform: "translateX(".concat(this.state.offset, "px)")
          },
          ref: function ref(c) {
            _this2.text = c;
          },
          children: mockup.title
        })
      });
    }
  }, {
    key: "renderSplitPreviewTitle",
    value: function renderSplitPreviewTitle() {
      var mockup = this.props.mockup;
      var titles = mockup.previewTitle.split(',');
      var titlesList = [];

      var _iterator = _createForOfIteratorHelper(titles),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var title = _step.value;

          if (title && title.length > 1) {
            titlesList.push( /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalisedTitle_LocalisedTitle, {
                title: title,
                intlId: "mockup.previewTitles.".concat(hashString(title))
              })
            }, "preview-title-".concat(mockup.id, "-").concat(title)));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: mockup.hasBackground ? (MockupPreview_module_default()).listTitlesInverse : (MockupPreview_module_default()).listTitles,
        children: titlesList
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mockup = _this$props.mockup,
          intl = _this$props.intl;
      var previewTitleLength = mockup.previewTitle ? mockup.previewTitle.length : 0;
      var titleLength = mockup.title ? mockup.title.length : 0;

      if (intl.locale === 'en' && previewTitleLength < titleLength) {
        return this.renderScrollingPreviewTitle();
      }

      if (mockup.previewTitle) {
        return this.renderSplitPreviewTitle();
      }

      return null;
    }
  }]);

  return MockupPreviewTitle;
}(react.Component);

/* harmony default export */ var parts_MockupPreviewTitle = ((0,injectIntl/* default */.ZP)(MockupPreviewTitle));
;// CONCATENATED MODULE: ./components/List/MockupPreview/parts/AdminBtn.js




var AdminBtn = function AdminBtn(props) {
  var handleCopy = function handleCopy(e) {
    navigator.clipboard.writeText(e.currentTarget.value);
  };

  if (props.type === 'copy') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: props.isInverse ? (MockupPreview_module_default()).adminBtnInverse : (MockupPreview_module_default()).adminBtn,
      onClick: handleCopy,
      value: props.id,
      children: "Copy ID"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: "https://admin-smartmockups.com/mockups?s=".concat(props.id),
    className: props.isInverse ? (MockupPreview_module_default()).adminBtnInverse : (MockupPreview_module_default()).adminBtn,
    target: "_blank",
    rel: "noopener noreferrer",
    children: "Edit"
  });
};

/* harmony default export */ var parts_AdminBtn = (AdminBtn);
// EXTERNAL MODULE: ./components/List/MockupPreview/parts/new.svg
var parts_new = __webpack_require__(94463);
var new_default = /*#__PURE__*/__webpack_require__.n(parts_new);
// EXTERNAL MODULE: ./components/List/MockupPreview/parts/PreviewBadges.module.scss
var PreviewBadges_module = __webpack_require__(39268);
var PreviewBadges_module_default = /*#__PURE__*/__webpack_require__.n(PreviewBadges_module);
// EXTERNAL MODULE: ./components/List/MockupPreview/parts/PremiumBadge.svg
var PremiumBadge = __webpack_require__(12083);
var PremiumBadge_default = /*#__PURE__*/__webpack_require__.n(PremiumBadge);
// EXTERNAL MODULE: ./components/List/MockupPreview/UnlockedBadge.svg
var UnlockedBadge = __webpack_require__(21194);
var UnlockedBadge_default = /*#__PURE__*/__webpack_require__.n(UnlockedBadge);
// EXTERNAL MODULE: ./components/List/MockupPreview/parts/DraftBadge.svg
var DraftBadge = __webpack_require__(72608);
var DraftBadge_default = /*#__PURE__*/__webpack_require__.n(DraftBadge);
// EXTERNAL MODULE: ./components/List/MockupPreview/parts/ScheduledBadge.svg
var ScheduledBadge = __webpack_require__(98429);
var ScheduledBadge_default = /*#__PURE__*/__webpack_require__.n(ScheduledBadge);
;// CONCATENATED MODULE: ./components/List/MockupPreview/parts/DateBadge.js




var DateBadge = function DateBadge(props) {
  var date = new Date(props.date);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: (PreviewBadges_module_default()).scheduledBadge,
    children: [date.getDate(), ".", date.getMonth() + 1]
  });
};

/* harmony default export */ var parts_DateBadge = (DateBadge);
;// CONCATENATED MODULE: ./components/List/MockupPreview/parts/PreviewBadges.js






function PreviewBadges_createSuper(Derived) { var hasNativeReflectConstruct = PreviewBadges_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function PreviewBadges_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }











var PreviewBadges = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(PreviewBadges, _Component);

  var _super = PreviewBadges_createSuper(PreviewBadges);

  function PreviewBadges() {
    (0,classCallCheck/* default */.Z)(this, PreviewBadges);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(PreviewBadges, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mockup = _this$props.mockup,
          isUserPremium = _this$props.isUserPremium,
          isUserInternal = _this$props.isUserInternal,
          isUserScheduled = _this$props.isUserScheduled;
      var badges = [];
      var publishDate = new Date(mockup.publishDate);
      var now = new Date();
      var twoWeeksAgo = new Date();
      twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

      if (publishDate > twoWeeksAgo.getTime() && publishDate < now.getTime()) {
        badges.push( /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: (new_default()),
          className: (PreviewBadges_module_default()).badge,
          alt: "new"
        }, "".concat(mockup.id, "-new-badge")));
      }

      if (mockup.isPremium && !isUserPremium) {
        badges.push( /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: (PremiumBadge_default()),
          className: (PreviewBadges_module_default()).badge,
          alt: "Pro only",
          title: "Pro mockup"
        }, "".concat(mockup.id, "-premium-badge")));
      } else if (mockup.isPremium) {
        badges.push( /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: (UnlockedBadge_default()),
          className: (PreviewBadges_module_default()).badge,
          alt: "Mockup unlocked",
          title: "Pro mockup unlocked"
        }, "".concat(mockup.id, "-premium-badge")));
      }

      if (isUserInternal && mockup.isDraft) {
        badges.push( /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: (DraftBadge_default()),
          className: (PreviewBadges_module_default()).badge,
          alt: "Mockup draft",
          title: "Mockup draft"
        }, "".concat(mockup.id, "-draft-badge")));
      } else if ((isUserInternal || isUserScheduled) && mockup.publishDate > now.getTime()) {
        badges.push( /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: (ScheduledBadge_default()),
          className: (PreviewBadges_module_default()).badge,
          alt: "Mockup scheduled",
          title: "Mockup scheduled"
        }, "".concat(mockup.id, "-scheduled-badge")));
        badges.push( /*#__PURE__*/(0,jsx_runtime.jsx)(parts_DateBadge, {
          date: mockup.publishDate
        }, "".concat(mockup.id, "-scheduled-badge-date")));
      }

      if (badges.length === 0) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PreviewBadges_module_default()).badges,
        children: badges
      });
    }
  }]);

  return PreviewBadges;
}(react.Component);


// EXTERNAL MODULE: ./utils/variables.js
var variables = __webpack_require__(791);
// EXTERNAL MODULE: ./apis/ServiceClient/index.js + 2 modules
var ServiceClient = __webpack_require__(27469);
// EXTERNAL MODULE: ./node_modules/@smartmockups/rendering/dist/index.js
var dist = __webpack_require__(50970);
// EXTERNAL MODULE: ./utils/loadImageAsCanvas.js
var utils_loadImageAsCanvas = __webpack_require__(93356);
// EXTERNAL MODULE: ./utils/loadImageAsImg.js
var loadImageAsImg = __webpack_require__(17485);
;// CONCATENATED MODULE: ./utils/loadBlob.js




var loadBlobAsImg = function loadBlobAsImg(blob) {
  return handleBlob(blob, loadImageAsImg/* default */.Z);
};
var loadBlobAsCanvas = function loadBlobAsCanvas(blob) {
  return handleBlob(blob, utils_loadImageAsCanvas/* default */.Z);
};

function handleBlob(_x, _x2) {
  return _handleBlob.apply(this, arguments);
}

function _handleBlob() {
  _handleBlob = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(blob, handler) {
    var url, img;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = URL.createObjectURL(blob);
            _context.prev = 1;
            _context.next = 4;
            return handler(url);

          case 4:
            img = _context.sent;
            URL.revokeObjectURL(url);
            return _context.abrupt("return", img);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            URL.revokeObjectURL(url);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));
  return _handleBlob.apply(this, arguments);
}
;// CONCATENATED MODULE: ./components/Editor/ColorPicker/ColorPickerHelpers.js


function sanitizeSelectedColor(selected) {
  //get current colors
  var color; //pokud je zadany nesmysl(neni to barva) nastav bilou

  if (Array.isArray(selected) && selected.length === 4) {
    color = _toConsumableArray(selected);
  } else {
    color = [255, 255, 255, 1];
  } //pokud ma barva 100% pruhlednost, tak ji vypni


  if (selected[0] === 0 && selected[1] === 0 && selected[2] === 0 && selected[3] === 0) {
    color[3] = 1;
  }

  return {
    r: color[0],
    g: color[1],
    b: color[2],
    a: color[3]
  };
}
function colorObjectToRgbaArray(color) {
  return [color.rgb.r, color.rgb.g, color.rgb.b, color.rgb.a];
}
function rgbToHex(r, g, b) {
  return componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

function hexToRgba(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), 1] : null;
}
function getDefaultGradient() {
  return GRADIENTS_SOLID[1];
}
function getGradientColorsForActiveColor(color) {
  var color1;
  var color2;

  if (Array.isArray(color) && color.length === 9) {
    color1 = color.slice(0, 4);
    color2 = color.slice(4, 8);
  } else {
    var defaultGradient = getDefaultGradient(); //render default colors

    color1 = defaultGradient.slice(0, 4);
    color2 = defaultGradient.slice(4, 8);
  }

  return {
    color1: color1,
    color2: color2
  };
}
;// CONCATENATED MODULE: ./apis/livePreviewApi.js








/**
 * Create live preview of user's file exported from Canva
 * @param {String} mockupId - id of a mockup we want to render
 * @param {String} userFileId - key of a user file that we want to show on
 * @param {String} color - color of an object on a mockup
 * @returns {Object} - image in Base64 format
 * @param {String} source - source of the image. canva integration or smartmockups direct upload.
 * @param {Object} [cancelToken] - Axios cancelToken object.
 */

function getLivePreviewApi(mockupId, userFileId, color, source) {
  // we'll allow live previews only to logged in users, so'll need to send a token
  var config = {
    responseType: 'json'
  };
  userFileId = encodeURIComponent(userFileId);
  var size = window.devicePixelRatio > 1.5 ? 'medium' : 'small';
  var url = "preview/".concat(size, "/").concat(mockupId, "/").concat(userFileId, "/").concat(source);

  if (color) {
    url += "?color=".concat(color);
  }

  return ServiceClient/* rendererService.get */.Vi.get(url, config);
}
/**
 * Create live preview of client side - we allowed load image for unlogged user
 * @param {Object} mockup - object of mockup we want to render
 * @param {Object} canvas - object canvas of file input we want applied to mockup
 * @param {String} color - color of an object on a mockup
 * @returns {Object} - image in Base64 format
 */

function getLivePreviewClientSideApi(_x, _x2, _x3) {
  return _getLivePreviewClientSideApi.apply(this, arguments);
}
/**
 * Allows us to load live preview image to selected mockups as "Screens" param.
 * Creates an array of "Screen" objects that are then added to local state and used to render the mockup detail
 * @param {Object} mockup - object of mockup we want to render
 * @param {Object} file - blob object of file input we want applied to mockup
 * @param {string} fileId - id of file input we want loaded from url and applied to mockup
 * @param {Object} canvas - object canvas of file input we want applied to mockup
 * @param {String} color - color of an object on a mockup
 * @returns {Promise<*>}
 */

function _getLivePreviewClientSideApi() {
  _getLivePreviewClientSideApi = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(mockup, canvas, color) {
    var _yield$setLivePreview, screens, colorMaskColors, params, MockupCreator, mockupCreator, result;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!mockup.screens) {
              _context.next = 21;
              break;
            }

            _context.next = 3;
            return setLivePreviewToMockupApi(mockup, {
              canvas: canvas
            }, color);

          case 3:
            _yield$setLivePreview = _context.sent;
            screens = _yield$setLivePreview.screens;
            colorMaskColors = _yield$setLivePreview.colorMaskColors;
            params = {
              mockup: mockup,
              width: 300 * Math.min(2, window.devicePixelRatio),
              uploadedScreens: screens,
              colorMaskColors: colorMaskColors
            };

            if (!mockup.scene) {
              _context.next = 13;
              break;
            }

            _context.next = 10;
            return Promise.all(/* import() */[__webpack_require__.e(678), __webpack_require__.e(478)]).then(__webpack_require__.bind(__webpack_require__, 90478));

          case 10:
            MockupCreator = _context.sent["default"];
            _context.next = 16;
            break;

          case 13:
            _context.next = 15;
            return __webpack_require__.e(/* import() */ 127).then(__webpack_require__.bind(__webpack_require__, 72127));

          case 15:
            MockupCreator = _context.sent["default"];

          case 16:
            mockupCreator = new MockupCreator();
            _context.next = 19;
            return mockupCreator.drawMockup(params);

          case 19:
            result = _context.sent;
            return _context.abrupt("return", result.toDataURL());

          case 21:
            return _context.abrupt("return", {
              cancelled: true
            });

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getLivePreviewClientSideApi.apply(this, arguments);
}

function setLivePreviewToMockupApi(_x4, _x5, _x6) {
  return _setLivePreviewToMockupApi.apply(this, arguments);
}
/**
 * Allows us to load preview indexed history image to selected mockups as "Screens" param.
 * Creates an array of "Screen" objects that are then added to local state and used to render the mockup detail
 * @param {Object} mockup - object of mockup we want to render
 * @param {Array} screensSetting - array with screens setting
 * @param {Array} color - array colors of an object on a mockup
 * @param {Number} variationSetting - number of variation
 * @param {Boolean} shadowSetting - boolean for render shadow
 * @returns {Promise<*>}
 */

function _setLivePreviewToMockupApi() {
  _setLivePreviewToMockupApi = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(mockup, _ref, color) {
    var file, fileId, canvas, image, url, alignSize, screens, colorMaskColors, objectColor;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            file = _ref.file, fileId = _ref.fileId, canvas = _ref.canvas;

            if (!file) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return loadBlobAsCanvas(file);

          case 4:
            image = _context2.sent;
            _context2.next = 15;
            break;

          case 7:
            if (!canvas) {
              _context2.next = 11;
              break;
            }

            // canvas expects canvas from input, it does not need to be further processed.
            image = canvas;
            _context2.next = 15;
            break;

          case 11:
            // fileId expects id from input and image is loaded from url which must be converted to canvas.
            url = "".concat(variables/* HISTORY_IMGIX */.eK, "/").concat(fileId, "?auto=compress,format");
            _context2.next = 14;
            return (0,utils_loadImageAsCanvas/* default */.Z)(url);

          case 14:
            image = _context2.sent;

          case 15:
            alignSize = mockup.category === 'apparel' ? '60 auto' : 'cover';
            screens = mockup.screens.map(function (mockupScreen) {
              var screen = (0,dist.alignImage)(image, mockupScreen, 'center, center', alignSize); // we need to add same properties that ImageCropper is adding to the "Screen" Object

              screen.uploadedImage = image;
              screen.uploadedImageWidth = image.width;
              screen.uploadedImageHeight = image.height;
              screen.uploadedImageTitle = 'Live preview image';
              screen.timestamp = new Date().getTime();
              return screen;
            });
            colorMaskColors = [];
            objectColor = color ? hexToRgba(color) : [255, 255, 255, 1];

            if (mockup.colorMasks) {
              colorMaskColors = mockup.colorMasks.map(function () {
                return objectColor;
              });
            } // compatibility with legacy colorMask property
            else if (mockup.colorMask) {
              colorMaskColors = objectColor;
            }

            return _context2.abrupt("return", {
              screens: screens,
              colorMaskColors: colorMaskColors
            });

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setLivePreviewToMockupApi.apply(this, arguments);
}

function setPreviewIndexedHistoryToMockupApi(_x7, _x8, _x9, _x10, _x11) {
  return _setPreviewIndexedHistoryToMockupApi.apply(this, arguments);
}

function _setPreviewIndexedHistoryToMockupApi() {
  _setPreviewIndexedHistoryToMockupApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(mockup, screensSetting, color, variationSetting, shadowSetting) {
    var screens, colorMaskColors, showShadows, variation;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all(screensSetting.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(screen) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(screen !== null && screen !== void 0 && screen.uploadedImage)) {
                          _context3.next = 4;
                          break;
                        }

                        _context3.next = 3;
                        return loadImageAsCanvas(screen.uploadedImage);

                      case 3:
                        screen.uploadedImage = _context3.sent;

                      case 4:
                        return _context3.abrupt("return", screen);

                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x12) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
            screens = _context4.sent;
            colorMaskColors = color || [[255, 255, 255, 1]];
            showShadows = shadowSetting || false;
            variation = variationSetting || 0;
            return _context4.abrupt("return", {
              screens: screens,
              colorMaskColors: colorMaskColors,
              showShadows: showShadows,
              variation: variation
            });

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _setPreviewIndexedHistoryToMockupApi.apply(this, arguments);
}
// EXTERNAL MODULE: ./utils/envDetection.js
var envDetection = __webpack_require__(32882);
;// CONCATENATED MODULE: ./utils/getURLSearchParams.js

function getURLSearchParams() {
  if ((0,envDetection/* isClient */.C5)()) {
    return new URLSearchParams(window.location.search);
  }

  return new URLSearchParams();
}
;// CONCATENATED MODULE: ./components/List/MockupPreview/previewSettings.js
var liveColorSubcats = ['tshirts', 'tanks', 'hoodies', 'sweatshirts', 'pillows', 'accessories'];
// EXTERNAL MODULE: ./node_modules/pica/dist/pica.js
var dist_pica = __webpack_require__(16373);
var pica_default = /*#__PURE__*/__webpack_require__.n(dist_pica);
// EXTERNAL MODULE: ./hooks/useActions.js
var useActions = __webpack_require__(11690);
// EXTERNAL MODULE: ./apis/helpers.js
var helpers = __webpack_require__(20927);
;// CONCATENATED MODULE: ./apis/historyApi.js




var _excluded = (/* unused pure expression or super */ null && (["uploadedImage"])),
    _excluded2 = (/* unused pure expression or super */ null && (["uploadedVideo"]));

function historyApi_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function historyApi_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? historyApi_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : historyApi_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var HISTORY_THUMB_WIDTH = 768;
var HISTORY_THUMB_FORMAT = 'jpg';
var HISTORY_ENDPOINT = 'history';
var CONTINUATION_VAR = 'continuation';
function getHistoryApi(_x, _x2) {
  return _getHistoryApi.apply(this, arguments);
}

function _getHistoryApi() {
  _getHistoryApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(timestamp, username) {
    var res, promises;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return historyService.get("".concat(HISTORY_ENDPOINT, "/").concat(username, "/").concat(timestamp));

          case 2:
            res = _context3.sent;
            console.log('%c HISTORY', 'background-color: lightblue', res.screens);
            promises = _toConsumableArray(res.screens.map(function (screen) {
              return loadScreen(screen);
            }));
            _context3.next = 7;
            return Promise.all(promises);

          case 7:
            res.screens = _context3.sent;
            return _context3.abrupt("return", res);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getHistoryApi.apply(this, arguments);
}

function fetchHistoryListApi(_x3, _x4) {
  return _fetchHistoryListApi.apply(this, arguments);
}

function _fetchHistoryListApi() {
  _fetchHistoryListApi = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(username, pagination) {
    var url;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = "historylist/".concat(username);

            if (pagination) {
              url += "?".concat(CONTINUATION_VAR, "=").concat(pagination);
            }

            return _context4.abrupt("return", ServiceClient/* historyService.get */.pq.get(url));

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchHistoryListApi.apply(this, arguments);
}

function deleteHistoryApi(_x5, _x6) {
  return _deleteHistoryApi.apply(this, arguments);
}
/**
 * Calls the API to duplicate history item
 * @param {number} timestamp
 * @param {string} username
 * @returns {HistoryItem}
 */

function _deleteHistoryApi() {
  _deleteHistoryApi = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(timestamp, username) {
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", ServiceClient/* historyService.delete */.pq["delete"]("".concat(HISTORY_ENDPOINT, "/").concat(username, "/").concat(timestamp)));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _deleteHistoryApi.apply(this, arguments);
}

function duplicateHistoryItemApi(_x7, _x8) {
  return _duplicateHistoryItemApi.apply(this, arguments);
}

function _duplicateHistoryItemApi() {
  _duplicateHistoryItemApi = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(timestamp, username) {
    var url, data;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = "".concat(HISTORY_ENDPOINT, "/duplicate");
            data = {
              username: username,
              timestamp: timestamp
            };
            return _context6.abrupt("return", ServiceClient/* historyService.post */.pq.post(url, data));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _duplicateHistoryItemApi.apply(this, arguments);
}

var uploadHistoryImage = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(previewImg, timestamp, username) {
    var filename, s3;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            filename = "".concat(timestamp);
            _context.next = 3;
            return getSignedUrl(filename, HISTORY_THUMB_FORMAT, username, '_pr');

          case 3:
            s3 = _context.sent;
            _context.next = 6;
            return uploadBlobToS3(previewImg, s3.mime, s3.url);

          case 6:
            return _context.abrupt("return", s3);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function uploadHistoryImage(_x9, _x10, _x11) {
    return _ref.apply(this, arguments);
  };
}()));

var getHistoryScreens = function getHistoryScreens(screensArg) {
  var screens = screensArg.map(function (scr) {
    if (!scr) return;

    var uploadedImage = scr.uploadedImage,
        screen = _objectWithoutProperties(scr, _excluded); // remove video item in case it was not uploaded ( should not happen)


    if (screen.uploadedVideo && typeof screen.uploadedVideo !== 'string' && !(screen.uploadedVideo instanceof String)) {
      var uploadedVideo = screen.uploadedVideo,
          output = _objectWithoutProperties(screen, _excluded2);

      return output;
    }

    return screen;
  });
  return screens;
};

var addHistoryApi = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, allowEmpty) {
    var dataScreens, uploadedScreensCounter, historyScreens, bg, finalData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            dataScreens = data.screens || [];
            uploadedScreensCounter = data.screens.filter(function (s) {
              return s === null || s === void 0 ? void 0 : s.historyFilename;
            }).length; // we don't want to upload empty history items without user's screen

            if (!(!allowEmpty && uploadedScreensCounter === 0)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", null);

          case 4:
            historyScreens = getHistoryScreens(dataScreens);
            _context2.prev = 5;
            _context2.next = 8;
            return uploadBgImage(data.bg, data.timestamp, data.username);

          case 8:
            bg = _context2.sent;
            finalData = historyApi_objectSpread(historyApi_objectSpread({}, data), {}, {
              screens: historyScreens,
              bg: bg
            });
            console.log("%c finalData", 'background-color: pink; color: white', finalData);
            return _context2.abrupt("return", historyService.post(HISTORY_ENDPOINT, historyApi_objectSpread({}, finalData)));

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](5);
            console.error('Unable to updateHistory', _context2.t0);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 14]]);
  }));

  return function addHistoryApi(_x12, _x13) {
    return _ref2.apply(this, arguments);
  };
}()));
function uploadHistoryScreensApi(_x14, _x15) {
  return _uploadHistoryScreensApi.apply(this, arguments);
}

function _uploadHistoryScreensApi() {
  _uploadHistoryScreensApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(screens, username) {
    var promises;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            promises = _toConsumableArray(screens.map(function (screen) {
              return uploadScreen(screen, username);
            }));
            _context7.next = 4;
            return Promise.all(promises);

          case 4:
            return _context7.abrupt("return", _context7.sent);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            console.log(_context7.t0);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));
  return _uploadHistoryScreensApi.apply(this, arguments);
}

function uploadScreen(_x16, _x17) {
  return _uploadScreen.apply(this, arguments);
}

function _uploadScreen() {
  _uploadScreen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(screen, username) {
    var filetype, filename, res, s3, blob, historyScreen;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;

            if (!(!screen || !screen.uploadedImage || screen.historyFilename)) {
              _context8.next = 3;
              break;
            }

            return _context8.abrupt("return", null);

          case 3:
            filetype = 'png';
            filename = getFileName(screen.uploadedImageTitle);
            _context8.next = 7;
            return getSignedUrl(filename, filetype, username);

          case 7:
            res = _context8.sent;
            s3 = res;
            _context8.next = 11;
            return canvasToBlob(screen.uploadedImage, s3.mime);

          case 11:
            blob = _context8.sent;
            _context8.next = 14;
            return uploadBlobToS3(blob, s3.mime, s3.url);

          case 14:
            historyScreen = {
              historyFilename: s3.key
            }; // in case screen has a video, and it's not an URL, we have to upload it as well

            if (!(screen.uploadedVideo && typeof screen.uploadedVideo !== 'string' && !(screen.uploadedVideo instanceof String))) {
              _context8.next = 23;
              break;
            }

            _context8.next = 18;
            return getSignedUrl(screen.uploadedImageTitle, getFileExension(screen.uploadedImageTitle), username);

          case 18:
            res = _context8.sent;
            s3 = res;
            _context8.next = 22;
            return uploadBlobToS3(screen.uploadedVideo, s3.mime, s3.url);

          case 22:
            historyScreen.uploadedVideo = s3.fileUrl;

          case 23:
            return _context8.abrupt("return", historyScreen);

          case 26:
            _context8.prev = 26;
            _context8.t0 = _context8["catch"](0);
            console.log(_context8.t0);

          case 29:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 26]]);
  }));
  return _uploadScreen.apply(this, arguments);
}

function getSignedUrl(filename, filetype, username, postfix) {
  return historyService.get("upload?filetype=".concat(filetype, "&filename=").concat(filename, "&username=").concat(username, "&postfix=").concat(postfix || ''));
}

function getImageUrlAsCanvas(image) {
  return new Promise(function (resolve, reject) {
    var img = new Image();

    img.onload = function () {
      var canvas = document.createElement('canvas'); // maximalni sirku nahravaneho obrazku omezime na 2500k at to neni zbytecne mega velky

      canvas.width = Math.min(img.width, 2500);
      canvas.height = Math.round(img.height / img.width * canvas.width);
      var ctx = canvas.getContext('2d');
      ctx.globalCompositeOperation = 'copy';
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';
      resolve(canvas);
    };

    img.onerror = function () {
      reject();
    };

    img.crossOrigin = 'Anonymous';
    img.src = image;
  });
}

function imageToCanvas(image) {
  var canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
  return canvas;
}

function canvasToBlob(_x18, _x19) {
  return _canvasToBlob.apply(this, arguments);
} // TODO refactor this into reusable shared function
//  find other occurences and unite


function _canvasToBlob() {
  _canvasToBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(canvas, mime) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", new Promise(function (resolve) {
              canvas.toBlob(function (blob) {
                resolve(blob);
              }, mime, 0.9);
            }));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _canvasToBlob.apply(this, arguments);
}

function uploadBlobToS3(blob, mime, s3url) {
  return new Promise(function (resolve, reject) {
    var xhr = createCORSRequest('PUT', s3url);

    xhr.onload = function () {
      if (xhr.status === 200) {
        console.log(xhr.status);
        resolve();
      } else {
        console.log(xhr.status);
        reject(xhr.status);
      }
    };

    xhr.setRequestHeader('Content-Type', mime);
    xhr.setRequestHeader('x-amz-acl', 'private');
    xhr.send(blob);
  });
}

function loadScreen(_x20) {
  return _loadScreen.apply(this, arguments);
}

function _loadScreen() {
  _loadScreen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(screen) {
    var url, newScreen, uploadedImage;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!(!screen || !screen.historyFilename)) {
              _context10.next = 2;
              break;
            }

            return _context10.abrupt("return", null);

          case 2:
            url = "".concat(HISTORY_IMGIX, "/").concat(screen.historyFilename, "?max-w=1920&auto=compress,format");
            _context10.prev = 3;
            newScreen = historyApi_objectSpread({}, screen); // create uploadedImage canvas from the history file

            _context10.next = 7;
            return getImageUrlAsCanvas(url);

          case 7:
            uploadedImage = _context10.sent;

            // backwards compatibility with old history screens, where transform was not stored
            if (screen.hasOwnProperty('transform')) {
              // handle transformations upon the uploadedImage
              // TODO can remove this logic as this is done in screenCreator itself
              // if (screen.transform.rotate && screen.transform.rotate !== 0) {
              //     uploadedImage = rotateCanvas(uploadedImage, screen.transform.rotate);
              // }
              if (screen.transform.hflip) {
                uploadedImage = flipCanvasHorizontally(uploadedImage);
              }

              if (screen.transform.vflip) {
                uploadedImage = flipCanvasVertically(uploadedImage);
              }
            }

            newScreen.uploadedImage = uploadedImage;
            return _context10.abrupt("return", newScreen);

          case 13:
            _context10.prev = 13;
            _context10.t0 = _context10["catch"](3);
            return _context10.abrupt("return", null);

          case 16:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[3, 13]]);
  }));
  return _loadScreen.apply(this, arguments);
}

function uploadBgImage(_x21, _x22, _x23) {
  return _uploadBgImage.apply(this, arguments);
}

function _uploadBgImage() {
  _uploadBgImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(bg, timestamp, username) {
    var finalData, filename, res, s3, canvas, blob;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(!bg || Array.isArray(bg) || bg.source !== 'local')) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return", bg);

          case 2:
            _context11.prev = 2;
            finalData = historyApi_objectSpread({}, bg);
            filename = "".concat(timestamp, "_bg");
            _context11.next = 7;
            return getSignedUrl(filename, 'png', username);

          case 7:
            res = _context11.sent;
            s3 = res.data;
            canvas = imageToCanvas(bg.image);
            _context11.next = 12;
            return canvasToBlob(canvas, s3.mime);

          case 12:
            blob = _context11.sent;
            _context11.next = 15;
            return uploadBlobToS3(blob, s3.mime, s3.url);

          case 15:
            finalData.image = s3.key;
            finalData.source = 'history';
            return _context11.abrupt("return", finalData);

          case 20:
            _context11.prev = 20;
            _context11.t0 = _context11["catch"](2);
            alert(_context11.t0);

          case 23:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[2, 20]]);
  }));
  return _uploadBgImage.apply(this, arguments);
}
// EXTERNAL MODULE: ./actions/actionTypes.js
var actionTypes = __webpack_require__(18569);
;// CONCATENATED MODULE: ./actions/mockupList.js








var mockupList_algoliasearch = __webpack_require__(24955);

var mockupList_client = mockupList_algoliasearch('CHOYNIXSLK', '137a0fb339d1422645b68c2d1eaafd20');
var mockupList_index = mockupList_client.initIndex('mockups');
function setActiveTags(tags) {
  return {
    type: actionTypes/* SET_ACTIVE_TAGS */.OD,
    payload: tags
  };
}
function setOrder(order) {
  return {
    type: actionTypes/* SET_ORDER */.GF,
    payload: order
  };
}
function setLivePreview(livePreview) {
  return {
    type: actionTypes/* SET_LIVE_PREVIEW */.BM,
    payload: livePreview
  };
}
function getSearchResults(query, locale) {
  query = query.replace(/(<([^>]+)>)/ig, '');

  if (!query) {
    return {
      type: actionTypes/* EMPTY_SEARCH_RESULTS */.d3,
      payload: []
    };
  }

  var restrictSearchableAttributes = ['title', 'tags', 'previewTitle', 'variation_title', 'subcategory', 'category', 'predictedTags'];
  var attributesToRetrieve = ['id', 'shortId', 'title', 'isPremium', 'category', 'subcategory', 'publishDate', 'hasBackground', 'isDraft', 'tags', 'previewTitle', 'thumb', 'blurhash', 'width', 'height', 'type', 'layers', 'metadata', 'previews'];

  if (locale && locale !== 'en') {
    restrictSearchableAttributes.unshift("title-".concat(locale));
  }

  var request = mockupList_index.search(query, {
    filters: 'NOT disabled.smartmockups: true',
    attributesToRetrieve: attributesToRetrieve,
    restrictSearchableAttributes: restrictSearchableAttributes,
    hitsPerPage: 5000
  });
  return {
    type: actionTypes/* GET_SEARCH_RESULTS */.IC,
    payload: request
  };
}
function fetchHistoryList(username) {
  var request = fetchHistoryListApi(username);
  return {
    type: actionTypes/* FETCH_HISTORY_LIST */.dw,
    payload: request
  };
}
function fetchHistoryListPage(username, pagination) {
  var request = fetchHistoryListApi(username, pagination);
  return {
    type: actionTypes/* FETCH_HISTORY_LIST_PAGE */.aM,
    payload: request
  };
}
function duplicateHistory(username, pagination) {
  var request = duplicateHistoryItemApi(username, pagination);
  return {
    type: actionTypes/* DUPLICATE_HISTORY */.g3,
    payload: request
  };
}
function deleteHistory(timestamp, username) {
  var request = deleteHistoryApi(timestamp, username);
  return {
    type: actionTypes/* DELETE_HISTORY */.Un,
    payload: request
  };
}
function fetchMockupsForCategory(category, user, locale) {
  var qs = '';

  if (user && user.isScheduled) {
    qs = "&scheduled=true";
  }

  if (user && user.isAdmin) {
    qs = "&scheduled=true&drafts=true&nocache=true";
  }

  var request = ServiceClient/* mockupsService.get */.rp.get("collection/".concat(category, "?locale=").concat(locale_getLocaleCodeLong(locale)).concat(qs));
  return {
    type: actionTypes/* FETCH_MOCKUPS_FOR_CATEGORY */.CD,
    payload: request
  };
}
function fetchMockupsForCategoryServer(_x, _x2) {
  return _fetchMockupsForCategoryServer.apply(this, arguments);
}

function _fetchMockupsForCategoryServer() {
  _fetchMockupsForCategoryServer = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(category, locale) {
    var res;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return ServiceClient/* mockupsService.get */.rp.get("collection/".concat(category, "?locale=").concat(locale_getLocaleCodeLong(locale)));

          case 2:
            res = _context.sent;
            return _context.abrupt("return", {
              type: actionTypes/* FETCH_MOCKUPS_FOR_CATEGORY */.CD,
              payload: res
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchMockupsForCategoryServer.apply(this, arguments);
}

function setLastVisitedCollection(collection) {
  return {
    type: actionTypes/* SET_LAST_VISITED_COLLECTION */.l4,
    payload: collection
  };
}
function fetchMockupsForBundle(bundleId) {
  var request = ServiceClient/* default.get */.ZP.get("".concat(variables/* BUNDLE_MOCKUPS_API */.OP, "/mockups/").concat(bundleId));
  return {
    type: actionTypes/* FETCH_MOCKUPS_FOR_BUNDLE */.xk,
    payload: request
  };
}
;// CONCATENATED MODULE: ./apis/userFileApi.js





function uploadUserFileToS3(_x, _x2, _x3, _x4) {
  return _uploadUserFileToS.apply(this, arguments);
}

function _uploadUserFileToS() {
  _uploadUserFileToS = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(file, filetype, username, progressFunction) {
    var s3;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return userFileApi_getSignedUrl(filetype, username);

          case 3:
            s3 = _context.sent;
            _context.next = 6;
            return userFileApi_uploadBlobToS3(file, s3.mime, s3.url, progressFunction);

          case 6:
            return _context.abrupt("return", s3.fileUrl);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
            throw _context.t0;

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));
  return _uploadUserFileToS.apply(this, arguments);
}

function userFileApi_uploadBlobToS3(blob, filetype, s3url, progressFunction) {
  return new Promise(function (resolve, reject) {
    var xhr = (0,helpers/* createCORSRequest */.QB)('PUT', s3url);

    xhr.onload = function () {
      if (xhr.status === 200) {
        console.log(xhr.status);
        resolve();
      } else {
        console.log(xhr.status);
        reject(xhr);
      }
    };

    xhr.upload.onprogress = progressFunction;
    xhr.setRequestHeader('Content-Type', filetype);
    xhr.setRequestHeader('x-amz-acl', 'public-read');
    xhr.send(blob);
  });
}
function userFileApi_getSignedUrl(filetype, username) {
  return ServiceClient/* default.get */.ZP.get("".concat(variables/* USER_FILE_API */.SF, "/upload?filetype=").concat(filetype, "&username=").concat(username));
}
;// CONCATENATED MODULE: ./hooks/useLivePreview.js



function useLivePreview_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useLivePreview_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useLivePreview_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useLivePreview_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var sourceHistory = 'history';
var sourceTemp = 'temp';
var maxLength = 500;

var useLivePreview = function useLivePreview(trigger) {
  var _useActions = (0,useActions/* default */.Z)(mockupList_namespaceObject, 'setLivePreview'),
      setLivePreview = _useActions.setLivePreview;

  var router = (0,next_router.useRouter)();

  var _ref = (0,es/* useSelector */.v9)(function (state) {
    return state.mockupsList.livePreview;
  }) || {},
      isUploading = _ref.isUploading,
      isClientSide = _ref.isClientSide,
      file = _ref.file,
      fileId = _ref.fileId,
      source = _ref.source,
      origin = _ref.origin,
      canvas = _ref.canvas,
      predefinedFileId = _ref.predefinedFileId;

  var user = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.user;
  });

  if (router.query.preview !== undefined && router.query.preview !== fileId) {
    fileId = router.query.preview;
    source = sourceHistory;
    setLivePreview({
      fileId: fileId,
      source: source
    });
  } // detect an origin page of live preview event


  function getCurrentOrigin() {
    var origin;
    var rootPath = router.route.split('/')[1];

    if (rootPath === 'mockups') {
      var _router$query$slug;

      origin = {
        path: 'collection',
        query: (_router$query$slug = router.query.slug) === null || _router$query$slug === void 0 ? void 0 : _router$query$slug[0]
      };
    }

    if (rootPath === 'user-collection') {
      var _router$query$id;

      origin = {
        path: 'userCollection',
        query: (_router$query$id = router.query.id) !== null && _router$query$id !== void 0 ? _router$query$id : null
      };
    }

    if (router.route === "/") {
      origin = {
        path: '/'
      };
    }

    return origin;
  }

  var uploadFile = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(blob) {
      var url, filetype, resizedBlob, uploadedFileKey;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = blob;
              isUploading = true;
              isClientSide = false;
              canvas = null;
              setLivePreview({
                isUploading: isUploading,
                file: file,
                isClientSide: isClientSide,
                canvas: canvas
              });
              filetype = getFileType(file);
              _context.next = 8;
              return resize(file);

            case 8:
              resizedBlob = _context.sent;
              _context.prev = 9;
              _context.next = 12;
              return uploadUserFileToS3(resizedBlob, filetype, user.username);

            case 12:
              url = _context.sent;
              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](9);
              alert("Error: ".concat(_context.t0.status, " - ").concat(_context.t0.statusText));
              console.error(_context.t0);
              setLivePreview(undefined);

            case 20:
              if (url) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return");

            case 22:
              uploadedFileKey = url.slice(variables/* TEMP_UPLOADS_S3.length */.Le.length + 1);
              source = sourceTemp;
              isUploading = false;
              origin = getCurrentOrigin();
              setLivePreview({
                isUploading: isUploading,
                file: file,
                fileId: uploadedFileKey,
                source: source,
                origin: origin
              });
              trackLivePreviewEvent('Live Preview uploaded', {
                isEdit: !!fileId
              });

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 15]]);
    }));

    return function uploadFile(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var uploadFileClient = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(url, id) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isUploading = true;
              isClientSide = true;
              predefinedFileId = id;
              setLivePreview({
                isUploading: isUploading,
                isClientSide: isClientSide,
                predefinedFileId: predefinedFileId
              });
              _context2.next = 6;
              return (0,utils_loadImageAsCanvas/* default */.Z)(url);

            case 6:
              canvas = _context2.sent;
              isUploading = false;
              origin = getCurrentOrigin();
              setLivePreview({
                isUploading: isUploading,
                canvas: canvas,
                origin: origin
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function uploadFileClient(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var trackLivePreviewEvent = function trackLivePreviewEvent(eventType, params) {
    var payload = useLivePreview_objectSpread({
      origin: origin,
      trigger: trigger
    }, params);

    (0,trackingParty/* trackEvent */.L9)(eventType, payload);
  };

  var resize = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(file) {
      var img, isLandscape, toWidth, toHeight, resizedCanvas, pica, resizeOption;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return loadBlobAsImg(file);

            case 2:
              img = _context3.sent;
              isLandscape = img.width > img.height;

              if (!(isLandscape && img.width >= maxLength)) {
                _context3.next = 9;
                break;
              }

              toWidth = maxLength;
              toHeight = img.height * (toWidth / img.width);
              _context3.next = 15;
              break;

            case 9:
              if (!(!isLandscape && img.height >= maxLength)) {
                _context3.next = 14;
                break;
              }

              toHeight = maxLength;
              toWidth = img.width * (toHeight / img.height);
              _context3.next = 15;
              break;

            case 14:
              return _context3.abrupt("return", file);

            case 15:
              resizedCanvas = (0,dist.createCanvas)(toWidth, toHeight);
              pica = new (pica_default())();
              resizeOption = {
                toWidth: toWidth,
                toHeight: toHeight,
                unsharpAmount: 90,
                unsharpRadius: 0.6,
                unsharpThreshold: 2,
                alpha: true
              };
              return _context3.abrupt("return", pica.resize(img, resizedCanvas, resizeOption).then(function (result) {
                return pica.toBlob(result, file.type);
              }));

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function resize(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var clear = function clear() {
    var currentPage = getCurrentOrigin();
    var isCurrentPage = currentPage.path === origin.path && currentPage.query === origin.query;
    trackLivePreviewEvent('Live Preview cleared', {
      isCurrentPage: isCurrentPage
    });
    setLivePreview(undefined);
  };

  return {
    file: file,
    fileId: fileId,
    source: source,
    canvas: canvas,
    predefinedFileId: predefinedFileId,
    isUploading: isUploading,
    isClientSide: isClientSide,
    uploadFile: uploadFile,
    uploadFileClient: uploadFileClient,
    clear: clear
  };
}; // Idea for improvement: extend this to primarilly use mimetype (File type has it, resized Blob as well).
// And move this to /utils for use in other places.


var getFileType = function getFileType(file) {
  return file.name.split('.').pop();
};

/* harmony default export */ var hooks_useLivePreview = (useLivePreview);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
;// CONCATENATED MODULE: ./components/List/MockupPreview/useMockupPreview.js











function useMockupPreview(props) {
  var livePreview = hooks_useLivePreview();

  var _useState = (0,react.useState)(null),
      dataUrl = _useState[0],
      setDataUrl = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(undefined),
      ongoingRequest = _useState3[0],
      setOngoingRequest = _useState3[1];

  var mockup = props.mockup;
  var fileId = livePreview.fileId,
      source = livePreview.source,
      isClientSide = livePreview.isClientSide,
      canvas = livePreview.canvas;
  var color = getColor();
  var mockupUrl = getMockupUrl();

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    rootMargin: '700px',
    triggerOnce: true
  }),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  (0,react.useEffect)(function () {
    if (inView && (fileId || canvas && mockup.screens) && mockup) {
      (function () {
        var _fetchPreview = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          var thisRequest, res;
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setIsLoading(true);

                  if ((ongoingRequest === null || ongoingRequest === void 0 ? void 0 : ongoingRequest.cancelled) === false) {
                    ongoingRequest.cancel();
                  }

                  if (!isClientSide) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 5;
                  return getLivePreviewClientSideApi(mockup, canvas, color);

                case 5:
                  _context.t0 = _context.sent;
                  _context.next = 9;
                  break;

                case 8:
                  _context.t0 = getLivePreviewApi(mockup.shortId, fileId, color, source);

                case 9:
                  thisRequest = _context.t0;
                  _context.next = 12;
                  return thisRequest;

                case 12:
                  res = _context.sent;

                  // fetching may have been cancelled outside of this fetch function
                  if (!thisRequest.cancelled) {
                    setOngoingRequest(undefined);
                    setDataUrl(isClientSide ? res : res.src);
                    setIsLoading(false);
                  }

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function fetchPreview() {
          return _fetchPreview.apply(this, arguments);
        }

        return fetchPreview;
      })()();
    } else {
      setDataUrl(null);
    }
  }, [inView, fileId, canvas, mockup, isClientSide]);

  function getColor() {
    if (!mockup.collections) return null;
    var urlParams = getURLSearchParams();
    mockup.collections.map(function (collection) {
      if (liveColorSubcats.indexOf(collection) > -1 && urlParams.has('color')) {
        return urlParams.get('color');
      }

      return null;
    });
    return null;
  }

  function getMockupUrl() {
    var _mockup$shortId;

    var id = (_mockup$shortId = mockup.shortId) !== null && _mockup$shortId !== void 0 ? _mockup$shortId : mockup.id;
    var mockupUrl = "/mockup/".concat(encodeURIComponent(id));

    if (color) {
      mockupUrl += "&color=".concat(color);
    }

    return mockupUrl;
  }

  return {
    ref: ref,
    dataUrl: dataUrl,
    isLoading: isLoading,
    mockupUrl: mockupUrl
  };
}

/* harmony default export */ var MockupPreview_useMockupPreview = (useMockupPreview);
useMockupPreview.propTypes = {
  onLockedClick: (prop_types_default()).func
};
;// CONCATENATED MODULE: ./components/List/MockupPreview/helpers.js
var PREVIEW_WIDTH = 366;
var PREVIEW_HEIGHT = 274;
var SIZES_WITH_SIDEBAR = "\n        367px,\n        (max-width: 1920px) calc(23vw - 2*9px),\n        (max-width: 1530px) calc(31vw - 2*9px),\n        (max-width: 1530px) calc(31vw - 2*9px),\n        (max-width: 922px) calc(31vw - 2*9px),\n        (max-width: 768px)  calc(46vw - 2*4px)";
var SIZES_WITHOUT_SIDEBAR = "\n        295px,\n        (max-width: 1392px) calc(23vw - 2*9px),\n        (max-width: 1200px) calc(31vw - 2*9px),\n        (max-width: 768px)  calc(46vw - 2*4px)";
function getImgixParams(mockupCategory) {
  var params = {
    crop: 'center',
    fit: 'crop',
    auto: 'compress',
    q: 38
  }; // portrait mockups has to be cropped from the top

  if (mockupCategory === 'apparel') {
    params.crop = 'faces,top';
    params.fit = 'crop';
  }

  return params;
}
;// CONCATENATED MODULE: ./utils/locale/isLocalisedMockupPreview.js


var isLocalisedMockupPreview = function isLocalisedMockupPreview(locale) {
  return localeVariables.MOCKUPS_PREVIEWS_LOCALES.find(function (code) {
    return code === locale;
  });
};

/* harmony default export */ var locale_isLocalisedMockupPreview = (isLocalisedMockupPreview);
// EXTERNAL MODULE: ./node_modules/react-imgix/es/index.js + 14 modules
var react_imgix_es = __webpack_require__(71100);
// EXTERNAL MODULE: ./node_modules/react-blurhash/es/index.js + 2 modules
var react_blurhash_es = __webpack_require__(93806);
;// CONCATENATED MODULE: ./components/List/MockupPreview/parts/MockupImage.js










var MockupImage = function MockupImage(props) {
  var mockup = props.mockup,
      isPreviewHover = props.isPreviewHover,
      locale = props.locale,
      isLazyLoad = props.isLazyLoad,
      isMasonry = props.isMasonry;
  var imgixParams = getImgixParams(mockup.category);
  var loc = locale_isLocalisedMockupPreview(locale) ? locale : 'en';
  var thumbId = mockup.thumb || "".concat(mockup.shortId, "_pr");
  var imageUrl = isMasonry ? "".concat(variables/* PUBLIC_MOCKUP_IMGIX */.Z9, "/").concat(thumbId, "_").concat(loc, ".jpg") : "".concat(variables/* PUBLIC_MOCKUP_IMGIX */.Z9, "/").concat(thumbId, "_").concat(loc, ".jpg?h=").concat(PREVIEW_HEIGHT, "&w=").concat(PREVIEW_WIDTH);
  var imageHover = isMasonry ? "".concat(variables/* PUBLIC_MOCKUP_IMGIX */.Z9, "/").concat(mockup.shortId, "_pr_hover.jpg") : "".concat(variables/* PUBLIC_MOCKUP_IMGIX */.Z9, "/").concat(mockup.shortId, "_pr_hover.jpg?h=").concat(PREVIEW_HEIGHT, "&w=").concat(PREVIEW_WIDTH);
  var isHoverImage = mockup.isPreviewHover && isPreviewHover;
  var blurhash = mockup.blurhash && mockup.blurhash.length > 6 ? mockup.blurhash : 'eIP7X,%M~9%M0g_NkWay%2j]^hof58WC=_-:s:bIIpaeR.j[slkCS5';
  return (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("figure", {
      title: mockup.title,
      className: (MockupPreview_module_default()).ratioContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_blurhash_es/* Blurhash */.E, {
        hash: blurhash,
        className: "".concat((MockupPreview_module_default()).blurhash, " blurhash")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_imgix_es/* default */.ZP, {
        className: "".concat((MockupPreview_module_default()).image, " ").concat(isLazyLoad && "".concat((MockupPreview_module_default()).isLazy, " lazyload")),
        src: "".concat(imageUrl),
        sizes: SIZES_WITH_SIDEBAR,
        attributeConfig: isLazyLoad && {
          src: 'data-src',
          srcSet: 'data-srcset',
          loading: 'lazy'
        },
        htmlAttributes: {
          alt: mockup.title
        },
        height: PREVIEW_HEIGHT,
        imgixParams: imgixParams
      }), isHoverImage && /*#__PURE__*/(0,jsx_runtime.jsx)(react_imgix_es/* default */.ZP, {
        className: "".concat((MockupPreview_module_default()).hover, " lazyload"),
        src: "".concat(imageHover),
        sizes: SIZES_WITH_SIDEBAR,
        attributeConfig: {
          src: 'data-src',
          srcSet: 'data-srcset',
          loading: 'lazy'
        },
        htmlAttributes: {
          alt: mockup.title
        },
        height: PREVIEW_HEIGHT,
        imgixParams: imgixParams
      })]
    });
  }, [isHoverImage, imageUrl, imgixParams, mockup]);
};

/* harmony default export */ var parts_MockupImage = (MockupImage);
// EXTERNAL MODULE: ./components/List/CollectionPreview/CollectionPreview.module.scss
var CollectionPreview_module = __webpack_require__(80123);
var CollectionPreview_module_default = /*#__PURE__*/__webpack_require__.n(CollectionPreview_module);
;// CONCATENATED MODULE: ./components/List/CollectionPreview/CollectionMockupImage.js







var CollectionMockupImage = function CollectionMockupImage(props) {
  var mockupId = props.mockupId,
      mockupThumb = props.mockupThumb,
      locale = props.locale,
      previewWidth = props.previewWidth,
      previewHeight = props.previewHeight,
      title = props.title,
      setIcon = props.setIcon,
      isNotLazy = props.isNotLazy;
  var thumbId = mockupThumb || "".concat(mockupId, "_pr");
  var loc = locale || 'en';
  var imageUrl = "".concat(variables/* PUBLIC_MOCKUP_IMGIX */.Z9, "/").concat(thumbId, "_").concat(loc, ".jpg?w=").concat(previewWidth, "?h=").concat(previewHeight);
  var params = {
    crop: 'top,center',
    fit: 'crop',
    auto: 'compress',
    'max-w': previewWidth * 2
  };
  return (0,react.useMemo)(function () {
    if (isNotLazy === true && (mockupId || mockupThumb)) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
        title: title,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_imgix_es/* default */.ZP, {
          src: "".concat(imageUrl),
          sizes: SIZES_WITH_SIDEBAR,
          htmlAttributes: {
            alt: title
          },
          width: previewWidth,
          height: previewHeight,
          imgixParams: params
        })
      });
    }

    if (mockupId || mockupThumb) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
        title: title,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_imgix_es/* default */.ZP, {
          className: "lazyload",
          src: "".concat(imageUrl),
          sizes: SIZES_WITH_SIDEBAR,
          attributeConfig: {
            src: 'data-src',
            srcSet: 'data-srcset',
            loading: 'lazy'
          },
          htmlAttributes: {
            src: "".concat(imageUrl, "?blur=200&px=8&fit=crop&q=1"),
            alt: title
          },
          width: previewWidth,
          height: previewHeight,
          imgixParams: params
        })
      });
    }

    if (setIcon) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "Image",
        width: 40,
        height: 40,
        color: "grey"
      });
    }

    return null;
  }, [imageUrl, params, setIcon, title, isNotLazy]);
};

/* harmony default export */ var CollectionPreview_CollectionMockupImage = (CollectionMockupImage);
;// CONCATENATED MODULE: ./components/List/CollectionPreview/CollectionPreview.js










var CollectionOverlay = function CollectionOverlay(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((CollectionPreview_module_default()).overlayWrap, " ").concat(props.className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CollectionPreview_module_default()).overlay
    }), props.children]
  });
};

var CollectionPreview = function CollectionPreview(props) {
  var collection = props.collection,
      handleUpdateMockups = props.handleUpdateMockups,
      handleCollectionEmpty = props.handleCollectionEmpty,
      mockupId = props.mockupId,
      mockupThumb = props.mockupThumb,
      isCondense = props.isCondense,
      maxCountMockups = props.maxCountMockups,
      isLoading = props.isLoading;
  var findMockup = collection.mockups.findIndex(function (shortId) {
    return shortId === mockupId;
  });
  var imagesCount = 4;

  var _useState = (0,react.useState)(),
      isActive = _useState[0],
      setIsActive = _useState[1];

  function getCollectionUrl() {
    return "/user-collection/".concat(collection.timestamp);
  }

  var getMockupThumb = function getMockupThumb(id) {
    if (collection.mockupsList) {
      var _mockupThumb$thumb;

      var _mockupThumb = Object.values(collection.mockupsList).find(function (obj) {
        return obj.shortId === id;
      });

      return (_mockupThumb$thumb = _mockupThumb === null || _mockupThumb === void 0 ? void 0 : _mockupThumb.thumb) !== null && _mockupThumb$thumb !== void 0 ? _mockupThumb$thumb : null;
    }

    return null;
  };

  function getLastMockups() {
    var getCollectionsMockups = (0,toConsumableArray/* default */.Z)(collection.mockups);

    if (getCollectionsMockups.length > imagesCount) {
      return getCollectionsMockups.slice(Math.max(getCollectionsMockups.length - imagesCount, 1)).reverse();
    }

    return getCollectionsMockups.reverse();
  }

  function getLastMockup() {
    if (isActive === true && mockupId && findMockup < 0) {
      return mockupThumb;
    }

    if (collection.mockups.length > 1) {
      return getMockupThumb(collection.mockups[collection.mockups.length - 1]);
    }

    if (collection.mockups.length === 1) {
      return getMockupThumb(collection.mockups[0]);
    }

    return null;
  }

  function getClassName() {
    if (isCondense) {
      if (collection.mockups.length >= maxCountMockups && findMockup < 0) {
        return (CollectionPreview_module_default()).full;
      }

      return findMockup >= 0 ? (CollectionPreview_module_default()).collected : (CollectionPreview_module_default()).collect;
    }

    return (CollectionPreview_module_default()).noPadding;
  }

  var handleActive = function handleActive(e) {
    if (findMockup < 0) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }

    if (handleUpdateMockups && collection.mockups.length >= maxCountMockups && findMockup >= 0) {
      return handleUpdateMockups(e);
    }

    if (handleUpdateMockups && collection.mockups.length < maxCountMockups && findMockup < 0 || handleUpdateMockups && collection.mockups.length < maxCountMockups && findMockup >= 0) {
      return handleUpdateMockups(e);
    }

    if (handleCollectionEmpty && collection.mockups.length === 0) {
      return handleCollectionEmpty(e);
    }
  }; /// ////////
  // RENDERS
  /// ////////


  var renderCollectionHover = function renderCollectionHover() {
    if (findMockup >= 0 || isActive && findMockup < 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(CollectionOverlay, {
        className: "".concat(isActive ? (CollectionPreview_module_default()).active : null),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
          name: "Check",
          width: 20,
          height: 20,
          color: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
          name: "Minus",
          width: 20,
          height: 20,
          color: "white"
        })]
      });
    }

    if (collection.mockups.length >= maxCountMockups && findMockup < 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionOverlay, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "font-bold text-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "iNX/Hb",
            defaultMessage: [{
              "type": 0,
              "value": "Collection is full"
            }]
          })
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionOverlay, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "Plus",
        width: 20,
        height: 20,
        color: "white"
      })
    });
  };

  var renderMockupsCount = function renderMockupsCount() {
    if (collection.mockups.length > imagesCount) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionOverlay, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "font-bold",
          children: ["+\xA0", collection.mockups.length - imagesCount]
        })
      });
    }

    return null;
  };

  var renderImages = function renderImages() {
    if (handleUpdateMockups) {
      var lastMockup = getLastMockup();
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((CollectionPreview_module_default()).aspectRation, " ").concat((CollectionPreview_module_default()).imageBox),
        children: [renderCollectionHover(), /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionMockupImage, {
          mockupThumb: lastMockup,
          previewWidth: 180,
          previewHeight: 130,
          title: collection.title,
          setIcon: true,
          isNotLazy: true
        })]
      });
    }

    var lastMockups = getLastMockups();
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CollectionPreview_module_default()).imagesHolder,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((CollectionPreview_module_default()).mainImage, " ").concat((CollectionPreview_module_default()).imageBox),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionMockupImage, {
          mockupThumb: getMockupThumb(lastMockups[0]),
          previewWidth: 200,
          previewHeight: 227,
          title: collection.title,
          setIcon: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CollectionPreview_module_default()).subImages,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((CollectionPreview_module_default()).aspectRation, " ").concat((CollectionPreview_module_default()).imageBox),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionMockupImage, {
            mockupThumb: getMockupThumb(lastMockups[1]),
            previewWidth: 100,
            previewHeight: 72,
            title: collection.title
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((CollectionPreview_module_default()).aspectRation, " ").concat((CollectionPreview_module_default()).imageBox),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionMockupImage, {
            mockupThumb: getMockupThumb(lastMockups[2]),
            previewWidth: 100,
            previewHeight: 72,
            title: collection.title
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((CollectionPreview_module_default()).aspectRation, " ").concat((CollectionPreview_module_default()).imageBox),
          children: [renderMockupsCount(), /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionMockupImage, {
            mockupThumb: getMockupThumb(lastMockups[3]),
            previewWidth: 100,
            previewHeight: 72,
            title: collection.title
          })]
        })]
      })]
    });
  };

  var renderTitle = function renderTitle() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
      className: (CollectionPreview_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "font-bold ".concat((CollectionPreview_module_default()).title),
        children: collection.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (CollectionPreview_module_default()).mockupsCount,
        children: collection.mockups.length
      })]
    });
  };

  var renderPreviewContent = function renderPreviewContent() {
    if (handleUpdateMockups || handleCollectionEmpty && collection.mockups.length === 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        onClick: function onClick(e) {
          return handleActive(e);
        },
        disabled: isLoading && isActive,
        id: collection.timestamp,
        children: [renderImages(), renderTitle()]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkLocalised/* default */.Z, {
      to: getCollectionUrl(),
      children: [renderImages(), renderTitle()]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("article", {
    className: "".concat((CollectionPreview_module_default()).collectionPreview, " ").concat(getClassName(), " "),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-cy": "collectionPreview",
      children: renderPreviewContent()
    })
  });
};

/* harmony default export */ var CollectionPreview_CollectionPreview = (CollectionPreview);
// EXTERNAL MODULE: ./components/Modals/CollectionsModal/CollectionModal.module.scss
var CollectionModal_module = __webpack_require__(20291);
var CollectionModal_module_default = /*#__PURE__*/__webpack_require__.n(CollectionModal_module);
// EXTERNAL MODULE: ./components/Base/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(96673);
;// CONCATENATED MODULE: ./components/Modals/CollectionsModal/CollectionModal.js








var CollectionModal = function CollectionModal(props) {
  var isModalOpen = props.isModalOpen,
      isModalClose = props.isModalClose,
      modalTitle = props.modalTitle,
      size = props.size,
      children = props.children,
      mockupId = props.mockupId,
      mockupThumb = props.mockupThumb;

  var renderModalContent = function renderModalContent() {
    if (size === "medium") {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CollectionModal_module_default()).wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CollectionModal_module_default()).left,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionMockupImage, {
            mockupId: mockupId,
            mockupThumb: mockupThumb,
            previewWidth: 450,
            previewHeight: 600,
            title: modalTitle
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CollectionModal_module_default()).right,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* ModalScroll */.TV, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
              level: 3,
              className: "text-center m-b-sm",
              children: modalTitle
            }), children]
          })
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* ModalScroll */.TV, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
        level: 3,
        className: "text-center m-b-sm",
        children: modalTitle
      }), children]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.ZP, {
    isOpen: isModalOpen,
    modalLabel: modalTitle,
    onClose: isModalClose,
    size: size,
    isCentered: true,
    children: renderModalContent()
  });
};

/* harmony default export */ var CollectionsModal_CollectionModal = (CollectionModal);
// EXTERNAL MODULE: ./components/List/CollectionPreview/CollectionCondenseList.module.scss
var CollectionCondenseList_module = __webpack_require__(87695);
var CollectionCondenseList_module_default = /*#__PURE__*/__webpack_require__.n(CollectionCondenseList_module);
;// CONCATENATED MODULE: ./components/List/CollectionPreview/CollectionCondenseList.js




var CollectionCondenseList = function CollectionCondenseList(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (CollectionCondenseList_module_default()).wrapper,
    children: props.children
  });
};

/* harmony default export */ var CollectionPreview_CollectionCondenseList = (CollectionCondenseList);
// EXTERNAL MODULE: ./utils/languageHelpers.js
var languageHelpers = __webpack_require__(60540);
// EXTERNAL MODULE: ./node_modules/sockette/dist/sockette.mjs
var sockette = __webpack_require__(36137);
;// CONCATENATED MODULE: ./utils/saveFile.js
/**
 * Function to download a file from URL
 * @param url
 */
function saveFile(url) {
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', ''); // Append to html link element page

  document.body.appendChild(link); // Start download

  link.click(); // Clean up and remove the link

  link.parentNode.removeChild(link);
}
// EXTERNAL MODULE: ./actions/windowActions.js
var windowActions = __webpack_require__(50349);
;// CONCATENATED MODULE: ./actions/userCollectionsAction.js


function fetchUserCollections(username) {
  var request = ServiceClient/* userCollectionsService.get */.Ui.get("user-collections/".concat(username));
  return {
    type: actionTypes/* FETCH_USER_COLLECTIONS */.Cb,
    payload: request
  };
}
function fetchUserCollectionMockups(username, timestamp) {
  var request = ServiceClient/* userCollectionsService.get */.Ui.get("user-collections/".concat(username, "/").concat(timestamp));
  return {
    type: actionTypes/* FETCH_USER_COLLECTION */.jC,
    payload: request
  };
}
function addUserCollection(username, title) {
  var request = ServiceClient/* userCollectionsService.post */.Ui.post("user-collections/".concat(username), title);
  return {
    type: actionTypes/* NEW_USER_COLLECTION */.sy,
    payload: request
  };
}
function editUserCollection(username, timestamp, title) {
  var request = ServiceClient/* userCollectionsService.patch */.Ui.patch("user-collections/".concat(username, "/").concat(timestamp), title);
  return {
    type: actionTypes/* EDIT_USER_COLLECTION */.lB,
    payload: request
  };
}
function removeUserCollection(username, timestamp) {
  var request = ServiceClient/* userCollectionsService.delete */.Ui["delete"]("user-collections/".concat(username, "/").concat(timestamp));
  return {
    type: actionTypes/* REMOVE_USER_COLLECTION */.JR,
    payload: request
  };
}
function updateMockupsCollection(username, timestamp, data) {
  data.type = data.type.toLowerCase();
  var request = ServiceClient/* userCollectionsService.post */.Ui.post("user-collections/".concat(username, "/").concat(timestamp), data);
  return {
    type: actionTypes/* UPDATE_MOCKUPS_COLLECTION */.Op,
    payload: request
  };
}
;// CONCATENATED MODULE: ./hooks/useMenu.js


var useMenu = function useMenu() {
  var locale = (0,es/* useSelector */.v9)(function (state) {
    return state.window.locale;
  });
  var localeMenu = (0,es/* useSelector */.v9)(function (state) {
    return state.window.menuItems;
  });
  var ssrLocaleMenu = (0,es/* useSelector */.v9)(function (state) {
    return state.server.menuItems;
  });
  var menuItems = locale ? localeMenu : ssrLocaleMenu;
  return {
    menuItems: menuItems
  };
};

/* harmony default export */ var hooks_useMenu = (useMenu);
;// CONCATENATED MODULE: ./hooks/useUserCollections.js




function useUserCollections_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useUserCollections_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useUserCollections_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useUserCollections_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var useUserCollections = function useUserCollections(props) {
  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.auth;
  }),
      user = _useSelector.user;

  var _useMenu = hooks_useMenu(),
      menuItems = _useMenu.menuItems;

  var _useSelector2 = (0,es/* useSelector */.v9)(function (state) {
    return state.customMockups;
  }),
      categories = _useSelector2.categories;

  var _useSelector3 = (0,es/* useSelector */.v9)(function (state) {
    return state.mockupsList;
  }),
      order = _useSelector3.order;

  var _useSelector4 = (0,es/* useSelector */.v9)(function (state) {
    return state.userCollections;
  }),
      userCollections = _useSelector4.userCollections,
      userCollection = _useSelector4.userCollection,
      hasLoadedCollections = _useSelector4.hasLoadedCollections,
      hasLoadedCollectedMockups = _useSelector4.hasLoadedCollectedMockups,
      hasCollectionChange = _useSelector4.hasCollectionChange,
      hasChangedStatus = _useSelector4.hasChangedStatus;

  var livePreview = hooks_useLivePreview();
  var router = (0,next_router.useRouter)();
  var query = router.query;
  var timestamp = parseInt(query.id);
  var intl = (0,useIntl/* default */.Z)();

  var _useQueryUrl = hooks_useQueryUrl(),
      makeQueryUrl = _useQueryUrl.makeQueryUrl;

  var _useActions = (0,useActions/* default */.Z)(useUserCollections_objectSpread(useUserCollections_objectSpread(useUserCollections_objectSpread({}, windowActions), mockupList_namespaceObject), userCollectionsAction_namespaceObject), ['setAlert', 'setPremiumModal', 'setOrder', 'addUserCollection', 'removeUserCollection', 'editUserCollection', 'updateMockupsCollection', 'fetchUserCollectionMockups', 'fetchUserCollections']),
      setAlert = _useActions.setAlert,
      setPremiumModal = _useActions.setPremiumModal,
      setOrder = _useActions.setOrder,
      addUserCollection = _useActions.addUserCollection,
      removeUserCollection = _useActions.removeUserCollection,
      editUserCollection = _useActions.editUserCollection,
      updateMockupsCollection = _useActions.updateMockupsCollection,
      fetchUserCollectionMockups = _useActions.fetchUserCollectionMockups,
      fetchUserCollections = _useActions.fetchUserCollections;

  var maxCountCollections = 12;
  var maxCountMockups = 100;
  var collectedMockups = (0,envDetection/* isClient */.C5)() ? localStorage.getItem('collectedMockups') : null;
  var initialState = {
    newCollection: '',
    modalOpen: false,
    modalTitle: '',
    modalType: '',
    success: false,
    isExportLoading: false
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return useUserCollections_objectSpread(useUserCollections_objectSpread({}, state), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1]; /// ///////////
  // Handlers
  /// //////////


  function roundPercent(value) {
    return Math.floor(value * 100);
  }

  var messages = (0,react_intl_lib/* defineMessages */.vU)({
    alertExport: {
      id: "OilPEU",
      defaultMessage: [{
        "type": 0,
        "value": "Exporting your collection"
      }]
    },
    alertLink: {
      id: "4UXuiE",
      defaultMessage: [{
        "type": 0,
        "value": "👍"
      }]
    },
    alertLinkLabel: {
      id: "gvzYzO",
      defaultMessage: [{
        "type": 0,
        "value": "Your download package is ready"
      }]
    },
    exportUserCollection: {
      id: "r+uQG+",
      defaultMessage: [{
        "type": 0,
        "value": "User collection"
      }]
    },
    exportLoadedMockups: {
      id: "DKdaXO",
      defaultMessage: [{
        "type": 0,
        "value": "Loaded mockups"
      }]
    },
    exportRenderingMockups: {
      id: "uSa1PV",
      defaultMessage: [{
        "type": 0,
        "value": "Rendering mockups"
      }]
    },
    exportPreparingZIPfile: {
      id: "7Cj+6s",
      defaultMessage: [{
        "type": 0,
        "value": "Preparing ZIP file"
      }]
    },
    exportSavingZIPfile: {
      id: "fHtbu1",
      defaultMessage: [{
        "type": 0,
        "value": "Saving ZIP file"
      }]
    },
    alertError: {
      id: "XZoMoH",
      defaultMessage: [{
        "type": 0,
        "value": "Oops, something went wrong"
      }]
    }
  });

  var handleBulkExport = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var data, token;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = {
                timestamp: timestamp,
                username: user.username,
                fileId: livePreview.fileId,
                size: 'high',
                // TODO this shall be handled by dropdown button to choose the size
                color: null,
                source: livePreview.source
              };
              (0,trackingParty/* trackEvent */.L9)('UserCollection download triggered', {
                data: data
              });
              _context.next = 4;
              return (0,helpers/* getUserToken */.Nh)();

            case 4:
              token = _context.sent;
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                setState({
                  isExportLoading: true
                });
                setAlert(data.filename, {
                  type: 'loader',
                  label: intl.formatMessage(messages.alertExport),
                  progress: 0
                });
                var ws = new sockette/* default */.Z("".concat(variables/* BULK_EXPORT_API_WS */.vc, "?Authorization=").concat(token), {
                  timeout: 2000,
                  maxAttempts: 2,
                  onmessage: function onmessage(e) {
                    handleWSMessage(e);
                  },
                  onopen: function onopen() {
                    handleOpen();
                  },
                  onerror: function onerror() {
                    handleError();
                  }
                }); // event handlers

                function handleOpen() {
                  console.log('Connection opened');
                  ws.json(data);
                }

                function handleWSMessage(e) {
                  console.log('Received:', e);
                  var res = JSON.parse(e.data); // progress status

                  if (res.hasOwnProperty('progress')) {
                    handleProgress(res);
                  } // final response


                  if (res.result) {
                    handleResult(res);
                  } // error happened


                  if (res.message === 'Internal server error') {
                    handleError(res);
                  }
                }

                function handleProgress(res) {
                  console.warn('progress', res);
                  setAlert(data.filename, {
                    type: 'loader',
                    label: intl.formatMessage(messages[res.message]),
                    progress: roundPercent(res.progress / 100)
                  });
                }

                function handleError() {
                  setAlert(data.filename, {
                    type: 'link',
                    label: intl.formatMessage(messages.alertError),
                    linkLabel: '',
                    link: '#'
                  });
                  console.log('Connection closed');
                  reject(ws);
                  setState({
                    isExportLoading: false
                  });
                }

                function handleResult(res) {
                  setAlert(data.filename, {
                    type: 'link',
                    label: intl.formatMessage(messages.alertLink),
                    linkLabel: intl.formatMessage(messages.alertLinkLabel),
                    link: res.result.fileUrl
                  });
                  saveFile(res.result.fileUrl);
                  setTimeout(function () {
                    setAlert(data.filename, null);
                  }, 3000);
                  resolve(res);
                  ws.close();
                  console.log('Connection closed');
                  setState({
                    isExportLoading: false
                  });
                  (0,trackingParty/* trackEvent */.L9)('UserCollection downloaded', {
                    fileKey: res.result.key,
                    mockupsCount: res.result.mockupsCount
                  });
                }
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleBulkExport() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleOrderChange = function handleOrderChange(e) {
    setOrder(e.currentTarget.value);
    (0,trackingParty/* trackEvent */.L9)('Collection list order change', {
      order: e.currentTarget.value
    });
  };

  var handleFiltersChange = function handleFiltersChange(e) {
    (0,trackingParty/* trackEvent */.L9)('Collection list filter change', {
      tags: e.currentTarget.value
    });
  };

  var handleCollectionUpdate = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(newCollection) {
      var response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return editUserCollection(user.sharedDataUsername, timestamp, {
                title: newCollection
              });

            case 3:
              response = _context2.sent;
              setState({
                success: !(response === true)
              });
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              setState({
                success: false
              });

            case 10:
              return _context2.abrupt("return", false);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function handleCollectionUpdate(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleCollectionCreate = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(newCollection) {
      var response;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return addUserCollection(user.sharedDataUsername, {
                title: newCollection
              });

            case 3:
              response = _context3.sent;
              (0,trackingParty/* trackEvent */.L9)('Collection create');
              setState({
                success: !(response === true)
              });
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              setState({
                success: false
              });

            case 11:
              return _context3.abrupt("return", false);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function handleCollectionCreate(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleRemoveCollection = function handleRemoveCollection(e) {
    e.preventDefault();
    removeUserCollection(user.sharedDataUsername, timestamp);
    (0,trackingParty/* trackEvent */.L9)('Collection remove');
    (0,languageHelpers/* pushBrowserHistoryLocalised */.Ns)('/user-collections');
  };

  var handleEmptyCollection = function handleEmptyCollection(e) {
    e.preventDefault();
    (0,languageHelpers/* pushBrowserHistoryLocalised */.Ns)('/mockups');
  };

  var handleUpdateMockups = function handleUpdateMockups(e) {
    e.preventDefault();
    var timestampCollection = parseInt(e.currentTarget.id);
    var index = userCollections.findIndex(function (_ref4) {
      var timestamp = _ref4.timestamp;
      return timestamp === timestampCollection;
    });
    var findMockup = userCollections[index].mockups.findIndex(function (shortId) {
      return shortId === props.mockupId;
    });
    var isFound = findMockup >= 0 ? 'REMOVE' : 'ADD';
    updateMockupsCollection(user.sharedDataUsername, timestampCollection, {
      type: isFound,
      mockup: props.mockupId
    });
    (0,trackingParty/* trackEvent */.L9)("Mockup ".concat(isFound, " collection "), {
      mockup: props.mockupId,
      collection: timestampCollection
    });
  };

  var handleModalClose = function handleModalClose() {
    if (hasChangedStatus === false) {
      setState({
        modalOpen: false
      });
    }
  };

  var handleModalCollectionCreate = function handleModalCollectionCreate(e) {
    e.preventDefault();
    setState({
      modalOpen: true,
      modalType: 'create',
      modalTitle: 'Create new collection',
      success: ''
    });
  };

  var handleModalCollectionRename = function handleModalCollectionRename(e) {
    e.preventDefault();
    setState({
      modalOpen: true,
      modalType: 'rename',
      modalTitle: 'Rename collection',
      success: ''
    });
  };

  var handleModalCollectionRemove = function handleModalCollectionRemove(e) {
    e.preventDefault();
    setState({
      modalOpen: true,
      modalType: 'remove',
      modalTitle: 'Remove collection'
    });
  };

  var handleModalCollectionUpdate = function handleModalCollectionUpdate(e) {
    e.preventDefault();

    if (user === null) {
      setPremiumModal('signup', 'Favorite modal');
      return;
    }

    setState({
      modalOpen: true,
      modalType: 'update',
      modalTitle: 'Add to collection'
    });
  };

  var handleLockedClick = function handleLockedClick(id) {
    var modalType = user ? 'locked-mockup' : 'signup';
    setPremiumModal("".concat(modalType, ":").concat(id), 'Locked mockup latest modal');
  };

  var handleLockedExportClick = function handleLockedExportClick() {
    var modalType = 'locked-feature';
    setPremiumModal("".concat(modalType), 'Locked feature UserCollection Export');
  }; /// ////////////////
  // Helper functions
  /// ////////////////


  function buildFilterUrl(tags) {
    return makeQueryUrl(tags, 'filter');
  }

  function getFilteredMockups(mockups) {
    // get mockups for current filter
    var activeFilter = query.filter ? query.filter.split(',') : [];
    var filteredMockups = filterMockups(mockups, activeFilter);
    var showFreeFirst = !user || !user.isPremium;
    filteredMockups = orderMockups(filteredMockups, order, showFreeFirst);
    return filteredMockups;
  }

  function getFiltersOptions() {
    var options = [[{
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        defaultMessage: [{
          "type": 0,
          "value": "Photo"
        }],
        id: "global.filter.photo"
      }),
      slug: 'photo'
    }, {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        defaultMessage: [{
          "type": 0,
          "value": "Isolated"
        }],
        id: "global.filter.isolated"
      }),
      slug: 'isolated'
    }], [{
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        defaultMessage: [{
          "type": 0,
          "value": "Free"
        }],
        id: "global.filter.free"
      }),
      slug: 'free'
    }, {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        defaultMessage: [{
          "type": 0,
          "value": "Premium"
        }],
        id: "global.filter.premium"
      }),
      slug: 'premium'
    }]]; // premium user can't see the premium / free switch

    if (user && !user.isTrial && user.isPremium) {
      options.pop();
    } else if (user && user.isTrial && user.disableTrialWatermark) {
      options.pop();
    }

    return options;
  }

  return {
    state: state,
    user: user,
    query: query,
    intl: intl,
    menuItems: menuItems,
    order: order,
    categories: categories,
    userCollections: userCollections,
    userCollection: userCollection,
    hasLoadedCollections: hasLoadedCollections,
    hasLoadedCollectedMockups: hasLoadedCollectedMockups,
    hasCollectionChange: hasCollectionChange,
    hasChangedStatus: hasChangedStatus,
    timestamp: timestamp,
    maxCountCollections: maxCountCollections,
    maxCountMockups: maxCountMockups,
    collectedMockups: collectedMockups,
    handleModalCollectionRename: handleModalCollectionRename,
    handleModalCollectionRemove: handleModalCollectionRemove,
    handleModalCollectionUpdate: handleModalCollectionUpdate,
    handleModalCollectionCreate: handleModalCollectionCreate,
    handleModalClose: handleModalClose,
    handleCollectionCreate: handleCollectionCreate,
    handleCollectionUpdate: handleCollectionUpdate,
    handleRemoveCollection: handleRemoveCollection,
    handleEmptyCollection: handleEmptyCollection,
    handleUpdateMockups: handleUpdateMockups,
    handleLockedClick: handleLockedClick,
    handleOrderChange: handleOrderChange,
    handleFiltersChange: handleFiltersChange,
    buildFilterUrl: buildFilterUrl,
    getFilteredMockups: getFilteredMockups,
    getFiltersOptions: getFiltersOptions,
    handleBulkExport: handleBulkExport,
    handleLockedExportClick: handleLockedExportClick,
    fetchUserCollectionMockups: fetchUserCollectionMockups,
    fetchUserCollections: fetchUserCollections
  };
};

/* harmony default export */ var hooks_useUserCollections = (useUserCollections);
// EXTERNAL MODULE: ./components/List/CollectionList/ToolBar.module.scss
var ToolBar_module = __webpack_require__(48860);
var ToolBar_module_default = /*#__PURE__*/__webpack_require__.n(ToolBar_module);
;// CONCATENATED MODULE: ./components/List/CollectionList/ToolBar.js









var ToolBar = function ToolBar(props) {
  var isDetail = props.isDetail,
      onModalCreate = props.onModalCreate,
      onModalRename = props.onModalRename,
      onModalRemove = props.onModalRemove,
      collections = props.collections,
      maxCountCollections = props.maxCountCollections;

  var renderButtons = function renderButtons() {
    if (isDetail) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
          design: "default",
          size: "xlarge",
          className: (ToolBar_module_default()).rename,
          onClick: onModalRename,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: "Edit",
              size: "md"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "iXNbPf",
              defaultMessage: [{
                "type": 0,
                "value": "Rename"
              }]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          design: "default",
          size: "xlarge",
          onClick: onModalRemove,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: "Trash",
              size: "md"
            })
          })
        })]
      });
    }

    if (collections < maxCountCollections) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        design: "dashed",
        size: "xlarge",
        className: (ToolBar_module_default()).create,
        onClick: onModalCreate,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "Plus",
            width: 10,
            height: 10
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "O+3CZK",
            defaultMessage: [{
              "type": 0,
              "value": "Create new collection"
            }]
          })
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "PPugYR",
        defaultMessage: [{
          "type": 0,
          "value": "You have reached the maximum number of collections:"
        }]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: "font-bold",
        children: ["\xA0", maxCountCollections]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ToolBar_module_default()).toolBar,
    children: renderButtons()
  });
};

/* harmony default export */ var CollectionList_ToolBar = (ToolBar);
// EXTERNAL MODULE: ./styles/modules/Forms.module.scss
var Forms_module = __webpack_require__(24142);
var Forms_module_default = /*#__PURE__*/__webpack_require__.n(Forms_module);
;// CONCATENATED MODULE: ./components/Modals/CollectionsModal/CollectionForm.js


function CollectionForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CollectionForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CollectionForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CollectionForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var FieldWrapper = function FieldWrapper(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Forms_module_default()).inputIconWrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Forms_module_default()).inputIcon,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "Image",
        size: "sm",
        color: "grey"
      })
    }), props.children]
  });
};

var CollectionForm = function CollectionForm(props) {
  var _useUserCollections = hooks_useUserCollections(),
      intl = _useUserCollections.intl;

  var initialState = {
    inputName: "".concat(props.oldCollection ? props.oldCollection : ''),
    isNameValid: !!props.oldCollection
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return CollectionForm_objectSpread(CollectionForm_objectSpread({}, state), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1];

  var onNewCollectionChange = function onNewCollectionChange(e) {
    e.preventDefault();
    setState({
      inputName: e.target.value
    });

    if (e.target.value) {
      setState({
        isNameValid: true
      });
    } else {
      setState({
        isNameValid: false
      });
    }
  };

  var messages = (0,react_intl_lib/* defineMessages */.vU)({
    collectionForm: {
      defaultMessage: [{
        "type": 0,
        "value": "Collection name"
      }],
      id: "global.form.collectionForm"
    }
  });

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();

    if (state.isNameValid) {
      props.onFormSubmit(state.inputName);
      setState({
        isNameValid: false
      });
    } else {
      setState({
        isNameValid: false
      });
    }
  };

  function modalClose() {
    setTimeout(function () {
      props.isModalClose();
    }, 300);
  }

  var renderSubmitText = function renderSubmitText() {
    if (props.success === true) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "xrKHS6",
        defaultMessage: [{
          "type": 0,
          "value": "Success"
        }]
      });
    }

    if (props.isRenameType) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "p/2SNl",
        defaultMessage: [{
          "type": 0,
          "value": "Rename collection"
        }]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "9lnhZ4",
      defaultMessage: [{
        "type": 0,
        "value": "Create collection"
      }]
    });
  };

  var renderError = function renderError() {
    if (props.success === true) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((CollectionModal_module_default()).messages, " ").concat((CollectionModal_module_default()).success),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
          name: "Check",
          size: "sm"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "bHWkyN",
          defaultMessage: [{
            "type": 0,
            "value": "Everything went well"
          }]
        }), modalClose()]
      });
    }

    if (props.success === false) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((CollectionModal_module_default()).messages, " ").concat((CollectionModal_module_default()).error),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
          name: "Close",
          size: "sm",
          color: "red"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "NGdjY/",
          defaultMessage: [{
            "type": 0,
            "value": "The event was not successful"
          }]
        })]
      });
    }

    return null;
  };

  var renderButtons = function renderButtons() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CollectionModal_module_default()).buttonsGroup,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        design: "default",
        size: "large",
        onClick: props.isModalClose,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "47FYwb",
          defaultMessage: [{
            "type": 0,
            "value": "Cancel"
          }]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        type: "submit",
        design: "confirm",
        size: "large",
        isLoading: props.isLoading,
        disabled: !state.isNameValid,
        children: renderSubmitText()
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: function onSubmit(e) {
        return handleSubmit(e);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        className: (Forms_module_default()).inputLabel,
        htmlFor: "name",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "HAlOn1",
          defaultMessage: [{
            "type": 0,
            "value": "Name"
          }]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "text",
            id: "name",
            onChange: function onChange(e) {
              return onNewCollectionChange(e);
            },
            value: state.inputName,
            placeholder: intl.formatMessage(messages.collectionForm),
            className: "".concat((Forms_module_default()).inputLarge, " ").concat((CollectionModal_module_default()).inputModal)
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: renderButtons()
      }), renderError()]
    })
  });
};

/* harmony default export */ var CollectionsModal_CollectionForm = ((0,injectIntl/* default */.ZP)(CollectionForm));
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var react_loading_skeleton_lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./components/List/MockupList/Skeleton.module.scss
var Skeleton_module = __webpack_require__(12355);
var Skeleton_module_default = /*#__PURE__*/__webpack_require__.n(Skeleton_module);
;// CONCATENATED MODULE: ./components/List/MockupList/Skeleton.js






var MockupListSkeleton = function MockupListSkeleton(props) {
  var renderSkeletonsMockupList = function renderSkeletonsMockupList(numrows) {
    var rows = [];

    for (var i = 0; i < numrows; i++) {
      rows.push( /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Skeleton_module_default()).collection,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((Skeleton_module_default()).featuredMockups, " ").concat(props.isHalf ? (Skeleton_module_default()).featuredMockupsHalf : null),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            height: "0",
            width: "100%",
            count: 4
          })
        })
      }, i));
    }

    return rows;
  };

  var renderSkeletonsAllMockupsList = function renderSkeletonsAllMockupsList(numrows) {
    var rows = [];

    for (var i = 0; i < numrows; i++) {
      rows.push( /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Skeleton_module_default()).collection,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Skeleton_module_default()).collectionTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            height: "35px",
            width: "300px"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Skeleton_module_default()).collectionDescription,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            width: "100%",
            height: "100%"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Skeleton_module_default()).featuredMockups,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
            height: "0",
            width: "100%",
            count: 8
          })
        })]
      }, i));
    }

    return rows;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* SkeletonTheme */.yB, {
    children: props.isSimpleList ? renderSkeletonsMockupList(1) : renderSkeletonsAllMockupsList(6)
  });
};

/* harmony default export */ var Skeleton = (MockupListSkeleton);
;// CONCATENATED MODULE: ./components/Modals/CollectionsModal/CollectionUpdateMockups.js


function CollectionUpdateMockups_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CollectionUpdateMockups_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CollectionUpdateMockups_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CollectionUpdateMockups_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var CollectionUpdateMockups = function CollectionUpdateMockups(props) {
  var _useUserCollections = hooks_useUserCollections(props),
      state = _useUserCollections.state,
      userCollections = _useUserCollections.userCollections,
      hasLoadedCollections = _useUserCollections.hasLoadedCollections,
      hasCollectionChange = _useUserCollections.hasCollectionChange,
      hasChangedStatus = _useUserCollections.hasChangedStatus,
      maxCountMockups = _useUserCollections.maxCountMockups,
      maxCountCollections = _useUserCollections.maxCountCollections,
      fetchUserCollections = _useUserCollections.fetchUserCollections,
      handleUpdateMockups = _useUserCollections.handleUpdateMockups,
      handleCollectionCreate = _useUserCollections.handleCollectionCreate,
      handleModalCollectionCreate = _useUserCollections.handleModalCollectionCreate;

  var isModalOpen = props.isModalOpen,
      isModalClose = props.isModalClose,
      modalTitle = props.modalTitle,
      mockupId = props.mockupId,
      mockupThumb = props.mockupThumb;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.auth;
  }),
      user = _useSelector.user;

  var initialState = {
    isFormOpen: '',
    formTitle: ''
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return CollectionUpdateMockups_objectSpread(CollectionUpdateMockups_objectSpread({}, state), newState);
  }, initialState),
      stateForm = _useReducer[0],
      setStateForm = _useReducer[1];

  (0,react.useEffect)(function () {
    if (user && userCollections.length === 0 && isModalOpen) {
      fetchUserCollections(user.sharedDataUsername);
    }
  }, [user, isModalOpen]);

  function getModalTitle() {
    if (stateForm.formTitle === '') {
      return modalTitle;
    }

    return stateForm.formTitle;
  }

  var handleFormOpen = function handleFormOpen(e) {
    handleModalCollectionCreate(e);
    setStateForm({
      isFormOpen: true,
      formTitle: 'Create new collection'
    });
  };

  var handleFormClose = function handleFormClose() {
    setStateForm({
      isFormOpen: false,
      formTitle: ''
    });
  };

  var renderCreateForm = function renderCreateForm() {
    if (stateForm.isFormOpen === true) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionsModal_CollectionForm, {
        onFormSubmit: handleCollectionCreate,
        isLoading: hasCollectionChange,
        success: state.success,
        isModalClose: handleFormClose
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionList_ToolBar, {
      onModalCreate: function onModalCreate(e) {
        return handleFormOpen(e);
      },
      collections: userCollections.length,
      maxCountCollections: maxCountCollections
    });
  };

  var renderCollections = function renderCollections() {
    return userCollections.map(function (collection) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionPreview, {
        collection: collection,
        handleUpdateMockups: handleUpdateMockups,
        mockupId: mockupId,
        mockupThumb: mockupThumb,
        isCondense: true,
        maxCountMockups: maxCountMockups,
        isLoading: hasChangedStatus
      }, collection.timestamp);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CollectionsModal_CollectionModal, {
    isModalOpen: isModalOpen,
    isModalClose: isModalClose,
    modalTitle: getModalTitle(),
    size: "medium",
    mockupId: mockupId,
    mockupThumb: mockupThumb,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CollectionModal_module_default()).wrapperForm,
      children: renderCreateForm()
    }), !hasLoadedCollections ? /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton, {
      isSimpleList: true,
      isHalf: true
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CollectionPreview_CollectionCondenseList, {
      children: renderCollections()
    })]
  });
};

/* harmony default export */ var CollectionsModal_CollectionUpdateMockups = (CollectionUpdateMockups);
// EXTERNAL MODULE: ./components/List/MockupPreview/CollectionButton.module.scss
var CollectionButton_module = __webpack_require__(18570);
var CollectionButton_module_default = /*#__PURE__*/__webpack_require__.n(CollectionButton_module);
;// CONCATENATED MODULE: ./components/List/MockupPreview/CollectionButton.js










var CollectionButton = function CollectionButton(props) {
  var mockupId = props.mockupId,
      mockupThumb = props.mockupThumb,
      isIsolated = props.isIsolated,
      className = props.className;

  var _useUserCollections = hooks_useUserCollections(),
      state = _useUserCollections.state,
      user = _useUserCollections.user,
      collectedMockups = _useUserCollections.collectedMockups,
      handleModalCollectionUpdate = _useUserCollections.handleModalCollectionUpdate,
      handleModalClose = _useUserCollections.handleModalClose;

  var findMockup;

  if (collectedMockups) {
    findMockup = collectedMockups.split(',').findIndex(function (shortId) {
      return shortId === mockupId;
    });
  }

  var renderButton = function renderButton() {
    if (findMockup >= 0 && user) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "".concat((CollectionButton_module_default()).collectionButton, " ").concat((CollectionButton_module_default()).isActive),
        onClick: handleModalCollectionUpdate,
        title: "Collected",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "Plus",
            width: 10,
            height: 10,
            color: "white"
          })
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: "".concat((CollectionButton_module_default()).collectionButton, " ").concat(isIsolated ? (CollectionButton_module_default()).isolated : null, " ").concat(className),
      onClick: handleModalCollectionUpdate,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: "font-regular",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
          name: "Plus",
          width: 10,
          height: 10,
          color: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "kCPl0r",
          defaultMessage: [{
            "type": 0,
            "value": "Collect"
          }]
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CollectionsModal_CollectionUpdateMockups, {
      isModalOpen: state.modalOpen,
      isModalClose: handleModalClose,
      modalTitle: state.modalTitle,
      mockupId: mockupId,
      mockupThumb: mockupThumb
    }), renderButton()]
  });
};

/* harmony default export */ var MockupPreview_CollectionButton = (CollectionButton);
// EXTERNAL MODULE: ./utils/featureDetector.js
var featureDetector = __webpack_require__(72076);
// EXTERNAL MODULE: ./components/Base/VideoTimer/VideoTimer.module.scss
var VideoTimer_module = __webpack_require__(86747);
var VideoTimer_module_default = /*#__PURE__*/__webpack_require__.n(VideoTimer_module);
;// CONCATENATED MODULE: ./components/Base/VideoTimer/VideoTimer.js






var VideoTimer = function VideoTimer(props) {
  var isVideoPlay = props.isVideoPlay,
      isEnded = props.isEnded,
      duration = props.duration,
      className = props.className,
      type = props.type;

  var _useState = (0,react.useState)(0),
      currentTime = _useState[0],
      setCurrentTime = _useState[1];

  var _useState2 = (0,react.useState)(0.000),
      pauseTime = _useState2[0],
      setPauseTime = _useState2[1];

  (0,react.useEffect)(function () {
    if (!duration) return;
    var timeleft = pauseTime > 0.000 ? pauseTime : Math.floor(duration);

    if (isVideoPlay) {
      var start = Date.now() + timeleft * 1000;
      var timer = setInterval(function () {
        if (timeleft <= 0.000) {
          clearInterval(timer);
        } else {
          var current = Date.now();
          timeleft = (start - current) / 1000;
          setCurrentTime(timeleft);
          setPauseTime(timeleft);
        }
      }, 10);
      return function () {
        clearInterval(timer);
      };
    }

    if (!isVideoPlay) {
      if (pauseTime > 0.000) {
        setCurrentTime(pauseTime);
      } else {
        setCurrentTime(duration);
      }
    }
  }, [isVideoPlay, isEnded]);
  (0,react.useEffect)(function () {
    if (!duration) return;

    if (isEnded) {
      setPauseTime(0.000);
      setCurrentTime(duration);
    }
  }, [isEnded]);

  function formatTime(timeInSeconds) {
    var result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
    return {
      minutes: result.substr(3, 2),
      seconds: result.substr(6, 2)
    };
  }

  var renderTimer = function renderTimer() {
    var time = formatTime(currentTime ? Math.round(currentTime) : Math.round(duration));
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "".concat(time.minutes, ":").concat(time.seconds)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: "".concat((VideoTimer_module_default()).time, " ").concat(type ? (VideoTimer_module_default())[type] : '', " ").concat(className, " font-bold"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "Play2",
        width: 8,
        height: 10,
        color: "white"
      })
    }), duration && renderTimer()]
  });
};

/* harmony default export */ var VideoTimer_VideoTimer = (VideoTimer);
;// CONCATENATED MODULE: ./components/List/MockupPreview/parts/MockupVideo.js


function MockupVideo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MockupVideo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MockupVideo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MockupVideo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // import Hls from "hls.js";









var MockupVideo = function MockupVideo(props) {
  var mockup = props.mockup,
      locale = props.locale,
      isLazyLoad = props.isLazyLoad,
      isMasonry = props.isMasonry;
  var imgixParams = getImgixParams(mockup.category);
  var loc = locale_isLocalisedMockupPreview(locale) ? locale : 'en';
  var thumbId = mockup.previews.thumb;
  var player = (0,react.useRef)();
  var initialState = {
    isHover: false,
    isHoverPoster: false,
    duration: null,
    currentTime: null,
    videoCanPlay: false,
    videoPlay: false,
    isMobileOs: false,
    hasPreload: false
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return MockupVideo_objectSpread(MockupVideo_objectSpread({}, state), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1];

  var videoUrl = "".concat(variables/* PUBLIC_MOCKUP_VIDEO_IMGIX */.jg, "/").concat(thumbId, "_").concat(loc, ".mp4?fm=mp4&res=low#t=0.001");
  var posterUrl = isMasonry ? "".concat(variables/* PUBLIC_MOCKUP_IMGIX */.Z9, "/").concat(thumbId, "_").concat(loc, ".jpg") : "".concat(variables/* PUBLIC_MOCKUP_IMGIX */.Z9, "/").concat(thumbId, "_").concat(loc, ".jpg?h=").concat(PREVIEW_HEIGHT, "&w=").concat(PREVIEW_WIDTH);
  var blurhash = mockup.blurhash && mockup.blurhash.length > 6 ? mockup.blurhash : 'eIP7X,%M~9%M0g_NkWay%2j]^hof58WC=_-:s:bIIpaeR.j[slkCS5'; // TODO až budou videa přístupná na https://smartmockups-mockups-dev.imgix.video

  /*
  useEffect(() => {
      if (player.current?.canPlayType("application/vnd.apple.mpegurl")) {
          player.current.src = videoUrl;
      } else if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(videoUrl)
          hls.attachMedia(player.current);
      } else {
          player.current.src = videoUrl;
      }
  }, []);
    */

  (0,react.useEffect)(function () {
    if ((0,envDetection/* isClient */.C5)()) {
      setState({
        isMobileOs: (0,featureDetector/* isMobileOs */.P4)()
      });
      setState({
        hasPreload: true
      });
    }
  }, []);
  (0,react.useEffect)(function () {
    if (state.videoCanPlay) {
      if (state.isHover) {
        var _player$current;

        (_player$current = player.current) === null || _player$current === void 0 ? void 0 : _player$current.play();
        setState({
          videoPlay: true
        });
      } else {
        var _player$current2;

        (_player$current2 = player.current) === null || _player$current2 === void 0 ? void 0 : _player$current2.pause();
        setState({
          videoPlay: false
        });
      }
    }
  }, [state.videoCanPlay, state.isHover]);

  var handleMouseHover = function handleMouseHover(isHover) {
    setState({
      isHover: isHover
    });

    if (isHover === true) {
      setState({
        isHoverPoster: isHover
      });
    }
  };

  var handleCanPlay = function handleCanPlay() {
    var _player$current3;

    setState({
      videoCanPlay: true,
      duration: (_player$current3 = player.current) !== null && _player$current3 !== void 0 && _player$current3.duration ? player.current.duration : null
    });
  };

  var handleCurrentTime = function handleCurrentTime(event) {
    if (event && state.videoCanPlay) {
      setState({
        currentTime: Math.round(event.target.currentTime)
      });
    }
  };

  var renderPoster = function renderPoster() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(react_imgix_es/* default */.ZP, {
      className: "".concat((MockupPreview_module_default()).image, "\n                ").concat(isLazyLoad ? "".concat((MockupPreview_module_default()).isLazy, " lazyload") : '', "\n                ").concat(state.isHoverPoster ? (MockupPreview_module_default()).posterHidden : ''),
      src: "".concat(posterUrl),
      sizes: SIZES_WITH_SIDEBAR,
      attributeConfig: isLazyLoad && {
        src: 'data-src',
        srcSet: 'data-srcset',
        loading: 'lazy'
      },
      htmlAttributes: {
        alt: mockup.title
      },
      height: PREVIEW_HEIGHT,
      imgixParams: imgixParams
    });
  };

  var renderVideo = function renderVideo() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
      className: isLazyLoad ? "".concat((MockupPreview_module_default()).isLazy, " lazyload") : '',
      src: videoUrl,
      ref: player,
      preload: state.hasPreload ? 'metadata' : 'none',
      loop: true,
      muted: true,
      height: PREVIEW_HEIGHT,
      onCanPlay: handleCanPlay,
      onTimeUpdate: function onTimeUpdate(event) {
        return handleCurrentTime(event);
      }
    });
  };

  return (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("figure", {
      title: mockup.title,
      className: (MockupPreview_module_default()).ratioContainer,
      onMouseEnter: function onMouseEnter() {
        return handleMouseHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return handleMouseHover(false);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_blurhash_es/* Blurhash */.E, {
        hash: blurhash,
        className: "".concat((MockupPreview_module_default()).blurhash, " blurhash")
      }), renderPoster(), !state.isMobileOs && renderVideo(), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoTimer_VideoTimer, {
        isVideoPlay: state.videoPlay,
        isEnded: state.currentTime === 0,
        duration: state.duration,
        type: "list"
      })]
    });
  }, [mockup, videoUrl, posterUrl, imgixParams, state.videoPlay, state.currentTime]);
};

/* harmony default export */ var parts_MockupVideo = (MockupVideo);
;// CONCATENATED MODULE: ./components/List/MockupPreview/MockupPreview.js














var MockupPreview = function MockupPreview(props) {
  var preview = MockupPreview_useMockupPreview(props);
  var mockup = props.mockup,
      isUserPremium = props.isUserPremium,
      isUserInternal = props.isUserInternal,
      isUserScheduled = props.isUserScheduled;
  var isNotVideo = mockup.type !== "VIDEO";

  function renderBadges() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (MockupPreview_module_default()).videoBadges,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PreviewBadges, {
        mockup: mockup,
        isUserInternal: isUserInternal,
        isUserPremium: isUserPremium,
        isUserScheduled: isUserScheduled
      })
    });
  }

  function renderPreviewTitle() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(parts_MockupPreviewTitle, {
      mockup: mockup
    });
  }

  function renderAdminBtn() {
    if (!isUserInternal) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (MockupPreview_module_default()).adminBtnWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(parts_AdminBtn, {
        id: mockup.id,
        isInverse: mockup.hasBackground
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(parts_AdminBtn, {
        id: mockup.shortId,
        isInverse: mockup.hasBackground,
        type: "copy"
      })]
    });
  }

  function renderLivePreview() {
    // in case the preview image is preset by ty parent component
    // display just image
    if (preview.dataUrl) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (MockupPreview_module_default()).livePreview,
        style: {
          backgroundImage: "url(".concat(preview.dataUrl, ")")
        },
        children: mockup.type === 'VIDEO' && /*#__PURE__*/(0,jsx_runtime.jsx)(VideoTimer_VideoTimer, {
          type: "list"
        })
      });
    }

    return null;
  }

  function renderPreviewMedia() {
    if (isNotVideo) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(parts_MockupImage, {
        mockup: props.mockup,
        isPreviewHover: props.isPreviewHover && props.isUserLogged && !props.livePreview && !props.isLoading,
        locale: props.locale,
        livePreview: preview.dataUrl,
        isLazyLoad: props.isLazyLoad,
        isMasonry: props.isMasonry
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(parts_MockupVideo, {
      mockup: props.mockup,
      locale: props.locale,
      isLazyLoad: props.isLazyLoad,
      isMasonry: props.isMasonry
    });
  }

  function renderLoader() {
    if (!preview.isLoading) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (MockupPreview_module_default()).loader
    });
  }

  var handleClick = function handleClick() {
    if (props.onClick) {
      props.onClick(props.collection);
    }
  };

  function renderPreviewContent() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
      to: preview.mockupUrl,
      className: (MockupPreview_module_default()).mockupPreview,
      title: mockup.title,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        onClick: handleClick,
        title: mockup.title,
        "data-cy": mockup.isPremium && !isUserPremium ? 'mockup locked' : 'mockup unlocked',
        children: [renderPreviewMedia(), renderLivePreview(), renderLoader(), renderBadges(), isNotVideo && renderPreviewTitle()]
      })
    });
  }

  function renderCollectionButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(MockupPreview_CollectionButton, {
      mockupId: mockup.shortId,
      mockupThumb: mockup.thumb,
      isIsolated: mockup.hasBackground,
      className: (MockupPreview_module_default()).collectionBtn
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
    className: "".concat((MockupPreview_module_default()).wrapper, " ").concat(props.mockup.hasBackground && (MockupPreview_module_default()).imageBordered),
    ref: preview.ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (MockupPreview_module_default()).previewContent,
      "data-cy": "mockupPreview",
      children: renderPreviewContent()
    }), !props.hasNotCollectButton && isNotVideo ? renderCollectionButton() : null, renderAdminBtn()]
  });
};

/* harmony default export */ var MockupPreview_MockupPreview = (MockupPreview);
// EXTERNAL MODULE: ./hooks/useUser.js
var useUser = __webpack_require__(578);
// EXTERNAL MODULE: ./components/List/MockupList/MockupList.module.scss
var MockupList_module = __webpack_require__(94027);
var MockupList_module_default = /*#__PURE__*/__webpack_require__.n(MockupList_module);
// EXTERNAL MODULE: ./node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(40827);
;// CONCATENATED MODULE: ./hooks/useWindowDimensions.js



function getWindowDimensions() {
  var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8;

  var width = (0,envDetection/* isServer */.sk)() ? 1200 : window.innerWidth;
  var screenXSM = (_ref = width <= 379) !== null && _ref !== void 0 ? _ref : true;
  var screenSM = (_ref2 = width <= 767) !== null && _ref2 !== void 0 ? _ref2 : true;
  var screenMD = (_ref3 = width <= 992) !== null && _ref3 !== void 0 ? _ref3 : true;
  var screenXMD = (_ref4 = width <= 1019) !== null && _ref4 !== void 0 ? _ref4 : true;
  var screenLG = (_ref5 = width <= 1200) !== null && _ref5 !== void 0 ? _ref5 : true;
  var screenXLG = (_ref6 = width <= 1280) !== null && _ref6 !== void 0 ? _ref6 : true;
  var screenXL = (_ref7 = width <= 1440) !== null && _ref7 !== void 0 ? _ref7 : true;
  var screenXXL = (_ref8 = width <= 1850) !== null && _ref8 !== void 0 ? _ref8 : true;
  return {
    screenXSM: screenXSM,
    screenSM: screenSM,
    screenMD: screenMD,
    screenXMD: screenXMD,
    screenLG: screenLG,
    screenXLG: screenXLG,
    screenXL: screenXL,
    screenXXL: screenXXL
  };
}

function useWindowDimensions() {
  var _useState = (0,react.useState)(getWindowDimensions()),
      windowDimensions = _useState[0],
      setWindowDimensions = _useState[1];

  (0,react.useEffect)(function () {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowDimensions;
}
;// CONCATENATED MODULE: ./containers/MockupList/ListItems.js
















var ListItems = function ListItems(props) {
  var user = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.user;
  });
  var locale = (0,es/* useSelector */.v9)(function (state) {
    return state.window.locale;
  });

  var _useState = (0,react.useState)((0,helpers/* getCookie */.ej)('inView')),
      isView = _useState[0],
      setIsView = _useState[1];

  var mockups = props.mockups,
      isMasonry = props.isMasonry,
      isNoResponsive = props.isNoResponsive,
      ratio = props.ratio,
      hasNotCollectButton = props.hasNotCollectButton;
  var query = props.router.query;
  var page = query.page;

  var _useUser = (0,useUser/* default */.Z)(),
      isPro = _useUser.isPro;

  var _useWindowDimensions = useWindowDimensions(),
      screenSM = _useWindowDimensions.screenSM,
      screenXL = _useWindowDimensions.screenXL;

  var margin = '700px';
  var previewInView = 20;
  var previewMaxWidth = screenXL ? 320 : 366;
  var previewMinWidth = screenXL ? 170 : 230;
  var breakpointColumnsObj = {
    "default": 2
  };

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    rootMargin: margin,
    triggerOnce: true
  }),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  (0,react.useEffect)(function () {
    if (inView) {
      (0,helpers/* setCookie */.d8)('inView', true, 362);
      setIsView((0,helpers/* getCookie */.ej)('inView'));
    }
  }, [inView]);
  var pageCount = props.pageCount ? props.pageCount : 98;
  if (mockups.length === 0) return null;
  var paginatedMockups = paginateMockups(mockups, page, pageCount);

  var renderItem = function renderItem(mockup, index) {
    if (index < previewInView || isView) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MockupPreview_MockupPreview, {
        mockup: mockup,
        isPreviewHover: true,
        isUserInternal: !!(user && user.isAdmin),
        isUserScheduled: !!(user && user.isScheduled),
        isUserPremium: isPro,
        locale: locale,
        index: index,
        collection: props.collection || null,
        onClick: props.onClick,
        isUserLogged: !!user,
        isLazyLoad: index > 1,
        isMasonry: isMasonry,
        hasNotCollectButton: hasNotCollectButton
      }, mockup.id);
    }

    return null;
  };

  var renderPreview = function renderPreview() {
    return paginatedMockups.map(function (mockup, index) {
      var realWidth = mockup.width ? Number(mockup.width) : 3000;
      var realHeight = mockup.height ? Number(mockup.height) : 2000;
      var flexGrow = realWidth * previewMaxWidth / realHeight;
      var flexBasis = realWidth * previewMinWidth / realHeight;
      var paddingBottom = (realHeight + 4) / realWidth * 100;

      if (isMasonry) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: screenSM && !isNoResponsive ? null : {
            flexBasis: "".concat(ratio ? flexBasis * ratio / 100 : flexBasis, "px"),
            flexGrow: ratio ? flexGrow * ratio / 100 : flexGrow,
            maxWidth: ratio ? flexGrow * ratio / 100 : flexGrow
          },
          ref: index === previewInView + 1 ? ref : null,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            style: {
              paddingBottom: "".concat(paddingBottom, "%")
            }
          }), renderItem(mockup, index)]
        }, mockup.shortId);
      }

      return renderItem(mockup, index);
    });
  };

  if (screenSM && isMasonry && !isNoResponsive) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
      breakpointCols: breakpointColumnsObj,
      className: (MockupList_module_default()).myMasonryGrid,
      columnClassName: (MockupList_module_default()).myMasonryGridColumn,
      children: renderPreview()
    });
  }

  return renderPreview();
};

/* harmony default export */ var MockupList_ListItems = ((0,injectIntl/* default */.ZP)((0,next_router.withRouter)(ListItems)));
// EXTERNAL MODULE: ./components/List/MockupList/MockupPlaceholder.module.scss
var MockupPlaceholder_module = __webpack_require__(49021);
var MockupPlaceholder_module_default = /*#__PURE__*/__webpack_require__.n(MockupPlaceholder_module);
;// CONCATENATED MODULE: ./components/List/MockupList/MockupPlaceholder.js




var MockupPlacehoder = function MockupPlacehoder(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (MockupPlaceholder_module_default()).wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (MockupPlaceholder_module_default()).placeholder,
      style: {
        paddingTop: "".concat(props.height / props.width * 100, "%")
      }
    })
  });
};

/* harmony default export */ var MockupPlaceholder = (MockupPlacehoder);
;// CONCATENATED MODULE: ./containers/MockupList/ListPlaceholders.js




var ListPlaceholders = function ListPlaceholders(_ref) {
  var count = _ref.count;
  var placeholders = [];

  for (var i = 0; i < count; i++) {
    placeholders.push( /*#__PURE__*/(0,jsx_runtime.jsx)(MockupPlaceholder, {
      width: 380,
      height: 285
    }, "mockup-placeholder-".concat(i)));
  }

  return placeholders;
};

/* harmony default export */ var MockupList_ListPlaceholders = (ListPlaceholders);
;// CONCATENATED MODULE: ./components/List/MockupList/MockupList.js





var MockupList = function MockupList(props) {
  var isMasonry = props.isMasonry,
      isNoResponsive = props.isNoResponsive,
      className = props.className;

  var _useWindowDimensions = useWindowDimensions(),
      screenSM = _useWindowDimensions.screenSM;

  if (screenSM && isMasonry && !isNoResponsive) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-cy": "mockupList",
      ref: props.ref,
      className: "".concat(className !== null && className !== void 0 ? className : className),
      children: props.children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat(isMasonry ? (MockupList_module_default()).wrapperMasonry : (MockupList_module_default()).wrapper, " ").concat(className !== null && className !== void 0 ? className : className),
    "data-cy": "mockupList",
    children: props.children
  });
};

/* harmony default export */ var MockupList_MockupList = (MockupList);
// EXTERNAL MODULE: ./components/List/LivePreview/LivePreviewToolbar.module.scss
var LivePreviewToolbar_module = __webpack_require__(18528);
var LivePreviewToolbar_module_default = /*#__PURE__*/__webpack_require__.n(LivePreviewToolbar_module);
;// CONCATENATED MODULE: ./utils/allowedFileTypes.js
// list of allowed file formats (extensions) used by file uploader (file picker and drag'n'drop area)
var allowedImages = (/* unused pure expression or super */ null && (['jpg', 'jpeg', 'bmp', 'pdf', 'png', 'webp']));
var allowedLivePreviewImages = ['jpg', 'jpeg', 'bmp', 'png', 'webp'];
var allowedVideos = (/* unused pure expression or super */ null && (['mp4', 'avi', 'mov', 'gif']));
// EXTERNAL MODULE: ./components/List/LivePreview/LivePreviewUploadButton.module.scss
var LivePreviewUploadButton_module = __webpack_require__(10729);
var LivePreviewUploadButton_module_default = /*#__PURE__*/__webpack_require__.n(LivePreviewUploadButton_module);
;// CONCATENATED MODULE: ./utils/routing/LivePreviewRoutes.js
var removePreview = function removePreview(router) {
  var query = new URLSearchParams(window.location.search);
  query["delete"]('preview');
  var queryString = query.toString() ? "?".concat(query.toString()) : ''; // check location

  var rootPath = router.route.split('/')[1];
  var url = "/".concat(rootPath, "/");

  if (rootPath === 'mockups') {
    var _router$query$slug;

    url += (_router$query$slug = router.query.slug) !== null && _router$query$slug !== void 0 ? _router$query$slug : '';
  }

  if (rootPath === 'user-collection') {
    var _router$query$id;

    url += (_router$query$id = router.query.id) !== null && _router$query$id !== void 0 ? _router$query$id : '';
  }

  var href = "".concat(router.pathname).concat(queryString);
  var as = "".concat(url).concat(queryString);
  return router.push(href, as, {
    shallow: true
  });
};
/* harmony default export */ var LivePreviewRoutes = ((/* unused pure expression or super */ null && (removePreview)));
;// CONCATENATED MODULE: ./components/List/LivePreview/LivePreviewUploadButtonCore.js














var acceptedFormats = allowedLivePreviewImages.map(function (type) {
  return ".".concat(type);
}).join(',');

var LivePreviewUploadButtonCore = function LivePreviewUploadButtonCore(props) {
  var isClientSide = props.isClientSide,
      isPredefined = props.isPredefined,
      scrollTo = props.scrollTo;
  var user = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.user;
  });
  var router = (0,next_router.useRouter)();
  var livePreview = hooks_useLivePreview(props.trigger);

  var _useActions = (0,useActions/* default */.Z)(windowActions),
      setPremiumModal = _useActions.setPremiumModal;

  var inputName = "live-preview-upload-".concat(Math.round(Math.random() * 1000));
  var predefinedFileId = livePreview.predefinedFileId;

  var scrollToElement = function scrollToElement() {
    if (scrollTo) {
      scrollTo();
    }
  };

  var onClick = function onClick(event) {
    if (user || isClientSide) {
      event.target.value = null;
    } else {
      event.preventDefault();
      setPremiumModal('signup', 'Header signup modal');
    }
  };

  var handlePredefinedClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();

              if (!router.query.preview) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return removePreview(router);

            case 4:
              livePreview.uploadFileClient("livePreview/".concat(event.currentTarget.value, ".png"), event.currentTarget.value);
              scrollToElement();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePredefinedClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event) {
      var fileNames, files;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();
              fileNames = event.target.files;

              if (!router.query.preview) {
                _context2.next = 5;
                break;
              }

              _context2.next = 5;
              return removePreview(router);

            case 5:
              files = Array.from(fileNames);

              if (isClientSide) {
                livePreview.uploadFileClient(URL.createObjectURL(files[0]));
              } else {
                livePreview.uploadFile(files[0]);
              }

              scrollToElement();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onChange(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderButton = function renderButton() {
    if (isPredefined) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: handlePredefinedClick,
        value: props.value,
        type: "button",
        className: "".concat(props.className, " ").concat((LivePreviewUploadButton_module_default()).predefined, " ").concat(props.value === predefinedFileId ? (LivePreviewUploadButton_module_default()).predefinedActive : null),
        children: props.children
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      htmlFor: inputName,
      className: props.className,
      children: [props.children, /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        id: inputName,
        type: "file",
        accept: acceptedFormats,
        onClick: onClick,
        onChange: onChange,
        className: (LivePreviewUploadButton_module_default()).uploadInput
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: renderButton()
  });
};

/* harmony default export */ var LivePreview_LivePreviewUploadButtonCore = (LivePreviewUploadButtonCore);
;// CONCATENATED MODULE: ./utils/className.js
/* eslint-disable import/prefer-default-export */
function className_createClass() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(function (arg) {
    return typeof arg === 'string' && arg !== '';
  }).join(' ');
}
// EXTERNAL MODULE: ./components/Base/Button/Button.module.scss
var Button_module = __webpack_require__(8482);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/List/LivePreview/Edit.svg
var Edit = __webpack_require__(34988);
var Edit_default = /*#__PURE__*/__webpack_require__.n(Edit);
// EXTERNAL MODULE: ./components/List/LivePreview/Remove.svg
var Remove = __webpack_require__(37851);
var Remove_default = /*#__PURE__*/__webpack_require__.n(Remove);
// EXTERNAL MODULE: ./components/List/LivePreview/EditBackground.png
var EditBackground = __webpack_require__(79190);
var EditBackground_default = /*#__PURE__*/__webpack_require__.n(EditBackground);
;// CONCATENATED MODULE: ./components/List/LivePreview/LivePreviewToolbar.js























var LivePreviewToolbar = function LivePreviewToolbar(props) {
  var isClientSide = props.isClientSide,
      hasPredefinedPreviews = props.hasPredefinedPreviews,
      trigger = props.trigger;
  var livePreview = hooks_useLivePreview();
  var router = (0,next_router.useRouter)();
  var canvas = livePreview.canvas,
      predefinedFileId = livePreview.predefinedFileId,
      file = livePreview.file;
  var listRef = (0,react.useRef)();

  var _useWindowDimensions = useWindowDimensions(),
      screenSM = _useWindowDimensions.screenSM;

  var executeScroll = function executeScroll() {
    return screenSM && listRef.current.scrollIntoView();
  };

  var handleClearLivePreview = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!router.query.preview) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return removePreview(router);

            case 3:
              livePreview.clear();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClearLivePreview() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderPredefinedPreview = function renderPredefinedPreview() {
    var predefinedPreviews = [{
      name: "Logo",
      hasBorder: true
    }, {
      name: "Photo"
    }, {
      name: "Art"
    }];
    return predefinedPreviews.map(function (preview) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LivePreview_LivePreviewUploadButtonCore, {
        className: "".concat((LivePreviewToolbar_module_default()).predefinedButton, " ").concat(preview.hasBorder ? (LivePreviewToolbar_module_default()).predefinedButtonBorder : null),
        isPredefined: true,
        value: preview.name,
        trigger: trigger,
        scrollTo: executeScroll,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/livePreview/thumbs/".concat(preview.name, ".jpg"),
          alt: "Try live preview - ".concat(preview.name),
          layout: "fill"
        })
      }, preview.name);
    });
  };

  var renderPredefinedPreviews = function renderPredefinedPreviews() {
    if (hasPredefinedPreviews) {
      if (canvas && !predefinedFileId || file) {
        return null;
      }

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: renderPredefinedPreview()
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (LivePreviewToolbar_module_default()).separator,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "Ntjkqd",
            defaultMessage: [{
              "type": 0,
              "value": "or"
            }]
          })
        })]
      });
    }

    return null;
  };

  var renderUploadButton = function renderUploadButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(LivePreview_LivePreviewUploadButtonCore, {
      className: className_createClass((Button_module_default()).btn, (LivePreviewToolbar_module_default()).livePreviewUploadButton),
      isClientSide: isClientSide,
      trigger: trigger,
      scrollTo: executeScroll,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "Image",
        color: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "H++7fS",
          defaultMessage: [{
            "type": 0,
            "value": "Upload your image"
          }]
        })
      })]
    });
  };

  var renderEditButtons = function renderEditButtons() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LivePreview_LivePreviewUploadButtonCore, {
        className: className_createClass((Button_module_default()).btn, (LivePreviewToolbar_module_default()).livePreviewUploadButtonCompact),
        isClientSide: isClientSide,
        trigger: trigger,
        scrollTo: executeScroll,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LivePreviewToolbar_module_default()).uploadButtonBackground,
          style: {
            backgroundImage: "url(".concat(canvas ? canvas.toDataURL() : (EditBackground_default()), ")")
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: (Edit_default()),
            alt: ""
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: (LivePreviewToolbar_module_default()).livePreviewRemoveButton,
        onClick: handleClearLivePreview,
        size: "xlarge",
        design: "default",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: (Remove_default()),
          alt: ""
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
        to: "/mockups",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
          className: (LivePreviewToolbar_module_default()).buttonLink,
          size: "xlarge",
          design: "black",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "Image",
            size: "sm",
            color: "grey"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "GApPdN",
              defaultMessage: [{
                "type": 0,
                "value": "Browse all mockups"
              }]
            })
          })]
        })
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (LivePreviewToolbar_module_default()).livePreviewWrapper,
    ref: listRef,
    children: [hasPredefinedPreviews ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (LivePreviewToolbar_module_default()).title,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "UhRY/J",
        defaultMessage: [{
          "type": 0,
          "value": "Give it a try with our samples or upload your own image"
        }]
      })
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (LivePreviewToolbar_module_default()).buttonHolder,
      children: [renderPredefinedPreviews(), canvas && !predefinedFileId || file ? renderEditButtons() : renderUploadButton(), !hasPredefinedPreviews ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (LivePreviewToolbar_module_default()).livePreviewDescription,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "2zYYHW",
          defaultMessage: [{
            "type": 0,
            "value": "to get an instant preview on all mockups"
          }]
        })
      }) : null]
    }), hasPredefinedPreviews ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (LivePreviewToolbar_module_default()).info,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "iJoBOX",
        defaultMessage: [{
          "type": 0,
          "value": "*Your images are 100% safe, all the magic happens in your browser"
        }]
      })
    }) : null]
  });
};

/* harmony default export */ var LivePreview_LivePreviewToolbar = (LivePreviewToolbar);
;// CONCATENATED MODULE: ./components/Marketing/HomePageHeader/HomePageHeader.js




















var HomePageHeader = function HomePageHeader(props) {
  var mockups = props.mockups;
  var intl = (0,useIntl/* default */.Z)();

  var _useQueryUrl = hooks_useQueryUrl(),
      makeQueryUrl = _useQueryUrl.makeQueryUrl;

  var buildFilterUrl = function buildFilterUrl(value) {
    return makeQueryUrl(value, 'category', "mockups");
  };

  var filterOptions = [];
  var half = Math.ceil(mockups.length / 2);
  var firstRow = mockups.slice(0, half);
  var secondRow = mockups.slice(half);

  var _useWindowDimensions = useWindowDimensions(),
      screenSM = _useWindowDimensions.screenSM,
      screenXMD = _useWindowDimensions.screenXMD,
      screenXLG = _useWindowDimensions.screenXLG,
      screenXXL = _useWindowDimensions.screenXXL;

  var ratioTop = screenDimensions();
  var ratioBottom = screenXMD ? 100 : 80;

  function screenDimensions() {
    if (screenXXL && !screenXLG) {
      return 55;
    }

    if (screenXLG && !screenXMD) {
      return 48;
    }

    if (screenXMD) {
      return 100;
    }

    return 72;
  }

  var prepareFilterItems = function prepareFilterItems(tags) {
    return tags.filter(function (tag) {
      if (tag) {
        if (tag.intlId) {
          var message = {
            id: "".concat(tag.intlId, ".menuTitle"),
            defaultMessage: tag.menuTitle
          };
          tag.menuTitle = intl.formatMessage(message);
        }

        return tag;
      }

      return null;
    });
  };

  filterOptions.push(prepareFilterItems(utils_favoriteCollections));

  var renderMockupsList = function renderMockupsList(array, responsive, ratio) {
    if (array && array.length > 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MockupList_MockupList, {
        isMasonry: true,
        isNoResponsive: responsive,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MockupList_ListItems, {
          mockups: array,
          isMasonry: true,
          isNoResponsive: responsive,
          ratio: ratio,
          hasNotCollectButton: true
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(MockupList_MockupList, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MockupList_ListPlaceholders, {
        count: 3
      })
    });
  };

  var renderMockupsRows = function renderMockupsRows() {
    if (screenSM) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: renderMockupsList(mockups)
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (HomepageHeader_module_default()).mockupsFirstRow,
        children: renderMockupsList(firstRow, true, ratioTop)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (HomepageHeader_module_default()).mockupsSecondRow,
        children: renderMockupsList(secondRow, true, ratioBottom)
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (HomepageHeader_module_default()).topWrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
        isPaddingDisabled: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (HomepageHeader_module_default()).row,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (HomepageHeader_module_default()).content,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
              size: "sm",
              tag: "p",
              className: "color-grey",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                id: "r63fST",
                defaultMessage: [{
                  "type": 0,
                  "value": "The #1 product mockup generator"
                }]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomePageHeader_HeaderTitle, {}, props.intl.locale), /*#__PURE__*/(0,jsx_runtime.jsx)(LivePreview_LivePreviewToolbar, {
              hasPredefinedPreviews: true,
              isClientSide: true,
              trigger: "homepageHeader"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (HomepageHeader_module_default()).mockupsWrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (HomepageHeader_module_default()).mockupsEmptyTopRow,
              children: renderMockupsList()
            }), renderMockupsRows(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (HomepageHeader_module_default()).mockupsEmptyBottomRow,
              children: renderMockupsList()
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (HomepageHeader_module_default()).bottomWrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container_Container, {
        isPaddingDisabled: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (HomepageHeader_module_default()).searchTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "cvg9g+",
            defaultMessage: [{
              "type": 0,
              "value": "Let’s create your first mockup!"
            }]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (HomepageHeader_module_default()).searchWrap,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Searchbar_Searchbar, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (HomepageHeader_module_default()).filtersWrap,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SlideBar_SlideBar, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Filters_FilterGroup, {
              filters: filterOptions,
              active: [],
              filtersUrls: buildFilterUrl,
              isPrimary: true
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var HomePageHeader_HomePageHeader = ((0,injectIntl/* default */.ZP)(HomePageHeader));
// EXTERNAL MODULE: ./components/Layout/Headline/Headline.js
var Headline = __webpack_require__(58734);
// EXTERNAL MODULE: ./components/Layout/PageHeadline/PageHeadline.module.scss
var PageHeadline_module = __webpack_require__(58410);
var PageHeadline_module_default = /*#__PURE__*/__webpack_require__.n(PageHeadline_module);
;// CONCATENATED MODULE: ./components/Layout/PageHeadline/PageHeadline.js





var PageHeadline = function PageHeadline(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (PageHeadline_module_default()).wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Headline/* default */.Z, {
      title: props.subtitle,
      subtitle: props.title,
      design: props.design
    })
  });
};

/* harmony default export */ var PageHeadline_PageHeadline = (PageHeadline);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/CustomerTestimonials.module.scss
var CustomerTestimonials_module = __webpack_require__(7863);
var CustomerTestimonials_module_default = /*#__PURE__*/__webpack_require__.n(CustomerTestimonials_module);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/MoMosby.jpg
var MoMosby = __webpack_require__(22646);
var MoMosby_default = /*#__PURE__*/__webpack_require__.n(MoMosby);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/MoMosby@2x.jpg
var MoMosby_2x = __webpack_require__(74484);
var MoMosby_2x_default = /*#__PURE__*/__webpack_require__.n(MoMosby_2x);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/lubosVolkov.jpg
var lubosVolkov = __webpack_require__(4456);
var lubosVolkov_default = /*#__PURE__*/__webpack_require__.n(lubosVolkov);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/lubosVolkov@2x.jpg
var lubosVolkov_2x = __webpack_require__(35158);
var lubosVolkov_2x_default = /*#__PURE__*/__webpack_require__.n(lubosVolkov_2x);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/jacobCass@2x.jpg
var jacobCass_2x = __webpack_require__(94595);
var jacobCass_2x_default = /*#__PURE__*/__webpack_require__.n(jacobCass_2x);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/jacobCass.jpg
var jacobCass = __webpack_require__(81744);
var jacobCass_default = /*#__PURE__*/__webpack_require__.n(jacobCass);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/markCherry.jpg
var markCherry = __webpack_require__(18902);
var markCherry_default = /*#__PURE__*/__webpack_require__.n(markCherry);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/markCherry@2x.jpg
var markCherry_2x = __webpack_require__(74585);
var markCherry_2x_default = /*#__PURE__*/__webpack_require__.n(markCherry_2x);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/AugustAgency.jpg
var AugustAgency = __webpack_require__(50331);
var AugustAgency_default = /*#__PURE__*/__webpack_require__.n(AugustAgency);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/AugustAgency@2x.jpg
var AugustAgency_2x = __webpack_require__(25586);
var AugustAgency_2x_default = /*#__PURE__*/__webpack_require__.n(AugustAgency_2x);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/ArtyomTarasov.jpg
var ArtyomTarasov = __webpack_require__(22078);
var ArtyomTarasov_default = /*#__PURE__*/__webpack_require__.n(ArtyomTarasov);
// EXTERNAL MODULE: ./components/Marketing/CustomerTestimonials/images/ArtyomTarasov@2x.jpg
var ArtyomTarasov_2x = __webpack_require__(37684);
var ArtyomTarasov_2x_default = /*#__PURE__*/__webpack_require__.n(ArtyomTarasov_2x);
// EXTERNAL MODULE: ./components/Marketing/Trustpilot/TrustpilotWidget.js
var TrustpilotWidget = __webpack_require__(10405);
;// CONCATENATED MODULE: ./components/Marketing/CustomerTestimonials/CustomerTestimonials.js








function CustomerTestimonials_createSuper(Derived) { var hasNativeReflectConstruct = CustomerTestimonials_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function CustomerTestimonials_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



















var CustomerTestimonials = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(CustomerTestimonials, _Component);

  var _super = CustomerTestimonials_createSuper(CustomerTestimonials);

  function CustomerTestimonials() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, CustomerTestimonials);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "items", [{
      text: 'This app looks really promising. It gives you the ability to create nice marketing images without using Photoshop.',
      name: 'Lubos Volkov',
      job: 'Lead designer at Toptal',
      img: (lubosVolkov_default()),
      img2x: (lubosVolkov_2x_default())
    }, {
      text: 'I love using this app  and I wish I had my hands on it much earlier in my career, it really is super quick & simple to use!',
      name: 'Jacob Cass',
      job: 'Founder of JUST™ Creative',
      img: (jacobCass_default()),
      img2x: (jacobCass_2x_default())
    }, {
      text: 'Saves us a lot of time creating awesome mockups to use to demonstrate new sites to clients.',
      name: 'Mark Cherry',
      job: 'Founder of Green Stripe Media',
      img: (markCherry_default()),
      img2x: (markCherry_2x_default())
    }, {
      text: 'I just bought it and I love it. Easily the best tool for mockups I have encountered ever.',
      name: 'Mo Mosby',
      job: 'Freelance Graphic Designer',
      img: (MoMosby_default()),
      img2x: (MoMosby_2x_default())
    }, {
      text: 'Smartmockups is the best mockup tool for any studio or individual to produce high-quality mockups in no time.',
      name: 'August Agency',
      job: 'London UK',
      img: (AugustAgency_default()),
      img2x: (AugustAgency_2x_default())
    }, {
      text: "This is awesome! We're using tons of mockups, so this is really helpful.",
      name: 'Artyom Tarasov',
      job: 'Art Director at Great Simple',
      img: (ArtyomTarasov_default()),
      img2x: (ArtyomTarasov_2x_default())
    }]);

    return _this;
  }

  (0,createClass/* default */.Z)(CustomerTestimonials, [{
    key: "getColStyle",
    value: function getColStyle() {
      var styles = [];

      if (this.props.design === 'inverse') {
        styles.push((CustomerTestimonials_module_default()).inverse);
      }

      if (this.props.layout === 'single') {
        styles.push((CustomerTestimonials_module_default()).single);
      }

      return styles.join(' ');
    }
  }, {
    key: "renderItems",
    value: function renderItems(items) {
      var _this2 = this;

      return items.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((CustomerTestimonials_module_default()).testimonialCol, " ").concat(_this2.getColStyle(index)),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((CustomerTestimonials_module_default()).testimonialBox, " ").concat((CustomerTestimonials_module_default())[_this2.props.design]),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (CustomerTestimonials_module_default()).testimonialTitle,
              children: ["\u201C", item.text, "\u201D"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CustomerTestimonials_module_default()).testimonialAvatar,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (CustomerTestimonials_module_default()).testimonialAvatarImg,
              src: item.img,
              srcSet: "".concat(item.img2x, " 2x")
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (CustomerTestimonials_module_default()).testimonialAvatarPerson,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "".concat((CustomerTestimonials_module_default()).testimonialAvatarName, " ").concat((CustomerTestimonials_module_default())[_this2.props.design]),
                children: item.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "".concat((CustomerTestimonials_module_default()).testimonialAvatarPosition, " ").concat((CustomerTestimonials_module_default())[_this2.props.design]),
                children: item.job
              })]
            })]
          })]
        }, item.name);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var item;
      var items;

      switch (this.props.layout) {
        case 'single':
          item = this.items[Math.floor(Math.random() * this.items.length)];
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((CustomerTestimonials_module_default()).customerTestimonials, " ").concat((CustomerTestimonials_module_default()).single),
            children: this.renderItems([item])
          });

        case 'centered':
          item = this.items[Math.floor(Math.random() * this.items.length)];
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((CustomerTestimonials_module_default()).customerTestimonials, " ").concat((CustomerTestimonials_module_default()).single),
            children: this.renderItems([item])
          });

        default:
          items = this.items.slice(0, 3);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CustomerTestimonials_module_default()).customerTestimonials,
              children: this.renderItems(items)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CustomerTestimonials_module_default()).trustpilot,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotWidget/* default */.Z, {
                type: "horizontal"
              })
            })]
          });
      }
    }
  }]);

  return CustomerTestimonials;
}(react.Component);


// EXTERNAL MODULE: ./components/Marketing/InstagramFeed/InstagramFeed.module.scss
var InstagramFeed_module = __webpack_require__(23176);
var InstagramFeed_module_default = /*#__PURE__*/__webpack_require__.n(InstagramFeed_module);
;// CONCATENATED MODULE: ./components/Marketing/InstagramFeed/InstagramFeedItem.js






var InstagramFeedItem = function InstagramFeedItem(_ref) {
  var item = _ref.item,
      sizes = _ref.sizes;
  var placeholderUrl = "".concat(variables/* WEB_IMGIX */.iL, "/").concat(item.image, "?auto=compress&fit=crop&w=300&h=300&q=1&blur=200");
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: "https://www.instagram.com/p/".concat(item.id, "/"),
    target: "_blank",
    rel: "noreferrer",
    className: (InstagramFeed_module_default()).item,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_imgix_es/* default */.ZP, {
      className: "".concat((InstagramFeed_module_default()).image, " lazyload"),
      src: "".concat(variables/* WEB_IMGIX */.iL, "/").concat(item.image),
      sizes: sizes,
      htmlAttributes: {
        src: placeholderUrl
      },
      attributeConfig: {
        src: 'data-src',
        srcSet: 'data-srcset',
        loading: 'lazy'
      },
      imgixParams: {
        ar: "1:1",
        fit: 'crop',
        auto: 'compress'
      }
    })
  }, item.id);
};

/* harmony default export */ var InstagramFeed_InstagramFeedItem = (InstagramFeedItem);
;// CONCATENATED MODULE: ./components/Marketing/InstagramFeed/InstagramFeed.js








var InstagramFeed = function InstagramFeed(props) {
  var renderItems = function renderItems() {
    if (!props.instagram) return null;
    var sizes = "\n        240px,\n        (max-width: 768px)  calc(46vw - 2*4px)";
    return props.instagram.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(InstagramFeed_InstagramFeedItem, {
        item: item,
        sizes: sizes
      }, item.id);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (InstagramFeed_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (InstagramFeed_module_default()).titleWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Headline/* default */.Z, {
          title: "Instagram",
          subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "tTlfEg",
            defaultMessage: [{
              "type": 0,
              "value": "Share your mockups on "
            }, {
              "type": 1,
              "value": "newline"
            }, {
              "type": 0,
              "value": "Instagram and get featured"
            }],
            values: {
              newline: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
            }
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (InstagramFeed_module_default()).description,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "+0QWVB",
          defaultMessage: [{
            "type": 0,
            "value": "Share your projects with "
          }, {
            "type": 8,
            "value": "a1",
            "children": [{
              "type": 0,
              "value": " #madewithsmartmockups"
            }]
          }, {
            "type": 0,
            "value": " and get repost featured on "
          }, {
            "type": 8,
            "value": "a2",
            "children": [{
              "type": 0,
              "value": "our Instagram profile"
            }]
          }],
          values: {
            a1: function a1(msg) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://www.instagram.com/explore/tags/madewithsmartmockups/",
                target: "_blank",
                rel: "noreferrer",
                children: msg
              });
            },
            a2: function a2(msg) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://www.instagram.com/smartmockups/",
                target: "_blank",
                rel: "noreferrer",
                children: msg
              });
            }
          }
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InstagramFeed_module_default()).grid,
      children: renderItems()
    })]
  });
};

/* harmony default export */ var InstagramFeed_InstagramFeed = (InstagramFeed);
// EXTERNAL MODULE: ./containers/HomePage/Homepage.module.scss
var Homepage_module = __webpack_require__(71372);
var Homepage_module_default = /*#__PURE__*/__webpack_require__.n(Homepage_module);
// EXTERNAL MODULE: ./components/Marketing/LargeDescription/LargeDescription.module.scss
var LargeDescription_module = __webpack_require__(98012);
var LargeDescription_module_default = /*#__PURE__*/__webpack_require__.n(LargeDescription_module);
// EXTERNAL MODULE: ./components/Marketing/FeatureList/FeatureList.module.scss
var FeatureList_module = __webpack_require__(6181);
var FeatureList_module_default = /*#__PURE__*/__webpack_require__.n(FeatureList_module);
// EXTERNAL MODULE: ./components/Marketing/MarketingIcon/MarketingIcon.js + 18 modules
var MarketingIcon = __webpack_require__(50226);
;// CONCATENATED MODULE: ./components/Marketing/FeatureList/FeatureList.js






function FeatureList_createSuper(Derived) { var hasNativeReflectConstruct = FeatureList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function FeatureList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var FeatureList = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(FeatureList, _Component);

  var _super = FeatureList_createSuper(FeatureList);

  function FeatureList() {
    (0,classCallCheck/* default */.Z)(this, FeatureList);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(FeatureList, [{
    key: "renderIcon",
    value: function renderIcon(item) {
      if (!item.design) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MarketingIcon["default"], {
          width: 30,
          height: 30,
          name: "FeatureList"
        });
      }

      if (item.design === 'notAvailable') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MarketingIcon["default"], {
          width: 30,
          height: 30,
          name: "FeatureListNotAvailable"
        });
      }

      return null;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;

      return this.props.items.map(function (item, index) {
        var contentStyle = item.design === 'notAvailable' ? (FeatureList_module_default()).contentNotAvailable : (FeatureList_module_default()).content;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: (FeatureList_module_default()).item,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (FeatureList_module_default()).icon,
            children: _this.renderIcon(item)
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: contentStyle,
            children: [" ", item.content ? item.content : item]
          })]
        }, index);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (FeatureList_module_default()).list,
        children: this.renderItems()
      });
    }
  }]);

  return FeatureList;
}(react.Component);


// EXTERNAL MODULE: ./components/Marketing/SectionTitle/SectionTitle.module.scss
var SectionTitle_module = __webpack_require__(99940);
var SectionTitle_module_default = /*#__PURE__*/__webpack_require__.n(SectionTitle_module);
;// CONCATENATED MODULE: ./components/Marketing/SectionTitle/SectionTitle.js





var SectionTitle = function SectionTitle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (SectionTitle_module_default()).wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Headline/* default */.Z, {
      title: props.title,
      subtitle: props.subtitle,
      design: props.design
    })
  });
};

/* harmony default export */ var SectionTitle_SectionTitle = (SectionTitle);
;// CONCATENATED MODULE: ./components/Marketing/LargeDescription/LargeDescription.js







var LargeDescription = function LargeDescription(props) {
  var titleDesign = 'default';
  var descriptionStyles = (LargeDescription_module_default()).description;

  if (props.design === 'blue') {
    titleDesign = 'blue';
    descriptionStyles = (LargeDescription_module_default()).descriptionBlue;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (LargeDescription_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle, {
      subtitle: props.subtitle,
      title: props.title,
      design: titleDesign
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: descriptionStyles,
      children: props.description
    }), props.list ? /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureList, {
      items: props.list
    }) : null]
  });
};

/* harmony default export */ var LargeDescription_LargeDescription = (LargeDescription);
// EXTERNAL MODULE: ./components/Marketing/FeatureGrid/FeatureGrid.module.scss
var FeatureGrid_module = __webpack_require__(88611);
var FeatureGrid_module_default = /*#__PURE__*/__webpack_require__.n(FeatureGrid_module);
;// CONCATENATED MODULE: ./components/Marketing/FeatureGrid/FeatureGrid.js




var FeatureGrid = function FeatureGrid(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: props.singleColumn ? (FeatureGrid_module_default()).gridSingle : (FeatureGrid_module_default()).grid,
    children: props.children
  });
};

/* harmony default export */ var FeatureGrid_FeatureGrid = (FeatureGrid);
// EXTERNAL MODULE: ./components/Marketing/ShortDescription/ShortDescription.module.scss
var ShortDescription_module = __webpack_require__(98614);
var ShortDescription_module_default = /*#__PURE__*/__webpack_require__.n(ShortDescription_module);
;// CONCATENATED MODULE: ./components/Marketing/ShortDescription/ShortDescription.js







var ShortDescription = function ShortDescription(props) {
  var titleStyles = (ShortDescription_module_default()).title;
  var descriptionStyles = (ShortDescription_module_default()).description;

  if (props.design === 'blue') {
    titleStyles = (ShortDescription_module_default()).titleBlue;
    descriptionStyles = (ShortDescription_module_default()).descriptionBlue;
  }

  if (props.design === 'disabled') {
    titleStyles = (ShortDescription_module_default()).titleGrey;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ShortDescription_module_default()).wrapper,
    children: [props.icon ? /*#__PURE__*/(0,jsx_runtime.jsx)(MarketingIcon["default"], {
      name: props.icon,
      height: 100,
      width: 100,
      className: (ShortDescription_module_default()).icon
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
      className: titleStyles,
      children: [props.title, ' ', props.isPro ? /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "ProBadgeRight",
        width: 50,
        height: 20
      }) : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: descriptionStyles,
      children: props.description
    })]
  });
};

/* harmony default export */ var ShortDescription_ShortDescription = (ShortDescription);
// EXTERNAL MODULE: ./components/Marketing/Masonry/Masonry.module.scss
var Masonry_module = __webpack_require__(72293);
var Masonry_module_default = /*#__PURE__*/__webpack_require__.n(Masonry_module);
;// CONCATENATED MODULE: ./components/Marketing/Masonry/Masonry.js






function Masonry_createSuper(Derived) { var hasNativeReflectConstruct = Masonry_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Masonry_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var Masonry = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Masonry, _Component);

  var _super = Masonry_createSuper(Masonry);

  function Masonry() {
    (0,classCallCheck/* default */.Z)(this, Masonry);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Masonry, [{
    key: "renderImage",
    value: function renderImage(image) {
      var imageUrl = "".concat(variables/* WEB_IMGIX */.iL, "/").concat(image.src);
      return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: "".concat(image.isShadow ? (Masonry_module_default()).imageWithShadow : (Masonry_module_default()).image, " lazyload"),
        src: "".concat(imageUrl, "?w=").concat(image.width, "&h=").concat(image.height, "&auto=compress&q=1&blur=200"),
        "data-srcset": "".concat(imageUrl, "?w=").concat(image.width, "&h=").concat(image.height, "&dpr=2&q=60&auto=compress"),
        width: image.width,
        height: image.height,
        alt: "",
        loading: "lazy"
      }, image.src);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var firstCol = [];
      var secondCol = [];
      var thirdCol = []; // eslint-disable-next-line array-callback-return

      this.props.items.map(function (image, index) {
        if (index % 3 === 0) {
          firstCol.push(_this.renderImage(image));
        } else if (index % 3 === 1) {
          secondCol.push(_this.renderImage(image));
        } else {
          thirdCol.push(_this.renderImage(image));
        }
      });
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Masonry_module_default()).wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Masonry_module_default()).col,
          children: [firstCol, " "]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Masonry_module_default()).colMiddle,
          children: [secondCol, " "]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Masonry_module_default()).col,
          children: [thirdCol, " "]
        })]
      });
    }
  }]);

  return Masonry;
}(react.Component);


// EXTERNAL MODULE: ./components/Marketing/IntegrationsOverview/IntegrationsOverview.module.scss
var IntegrationsOverview_module = __webpack_require__(93565);
var IntegrationsOverview_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsOverview_module);
;// CONCATENATED MODULE: ./components/Marketing/IntegrationsOverview/Integrations.js


function Integrations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Integrations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Integrations_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Integrations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgIntegrations = function SvgIntegrations(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Integrations_objectSpread(Integrations_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 120"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(280 10)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          stroke: "#FFF",
          strokeWidth: 10,
          fill: "#ECFAFF",
          cx: 50,
          cy: 50,
          r: 55
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M70 48v22H30V48h12v12h16.006V48H70zM58 30h-.05v10H42V30h16z",
          fill: "#000"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(190 10)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          stroke: "#FFF",
          strokeWidth: 10,
          fill: "#ECFAFF",
          cx: 50,
          cy: 50,
          r: 55
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M50 40.5L40 47l10 6.5L40 60l-10-6.554 10-6.5L30 40.5 40 34l10 6.5zM40 62l10-6 10 6-10 6-10-6zm10-8.554l10.027-6.5L50 40.5l9.973-6.5L70 40.5 59.973 47 70 53.5 59.973 60 50 53.446z",
          fill: "#0061FF",
          fillRule: "nonzero"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        id: "Canva",
        transform: "translate(90.000000, 10.000000)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "60",
          cy: "50",
          r: "55",
          fill: "#ECFAFF",
          stroke: "white",
          strokeWidth: "10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
          fill: "#7D2AE7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
          fill: "url(#paint0_radial_1_594)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
          fill: "url(#paint1_radial_1_594)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
          fill: "url(#paint2_radial_1_594)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M60 70C71.0457 70 80 61.0457 80 50C80 38.9543 71.0457 30 60 30C48.9543 30 40 38.9543 40 50C40 61.0457 48.9543 70 60 70Z",
          fill: "url(#paint3_radial_1_594)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M75.9523 51.0964C75.8986 51.0964 75.8508 51.1324 75.827 51.2039C75.5026 52.1273 75.0647 52.6785 74.7045 52.6785C74.4976 52.6785 74.414 52.4477 74.414 52.0854C74.414 51.182 74.9573 49.2636 75.2279 48.388C75.2599 48.2977 75.278 48.2031 75.2818 48.1074C75.2818 47.8527 75.1424 47.7273 74.7982 47.7273C74.4538 47.7273 74.026 47.8746 73.6399 48.5552C73.5045 47.9542 73.0986 47.6915 72.5315 47.6915C71.8767 47.6915 71.2439 48.1134 70.7224 48.796C70.2011 49.4785 69.5902 49.7054 69.1285 49.594C69.4607 48.784 69.5822 48.177 69.5822 47.7273C69.5822 47.0208 69.234 46.595 68.6708 46.595C67.8129 46.595 67.3194 47.4129 67.3194 48.2726C67.3194 48.9372 67.6201 49.6218 68.2847 49.9542C67.7293 51.2098 66.9175 52.3462 66.6091 52.3462C66.211 52.3462 66.0935 50.3999 66.1175 49.0069C66.1293 48.2089 66.1971 48.1671 66.1971 47.9243C66.1971 47.787 66.1055 47.6915 65.7453 47.6915C64.9036 47.6915 64.6409 48.4059 64.603 49.2258C64.5885 49.5367 64.5399 49.845 64.4578 50.1452C64.1036 51.4029 63.3792 52.3561 62.9055 52.3561C62.6847 52.3561 62.627 52.1353 62.627 51.8488C62.627 50.9452 63.1325 49.8129 63.1325 48.8497C63.1325 48.1392 62.822 47.6915 62.2348 47.6915C61.5464 47.6915 60.6329 48.5134 59.7692 50.0497C60.0538 48.8736 60.1692 47.7333 59.3294 47.7333C59.1467 47.7361 58.9672 47.7825 58.806 47.8686C58.6906 47.9283 58.6289 48.0357 58.6369 48.1552C58.7165 49.4109 57.6259 52.6208 56.5911 52.6208C56.4021 52.6208 56.3125 52.4178 56.3125 52.0875C56.3125 51.1839 56.8518 49.2696 57.1225 48.392C57.1554 48.2965 57.1736 48.1965 57.1762 48.0954C57.1762 47.8566 57.0289 47.7333 56.6926 47.7333C56.3225 47.7333 55.9225 47.8746 55.5344 48.5552C55.3991 47.9542 54.9931 47.6915 54.4279 47.6915C53.4986 47.6915 52.4578 48.6746 52.002 49.9581C51.3911 51.6696 50.1592 53.3214 48.5015 53.3214C46.9971 53.3214 46.203 52.0696 46.203 50.0935C46.203 47.2357 48.3005 44.9034 49.8548 44.9034C50.5991 44.9034 50.9533 45.377 50.9533 46.1034C50.9533 46.983 50.4637 47.391 50.4637 47.7253C50.4637 47.8268 50.5473 47.9283 50.7165 47.9283C51.3931 47.9283 52.1871 47.1343 52.1871 46.0517C52.1871 44.9691 51.3095 44.175 49.7533 44.175C47.1841 44.175 44.597 46.7621 44.597 50.0756C44.597 52.7124 45.8985 54.3025 48.1473 54.3025C49.6816 54.3025 51.0229 53.1105 51.7473 51.7153C51.8289 52.8715 52.3523 53.4726 53.1503 53.4726C53.8607 53.4726 54.4359 53.0507 54.8757 52.3065C55.0448 53.0846 55.4926 53.4667 56.0757 53.4667C56.7443 53.4667 57.3016 53.0427 57.8329 52.2566C57.8249 52.8736 57.9662 53.4547 58.5016 53.4547C58.7543 53.4547 59.0568 53.397 59.1105 53.1761C59.6717 50.8457 61.0668 48.9432 61.4927 48.9432C61.618 48.9432 61.6519 49.0626 61.6519 49.2079C61.6519 49.8407 61.206 51.1382 61.206 51.966C61.206 52.8635 61.5862 53.4547 62.3723 53.4547C63.2439 53.4547 64.1293 52.3879 64.7205 50.8278C64.9055 52.2846 65.3055 53.4606 65.9285 53.4606C66.6965 53.4606 68.0599 51.8467 68.8856 50.1353C69.2081 50.177 69.6957 50.1671 70.1613 49.8368C69.9643 50.3402 69.8468 50.8915 69.8468 51.4408C69.8468 53.0288 70.603 53.4726 71.2559 53.4726C71.9662 53.4726 72.5413 53.0507 72.9811 52.3065C73.1264 52.977 73.4965 53.4646 74.1792 53.4646C75.2458 53.4646 76.1731 52.374 76.1731 51.4785C76.1731 51.2418 76.0717 51.0964 75.9523 51.0964ZM53.803 52.5949C53.3712 52.5949 53.202 52.1591 53.202 51.5124C53.202 50.39 53.9702 48.5114 54.7841 48.5114C55.1384 48.5114 55.2737 48.9313 55.2737 49.4427C55.2737 50.583 54.5433 52.5949 53.803 52.5949ZM68.5653 49.2397C68.3085 48.9333 68.215 48.5154 68.215 48.1452C68.215 47.6875 68.3822 47.3014 68.5832 47.3014C68.7841 47.3014 68.8439 47.4984 68.8439 47.7731C68.8439 48.2308 68.6807 48.9034 68.5653 49.2397ZM71.9066 52.5949C71.4767 52.5949 71.3074 52.0955 71.3074 51.5124C71.3074 50.4278 72.0757 48.5114 72.8957 48.5114C73.2498 48.5114 73.3771 48.9253 73.3771 49.4427C73.3771 50.583 72.6588 52.5949 71.9066 52.5949Z",
          fill: "white"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
            id: "paint0_radial_1_594",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(47.7263 65.4526) rotate(-49.4156) scale(30.9366)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#6420FF"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#6420FF",
              stopOpacity: "0"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
            id: "paint1_radial_1_594",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(50.5895 34.5474) rotate(54.7035) scale(34.8867)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#00C4CC"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#00C4CC",
              stopOpacity: "0"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
            id: "paint2_radial_1_594",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(47.7263 65.4526) rotate(-45.1954) scale(30.5621 14.0559)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#6420FF"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#6420FF",
              stopOpacity: "0"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
            id: "paint3_radial_1_594",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(56.3579 35.3895) rotate(66.5198) scale(31.4918 52.7558)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              stopColor: "#00C4CC",
              stopOpacity: "0.725916"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "0.0001",
              stopColor: "#00C4CC"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
              offset: "1",
              stopColor: "#00C4CC",
              stopOpacity: "0"
            })]
          })]
        })]
      })]
    })
  }));
};

/* harmony default export */ var Integrations = (SvgIntegrations);
;// CONCATENATED MODULE: ./components/Marketing/IntegrationsOverview/IntegrationsOverview.js







var IntegrationsOverview = function IntegrationsOverview(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (IntegrationsOverview_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (IntegrationsOverview_module_default()).content,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Headline/* default */.Z, {
        title: props.title,
        subtitle: props.subtitle
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (IntegrationsOverview_module_default()).iconWrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Integrations, {
        className: (IntegrationsOverview_module_default()).icon,
        width: 480,
        height: 120
      })
    })]
  });
};

/* harmony default export */ var IntegrationsOverview_IntegrationsOverview = (IntegrationsOverview);
;// CONCATENATED MODULE: ./components/Messages/HomepageMessages.js

var messages = (0,react_intl_lib/* defineMessages */.vU)({
  pageTitle: {
    id: "homepage.pageTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Create stunning product mockups easily and online - Smartmockups"
    }]
  },
  metaDescription: {
    id: "homepage.metaDescription",
    defaultMessage: [{
      "type": 0,
      "value": "Smartmockups enables you to create stunning high-resolution mockups right inside your browser within one interface across multiple devices."
    }]
  },
  introDescription: {
    id: "++yA9O",
    defaultMessage: [{
      "type": 0,
      "value": "Forget about spending hours learning how to use Photoshop. Smartmockups enables you to create stunning high-resolution mockups right inside your browser within one interface across multiple devices."
    }]
  },
  introList1: {
    id: "Zypwmg",
    defaultMessage: [{
      "type": 0,
      "value": "The fastest web-based mockup tool"
    }]
  },
  introList2: {
    id: "0nbwgg",
    defaultMessage: [{
      "type": 0,
      "value": "No experience or skills needed, super easy-to-use"
    }]
  },
  introList3: {
    id: "WLcLxO",
    defaultMessage: [{
      "type": 0,
      "value": "Ever-growing library of professional mockups"
    }]
  },
  introSubtitle: {
    id: "Ss9CyZ",
    defaultMessage: [{
      "type": 0,
      "value": "Create professional mockups right inside your browser, even on the go"
    }]
  },
  introTitle: {
    id: "BoEpk9",
    defaultMessage: [{
      "type": 0,
      "value": "Introduction"
    }]
  },
  featuresTitle: {
    id: "ZXp0z1",
    defaultMessage: [{
      "type": 0,
      "value": "Features"
    }]
  },
  featuresSubtitle: {
    id: "1KSDNp",
    defaultMessage: [{
      "type": 0,
      "value": "Get the most out of each mockup with advanced features"
    }]
  },
  uploadTitle: {
    id: "KpU2Lq",
    defaultMessage: [{
      "type": 0,
      "value": "Multiple upload options"
    }]
  },
  uploadDescription: {
    id: "9p3Bbq",
    defaultMessage: [{
      "type": 0,
      "value": "Upload your own image or video from computer, use third-party integration or grab a screenshot from URL."
    }]
  },
  customizeTitle: {
    id: "rTKJpS",
    defaultMessage: [{
      "type": 0,
      "value": "Customize each mockup like a pro"
    }]
  },
  customizeDescription: {
    id: "IhHDRi",
    defaultMessage: [{
      "type": 0,
      "value": "Change the background, color of the item or crop the whole scene. Our customization options are truly endless."
    }]
  },
  exportTitle: {
    id: "Ck8Ovn",
    defaultMessage: [{
      "type": 0,
      "value": "Unlimited export & share"
    }]
  },
  exportDescription: {
    id: "gtUMou",
    defaultMessage: [{
      "type": 0,
      "value": "Once your mockup is ready, export the final image in super-high 5K resolution in few seconds with no limits."
    }]
  },
  integrationsTitle: {
    id: "dKbXhp",
    defaultMessage: [{
      "type": 0,
      "value": "Third-party integrations"
    }]
  },
  integrationsSubtitle: {
    id: "trrkAe",
    defaultMessage: [{
      "type": 0,
      "value": "Speed up your workflow"
    }]
  }
});
/* harmony default export */ var HomepageMessages = (messages);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Layout/Navbar/Navbar.module.scss
var Navbar_module = __webpack_require__(70351);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
;// CONCATENATED MODULE: ./components/Layout/Navbar/Logo.js


function Logo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Logo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Logo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Logo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Logo_objectSpread(Logo_objectSpread({}, props), {}, {
    className: (Navbar_module_default()).logo,
    width: 198,
    height: 28,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "50%",
        y1: "100%",
        x2: "50%",
        y2: "0%",
        id: "Logo_svg__a",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#626262",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "100%"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "50%",
        y1: "100%",
        x2: "50%",
        y2: "0%",
        id: "Logo_svg__b",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#00BAFF",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#009AD3",
          offset: "100%"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        x1: "50%",
        y1: "100%",
        x2: "50%",
        y2: "0%",
        id: "Logo_svg__c",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FFF",
          offset: "0%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#DCDCDC",
          offset: "100%"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        className: (Navbar_module_default()).logoMobile,
        d: "M53.256 9c-2.746 0-4.55 1.316-4.55 3.381 0 3.779 5.742 2.754 5.742 4.376 0 .49-.44.719-1.13.719-1.13 0-2.965-.704-4.094-1.637L48 18.256c1.38 1.056 3.42 1.698 5.287 1.698 2.463 0 4.534-1.086 4.534-3.366 0-3.87-5.742-2.937-5.742-4.513 0-.398.36-.581.91-.581.926 0 2.526.566 3.655 1.193l1.209-2.448C56.66 9.49 54.934 9 53.256 9zM72.49 19.862V9.138h-3.498l-2.652 6.609-2.651-6.61H60.19v10.725h2.871v-5.775l2.212 5.775h2.134l2.212-5.775.016 5.775h2.855zm10.237-1.713h-4.44l-.659 1.713h-3.357l4.69-10.724h3.358l4.534 10.724H83.37l-.643-1.713zm-.863-2.326l-1.318-3.503-1.349 3.503h2.667zm13.218 4.04l-1.46-2.892h-1.725v2.891h-3.263V9.138h5.13c2.95 0 4.644 1.377 4.644 3.81 0 1.59-.659 2.753-1.851 3.41l2.227 3.504h-3.702zm-3.185-5.34h1.867c.973 0 1.538-.52 1.538-1.484 0-.933-.565-1.453-1.538-1.453h-1.867v2.937zm17.924-2.846v-2.54h-9.664v2.54h3.185v8.185h3.279v-8.185h3.2zm14.105 8.185V9.138h-3.499l-2.684 6.609-2.619-6.61h-3.498v10.725h2.87v-5.775l2.18 5.775h2.134l2.245-5.775.015 5.775h2.856zm8.197-10.816c3.452 0 5.993 2.31 5.993 5.446 0 3.152-2.541 5.508-5.993 5.508-3.452 0-5.993-2.34-5.993-5.508 0-3.151 2.541-5.446 5.993-5.446zm.047 2.662c-1.459 0-2.698 1.178-2.698 2.8 0 1.621 1.255 2.83 2.698 2.83s2.604-1.209 2.604-2.83c0-1.622-1.16-2.8-2.604-2.8zm13.343-2.662c-3.404 0-5.914 2.31-5.914 5.431 0 3.167 2.463 5.523 5.805 5.523 1.663 0 3.467-.81 4.66-2.065l-1.884-1.959c-.753.75-1.772 1.24-2.62 1.24-1.49 0-2.62-1.194-2.62-2.77 0-1.575 1.13-2.753 2.62-2.753.91 0 1.93.566 2.62 1.422l1.883-2.172c-1.114-1.163-2.887-1.897-4.55-1.897zm13.579 10.816h3.906l-4.236-6.364 3.985-4.36h-3.765l-3.687 4.13v-4.13h-3.263v10.724h3.263v-2.57l1.24-1.346 2.557 3.916zm15.83-10.724h-3.263v6.196c0 1.254-.77 2.004-1.852 2.004-1.098 0-1.96-.765-1.96-2.004V9.138h-3.264v6.196c0 2.845 2.055 4.666 5.209 4.666 3.137 0 5.13-1.82 5.13-4.666V9.138zm2.66 0h4.988c2.84 0 4.471 1.377 4.471 3.81 0 2.554-1.631 4.023-4.47 4.023h-1.727v2.891h-3.263V9.138zm3.262 2.448v2.937h1.57c.972 0 1.537-.52 1.537-1.484 0-.933-.565-1.453-1.538-1.453h-1.569zM193.404 9c-2.746 0-4.55 1.316-4.55 3.381 0 3.779 5.742 2.754 5.742 4.376 0 .49-.44.719-1.13.719-1.13 0-2.965-.704-4.095-1.637l-1.224 2.417c1.381 1.056 3.42 1.698 5.288 1.698 2.463 0 4.534-1.086 4.534-3.366 0-3.87-5.742-2.937-5.742-4.513 0-.398.36-.581.91-.581.925 0 2.525.566 3.655 1.193L198 10.24C196.808 9.49 195.082 9 193.403 9z",
        fill: "#00BAFF"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.022 17.987l11.51-5.569c1.363-.66 3.572-.66 4.934 0l11.511 5.57c1.362.659 1.362 1.727 0 2.386l-11.51 5.57c-1.363.659-3.572.659-4.934 0l-11.511-5.57c-1.363-.659-1.363-1.727 0-2.387z",
        fill: "url(#Logo_svg__a)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.022 12.026l11.51-5.57c1.363-.659 3.572-.659 4.934 0l11.511 5.57c1.362.659 1.362 1.727 0 2.387l-11.51 5.569c-1.363.659-3.572.659-4.934 0l-11.511-5.57c-1.363-.659-1.363-1.727 0-2.386z",
        fill: "url(#Logo_svg__b)",
        opacity: 0.95
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.022 6.064l11.51-5.57c1.363-.659 3.572-.659 4.934 0l11.511 5.57c1.362.659 1.362 1.728 0 2.387l-11.51 5.57c-1.363.658-3.572.658-4.934 0L1.022 8.45c-1.363-.66-1.363-1.728 0-2.387z",
        fill: "url(#Logo_svg__c)",
        opacity: 0.3
      })]
    })]
  }));
};

/* harmony default export */ var Logo = (SvgLogo);
// EXTERNAL MODULE: ./components/Layout/Navbar/NoUserLogin.module.scss
var NoUserLogin_module = __webpack_require__(20304);
var NoUserLogin_module_default = /*#__PURE__*/__webpack_require__.n(NoUserLogin_module);
// EXTERNAL MODULE: ./containers/Common/Login/index.js + 3 modules
var Login = __webpack_require__(85155);
// EXTERNAL MODULE: ./containers/Login/LoginPage.module.scss
var LoginPage_module = __webpack_require__(70563);
var LoginPage_module_default = /*#__PURE__*/__webpack_require__.n(LoginPage_module);
// EXTERNAL MODULE: ./node_modules/react-ga/dist/esm/index.js + 11 modules
var esm = __webpack_require__(98719);
;// CONCATENATED MODULE: ./containers/Login/LoginContainer.js















var LoginContainer = function LoginContainer(props) {
  var dispatch = (0,es/* useDispatch */.I0)();
  var previousLocation = (0,es/* useSelector */.v9)(function (state) {
    return state.window.previousLocation;
  });
  var auth = (0,es/* useSelector */.v9)(function (state) {
    return state.auth;
  });

  function getPrefillEmail() {
    // prefill email via query param
    if ((0,envDetection/* isClient */.C5)() && (router_default()).query && (router_default()).query.email) {
      return (router_default()).query.email;
    }

    return null;
  }

  (0,react.useEffect)(function () {
    if (auth.authenticated && !auth.signInCallback) {
      (0,languageHelpers/* pushBrowserHistoryLocalised */.Ns)('/mockups');
    }
  }, [auth]);

  var handleSuccessLogin = function handleSuccessLogin(user) {
    // make sure we're not redirecting to password reset or signup page after login
    var redirectLocation = (0,languageHelpers/* removePathnameFromLocale */.K2)(previousLocation);

    if (redirectLocation === '/' || redirectLocation.indexOf('password') > -1 || redirectLocation.indexOf('signup') > -1) {
      redirectLocation = '/mockups';
    }

    if (user.isTrialEndModal) {
      (0,trackingParty/* trackEvent */.L9)('Trial end modal show');
      dispatch((0,windowActions.setPremiumModal)('trial-ended', 'Trial end modal'));
    }

    if (user.isSingleAppUser) {
      (0,trackingParty/* trackEvent */.L9)('App user login');
      dispatch((0,windowActions.setPremiumModal)('app-user'));
    }

    esm/* default.event */.ZP.event({
      category: 'User',
      action: 'Login'
    });
    router_default().push(redirectLocation, redirectLocation, {
      locale: languageHelpers/* DEFAULT_LOCALE */.ZW
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: !props.isCompact ? (LoginPage_module_default()).loginCenter : null,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Login/* default */.Z, {
      onLoginSuccess: handleSuccessLogin,
      isHeadline: !props.isCompact,
      prefillEmail: getPrefillEmail()
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (LoginPage_module_default()).bottomWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
        className: (LoginPage_module_default()).loginPasswordResetBtn,
        to: "/password-reset",
        tabIndex: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          defaultMessage: [{
            "type": 0,
            "value": "Forgot password?"
          }],
          id: "global.forms.forgotLabel"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (LoginPage_module_default()).sep,
        children: "\xB7"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
        to: "/signup",
        className: (LoginPage_module_default()).signupLink,
        tabIndex: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          defaultMessage: [{
            "type": 0,
            "value": "Sign up for free"
          }],
          id: "global.nav.label.signupLong"
        })
      })]
    })]
  });
};

/* harmony default export */ var Login_LoginContainer = (LoginContainer);
;// CONCATENATED MODULE: ./components/Layout/Navbar/NoUserLogin.js


function NoUserLogin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NoUserLogin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NoUserLogin_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NoUserLogin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var NoUserLogin = function NoUserLogin() {
  var initialState = {
    modalOpen: false,
    modalFirstQuestion: false,
    modalSecondQuestion: false,
    loading: false
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return NoUserLogin_objectSpread(NoUserLogin_objectSpread({}, state), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1];

  var handleModalOpen = function handleModalOpen() {
    setState({
      modalOpen: true
    });
  };

  var handleModalClose = function handleModalClose() {
    setState({
      modalOpen: false
    });
  };

  var renderLoginModal = function renderLoginModal() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.ZP, {
      isOpen: state.modalOpen,
      modalLabel: "Set a password",
      onClose: handleModalClose,
      size: "small",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* ModalScroll */.TV, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          level: 3,
          size: "sm",
          className: "text-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "Ub+AGc",
            defaultMessage: [{
              "type": 0,
              "value": "Sign In"
            }]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
          level: 2,
          className: "text-center m-b-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "lWxsGV",
            defaultMessage: [{
              "type": 0,
              "value": "Welcome back!"
            }, {
              "type": 1,
              "value": "newline"
            }, {
              "type": 0,
              "value": "Sign into your account"
            }],
            values: {
              newline: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Login_LoginContainer, {
          isCompact: true
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [renderLoginModal(), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: (NoUserLogin_module_default()).wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (NoUserLogin_module_default()).listButton,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          size: "small",
          className: (NoUserLogin_module_default()).btn,
          onClick: function onClick() {
            return handleModalOpen();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "Sign In"
            }],
            id: "global.nav.label.signin"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (NoUserLogin_module_default()).listButton,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
          to: "/signup",
          tabIndex: -1,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
            size: "small",
            design: "orange",
            className: (NoUserLogin_module_default()).btn,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (NoUserLogin_module_default()).longLabel,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "Get started for free"
                }],
                id: "global.nav.label.signupLong"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (NoUserLogin_module_default()).shortLabel,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "Get started"
                }],
                id: "global.nav.label.signupShort"
              })
            })]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Navbar_NoUserLogin = (NoUserLogin);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./components/Base/Dropdown/Dropdown.module.scss
var Dropdown_module = __webpack_require__(92548);
var Dropdown_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_module);
;// CONCATENATED MODULE: ./components/Base/Dropdown/DropdownTrigger.js







var DropdownTrigger_excluded = ["children", "className"];

function DropdownTrigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DropdownTrigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DropdownTrigger_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DropdownTrigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function DropdownTrigger_createSuper(Derived) { var hasNativeReflectConstruct = DropdownTrigger_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function DropdownTrigger_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var DropdownTrigger = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(DropdownTrigger, _Component);

  var _super = DropdownTrigger_createSuper(DropdownTrigger);

  function DropdownTrigger() {
    (0,classCallCheck/* default */.Z)(this, DropdownTrigger);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(DropdownTrigger, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          dropdownTriggerProps = (0,objectWithoutProperties/* default */.Z)(_this$props, DropdownTrigger_excluded);

      dropdownTriggerProps.className = "".concat((Dropdown_module_default()).dropdownToggle, " ").concat(className);
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", DropdownTrigger_objectSpread(DropdownTrigger_objectSpread({
        "data-trigger": ""
      }, dropdownTriggerProps), {}, {
        children: children
      }));
    }
  }]);

  return DropdownTrigger;
}(react.Component);

DropdownTrigger.displayName = 'DropdownTrigger';
DropdownTrigger.defaultProps = {
  className: ''
};
/* harmony default export */ var Dropdown_DropdownTrigger = (DropdownTrigger);
;// CONCATENATED MODULE: ./components/Base/Dropdown/DropdownContent.js







var DropdownContent_excluded = ["children", "className", "position", "isArrow"];

function DropdownContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DropdownContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DropdownContent_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DropdownContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function DropdownContent_createSuper(Derived) { var hasNativeReflectConstruct = DropdownContent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function DropdownContent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var DropdownContent = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(DropdownContent, _Component);

  var _super = DropdownContent_createSuper(DropdownContent);

  function DropdownContent() {
    (0,classCallCheck/* default */.Z)(this, DropdownContent);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(DropdownContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          position = _this$props.position,
          isArrow = _this$props.isArrow,
          dropdownContentProps = (0,objectWithoutProperties/* default */.Z)(_this$props, DropdownContent_excluded);

      var positionClassName = '';

      if (position === 'left') {
        positionClassName = (Dropdown_module_default()).dropdownContentLeft;
      }

      if (position === 'right') {
        positionClassName = (Dropdown_module_default()).dropdownContentRight;
      }

      dropdownContentProps.className = "".concat((Dropdown_module_default()).dropdownContent, " ").concat(positionClassName, " ").concat(isArrow ? (Dropdown_module_default()).dropdownContentWithArrow : '', " ").concat(className);
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", DropdownContent_objectSpread(DropdownContent_objectSpread({}, dropdownContentProps), {}, {
        children: children
      }));
    }
  }]);

  return DropdownContent;
}(react.Component);

DropdownContent.displayName = 'DropdownContent';
DropdownContent.defaultProps = {
  className: ''
};
/* harmony default export */ var Dropdown_DropdownContent = (DropdownContent);
;// CONCATENATED MODULE: ./components/Base/Dropdown/Dropdown.js








var Dropdown_excluded = ["active", "onShow", "onHide", "removeElement", "onDisabledClick"];

function Dropdown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Dropdown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Dropdown_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Dropdown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Dropdown_createSuper(Derived) { var hasNativeReflectConstruct = Dropdown_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Dropdown_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var Dropdown = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Dropdown, _Component);

  var _super = Dropdown_createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Dropdown);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "ref", null);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onWindowClick", function (event) {
      var dropdownElement = _this.ref;

      if (event.target !== dropdownElement && !dropdownElement.contains(event.target) && _this.isActive()) {
        _this.hide();
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onToggleClick", function (event) {
      event.preventDefault();

      if (_this.isActive()) {
        _this.hide();
      } else {
        _this.show();
      }
    });

    _this.state = {
      active: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('mousedown', this.onWindowClick);
      window.addEventListener('touchstart', this.onWindowClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.onWindowClick);
      window.removeEventListener('touchstart', this.onWindowClick);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return typeof this.props.active === 'boolean' ? this.props.active : this.state.active;
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this2 = this;

      this.setState({
        active: false
      }, function () {
        if (_this2.props.onHide) {
          _this2.props.onHide();
        }
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;

      this.setState({
        active: true
      }, function () {
        if (_this3.props.onShow) {
          _this3.props.onShow();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disabled = _this$props.disabled;

      var _this$props2 = this.props,
          isActive = _this$props2.active,
          onShow = _this$props2.onShow,
          onHide = _this$props2.onHide,
          removeElement = _this$props2.removeElement,
          onDisabledClick = _this$props2.onDisabledClick,
          cleanProps = (0,objectWithoutProperties/* default */.Z)(_this$props2, Dropdown_excluded); // create component classes


      var active = this.isActive(); // stick callback on trigger element

      var boundChildren = react.Children.map(children, function (child) {
        if (child.type === Dropdown_DropdownTrigger) {
          var originalOnClick = child.props.onClick;
          child = /*#__PURE__*/(0,react.cloneElement)(child, {
            ref: 'trigger',
            onClick: function onClick(event) {
              if (!disabled) {
                _this4.onToggleClick(event);

                if (originalOnClick) {
                  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                  }

                  originalOnClick.apply.apply(originalOnClick, [child, event].concat(args));
                }
              } else {
                var _this4$props$onDisabl, _this4$props;

                (_this4$props$onDisabl = (_this4$props = _this4.props).onDisabledClick) === null || _this4$props$onDisabl === void 0 ? void 0 : _this4$props$onDisabl.call(_this4$props);
              }
            }
          });
        } else if (child.type === Dropdown_DropdownContent && removeElement && !active) {
          child = null;
        }

        return child;
      });
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Dropdown_objectSpread(Dropdown_objectSpread({
        ref: function ref(c) {
          return _this4.ref = c;
        }
      }, cleanProps), {}, {
        className: "".concat((Dropdown_module_default()).dropdown, " ").concat(active ? (Dropdown_module_default()).active : '', " ").concat(disabled ? (Dropdown_module_default()).disabled : '', " ").concat(className),
        children: boundChildren
      }));
    }
  }]);

  return Dropdown;
}(react.Component);

Dropdown.defaultProps = {
  className: ''
};

/* harmony default export */ var Dropdown_Dropdown = (Dropdown);
// EXTERNAL MODULE: ./components/User/UserMenu/UserAvatar.module.scss
var UserAvatar_module = __webpack_require__(87721);
var UserAvatar_module_default = /*#__PURE__*/__webpack_require__.n(UserAvatar_module);
;// CONCATENATED MODULE: ./components/User/UserMenu/UserAvatar.js






function UserAvatar_createSuper(Derived) { var hasNativeReflectConstruct = UserAvatar_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function UserAvatar_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var UserAvatar = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(UserAvatar, _Component);

  var _super = UserAvatar_createSuper(UserAvatar);

  function UserAvatar() {
    (0,classCallCheck/* default */.Z)(this, UserAvatar);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(UserAvatar, [{
    key: "render",
    value: function render() {
      var user = this.props.user;
      var firstLeter = user.email.charAt(0);

      if (user.given_name) {
        firstLeter = user.given_name.charAt(0);
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (UserAvatar_module_default()).wrapper,
        children: user.picture ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: user.picture,
          className: (UserAvatar_module_default()).image
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (UserAvatar_module_default()).icon,
          children: firstLeter
        })
      });
    }
  }]);

  return UserAvatar;
}(react.Component);


// EXTERNAL MODULE: ./components/User/UserTrialSlider/UserTrialSlider.module.scss
var UserTrialSlider_module = __webpack_require__(11903);
var UserTrialSlider_module_default = /*#__PURE__*/__webpack_require__.n(UserTrialSlider_module);
;// CONCATENATED MODULE: ./components/User/UserTrialSlider/UserTrialSlider.js






function UserTrialSlider_createSuper(Derived) { var hasNativeReflectConstruct = UserTrialSlider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function UserTrialSlider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var UserTrialSlider = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(UserTrialSlider, _Component);

  var _super = UserTrialSlider_createSuper(UserTrialSlider);

  function UserTrialSlider() {
    (0,classCallCheck/* default */.Z)(this, UserTrialSlider);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(UserTrialSlider, [{
    key: "render",
    value: function render() {
      var width = 0;

      if (this.props.expirationDate) {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

        var now = new Date();
        var ending = new Date(this.props.expirationDate);
        var diffDays = Math.round(Math.abs((now.getTime() - ending.getTime()) / oneDay));
        width = Math.min(Math.round(diffDays / 7 * 100), 100); //7 days trial, max 100%
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (UserTrialSlider_module_default()).userTrialSliderTrack,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (UserTrialSlider_module_default()).userTrialSlider,
          style: {
            width: "".concat(width, "%")
          }
        })
      });
    }
  }]);

  return UserTrialSlider;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/relative-time-format/modules/RelativeTimeFormat.js + 5 modules
var RelativeTimeFormat = __webpack_require__(5585);
;// CONCATENATED MODULE: ./components/User/UserTrialDateCountdown/UserTrialDaysCounter.js




var UserTrialDaysCounter = function UserTrialDaysCounter(props) {
  var lang = (0,es/* useSelector */.v9)(function (state) {
    return state.window.locale;
  });
  if (!lang) return null;
  if (!props.expirationDate) return null;
  var ending = Math.ceil((Date.parse(props.expirationDate) - Date.now()) / 1000 / 3600 / 24); // polyfill for non Intl supported browsers
  // should be removed when Intl will be fully supported

  if (Intl === undefined || typeof Intl.RelativeTimeFormat !== 'function') {
    /* eslint-disable import/no-dynamic-require */

    /* eslint-disable global-require */
    if (!lang) return '';

    var locale = __webpack_require__(28453)("./".concat(lang, ".json"));

    RelativeTimeFormat/* default.addLocale */.Z.addLocale(locale);
    var value = new RelativeTimeFormat/* default */.Z(lang, {
      style: 'long' // "long" is the default. Other options: "short", "narrow".

    }).format(ending, 'day');
    return value;
  }

  try {
    var _value = new Intl.RelativeTimeFormat(lang);

    return _value.format(ending, 'day');
  } catch (err) {
    console.log(err);
    return null;
  }
};

/* harmony default export */ var UserTrialDateCountdown_UserTrialDaysCounter = (UserTrialDaysCounter);
UserTrialDaysCounter.propTypes = {
  expirationDate: (prop_types_default()).string
};
// EXTERNAL MODULE: ./components/User/UserMenu/UserTrialExpiration.module.scss
var UserTrialExpiration_module = __webpack_require__(9151);
var UserTrialExpiration_module_default = /*#__PURE__*/__webpack_require__.n(UserTrialExpiration_module);
;// CONCATENATED MODULE: ./components/User/UserMenu/UserTrialExpiration.js






function UserTrialExpiration_createSuper(Derived) { var hasNativeReflectConstruct = UserTrialExpiration_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function UserTrialExpiration_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var UserTrialExpiration = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(UserTrialExpiration, _Component);

  var _super = UserTrialExpiration_createSuper(UserTrialExpiration);

  function UserTrialExpiration() {
    (0,classCallCheck/* default */.Z)(this, UserTrialExpiration);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(UserTrialExpiration, [{
    key: "render",
    value: function render() {
      if (!this.props.expirationDate) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: this.props.onClick,
        className: (UserTrialExpiration_module_default()).upgradeButton,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (UserTrialExpiration_module_default()).wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "p7ZsLa",
              defaultMessage: [{
                "type": 0,
                "value": "Your trial expires"
              }]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(UserTrialSlider, {
            expirationDate: this.props.expirationDate
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(UserTrialDateCountdown_UserTrialDaysCounter, {
              expirationDate: this.props.expirationDate
            })
          })]
        })
      });
    }
  }]);

  return UserTrialExpiration;
}(react.Component);


// EXTERNAL MODULE: ./components/User/NotificationCenter/NotificationIcon.svg
var NotificationIcon = __webpack_require__(80020);
var NotificationIcon_default = /*#__PURE__*/__webpack_require__.n(NotificationIcon);
// EXTERNAL MODULE: ./components/User/NotificationCenter/NotificationIconUnread.svg
var NotificationIconUnread = __webpack_require__(48070);
var NotificationIconUnread_default = /*#__PURE__*/__webpack_require__.n(NotificationIconUnread);
// EXTERNAL MODULE: ./components/User/NotificationCenter/NotificationCenter.module.scss
var NotificationCenter_module = __webpack_require__(13895);
var NotificationCenter_module_default = /*#__PURE__*/__webpack_require__.n(NotificationCenter_module);
// EXTERNAL MODULE: ./utils/braze.js
var braze = __webpack_require__(26599);
;// CONCATENATED MODULE: ./components/User/NotificationCenter/NotificationCenter.js


function NotificationCenter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NotificationCenter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationCenter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationCenter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var NotificationCenter = function NotificationCenter() {
  var initialState = {
    isActive: false,
    isUnread: false,
    unreadCount: null
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return NotificationCenter_objectSpread(NotificationCenter_objectSpread({}, state), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1];

  var unread = (0,braze/* brazeCachedCards */.Aj)();
  var notificationsElement = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    (0,braze/* brazeRefreshCards */.cI)();
  }, []);
  (0,react.useEffect)(function () {
    if (unread > 0) {
      setState({
        isActive: true,
        isUnread: true,
        unreadCount: unread
      });
      (0,braze/* brazeToggleCards */.PF)(notificationsElement.current);
    }
  }, [unread]);

  var handleDropdownShow = function handleDropdownShow() {
    setState({
      isActive: true
    });
    (0,braze/* brazeToggleCards */.PF)(notificationsElement.current);
  };

  var handleDropdownHide = function handleDropdownHide() {
    setState({
      isActive: false,
      isUnread: false
    });
    (0,braze/* brazeToggleCards */.PF)(notificationsElement.current);
  };

  var renderUnreadAlert = function renderUnreadAlert() {
    if (unread === 0 && state.isUnread === false) return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: (NotificationIcon_default()),
      alt: ""
    });
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: (NotificationIconUnread_default()),
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (NotificationCenter_module_default()).badge,
        children: state.unreadCount
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (NotificationCenter_module_default()).notificationCenter,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Dropdown_Dropdown, {
      onShow: handleDropdownShow,
      onHide: handleDropdownHide,
      active: state.isActive,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown_DropdownTrigger, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          size: "small",
          design: "text",
          className: (NotificationCenter_module_default()).notificationCenterBtn,
          children: [renderUnreadAlert(), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (NotificationCenter_module_default()).label,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "NAidKb",
              defaultMessage: [{
                "type": 0,
                "value": "Notifications"
              }]
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown_DropdownContent, {
        className: (NotificationCenter_module_default()).notificationCenterDropdownContent,
        position: "right",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (NotificationCenter_module_default()).notificationCenterInner,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (NotificationCenter_module_default()).notificationCenterHeader,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                id: "/pboiq",
                defaultMessage: [{
                  "type": 0,
                  "value": "Latest updates"
                }]
              })
            }), ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (NotificationCenter_module_default()).notificationCenterScroll,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: notificationsElement
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var NotificationCenter_NotificationCenter = (NotificationCenter);
// EXTERNAL MODULE: ./components/User/UserMenu/UserMenu.module.scss
var UserMenu_module = __webpack_require__(15514);
var UserMenu_module_default = /*#__PURE__*/__webpack_require__.n(UserMenu_module);
// EXTERNAL MODULE: ./components/User/UserMenu/Buttons/UpgradeBtn.module.scss
var UpgradeBtn_module = __webpack_require__(77664);
var UpgradeBtn_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeBtn_module);
// EXTERNAL MODULE: ./components/User/UserMenu/Buttons/UpgradeProminentIcon.svg
var UpgradeProminentIcon = __webpack_require__(44160);
var UpgradeProminentIcon_default = /*#__PURE__*/__webpack_require__.n(UpgradeProminentIcon);
;// CONCATENATED MODULE: ./components/User/UserMenu/Buttons/UpgradeBtn.js








var UpgradeBtn = function UpgradeBtn(props) {
  var intl = (0,useIntl/* default */.Z)();
  var messages = (0,react_intl_lib/* defineMessages */.vU)({
    text: {
      id: "5N04mo",
      defaultMessage: [{
        "type": 0,
        "value": "Upgrade to Pro"
      }]
    }
  });
  var defaultText = intl.formatMessage(messages.text);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
    onClick: props.onClick,
    design: "text",
    size: "small",
    className: (UpgradeBtn_module_default()).upgradeBtn,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: props.imgClassName,
      src: (UpgradeProminentIcon_default()),
      alt: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (UpgradeBtn_module_default()).upgradeLink,
      children: defaultText
    })]
  });
};

/* harmony default export */ var Buttons_UpgradeBtn = (UpgradeBtn);
// EXTERNAL MODULE: ./components/Marketing/Helpscout/HelpscoutButton.module.scss
var HelpscoutButton_module = __webpack_require__(15908);
var HelpscoutButton_module_default = /*#__PURE__*/__webpack_require__.n(HelpscoutButton_module);
;// CONCATENATED MODULE: ./components/Marketing/Helpscout/HelpscoutInit.js



var HelpscoutInit = function HelpscoutInit(active) {
  /* eslint-disable react/no-unescaped-entities */
  if (active) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("script", {
      type: "text/javascript",
      children: ["\n                            try{\n                            !function(e,t,n){function a(){var e=t.getElementsByTagName(\"script\")[0],n=t.createElement(\"script\");n.type=\"text/javascript\",n.async=!0,n.src=\"https://beacon-v2.helpscout.net\",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],\"complete\"===t.readyState)return a();e.attachEvent?e.attachEvent(\"onload\",a):e.addEventListener(\"load\",a,!1)}(window,document,window.Beacon||function(){});\n                            }catch(err){\n                            console.log(err)\n                            }\n                        ", "window.Beacon('init', '0855ac2d-3a9d-4df8-9dd6-6b1efb445837');"]
    });
  }
};

/* harmony default export */ var Helpscout_HelpscoutInit = (HelpscoutInit);
;// CONCATENATED MODULE: ./components/Marketing/Helpscout/HelpscoutButton.js












var HelpscoutButton = function HelpscoutButton(props) {
  var children = props.children,
      isDefault = props.isDefault,
      className = props.className,
      onClick = props.onClick,
      navigate = props.navigate;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.auth;
  }),
      authenticated = _useSelector.authenticated;

  var _useActions = (0,useActions/* default */.Z)(windowActions),
      setActiveHelpscout = _useActions.setActiveHelpscout;

  var _useSelector2 = (0,es/* useSelector */.v9)(function (state) {
    return state.helpscout;
  }),
      isActive = _useSelector2.isActive;

  var checkIsActive = isActive || authenticated || (0,envDetection/* isClient */.C5)() && window.Beacon;

  var _useState = (0,react.useState)(false),
      isLocActive = _useState[0],
      setLocIsActive = _useState[1];

  (0,react.useEffect)(function () {
    if (isLocActive) {
      openBeacon();
    }
  }, [isLocActive]);

  var openBeacon = function openBeacon() {
    window.Beacon('open');

    if (navigate) {
      window.Beacon('navigate', navigate);
    }
  };

  var handleClick = function handleClick() {
    if (window.Beacon) {
      openBeacon();
    } else {
      setLocIsActive(true);
      setActiveHelpscout(true);
    }
  };

  var getClassName = function getClassName() {
    if (className) {
      return className;
    }

    if (isDefault) {
      return "font-medium ".concat((HelpscoutButton_module_default()).button, " ").concat(checkIsActive ? (HelpscoutButton_module_default()).active : null);
    }

    return null;
  };

  var handleOnClick = function handleOnClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: getClassName(),
      onClick: function onClick() {
        handleClick();
        handleOnClick();
      },
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: Helpscout_HelpscoutInit(checkIsActive)
    })]
  });
};

/* harmony default export */ var Helpscout_HelpscoutButton = (HelpscoutButton);
;// CONCATENATED MODULE: ./components/User/UserMenu/UserMenu.js
















var UserMenu = function UserMenu(props) {
  var dropdown = (0,react.useRef)();
  var user = (0,useUser/* default */.Z)();

  var handleLinkClick = function handleLinkClick() {
    dropdown.current.hide();
  };

  var handleLogoutClick = function handleLogoutClick(e) {
    dropdown.current.hide();
    props.onLogoutClick(e);
  };

  var handleUpgradeClick = function handleUpgradeClick() {
    props.onUpgradeClick();
  };

  var handleUpgradeTrialClick = function handleUpgradeTrialClick() {
    dropdown.current.hide();
    props.onUpgradeTrialClick();
  };

  function renderUpgradebutton() {
    if (user.isPro && !user.isTrial || user.isProGifted) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_UpgradeBtn, {
      onClick: handleUpgradeClick
    });
  }

  function renderTrialCountDown() {
    if (!props.user.isTrial) return null;
    if (user.isProGifted) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(UserTrialExpiration, {
      expirationDate: props.user.trialExpire,
      onClick: handleUpgradeTrialClick
    });
  }

  if (!props.user) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (UserMenu_module_default()).wrapper,
    children: [renderUpgradebutton(), /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationCenter_NotificationCenter, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dropdown_Dropdown, {
      ref: dropdown,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown_DropdownTrigger, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(UserAvatar, {
          user: props.user
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dropdown_DropdownContent, {
        className: (UserMenu_module_default()).dropdown,
        position: "right",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (UserMenu_module_default()).userName,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
              children: [props.user.given_name, "\xA0", props.user.family_name]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: props.user.email
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
          to: "/user-settings/personal",
          className: "font-regular ".concat((UserMenu_module_default()).dropdownItem),
          onClick: handleLinkClick,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "NQgbYA",
            defaultMessage: [{
              "type": 0,
              "value": "Account Settings"
            }]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
          to: "/user-collections",
          className: "font-regular ".concat((UserMenu_module_default()).dropdownItem),
          onClick: handleLinkClick,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "Your Collections"
            }],
            id: "global.nav.label.userCollections"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
          to: "/history",
          className: "font-regular ".concat((UserMenu_module_default()).dropdownItem),
          onClick: handleLinkClick,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "Saved Mockups"
            }],
            id: "global.history.title"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Helpscout_HelpscoutButton, {
          onClick: handleLinkClick,
          className: "font-regular ".concat((UserMenu_module_default()).dropdownItem),
          navigate: "/ask",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "Get Help"
            }],
            id: "global.nav.label.getHelp"
          })
        }), renderTrialCountDown(), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          onClick: handleLogoutClick,
          design: "default",
          size: "small",
          className: (UserMenu_module_default()).logoutBtn,
          isFull: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "xXbJso",
            defaultMessage: [{
              "type": 0,
              "value": "Sign out"
            }]
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var UserMenu_UserMenu = (UserMenu);
// EXTERNAL MODULE: ./components/Layout/Navbar/Nav.module.scss
var Nav_module = __webpack_require__(11670);
var Nav_module_default = /*#__PURE__*/__webpack_require__.n(Nav_module);
// EXTERNAL MODULE: ./components/Layout/Navbar/NavSectionItem.module.scss
var NavSectionItem_module = __webpack_require__(69740);
var NavSectionItem_module_default = /*#__PURE__*/__webpack_require__.n(NavSectionItem_module);
;// CONCATENATED MODULE: ./components/Base/LinkWithQuery/LinkWithQuery.js






var LinkWithQuery = function LinkWithQuery(props) {
  var currentQuery = (router_default()).router ? (router_default()).router.query : null;
  var newQuery = new URLSearchParams();

  if (currentQuery) {
    for (var _i = 0, _Object$entries = Object.entries(currentQuery); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (props.preserveQuery === 'all' || props.preserveQuery.indexOf(key) > -1) {
        newQuery.append(key, value);
      }
    }
  }

  if (props.query) {
    Object.keys(props.query).forEach(function (key) {
      if (props.query[key] && props.query[key].length > 0) {
        newQuery.append(key, props.query[key]);
      } else {
        newQuery["delete"](key);
      }
    });
  }

  var to = props.to;

  if (newQuery.toString().length > 0) {
    to += "?".concat(newQuery.toString());
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
    className: props.className,
    style: props.style,
    to: to,
    children: props.children
  });
};

/* harmony default export */ var LinkWithQuery_LinkWithQuery = (LinkWithQuery);
;// CONCATENATED MODULE: ./components/Layout/Navbar/NavSectionItem.js









var NavSectionItem = function NavSectionItem(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      slug = _ref.slug,
      parentSlug = _ref.parentSlug,
      isNew = _ref.isNew,
      onClick = _ref.onClick,
      children = _ref.children;

  var _useState = (0,react.useState)(false),
      hover = _useState[0],
      setHover = _useState[1];

  var handleMouseOver = function handleMouseOver() {
    setHover(true);
  };

  var handleMouseOut = function handleMouseOut() {
    setHover(false);
  };

  function renderSubcategoryIcon() {
    // if no icon is given, use fallback icon from the collection slug
    var defaultSlug = parentSlug ? "".concat(parentSlug, "-").concat(slug) : "".concat(slug, "-all");
    var iconSlug = icon || "icon-".concat(defaultSlug, ".svg");
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: "".concat(variables/* WEB_IMGIX */.iL, "/").concat(iconSlug),
      width: 36,
      height: 36,
      loading: "lazy",
      className: "".concat((NavSectionItem_module_default()).subcategoryIcon),
      alt: ""
    });
  }

  function renderTags() {
    // TODO remove when solved the overflow of long collection titles
    return null;
    /* eslint-disable no-unreachable */

    if (!children) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        onMouseEnter: handleMouseOver,
        onMouseLeave: handleMouseOut,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery_LinkWithQuery, {
          to: "/mockups/".concat(slug),
          preserveQuery: ['color'],
          onClick: onClick,
          className: (NavSectionItem_module_default()).subtitleNoHover,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "global.mockups.browse",
            defaultMessage: [{
              "type": 0,
              "value": "browse all"
            }]
          })
        })
      });
    }

    var items = children.map(function (item, index) {
      var menuItems = [];

      if (index < 2) {
        menuItems.push( /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery_LinkWithQuery, {
          to: "/mockups/".concat(item.slug),
          preserveQuery: ['color'],
          className: (NavSectionItem_module_default()).subtitle,
          onClick: onClick,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalisedTitle_LocalisedTitle, {
            title: item.menuTitle
          })
        }, "dropdown-link-".concat(slug, "-").concat(item.slug)));

        if (index < 1 && children.length > 1) {
          menuItems.push( /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: ", "
          }, "dropdown-link-".concat(item.slug, "-separator")));
        }
      }

      if (menuItems.length > 0) return menuItems;
      return null;
    });

    if (children.length > 2) {
      items.push( /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: ", ..."
      }, "dropdown-link-".concat(slug, "-more-tags")));
    }

    return items.flat();
    /* eslint-enable no-unreachable */
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    className: (NavSectionItem_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      onMouseEnter: handleMouseOver,
      onMouseLeave: handleMouseOut,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery_LinkWithQuery, {
        to: "/mockups/".concat(slug),
        onClick: onClick,
        preserveQuery: ['color'],
        onMouseEnter: function onMouseEnter() {
          return handleMouseOver;
        },
        onMouseLeave: handleMouseOut,
        children: renderSubcategoryIcon()
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (NavSectionItem_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (NavSectionItem_module_default()).titleWrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery_LinkWithQuery, {
          to: "/mockups/".concat(slug),
          preserveQuery: ['color'],
          activeClassName: "active",
          className: hover ? (NavSectionItem_module_default()).subcategoryTitleHover : (NavSectionItem_module_default()).subcategoryTitle,
          onClick: onClick,
          children: title
        }), isNew && /*#__PURE__*/(0,jsx_runtime.jsxs)("sup", {
          className: (NavSectionItem_module_default()).newBadge,
          children: [' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "NEW"
            }],
            id: "global.nav.badge.new"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (NavSectionItem_module_default()).subtitleWrapper,
        children: renderTags()
      })]
    })]
  }, slug);
};

/* harmony default export */ var Navbar_NavSectionItem = (NavSectionItem);
;// CONCATENATED MODULE: ./components/Layout/Navbar/NavSection.js


function NavSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NavSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NavSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var NavSection = function NavSection(props) {
  var dropdown = null;
  var menuItem = null;
  var category = props.category;

  var _useWindowDimensions = useWindowDimensions(),
      screenMD = _useWindowDimensions.screenMD;

  var initialState = {
    dropdownLeft: 0,
    dropdownTop: 0
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return NavSection_objectSpread(NavSection_objectSpread({}, state), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1];

  var getDropdownPosition = function getDropdownPosition() {
    var parentPosition = menuItem.getBoundingClientRect();
    var dropdownLeft = Math.max(Math.round(parentPosition.left), 0);

    if (dropdownLeft + 200 > window.innerWidth) {
      dropdownLeft = window.innerWidth - 200;
    }

    var dropdownTop = Math.round(parentPosition.top + parentPosition.height); // this hack fixes a iOS safari bug, where getBoundingClientRect returns negative values

    if ((0,featureDetector/* isIos */.s)()) {
      dropdownTop = Math.max(dropdownTop, 54 + 49);
    }

    setState({
      dropdownLeft: dropdownLeft,
      dropdownTop: dropdownTop
    });
  };

  var handleMouseOver = function handleMouseOver() {
    if (!screenMD) {
      getDropdownPosition();
      dropdown.show();
    }
  };

  var handleMouseOut = function handleMouseOut() {
    if (dropdown.isActive && !screenMD) {
      dropdown.hide();
    }
  };

  var handleTriggerClick = function handleTriggerClick() {
    getDropdownPosition();
  };

  var handleItemClick = function handleItemClick(slug) {
    dropdown.hide();
    (0,trackingParty/* trackEvent */.L9)('Subcategory open', {
      source: 'navbar',
      subcategory: slug
    });
  };

  var renderItems = function renderItems() {
    return category.children.map(function (subcategory) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NavSectionItem, {
        title: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalisedTitle_LocalisedTitle, {
          title: subcategory.menuTitle
        }),
        icon: subcategory.icon,
        isNew: subcategory.isNew,
        parentSlug: subcategory.parent,
        slug: subcategory.slug,
        onClick: function onClick() {
          handleItemClick(subcategory.slug);
        },
        children: subcategory.children
      }, "nav-section-item-".concat(category.slug, "-").concat(subcategory.slug));
    });
  }; // single item category


  if (category.children.length === 1) {
    var subcategory = category.children[0];
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (Nav_module_default()).navItem,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery_LinkWithQuery, {
        to: "/mockups/".concat(category.slug, "/").concat(subcategory.slug),
        preserveQuery: ['preview', 'previewCleared', 'color'],
        activeClassName: "active",
        className: (Nav_module_default()).navLink,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalisedTitle_LocalisedTitle, {
          title: subcategory.menuTitle
        })
      })
    }, subcategory.slug);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    ref: function ref(c) {
      menuItem = c;
    },
    className: (Nav_module_default()).navItem,
    onMouseEnter: handleMouseOver,
    onMouseLeave: handleMouseOut,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Dropdown_Dropdown, {
      ref: function ref(c) {
        return dropdown = c;
      },
      className: (Nav_module_default()).dropdown,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown_DropdownTrigger, {
        onClick: handleTriggerClick,
        className: (Nav_module_default()).navSeparator,
        tabIndex: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalisedTitle_LocalisedTitle, {
          title: category.menuTitle
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown_DropdownContent, {
        className: category.children.length > 6 ? (Nav_module_default()).dropdownContentTwoCols : (Nav_module_default()).dropdownContent,
        style: {
          left: "".concat(state.dropdownLeft, "px"),
          right: 'auto',
          top: "".concat(state.dropdownTop, "px")
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: category.children.length > 6 ? (Nav_module_default()).dropdownListTwoCols : (Nav_module_default()).dropdownList,
          children: renderItems()
        })
      })]
    })
  });
};

/* harmony default export */ var Navbar_NavSection = ((0,next_router.withRouter)(NavSection));
;// CONCATENATED MODULE: ./components/Layout/Navbar/Nav.js








var Nav = function Nav(props) {
  function renderNavSections() {
    return props.menuItems.map(function (category) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NavSection, {
        category: category
      }, "navitem".concat(category.slug));
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: (Nav_module_default()).navbar,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (Nav_module_default()).navItem,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
        to: "/mockups",
        activeClassName: (Nav_module_default()).navLinkActive,
        className: (Nav_module_default()).navLink,
        tabIndex: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "H+7cRe",
          defaultMessage: [{
            "type": 0,
            "value": "All mockups"
          }]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (Nav_module_default()).navItem,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
        to: !props.isUserWithoutAccount ? '/custom-mockups' : '/custom-mockups/introduction',
        activeClassName: (Nav_module_default()).navLinkActive,
        className: (Nav_module_default()).navLink,
        tabIndex: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          defaultMessage: [{
            "type": 0,
            "value": "Custom"
          }],
          id: "global.nav.label.customMockupsShort"
        })
      })
    }), renderNavSections()]
  });
};

/* harmony default export */ var Navbar_Nav = (Nav);
// EXTERNAL MODULE: ./components/Base/Loader/Loader.js
var Loader = __webpack_require__(43142);
;// CONCATENATED MODULE: ./components/Layout/Navbar/Navbar.js













var Navbar = function Navbar(props) {
  var _useState = (0,react.useState)(false),
      isInTwoRows = _useState[0],
      setIsInTwoRows = _useState[1];

  var left = (0,react.useRef)();
  var right = (0,react.useRef)();
  var center = (0,react.useRef)();
  (0,react.useEffect)(function () {
    setNavbarType();
    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  (0,react.useEffect)(function () {
    setNavbarType();
  }, [props.locale, props.user]);

  function setNavbarType() {
    if (!left.current || !right.current || !center.current) return;
    var remainingWidth = document.body.clientWidth - left.current.getBoundingClientRect().width - right.current.getBoundingClientRect().width;
    var checkIsInTwoRows = remainingWidth < center.current.getBoundingClientRect().width;

    if (checkIsInTwoRows) {
      setIsInTwoRows(checkIsInTwoRows);
    }
  }

  var handleWindowResize = function handleWindowResize() {
    setNavbarType();
  };

  var user = props.user,
      isUserWithoutAccount = props.isUserWithoutAccount,
      menuItems = props.menuItems,
      onLogoutClick = props.onLogoutClick,
      onUpgradeClick = props.onUpgradeClick,
      onUpgradeTrialClick = props.onUpgradeTrialClick,
      initialFederatedSignIn = props.initialFederatedSignIn;

  function renderBar() {
    if ((0,envDetection/* isServer */.sk)() || !props.isUserLoaded) {
      return null;
    } // loading block


    if (initialFederatedSignIn) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
        design: "grey",
        size: "small"
      });
    } // usermenu block


    if (user !== null) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(UserMenu_UserMenu, {
        user: user,
        onLogoutClick: onLogoutClick,
        onUpgradeClick: onUpgradeClick,
        onUpgradeTrialClick: onUpgradeTrialClick
      });
    } // guest block


    return /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NoUserLogin, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((Navbar_module_default()).navbarWrapper, " ").concat(isInTwoRows !== false ? (Navbar_module_default()).navbarWrapperSoonerWrap : null, "  "),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      "aria-labelledby": "primary-navigation",
      className: (Navbar_module_default()).navbar,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Navbar_module_default()).left,
        ref: function ref(c) {
          return left.current = c;
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
          to: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Navbar_module_default()).center,
        ref: function ref(c) {
          return center.current = c;
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_Nav, {
          menuItems: menuItems,
          isUserWithoutAccount: isUserWithoutAccount
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Navbar_module_default()).right,
        ref: function ref(c) {
          return right.current = c;
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Navbar_module_default()).usermenuWrapper,
          children: renderBar()
        })
      })]
    })
  });
};

/* harmony default export */ var Navbar_Navbar = ((0,injectIntl/* default */.ZP)(Navbar));
// EXTERNAL MODULE: ./components/Base/Alerts/LoaderAlert/LoaderAlert.module.scss
var LoaderAlert_module = __webpack_require__(52532);
var LoaderAlert_module_default = /*#__PURE__*/__webpack_require__.n(LoaderAlert_module);
;// CONCATENATED MODULE: ./components/Base/Alerts/LoaderAlert/LoaderAlert.js






function LoaderAlert_createSuper(Derived) { var hasNativeReflectConstruct = LoaderAlert_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function LoaderAlert_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var LoaderAlert = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(LoaderAlert, _Component);

  var _super = LoaderAlert_createSuper(LoaderAlert);

  function LoaderAlert() {
    (0,classCallCheck/* default */.Z)(this, LoaderAlert);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(LoaderAlert, [{
    key: "render",
    value: function render() {
      var progress = Math.min(this.props.progress, 100);
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LoaderAlert_module_default()).wrapper,
        style: {
          top: "".concat(this.props.top, "px")
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LoaderAlert_module_default()).detailsRow,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (LoaderAlert_module_default()).label,
            children: [this.props.label, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (LoaderAlert_module_default()).dots,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (LoaderAlert_module_default()).dot,
                children: "."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (LoaderAlert_module_default()).dot,
                children: "."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (LoaderAlert_module_default()).dot,
                children: "."
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (LoaderAlert_module_default()).progress,
            children: [progress, "%"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LoaderAlert_module_default()).progressBarWrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (LoaderAlert_module_default()).progressBar,
            style: {
              width: "".concat(progress, "%")
            }
          })
        })]
      });
    }
  }]);

  return LoaderAlert;
}(react.Component);


// EXTERNAL MODULE: ./containers/Common/Alerts/AlertsContainer.module.scss
var AlertsContainer_module = __webpack_require__(37984);
var AlertsContainer_module_default = /*#__PURE__*/__webpack_require__.n(AlertsContainer_module);
// EXTERNAL MODULE: ./components/Base/Alerts/LinkAlert/LinkAlert.module.scss
var LinkAlert_module = __webpack_require__(19074);
var LinkAlert_module_default = /*#__PURE__*/__webpack_require__.n(LinkAlert_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Base/Alerts/LinkAlert/LinkAlert.js






function LinkAlert_createSuper(Derived) { var hasNativeReflectConstruct = LinkAlert_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function LinkAlert_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var LinkAlert = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(LinkAlert, _Component);

  var _super = LinkAlert_createSuper(LinkAlert);

  function LinkAlert() {
    (0,classCallCheck/* default */.Z)(this, LinkAlert);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(LinkAlert, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (LinkAlert_module_default()).wrapper,
        style: {
          top: "".concat(this.props.top, "px")
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LinkAlert_module_default()).detailsRow,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (LinkAlert_module_default()).label,
            children: this.props.label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: this.props.link,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (LinkAlert_module_default()).link,
              children: this.props.linkLabel
            })
          })]
        })
      });
    }
  }]);

  return LinkAlert;
}(react.Component);


;// CONCATENATED MODULE: ./containers/Common/Alerts/AlertsContainer.js






function AlertsContainer_createSuper(Derived) { var hasNativeReflectConstruct = AlertsContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function AlertsContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var AlertsContainer = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(AlertsContainer, _Component);

  var _super = AlertsContainer_createSuper(AlertsContainer);

  function AlertsContainer() {
    (0,classCallCheck/* default */.Z)(this, AlertsContainer);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(AlertsContainer, [{
    key: "renderAlert",
    value: function renderAlert(alertId, alertData, index) {
      var top = 100 + index * 80;

      if (alertData.type === 'loader') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LoaderAlert, {
          label: alertData.label,
          progress: alertData.progress,
          top: top
        }, alertId);
      }

      if (alertData.type === 'link') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkAlert, {
          label: alertData.label,
          linkLabel: alertData.linkLabel,
          link: alertData.link,
          top: top
        }, alertId);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var alerts = this.props.alerts;
      if (Object.keys(alerts).length === 0) return null;
      var items = [];
      Object.keys(alerts).map(function (alertId, index) {
        items.push(_this.renderAlert(alertId, alerts[alertId], index));
      });
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (AlertsContainer_module_default()).container,
        children: items
      });
    }
  }]);

  return AlertsContainer;
}(react.Component);

function mapStateToProps(state) {
  return {
    alerts: state.window.alerts
  };
}

/* harmony default export */ var Alerts_AlertsContainer = ((0,es/* connect */.$j)(mapStateToProps, {})(AlertsContainer));
// EXTERNAL MODULE: ./utils/helpscoutBeaconHelpers.js
var helpscoutBeaconHelpers = __webpack_require__(65196);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./actions/authActions.js + 1 modules
var authActions = __webpack_require__(31672);
// EXTERNAL MODULE: ./components/Marketing/BfBanner/BfBanner.module.scss
var BfBanner_module = __webpack_require__(51639);
var BfBanner_module_default = /*#__PURE__*/__webpack_require__.n(BfBanner_module);
// EXTERNAL MODULE: ./components/Marketing/BfBanner/CloseIcon.svg
var CloseIcon = __webpack_require__(25754);
var CloseIcon_default = /*#__PURE__*/__webpack_require__.n(CloseIcon);
// EXTERNAL MODULE: ./components/Marketing/BfBanner/discount.svg
var discount = __webpack_require__(68839);
var discount_default = /*#__PURE__*/__webpack_require__.n(discount);
// EXTERNAL MODULE: ./containers/Common/Plans/usePlan.js
var usePlan = __webpack_require__(57734);
// EXTERNAL MODULE: ./hooks/useSeasonalDiscount.js
var useSeasonalDiscount = __webpack_require__(25628);
;// CONCATENATED MODULE: ./components/Marketing/BfBanner/BfBanner.js


function BfBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BfBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BfBanner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BfBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var BLACK_FRIDAY_BANNER = 'black-friday-banner';

var BfBanner = function BfBanner(props) {
  var isClosable = props.isClosable,
      isHidden = props.isHidden;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.server;
  }),
      seasonalDiscount = _useSelector.seasonalDiscount;

  var _useUser = (0,useUser/* default */.Z)(),
      isProMonthly = _useUser.isProMonthly;

  var _useSeasonalDiscount = (0,useSeasonalDiscount/* default */.Z)(),
      isActiveDiscount = _useSeasonalDiscount.isActiveDiscount;

  var plan = {
    planType: 'pro',
    frequency: 'yearly'
  };

  var _usePlan = (0,usePlan/* default */.Z)(plan),
      planPrices = _usePlan.planPrices;

  var yearlyPlanId = variables/* PLANS.yearly */.Xf.yearly[plan.planType];
  var yearlyAmount = seasonalDiscount;
  var symbol = planPrices[yearlyPlanId].symbol;
  var initialState = {
    visible: false,
    open: false
  };

  var _useReducer = (0,react.useReducer)(function (state, newState) {
    return BfBanner_objectSpread(BfBanner_objectSpread({}, state), newState);
  }, initialState),
      state = _useReducer[0],
      setState = _useReducer[1];

  (0,react.useEffect)(function () {
    var hidden = localStorage.getItem('bfBanner');
    if (hidden === 'true') return;
    setState({
      visible: true
    });
    setTimeout(function () {
      setState({
        open: true
      });
    }, 800);
  }, [state.visible]);

  var handleHideClick = function handleHideClick() {
    localStorage.setItem('bfBanner', 'true');
    setState({
      visible: false
    });
  };

  var renderCta = function renderCta() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
      size: "xxlarge",
      design: "white",
      className: "font-bold",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        role: "img",
        children: "\uD83D\uDECD\xA0"
      }), isProMonthly ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "hye/AK",
        defaultMessage: [{
          "type": 0,
          "value": "Grab the deal"
        }]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "9tBhzB",
        defaultMessage: [{
          "type": 0,
          "value": "Upgrade now"
        }]
      })]
    });
  };

  var renderCloseButton = function renderCloseButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: "btn btn-icon ".concat((BfBanner_module_default()).close),
      onClick: handleHideClick,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: (CloseIcon_default()),
        alt: "close",
        layout: "fill"
      })
    });
  };

  var handleClick = function handleClick() {
    (0,trackingParty/* trackEvent */.L9)(BLACK_FRIDAY_BANNER, {
      type: 'clicked'
    });
  };

  var shouldShowBanner = function shouldShowBanner() {
    return isActiveDiscount && isHidden !== true && state.visible;
  };

  if (!shouldShowBanner()) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((BfBanner_module_default()).wrapper, " ").concat(state.open ? (BfBanner_module_default()).open : null),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkLocalised/* default */.Z, {
      to: "/pricing",
      onClick: handleClick,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BfBanner_module_default()).center,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (BfBanner_module_default()).subtitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "7Jtn5h",
            defaultMessage: [{
              "type": 0,
              "value": "BLACK FRIDAY DEAL ALERT"
            }]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
          className: "font-bold",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            role: "img",
            children: "\uD83D\uDD25\xA0"
          }), isProMonthly ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "woIbI9",
            defaultMessage: [{
              "type": 0,
              "value": "Switch to annual billing and pay just "
            }, {
              "type": 1,
              "value": "discount"
            }, {
              "type": 0,
              "value": "/month"
            }],
            values: {
              discount: "".concat(symbol).concat(yearlyAmount.toFixed(2))
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "7LCeh2",
            defaultMessage: [{
              "type": 0,
              "value": "Get your first year of PRO annual for just "
            }, {
              "type": 1,
              "value": "discount"
            }, {
              "type": 0,
              "value": "/month"
            }],
            values: {
              discount: "".concat(symbol).concat(yearlyAmount.toFixed(2))
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            role: "img",
            children: "\xA0\uD83D\uDD25"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (BfBanner_module_default()).right,
        children: renderCta()
      }), isClosable ? renderCloseButton() : null, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (BfBanner_module_default()).left,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: (discount_default()),
          alt: "Discount Black Friday",
          width: "118",
          height: "118"
        })
      })]
    })
  });
};

/* harmony default export */ var BfBanner_BfBanner = (BfBanner);
;// CONCATENATED MODULE: ./components/Marketing/Trustpilot/TrustpilotScript.js




var TrustpilotScript = function TrustpilotScript() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
    src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
  });
};

/* harmony default export */ var Trustpilot_TrustpilotScript = (TrustpilotScript);
;// CONCATENATED MODULE: ./containers/Common/NavbarContainer/NavbarContainer.js
























var NavbarContainer = function NavbarContainer(props) {
  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();

  var _useMenu = hooks_useMenu(),
      menuItems = _useMenu.menuItems;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.auth;
  }),
      user = _useSelector.user,
      isUserWithoutAccount = _useSelector.isUserWithoutAccount,
      isUserLoaded = _useSelector.isUserLoaded,
      initialFederatedSignIn = _useSelector.initialFederatedSignIn;

  var _useActions = (0,useActions/* default */.Z)(windowActions),
      setTotalCountPaddle = _useActions.setTotalCountPaddle,
      setPaddleEventCallback = _useActions.setPaddleEventCallback,
      setPremiumModal = _useActions.setPremiumModal;

  (0,react.useEffect)(function () {
    // if new user is loaded (usually from local storage)
    // load notifications
    addUserToBeacon(user);
    (0,helpscoutBeaconHelpers/* showBeaconMessage */.aO)({
      messageId: '54dcf2cd-7a05-4c3b-8437-c7d408d5e7c8',
      user: user,
      targetPlan: 'Premium',
      targetFrequency: 'monthly',
      maxLength: 0.5,
      maxLenght: 1.5
    });
  }, [user, dispatch]);

  function addUserToBeacon(user) {
    if ((0,envDetection/* isServer */.sk)() || !user || !window.Beacon) return;
    var data = (0,helpscoutBeaconHelpers/* getIdentifyData */.oh)(user);

    try {
      window.Beacon('identify', data);
      window.Beacon('prefill', {
        subject: 'Message from Smartmockups.com'
      });
    } catch (err) {
      console.log(err);
    }
  }

  var handleScriptError = function handleScriptError() {
    console.log('Unable to load payment script');
  };

  var handleScriptLoad = function handleScriptLoad() {
    /* eslint-disable no-undef */
    Paddle.Setup({
      vendor: 19214,
      eventCallback: function eventCallback(eventData) {
        updatePrices(eventData);
        updateEventCallback(eventData);
      }
    });
    /* eslint-enable no-undef */
  };

  function updatePrices(data) {
    setTotalCountPaddle(data.eventData.checkout.prices.customer);
  }

  function updateEventCallback(data) {
    setPaddleEventCallback(data.event);
  }

  var handleLogoutClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              _context.next = 3;
              return dispatch((0,authActions.logout)());

            case 3:
              _context.next = 5;
              return dispatch((0,authActions.clear)());

            case 5:
              _context.next = 7;
              return router.push('/', '/', {
                locale: languageHelpers/* DEFAULT_LOCALE */.ZW
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLogoutClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleUpgradeClick = function handleUpgradeClick() {
    dispatch(setPremiumModal('upgrade', 'Navbar upgrade button'));
  };

  var handleUpgradeTrialClick = function handleUpgradeTrialClick() {
    dispatch(setPremiumModal('upgrade', 'Profile Dropdown trial button'));
  };

  function renderScripts() {
    if ((0,envDetection/* isServer */.sk)()) return;
    /* eslint-disable react/no-unescaped-entities */

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        src: "https://cdn.paddle.com/paddle/paddle.js",
        strategy: "afterInteractive",
        onError: handleScriptError,
        onLoad: handleScriptLoad
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Trustpilot_TrustpilotScript, {})]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width,minimum-scale=1,maximum-scale=1,user-scalable=no"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Alerts_AlertsContainer, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(BfBanner_BfBanner, {
      isHidden: props.isBannerHidden
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_Navbar, {
      user: user,
      initialFederatedSignIn: initialFederatedSignIn,
      isUserWithoutAccount: isUserWithoutAccount,
      isUserLoaded: isUserLoaded,
      menuItems: menuItems,
      onLogoutClick: handleLogoutClick,
      onUpgradeClick: handleUpgradeClick,
      onUpgradeTrialClick: handleUpgradeTrialClick
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Helpscout_HelpscoutButton, {
      isDefault: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "krty63",
        defaultMessage: [{
          "type": 0,
          "value": "Need help?"
        }]
      })
    }), renderScripts()]
  });
};

/* harmony default export */ var NavbarContainer_NavbarContainer = (NavbarContainer);
;// CONCATENATED MODULE: ./components/Layout/Footer/PaymentsIcons.js


function PaymentsIcons_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PaymentsIcons_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentsIcons_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentsIcons_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPaymentsIcons = function SvgPaymentsIcons(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", PaymentsIcons_objectSpread(PaymentsIcons_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 214 20"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "PaymentsIcons_svg__a",
        d: "M0 0h19.441v19.355H0z"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        fillRule: "nonzero",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M160.23 2.51c-.754-.853-2.122-1.22-3.87-1.22h-5.071a.726.726 0 0 0-.718.608l-2.11 13.28c-.044.264.16.5.428.5h3.132l.787-4.946-.026.155a.724.724 0 0 1 .715-.608h1.49c2.921 0 5.21-1.177 5.88-4.583.022-.101.037-.198.052-.295.198-1.257 0-2.115-.689-2.89",
          fill: "#A7A7A7",
          opacity: 0.7
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M160.743 5.29c-.022.097-.033.194-.053.295-.682 3.405-3.014 4.581-5.99 4.581h-1.516a.734.734 0 0 0-.729.608l-.775 4.79-.221 1.357a.384.384 0 0 0 .383.437h2.69a.642.642 0 0 0 .638-.532l.027-.134.507-3.124.033-.172a.64.64 0 0 1 .637-.532h.403c2.604 0 4.644-1.028 5.24-4.008.25-1.243.119-2.282-.539-3.012a2.583 2.583 0 0 0-.735-.554",
          fill: "#C8C8C8",
          opacity: 0.5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M198.859 5.29h-3.523a.49.49 0 0 0-.478.414l-1.414 9.032c-.022.177.109.339.283.339h1.805c.174 0 .304-.123.348-.289l.391-2.56a.49.49 0 0 1 .479-.414h1.109c2.305 0 3.653-1.124 3.98-3.348.173-.974.021-1.739-.436-2.275-.5-.588-1.391-.899-2.544-.899m.391 3.298c-.195 1.264-1.152 1.264-2.087 1.264h-.522l.37-2.36a.297.297 0 0 1 .282-.246h.261c.63 0 1.218 0 1.523.36.195.217.239.538.173.982M173.872 5.29h-3.501c-.24 0-.457.175-.479.414l-1.435 9.032a.3.3 0 0 0 .304.339h1.675a.49.49 0 0 0 .478-.413l.37-2.437a.49.49 0 0 1 .478-.413h1.11c2.305 0 3.653-1.124 4-3.348.153-.974 0-1.739-.456-2.275-.5-.588-1.37-.899-2.544-.899m.391 3.298c-.195 1.264-1.152 1.264-2.066 1.264h-.543l.37-2.36a.302.302 0 0 1 .304-.246h.24c.63 0 1.217 0 1.521.36.196.217.24.538.174.982m10.07-.039h-1.675a.28.28 0 0 0-.283.247l-.087.472-.109-.17c-.37-.532-1.174-.709-1.979-.709-1.848 0-3.436 1.413-3.74 3.392-.174.989.065 1.934.609 2.592.522.606 1.261.86 2.13.86 1.48 0 2.306-.967 2.306-.967l-.065.47c-.022.177.109.339.283.339h1.522a.49.49 0 0 0 .478-.413l.892-5.774c.043-.18-.109-.339-.283-.339m-2.327 3.283c-.174.964-.935 1.611-1.892 1.611-.5 0-.891-.16-1.13-.457-.262-.295-.349-.715-.262-1.183.153-.956.914-1.625 1.87-1.625.48 0 .87.16 1.132.462.239.302.347.726.282 1.192m27.314-3.283h-1.674a.28.28 0 0 0-.283.247l-.087.472-.109-.17c-.37-.532-1.174-.709-1.979-.709-1.87 0-3.436 1.413-3.74 3.392-.174.989.065 1.934.609 2.592.522.606 1.24.86 2.11.86 1.5 0 2.326-.967 2.326-.967l-.065.47c-.044.177.109.339.283.339h1.5c.24 0 .457-.175.5-.413l.892-5.774c.043-.18-.109-.339-.283-.339m-2.327 3.283c-.174.964-.935 1.611-1.913 1.611-.479 0-.87-.16-1.11-.457-.26-.295-.347-.715-.26-1.183.152-.956.913-1.625 1.87-1.625.478 0 .87.16 1.109.462.26.302.37.726.304 1.192M193.27 8.549h-1.696a.47.47 0 0 0-.392.214l-2.327 3.445-.978-3.311a.504.504 0 0 0-.479-.348h-1.652c-.196 0-.348.197-.283.387l1.87 5.48-1.761 2.478c-.13.195 0 .464.239.464h1.696a.476.476 0 0 0 .392-.21l5.61-8.14c.13-.194 0-.459-.239-.459m18.028-3.011l-1.435 9.198c-.022.177.109.339.283.339h1.457a.49.49 0 0 0 .478-.413l1.414-9.033c.021-.179-.109-.339-.283-.339h-1.631a.297.297 0 0 0-.283.248",
          fill: "#C8C8C8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        fillRule: "nonzero",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M128.727 12.336h1.85c.053 0 .176-.018.229-.018a.825.825 0 0 0 .652-.828c0-.422-.3-.74-.652-.827-.053-.018-.159-.018-.229-.018h-1.85v1.69z",
          fill: "#E8E8E8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M130.951.645a3.206 3.206 0 0 0-3.206 3.205v3.328h4.527c.106 0 .23 0 .317.017 1.022.053 1.78.582 1.78 1.497 0 .722-.511 1.338-1.463 1.462v.035c1.04.07 1.833.651 1.833 1.55 0 .968-.881 1.602-2.044 1.602h-4.968v6.515h4.704a3.206 3.206 0 0 0 3.206-3.205V.645h-4.686z",
          fill: "#C8C8C8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M131.229 9.42a.75.75 0 0 0-.652-.757c-.035 0-.123-.018-.176-.018h-1.674v1.55h1.674c.053 0 .158 0 .176-.018a.75.75 0 0 0 .652-.757z",
          fill: "#E8E8E8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M112.951.645a3.206 3.206 0 0 0-3.206 3.205v7.906c.898.44 1.832.722 2.766.722 1.11 0 1.708-.67 1.708-1.585V7.16h2.749v3.716c0 1.443-.899 2.623-3.946 2.623-1.85 0-3.295-.405-3.295-.405v6.744h4.704a3.206 3.206 0 0 0 3.206-3.204V.645h-4.686zM121.933.645a3.206 3.206 0 0 0-3.206 3.205v4.19c.81-.686 2.22-1.126 4.492-1.02 1.216.052 2.52.387 2.52.387v1.356c-.652-.335-1.427-.634-2.431-.705-1.727-.123-2.766.722-2.766 2.201 0 1.497 1.04 2.342 2.766 2.201 1.004-.07 1.779-.387 2.43-.704v1.356s-1.285.334-2.519.387c-2.272.106-3.681-.334-4.492-1.021v7.395h4.704a3.206 3.206 0 0 0 3.206-3.204V.645h-4.704z",
          fill: "#C8C8C8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(77.196)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("image", {
          width: 19.441,
          height: 19.355,
          xlinkHref: "data:image/png;base64,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"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
          fill: "#C8C8C8",
          xlinkHref: "#PaymentsIcons_svg__a"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M77.199 10.135h.92l.206-.5h.464l.207.5h1.807v-.381l.163.384h.937l.16-.39v.387h4.492v-.82h.088c.062 0 .08 0 .08.108v.71h2.324v-.191c.268.133.564.198.862.19h.979l.209-.5h.465l.206.5h1.882v-.471l.287.474h1.508V7h-1.493v.38l-.209-.372h-1.541v.371l-.191-.371h-2.066c-.31-.015-.619.048-.898.183v-.183h-1.44v.183a.894.894 0 0 0-.61-.183h-5.21l-.351.81-.36-.81h-1.644v.371l-.183-.371h-1.402l-.65 1.489.002 1.638zm17.76-.433h-.774l-1.02-1.685v1.685H92.07l-.196-.516h-1.118l-.201.516h-.625a1.134 1.134 0 0 1-.775-.258 1.125 1.125 0 0 1-.286-.86c-.025-.319.079-.635.289-.877a1.09 1.09 0 0 1 .816-.258h.516v.483h-.516a.517.517 0 0 0-.416.134.75.75 0 0 0-.155.516.774.774 0 0 0 .15.516c.105.086.24.126.374.114h.243l.756-1.768h.811l.912 2.126V7.444h.818l.945 1.566V7.444h.55l-.003 2.258zm-6.364-2.248v2.248h-.55V7.444l.55.01zm-.862.607a.635.635 0 0 1-.385.59c.102.04.191.106.258.192a.64.64 0 0 1 .09.41v.449h-.542v-.284a.658.658 0 0 0-.087-.436c-.078-.08-.197-.098-.39-.098h-.579v.818h-.537V7.444h1.237c.223-.022.447.016.65.108a.516.516 0 0 1 .272.498l.013.01zM85.2 9.7h-1.807V7.445H85.2v.47h-1.257v.402h1.226v.462h-1.226v.45H85.2v.474zm-2.197 0h-.56V7.935l-.775 1.768h-.472l-.775-1.763v1.763h-1.095l-.206-.5H78l-.205.5h-.583l.96-2.248h.8l.915 2.13v-2.14h.877l.703 1.525.648-1.525h.896l-.008 2.258zm8.685-.97l-.372-.892-.369.893h.741zm-4.647-.356a.53.53 0 0 1-.258.047h-.654v-.508h.661a.581.581 0 0 1 .259.038.212.212 0 0 1 .11.199.237.237 0 0 1-.11.217l-.008.007zm-8.1.349l-.369-.893-.366.893h.736zM87.814 12.194c0 .622-.465.754-.938.754h-.67v.76h-1.034l-.663-.742-.695.743h-2.13V11.45h2.164l.66.735.685-.735h1.717c.426 0 .906.119.906.74l-.002.003zm-4.273 1.03h-1.322v-.439h1.193v-.46h-1.18v-.407h1.347l.586.653-.624.653zm2.132.258l-.823-.916.823-.888v1.804zm1.232-1.01h-.697v-.554h.702c.194 0 .328.077.328.276s-.13.294-.333.294v-.015zm3.614-1.016h1.808v.467h-1.26v.408h1.229v.46h-1.23v.446h1.26v.472H90.52v-2.253zm-.679 1.205a.576.576 0 0 1 .258.189.648.648 0 0 1 .088.41v.449h-.54v-.29c0-.136.014-.335-.087-.438-.1-.103-.199-.1-.393-.1h-.575v.828h-.532V11.45H89.3c.221-.02.444.016.648.106a.516.516 0 0 1 .273.5.632.632 0 0 1-.38.599l-.002.005zm-.322-.284a.517.517 0 0 1-.259.047h-.653v-.516h.661a.542.542 0 0 1 .258.038c.074.041.117.12.111.204a.243.243 0 0 1-.11.214l-.008.013zm4.861.124c.118.13.176.303.16.478 0 .485-.302.71-.844.71h-1.048v-.47h1.032a.323.323 0 0 0 .222-.057.199.199 0 0 0 .062-.147.19.19 0 0 0-.064-.15.282.282 0 0 0-.191-.052c-.517-.015-1.134.016-1.134-.694 0-.325.204-.668.775-.668h1.08v.48h-.987a.375.375 0 0 0-.217.041.175.175 0 0 0-.08.163.17.17 0 0 0 .119.165c.067.02.137.029.206.026h.29c.22-.02.44.045.614.18l.005-.005zm2.14.906a.842.842 0 0 1-.715.302h-1.032v-.49h1.032a.313.313 0 0 0 .217-.057.196.196 0 0 0 .065-.147.188.188 0 0 0-.065-.15.282.282 0 0 0-.19-.052c-.517-.015-1.137.016-1.137-.694 0-.325.21-.668.775-.668h1.071v-.447h-.996a1.116 1.116 0 0 0-.674.186v-.186h-1.472a1.033 1.033 0 0 0-.643.186v-.186h-2.63v.186a1.402 1.402 0 0 0-.726-.186h-1.733v.186a1.224 1.224 0 0 0-.759-.186h-1.946l-.444.483-.416-.483h-2.905v3.138h2.84l.457-.487.432.487h1.75v-.738h.173c.254.017.51-.02.749-.108v.846h1.446v-.818h.07c.09 0 .097 0 .097.093v.725h4.39c.258.01.513-.059.73-.198v.198h1.394c.27.01.539-.04.788-.144l.007-.591zm0-1.484h-.973a.367.367 0 0 0-.214.041.178.178 0 0 0-.08.163.168.168 0 0 0 .119.165c.067.02.138.03.209.026h.289c.22-.02.438.045.612.18a.663.663 0 0 1 .049.057l-.01-.632z",
        fill: "#FFF",
        fillRule: "nonzero"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        fillRule: "nonzero",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M43.586 19.85v-1.276a.742.742 0 0 0-.787-.808.839.839 0 0 0-.724.361.745.745 0 0 0-.68-.361.724.724 0 0 0-.618.297v-.255h-.404v2.042h.404v-1.17a.476.476 0 0 1 .51-.531c.299 0 .469.191.469.531v1.17h.404v-1.17a.476.476 0 0 1 .51-.531c.299 0 .469.191.469.531v1.17h.447zm6.639-2.02h-.745v-.617h-.404v.616h-.426v.362h.426v.957c0 .468.17.745.68.745a1.19 1.19 0 0 0 .554-.15l-.128-.36a.7.7 0 0 1-.383.105.298.298 0 0 1-.319-.34v-.978h.745v-.34zm3.787-.064a.638.638 0 0 0-.553.297v-.255h-.404v2.042h.404v-1.148c0-.34.17-.553.447-.553.094.003.186.018.277.042l.127-.383a1.437 1.437 0 0 0-.298-.042zm-5.724.212a1.46 1.46 0 0 0-.83-.212c-.51 0-.83.234-.83.638 0 .34.235.531.682.595l.212.022c.234.042.383.127.383.234 0 .148-.17.255-.489.255a1.122 1.122 0 0 1-.68-.213l-.214.32c.259.17.563.259.873.254.596 0 .915-.276.915-.659s-.256-.532-.703-.596l-.212-.02c-.192-.022-.362-.086-.362-.214 0-.127.17-.255.404-.255.223.01.44.068.639.17l.212-.319zm6.193.851a1.004 1.004 0 0 0 1.063 1.064c.262.013.52-.07.724-.234l-.213-.32a.851.851 0 0 1-.532.192.683.683 0 0 1 0-1.361.851.851 0 0 1 .532.191l.213-.319a1.064 1.064 0 0 0-.724-.234.954.954 0 0 0-1.063 1.021zm-2.873-1.063c-.596 0-1 .425-1 1.063a1 1 0 0 0 1.042 1.064c.3.006.594-.092.83-.277l-.212-.298c-.171.133-.38.207-.596.213a.598.598 0 0 1-.617-.532h1.51v-.17c0-.638-.383-1.063-.957-1.063zm0 .383a.509.509 0 0 1 .532.51h-1.107a.547.547 0 0 1 .575-.51zm-5.511.68v-1.02h-.405v.254a.783.783 0 0 0-.66-.297 1.064 1.064 0 1 0 0 2.127.783.783 0 0 0 .66-.298v.255h.405v-1.02zm-1.66 0a.638.638 0 1 1 .638.68.626.626 0 0 1-.638-.68zm15.725-1.063a.638.638 0 0 0-.553.297v-.255h-.405v2.042h.405v-1.148c0-.34.17-.553.447-.553.093.003.186.018.276.042l.128-.383a1.437 1.437 0 0 0-.298-.042zm-1.575 1.063v-1.02h-.404v.254a.783.783 0 0 0-.66-.297 1.064 1.064 0 1 0 0 2.127.783.783 0 0 0 .66-.298v.255h.404v-1.02zm-1.638 0a.638.638 0 1 1 .638.68c-.404.022-.638-.297-.638-.68zm5.766 0V17h-.404v1.063a.783.783 0 0 0-.66-.297 1.064 1.064 0 1 0 0 2.127.783.783 0 0 0 .66-.298v.255h.404v-1.02zm-1.66 0a.638.638 0 1 1 .639.68.626.626 0 0 1-.638-.68z",
          fill: "#C8C8C8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#A7A7A7",
          d: "M48.373 2h7.384v12.038h-7.384z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M48.853 7.657a7.677 7.677 0 0 1 2.915-6.02 7.663 7.663 0 0 0-9.082-.285 7.655 7.655 0 0 0 4.358 13.962 7.616 7.616 0 0 0 4.724-1.638 7.677 7.677 0 0 1-2.915-6.02z",
          fill: "#C8C8C8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M63.757 7.648a7.657 7.657 0 0 1-4.31 6.878 7.663 7.663 0 0 1-8.074-.858 7.673 7.673 0 0 0 0-12.039 7.663 7.663 0 0 1 8.073-.858 7.657 7.657 0 0 1 4.31 6.877z",
          fill: "#C8C8C8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#C8C8C8",
        fillRule: "nonzero",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M0 15.935h25.869v2.32H0zM0 1.935h25.869v2.32H0zM10.749 7.053l-2.673 6.368H6.328L5.017 8.33c-.084-.32-.151-.42-.387-.554A6.628 6.628 0 0 0 3 7.238l.034-.185H5.84c.38.002.7.28.756.655l.69 3.68L9 7.053h1.748zm6.841 4.284c0-1.68-2.32-1.78-2.303-2.52 0-.235.219-.47.706-.537a3.143 3.143 0 0 1 1.63.285l.286-1.344a4.301 4.301 0 0 0-1.546-.286c-1.63 0-2.774.874-2.79 2.1-.017.925.823 1.429 1.445 1.731.622.303.857.521.857.79 0 .42-.52.621-.991.621a3.383 3.383 0 0 1-1.698-.403l-.302 1.395a4.685 4.685 0 0 0 1.832.336c1.731.017 2.857-.84 2.874-2.168zm4.303 2.084h1.53l-1.328-6.368h-1.412a.751.751 0 0 0-.706.47l-2.488 5.898h1.731l.337-.958h2.117l.219.958zm-1.849-2.252l.874-2.385.504 2.385h-1.378zm-6.942-4.116l-1.361 6.368h-1.648l1.362-6.368h1.647z"
        })
      })]
    })]
  }));
};

/* harmony default export */ var PaymentsIcons = (SvgPaymentsIcons);
// EXTERNAL MODULE: ./components/Layout/Footer/Footer.module.scss
var Footer_module = __webpack_require__(1301);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/Layout/Footer/Footer.js






function Footer_createSuper(Derived) { var hasNativeReflectConstruct = Footer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Footer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }















var LanguagePicker = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 418).then(__webpack_require__.bind(__webpack_require__, 48418));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48418)];
    }
  }
});

var Footer = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Footer, _Component);

  var _super = Footer_createSuper(Footer);

  function Footer() {
    (0,classCallCheck/* default */.Z)(this, Footer);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Footer, [{
    key: "trackExternalLink",
    value: function trackExternalLink(link) {
      esm/* default.event */.ZP.event({
        category: 'external link clicked',
        action: link
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            "aria-labelledby": "footer-navigation",
            className: (Footer_module_default()).footer,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Footer_module_default()).footerContent,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footerContentHolder,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Footer_module_default()).footerContentTop,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
                    to: "/",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {})
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (Footer_module_default()).footerContentBottom,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (Footer_module_default()).languagePickerRow,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (Footer_module_default()).languagePickerWrapper,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LanguagePicker, {})
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                      className: (Footer_module_default()).footerSocialNav,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        className: (Footer_module_default()).footerSocialNavItem,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          href: "https://twitter.com/smartmockups",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "Twitter",
                            color: "grey"
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        className: (Footer_module_default()).footerSocialNavItem,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          href: "https://facebook.com/smartmockups",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "Facebook",
                            color: "grey"
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        className: (Footer_module_default()).footerSocialNavItem,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          href: "https://instagram.com/smartmockups",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "Instagram",
                            color: "grey"
                          })
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (Footer_module_default()).trustpilot,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotWidget/* default */.Z, {
                      type: "microCombo"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (Footer_module_default()).footerLowerContent,
                    children: "\xA9 Smartmockups s.r.o. - All rights reserved. All product names, logos, and brands are property of their respective owners."
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentsIcons, {
                      width: 216,
                      height: 21,
                      className: (Footer_module_default()).footerLowerPayment
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Footer_module_default()).footerCol,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footerNav,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  type: "checkbox"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Footer_module_default()).footerNavTitle,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                      id: "x/ZVlU",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Product"
                      }]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "ArrowDown",
                        size: "md",
                        color: "grey"
                      })
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
                      to: "/features",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "Features"
                        }],
                        id: "global.nav.label.features"
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
                      to: "/create",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "VzzYJk",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Create"
                        }]
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
                      to: "/customers",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "TkYZBT",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Customers"
                        }]
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkLocalised/* default */.Z, {
                      to: "/pricing",
                      children: [' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "Pricing"
                        }],
                        id: "global.nav.label.pricing"
                      })]
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                      href: "https://blog.smartmockups.com",
                      children: [' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "Blog"
                        }],
                        id: "global.nav.label.blog"
                      })]
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Footer_module_default()).footerCol,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footerNav,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  type: "checkbox"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Footer_module_default()).footerNavTitle,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                      id: "/VnDMl",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Other"
                      }]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "ArrowDown",
                        size: "md",
                        color: "grey"
                      })
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://a.paddle.com/join/1793",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "0nb2QR",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Affiliate program"
                        }]
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Helpscout_HelpscoutButton, {
                      navigate: "/answers/article/610288566ffe270af2a93bfd",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "Suggest a new idea"
                        }],
                        id: "global.nav.label.suggestAnIdea"
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://www.dropbox.com/sh/b2f0udxj4i48hqx/AADZ4BUHPTKcV_io4-on4q2ea?dl=0",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: "Press Kit"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
                      to: "/privacy-terms-of-use",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "7wYtqn",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Privacy & terms"
                        }]
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
                      to: "/license",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "HBxXD/",
                        defaultMessage: [{
                          "type": 0,
                          "value": "License"
                        }]
                      })
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Footer_module_default()).footerCol,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footerNav,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  type: "checkbox"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Footer_module_default()).footerNavTitle,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                      id: "SENRqu",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Help"
                      }]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "ArrowDown",
                        size: "md",
                        color: "grey"
                      })
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
                      to: "/frequently-asked-questions",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "2zAY1d",
                        defaultMessage: [{
                          "type": 0,
                          "value": "FAQs"
                        }]
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://help.smartmockups.com",
                      target: "_blank",
                      rel: "noreferrer",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "vc+75n",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Knowledge Hub"
                        }]
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Footer_module_default()).footerNavItem,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Helpscout_HelpscoutButton, {
                      navigate: "/ask",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "zFegDD",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Contact"
                        }]
                      })
                    })
                  })]
                })]
              })
            })]
          })
        })
      });
    }
  }]);

  return Footer;
}(react.Component);


;// CONCATENATED MODULE: ./containers/Common/FooterContainer/index.js







var PremiumModalContainerAsync = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 142).then(__webpack_require__.bind(__webpack_require__, 41142));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(41142)];
    }
  }
});

var FooterContainer = function FooterContainer(props) {
  var premiumModal = (0,es/* useSelector */.v9)(function (state) {
    return state.window.premiumModal;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!props.hideContent && /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {}), premiumModal && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PremiumModalContainerAsync, {})
    })]
  });
};

/* harmony default export */ var Common_FooterContainer = (FooterContainer);
// EXTERNAL MODULE: ./components/Base/GradientBgBlock/GradientBgBlock.js
var GradientBgBlock = __webpack_require__(20318);
// EXTERNAL MODULE: ./components/Marketing/BannerFullWidth/BannerFullWidth.module.scss
var BannerFullWidth_module = __webpack_require__(12221);
var BannerFullWidth_module_default = /*#__PURE__*/__webpack_require__.n(BannerFullWidth_module);
// EXTERNAL MODULE: ./components/Base/Emoji/Emoji.js
var Emoji = __webpack_require__(76967);
;// CONCATENATED MODULE: ./components/Marketing/BannerFullWidth/FullWidthBannerSignup.js












var FullWidthBannerSignup = function FullWidthBannerSignup() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
    size: "lg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(GradientBgBlock/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BannerFullWidth_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Headline/* default */.Z, {
          design: "inverse",
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "Get started"
            }],
            id: "global.nav.label.signupShort"
          }),
          subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "jtGi4N",
            defaultMessage: [{
              "type": 0,
              "value": "Join thousands of professionals and "
            }, {
              "type": 1,
              "value": "newline"
            }, {
              "type": 0,
              "value": "start your 7-day free trial"
            }],
            values: {
              newline: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkLocalised/* default */.Z, {
          to: "/signup",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
            size: "xlarge",
            design: "white",
            className: (BannerFullWidth_module_default()).btn,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Emoji/* default */.Z, {
              symbol: "\uD83D\uDC49"
            }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              defaultMessage: [{
                "type": 0,
                "value": "Get started for free"
              }],
              id: "global.nav.label.signupLong"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "color-blue-light text-small",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "S40HaS",
            defaultMessage: [{
              "type": 0,
              "value": "*No credit card required, and you can cancel at any time. You can use it free forever or upgrade to our subscription."
            }]
          })
        })]
      })
    })
  });
};

/* harmony default export */ var BannerFullWidth_FullWidthBannerSignup = (FullWidthBannerSignup);
// EXTERNAL MODULE: ./components/Marketing/CategoriesSlider/Skeleton.module.scss
var CategoriesSlider_Skeleton_module = __webpack_require__(48056);
var CategoriesSlider_Skeleton_module_default = /*#__PURE__*/__webpack_require__.n(CategoriesSlider_Skeleton_module);
;// CONCATENATED MODULE: ./components/Marketing/CategoriesSlider/Skeleton.js






var CategoriesSliderSkeleton = function CategoriesSliderSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* SkeletonTheme */.yB, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CategoriesSlider_Skeleton_module_default()).skeletonWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
          count: 6,
          height: '90px'
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_lib/* default */.ZP, {
          height: '550px'
        })
      })]
    })
  });
};

/* harmony default export */ var CategoriesSlider_Skeleton = (CategoriesSliderSkeleton);
;// CONCATENATED MODULE: ./containers/HomePage/index.js



























var BlogFeed = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 987).then(__webpack_require__.bind(__webpack_require__, 62987));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(62987)];
    }
  }
});
var CategoriesSlider = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 338).then(__webpack_require__.bind(__webpack_require__, 17338));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSlider_Skeleton, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(17338)];
    }
  }
});

var HomePage = function HomePage(props) {
  var video = (0,react.useRef)(null);
  var videoPlaying = (0,react.useRef)(false);
  var intl = props.intl;
  var user = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.user;
  });
  var isUserLoaded = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.isUserLoaded;
  });

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.server;
  }),
      homepageData = _useSelector.homepageData,
      homepageMockups = _useSelector.homepageMockups;

  var handleVideoClick = function handleVideoClick() {
    if (!video.current) return;

    if (videoPlaying.current) {
      video.current.pause();
      videoPlaying.current = false;
    } else {
      var playPromise = video.current.play();

      if (playPromise !== undefined) {
        playPromise.then(function () {})["catch"](function (error) {
          console.log(error);
        });
      }

      videoPlaying.current = true;
      (0,trackingParty/* trackEvent */.L9)('Homepage video play');
    }
  }; // const dpr = isClient() ? Math.min(window.devicePixelRatio, 2) : 1;


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: intl.formatMessage(HomepageMessages.pageTitle)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: intl.formatMessage(HomepageMessages.metaDescription)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "fb:app_id",
        content: "172780239415226"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: intl.formatMessage(HomepageMessages.pageTitle)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: intl.formatMessage(HomepageMessages.metaDescription)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://smartmockups.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://smartmockups.com/android-chrome-400x400.jpg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:secure_url",
        content: "https://smartmockups.com/android-chrome-400x400.jpg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:type",
        content: "image/jpeg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:card",
        content: "summary_large_image"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:site",
        content: "@smartmockups"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "twitter:description",
        content: intl.formatMessage(HomepageMessages.metaDescription)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "twitter:image",
        content: "https://smartmockups.com/android-chrome-400x400.jpg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        httpEquiv: "Accept-CH",
        content: "DPR,Width,Viewport-Width"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavbarContainer_NavbarContainer, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HomePageHeader_HomePageHeader, {
      mockups: homepageMockups
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "m-t-lg m-b-md "
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
      size: "lg",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Homepage_module_default()).rowVideo,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Homepage_module_default()).absoluteHalf,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
            ref: video,
            className: (Homepage_module_default()).introVideo,
            controls: true,
            preload: "none",
            poster: "".concat(variables/* WEB_IMGIX */.iL, "/intro-video-placeholder.jpg?w=892&dpr=2&auto=compress"),
            width: 892,
            height: 558,
            onClick: handleVideoClick,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              src: "https://s3.amazonaws.com/smartmockups-web-assets/introduction.webm",
              type: "video/webm"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              src: "https://s3.amazonaws.com/smartmockups-web-assets/introduction.mp4",
              type: "video/mp4"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Homepage_module_default()).rowNoMargin,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Homepage_module_default()).half,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Homepage_module_default()).contentRight,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LargeDescription_LargeDescription, {
                description: intl.formatMessage(HomepageMessages.introDescription),
                list: [intl.formatMessage(HomepageMessages.introList1), intl.formatMessage(HomepageMessages.introList2), intl.formatMessage(HomepageMessages.introList3)],
                subtitle: intl.formatMessage(HomepageMessages.introSubtitle),
                title: intl.formatMessage(HomepageMessages.introTitle)
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
      className: "m-b-lg",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSlider, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
      size: "lg",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Homepage_module_default()).rowBlue,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Homepage_module_default()).absoluteHalfOffset,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Masonry, {
            items: [{
              src: 'masonry-features-url-picker.jpg',
              width: 261,
              height: 255,
              isShadow: true
            }, {
              src: 'masonry-features-picker.jpg',
              width: 261,
              height: 498
            }, {
              src: 'masonry-features-upload-new-2.jpg',
              width: 261,
              height: 233,
              isShadow: true
            }, {
              src: 'masonry-features-crop.jpg',
              width: 261,
              height: 321
            }, {
              src: 'masonry-features-picker-quality.jpg',
              width: 261,
              height: 194,
              isShadow: true
            }, {
              src: 'masonry-features-bg.jpg',
              width: 261,
              height: 371
            }]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container_Container, {
          isPaddingDisabled: false,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Homepage_module_default()).rowNoMargin,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Homepage_module_default()).half,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Homepage_module_default()).contentRight,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FeatureGrid_FeatureGrid, {
                singleColumn: true,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle, {
                  title: intl.formatMessage(HomepageMessages.featuresTitle),
                  subtitle: intl.formatMessage(HomepageMessages.featuresSubtitle),
                  design: "blue"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShortDescription_ShortDescription, {
                  design: "blue",
                  title: intl.formatMessage(HomepageMessages.uploadTitle),
                  description: intl.formatMessage(HomepageMessages.uploadDescription)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShortDescription_ShortDescription, {
                  design: "blue",
                  title: intl.formatMessage(HomepageMessages.customizeTitle),
                  description: intl.formatMessage(HomepageMessages.customizeDescription)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShortDescription_ShortDescription, {
                  design: "blue",
                  title: intl.formatMessage(HomepageMessages.exportTitle),
                  description: intl.formatMessage(HomepageMessages.exportDescription)
                })]
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container_Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IntegrationsOverview_IntegrationsOverview, {
        title: intl.formatMessage(HomepageMessages.integrationsTitle),
        subtitle: intl.formatMessage(HomepageMessages.integrationsSubtitle)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "m-b-lg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(InstagramFeed_InstagramFeed, {
          instagram: homepageData.instagram
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "m-b-lg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeadline_PageHeadline, {
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "Trusted by thousands of people "
            }, {
              "type": 1,
              "value": "newLine"
            }, {
              "type": 0,
              "value": " and companies worldwide"
            }],
            id: "global.testimonials.title",
            values: {
              newLine: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
            }
          }),
          subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            defaultMessage: [{
              "type": 0,
              "value": "Testimonials"
            }],
            id: "global.testimonials.subtitle"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomerTestimonials, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "m-b-lg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BlogFeed, {
          blog: homepageData.blog
        })
      }), props.children]
    }), !user && isUserLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(BannerFullWidth_FullWidthBannerSignup, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Common_FooterContainer, {})]
  });
};

/* harmony default export */ var containers_HomePage = ((0,injectIntl/* default */.ZP)(HomePage));

/***/ }),

/***/ 11690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27812);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36456);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




var useActions = function useActions(actions) {
  for (var _len = arguments.length, filteredKeys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filteredKeys[_key - 1] = arguments[_key];
  }

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
  filteredKeys = filteredKeys.flat();

  if (filteredKeys.length === 0) {
    filteredKeys = Object.keys(actions);
  }

  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var dispatches = {};

    var _iterator = _createForOfIteratorHelper(filteredKeys),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        var action = actions[key];

        dispatches[key] = function () {
          return dispatch(action.apply(void 0, arguments));
        };
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return dispatches;
  }, [dispatch, actions].concat((0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(filteredKeys)));
};

/* harmony default export */ __webpack_exports__["Z"] = (useActions);

/***/ }),

/***/ 25628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _useUser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(578);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36456);



var useSeasonalDiscount = function useSeasonalDiscount() {
  var _useUser = (0,_useUser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
      isFree = _useUser.isFree,
      isProMonthly = _useUser.isProMonthly;

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.server;
  }),
      isSeasonalDiscount = _useSelector.isSeasonalDiscount;

  var isActiveDiscount = isSeasonalDiscount && (isFree || isProMonthly);
  var isActiveDiscountSubscriber = isSeasonalDiscount && isProMonthly;
  return {
    isActiveDiscount: isActiveDiscount,
    isActiveDiscountSubscriber: isActiveDiscountSubscriber
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useSeasonalDiscount);

/***/ }),

/***/ 578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36456);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(791);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_buildhome_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var useUser = function useUser() {
  var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.auth.user;
  });
  var isProGifted = user && user.isTrial && user.disableTrialWatermark;
  var isPro = !!(user && user.isPremium || user && user.isTrial && user.disableTrialWatermark);
  var isFree = !!(user && !user.isPremium || user && user.isTrial);
  var hasFederation = !!(user && !user.identities);
  var isUserInternal = !!(user && user.isAdmin);
  var isUserScheduled = !!(user && user.isScheduled);
  var isProYearly = !!(user && getPlan(_utils_variables__WEBPACK_IMPORTED_MODULE_2__/* .PLANS.yearly */ .Xf.yearly, user.planId) !== undefined);
  var isProMonthly = !!(user && getPlan(_utils_variables__WEBPACK_IMPORTED_MODULE_2__/* .PLANS.monthly */ .Xf.monthly, user.planId) !== undefined);

  function getPlan(object, value) {
    return Object.keys(object).find(function (key) {
      return object[key] === value;
    });
  }

  return _objectSpread(_objectSpread({}, user), {}, {
    isPro: isPro,
    isFree: isFree,
    isProGifted: isProGifted,
    hasFederation: hasFederation,
    isUserInternal: isUserInternal,
    isUserScheduled: isUserScheduled,
    isProYearly: isProYearly,
    isProMonthly: isProMonthly,
    isAuth: user !== null
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useUser);

/***/ }),

/***/ 93356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _smartmockups_rendering__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50970);
/* harmony import */ var _smartmockups_rendering__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_smartmockups_rendering__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Load Image source as Canvas element
 * @param src
 * @param maxSize - max size of canvas to avoid exceeding its limit, f.e. by uploading too large resolution images
 * @returns {Promise<unknown>} - canvas containing image source
 */

var loadImageAsCanvas = function loadImageAsCanvas(src) {
  var maxSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
  return new Promise(function (resolve, reject) {
    var image = new Image();

    image.onload = function () {
      var MAX_WIDTH = maxSize;
      var MAX_HEIGHT = maxSize;
      var width = image.width;
      var height = image.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
      }

      var canvas = (0,_smartmockups_rendering__WEBPACK_IMPORTED_MODULE_0__.createCanvas)(width, height);
      canvas.getContext('2d').drawImage(image, 0, 0, width, height);
      resolve(canvas);
    };

    image.onerror = function (err) {
      reject(err);
    };

    image.crossOrigin = 'Anonymous';
    image.src = src;
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (loadImageAsCanvas);

/***/ }),

/***/ 17485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ loadImageAsImg; }
/* harmony export */ });
function loadImageAsImg(src) {
  return new Promise(function (resolve, reject) {
    var image = new Image();

    image.onload = function () {
      resolve(image);
    };

    image.onerror = function (err) {
      reject(err);
    };

    image.crossOrigin = 'Anonymous';
    image.src = src;
  });
}

/***/ }),

/***/ 19074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LinkAlert_wrapper__0qfsC","detailsRow":"LinkAlert_detailsRow__4v2yX","label":"LinkAlert_label__vf7gp","link":"LinkAlert_link__jG2Sf","LinkWrapper":"LinkAlert_LinkWrapper__drlB3"};

/***/ }),

/***/ 52532:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoaderAlert_wrapper__Sl6XE","detailsRow":"LoaderAlert_detailsRow__5RPwT","label":"LoaderAlert_label__CceUe","progress":"LoaderAlert_progress__V_h6C","progressBarWrapper":"LoaderAlert_progressBarWrapper__1NwzY","progressBar":"LoaderAlert_progressBar__u5CDv","dots":"LoaderAlert_dots__2IXxA","dot":"LoaderAlert_dot__ENIUQ","wave":"LoaderAlert_wave__58QXJ","blink":"LoaderAlert_blink__sPOHl"};

/***/ }),

/***/ 6778:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerLarge":"Container_containerLarge__aa6JD","container":"Container_container__j2eJu","containerSmall":"Container_containerSmall__QuDZe","noPadding":"Container_noPadding__xoIPP"};

/***/ }),

/***/ 92548:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__aRHaw","dropdownContent":"Dropdown_dropdownContent__JEtt6","dropdownContentLeft":"Dropdown_dropdownContentLeft__FHQ0T","dropdownContentRight":"Dropdown_dropdownContentRight__qLgLX","dropdownContentWithArrow":"Dropdown_dropdownContentWithArrow__f65Z_","dropdownToggle":"Dropdown_dropdownToggle__oGDXz","active":"Dropdown_active__Anw5B"};

/***/ }),

/***/ 68173:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"GradientBgBlock_block__Y_C_7"};

/***/ }),

/***/ 81680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageHeadlineSm":"Heading_pageHeadlineSm__xBiu_","inverse":"Heading_inverse__PHhKZ","blue":"Heading_blue__KU1uW","pageHeadlineLgSmaller":"Heading_pageHeadlineLgSmaller__7yI4f","pageHeadlineLg":"Heading_pageHeadlineLg__X9CxD"};

/***/ }),

/***/ 76483:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"colorGrey":"Icons_colorGrey__aI3oa","colorBlueLight":"Icons_colorBlueLight__uhg5f","colorWhite":"Icons_colorWhite__jHirI","colorGreen":"Icons_colorGreen__KNebj","colorOrange":"Icons_colorOrange__nyABa","colorBlack":"Icons_colorBlack__oBcm7","colorRed":"Icons_colorRed__AYZwN","colorBlue":"Icons_colorBlue__u6yx1","colorLightGreen":"Icons_colorLightGreen__Fzzn6","colorLightOrange":"Icons_colorLightOrange__C0CkN","colorPurple":"Icons_colorPurple__hZyVU"};

/***/ }),

/***/ 34875:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__p9gGA","modalFull":"Modal_modalFull__Jd0hH","modalLarge":"Modal_modalLarge__y8OGQ","modalMedium":"Modal_modalMedium__cdJj0","modalExtraSmall":"Modal_modalExtraSmall__VKFpM","modalSmall":"Modal_modalSmall__wzWsE","modalPushed":"Modal_modalPushed__uHOoD","modalWhite":"Modal_modalWhite__BwCym","modalBlack":"Modal_modalBlack__7CXsA","overlay":"Modal_overlay__ZMXMj","modalCentered":"Modal_modalCentered__h7S4L","close":"Modal_close__BoAJR","fadeInDown":"Modal_fadeInDown__RdZX5","fadeOutDown":"Modal_fadeOutDown__WgYoA","fadeIn":"Modal_fadeIn__4f6n6","fadeOut":"Modal_fadeOut__mb__W"};

/***/ }),

/***/ 18035:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalScroll_wrapper__j4b_L","wrapperNoPadding":"ModalScroll_wrapperNoPadding__jG_r4"};

/***/ }),

/***/ 73300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"SlideBar_outerContainer__HcGOn","sliderWrapper":"SlideBar_sliderWrapper__7jSNi","container":"SlideBar_container__QCT2Y","slidebar":"SlideBar_slidebar__EOGXB","center":"SlideBar_center__tDkk9"};

/***/ }),

/***/ 86747:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"time":"VideoTimer_time__U_6Mo","list":"VideoTimer_list__HbiL_","detail":"VideoTimer_detail__UDeDC"};

/***/ }),

/***/ 1301:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__e6iqw","footerContent":"Footer_footerContent___K_q_","footerContentHolder":"Footer_footerContentHolder__nQOr6","footerContentTop":"Footer_footerContentTop__QmWLn","languagePickerRow":"Footer_languagePickerRow__uypgZ","languagePickerWrapper":"Footer_languagePickerWrapper__Ecnfp","footerRight":"Footer_footerRight__QUKns","footerCol":"Footer_footerCol__eemq_","footerNav":"Footer_footerNav__3KDr_","footerNavTitle":"Footer_footerNavTitle__eNemj","footerNavItem":"Footer_footerNavItem__Oxb_X","footerLowerContent":"Footer_footerLowerContent__v_D5S","footerLowerPayment":"Footer_footerLowerPayment__93dEm","footerSocialNav":"Footer_footerSocialNav__dArdL","footerSocialNavItem":"Footer_footerSocialNavItem__KCpbt","footerSocialLabel":"Footer_footerSocialLabel__ZmGIl","trustpilot":"Footer_trustpilot__ROnAi"};

/***/ }),

/***/ 58721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Headline_subtitle__BJeA_","titleBlue":"Headline_titleBlue__TkRBC","subtitleBlue":"Headline_subtitleBlue__iQpRX","titleInverse":"Headline_titleInverse__uVBHE","subtitleInverse":"Headline_subtitleInverse__b0z65"};

/***/ }),

/***/ 11670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navbarContainer":"Nav_navbarContainer__IXpQb","navbar":"Nav_navbar__DH_Y7","navItem":"Nav_navItem__fHGXi","navLink":"Nav_navLink__bT84m","navSeparator":"Nav_navSeparator__f2F4y","navArrow":"Nav_navArrow__LssDc","navLinkActive":"Nav_navLinkActive__wkMuJ Nav_navLink__bT84m","dropdown":"Nav_dropdown__Ixt5O","dropdownContent":"Nav_dropdownContent__npnRU","dropdownContentTwoCols":"Nav_dropdownContentTwoCols__7Dnj1","dropdownList":"Nav_dropdownList__EfjWF","dropdownListTwoCols":"Nav_dropdownListTwoCols__LCA_s"};

/***/ }),

/***/ 69740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavSectionItem_wrapper__iN1WQ","titleWrapper":"NavSectionItem_titleWrapper__E8X7y","subcategoryTitle":"NavSectionItem_subcategoryTitle__oQc1t","subcategoryTitleHover":"NavSectionItem_subcategoryTitleHover__07aOb","newBadge":"NavSectionItem_newBadge__avwJN","subtitleWrapper":"NavSectionItem_subtitleWrapper__VmUJh","subtitle":"NavSectionItem_subtitle__77LiW","subtitleNoHover":"NavSectionItem_subtitleNoHover__fLhAz","subcategoryIcon":"NavSectionItem_subcategoryIcon__dMhq4"};

/***/ }),

/***/ 70351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navbarWrapper":"Navbar_navbarWrapper__K73mh","navbar":"Navbar_navbar__mARzx","left":"Navbar_left__Sh0bx","center":"Navbar_center__lAmM2","right":"Navbar_right__2KXvb","logo":"Navbar_logo__gf6N_","logoMobile":"Navbar_logoMobile__JHsPd","noUserNavbar":"Navbar_noUserNavbar__Wdp6_","noUserCenter":"Navbar_noUserCenter__gmcwn","loginCenter":"Navbar_loginCenter__uur2h","navbarWrapperSoonerWrap":"Navbar_navbarWrapperSoonerWrap__s5oN3","usermenuWrapper":"Navbar_usermenuWrapper__ENdk8"};

/***/ }),

/***/ 20304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoUserLogin_wrapper__4mpHo","listItem":"NoUserLogin_listItem__OsPmD","listButton":"NoUserLogin_listButton__R21Xe","btn":"NoUserLogin_btn__Ms4tA","link":"NoUserLogin_link__Jfj_j","longLabel":"NoUserLogin_longLabel__sGTO2","shortLabel":"NoUserLogin_shortLabel__zFmB7"};

/***/ }),

/***/ 58410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeadline_wrapper__UBKf1"};

/***/ }),

/***/ 48860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toolBar":"ToolBar_toolBar__sGYWd","create":"ToolBar_create__F9T6P","rename":"ToolBar_rename__noBke"};

/***/ }),

/***/ 87695:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollectionCondenseList_wrapper__UrWvX"};

/***/ }),

/***/ 80123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"collectionPreview":"CollectionPreview_collectionPreview__W_Am_","noPadding":"CollectionPreview_noPadding__1hMxB","imagesHolder":"CollectionPreview_imagesHolder__2jUNt","mainImage":"CollectionPreview_mainImage__ERv4Y","subImages":"CollectionPreview_subImages__e5Gpc","imageBox":"CollectionPreview_imageBox__JFUfM","aspectRation":"CollectionPreview_aspectRation__VSP_A","content":"CollectionPreview_content__jyeKu","title":"CollectionPreview_title__jDjEQ","mockupsCount":"CollectionPreview_mockupsCount__wRgxk","overlayWrap":"CollectionPreview_overlayWrap__LXf2t","overlay":"CollectionPreview_overlay____IB5","collected":"CollectionPreview_collected__qVF_c","collect":"CollectionPreview_collect__oIm4W","active":"CollectionPreview_active__dPmaD","full":"CollectionPreview_full__c1tTR"};

/***/ }),

/***/ 42345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filters":"filter_filters__gr93q","filterWrapper":"filter_filterWrapper__63y33","filter":"filter_filter__Qx2D_","filterButton":"filter_filterButton__31Gcg","filterButtonActive":"filter_filterButtonActive__lB7Rs","filterItem":"filter_filterItem__ZN57K"};

/***/ }),

/***/ 18528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"livePreviewWrapper":"LivePreviewToolbar_livePreviewWrapper__4QAM5","buttonHolder":"LivePreviewToolbar_buttonHolder__yOgwd","predefinedButton":"LivePreviewToolbar_predefinedButton___ASjz","livePreviewUploadButtonCompact":"LivePreviewToolbar_livePreviewUploadButtonCompact__hjoQV","buttonLink":"LivePreviewToolbar_buttonLink__Pg_qz","livePreviewUploadButton":"LivePreviewToolbar_livePreviewUploadButton__YZeQu","uploadButtonBackground":"LivePreviewToolbar_uploadButtonBackground__MQXCX","livePreviewRemoveButton":"LivePreviewToolbar_livePreviewRemoveButton__qyAEQ","livePreviewDescription":"LivePreviewToolbar_livePreviewDescription__rsrxw","predefinedButtonBorder":"LivePreviewToolbar_predefinedButtonBorder__0vp6T","separator":"LivePreviewToolbar_separator__Y9MgS","info":"LivePreviewToolbar_info__UNl8c","title":"LivePreviewToolbar_title__EFFQP"};

/***/ }),

/***/ 10729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"LivePreviewUploadButton_uploadButton__9gzQS","darkened":"LivePreviewUploadButton_darkened__wgmbn","uploadIcon":"LivePreviewUploadButton_uploadIcon__o4321","uploadInput":"LivePreviewUploadButton_uploadInput__kIgnB","centeredContent":"LivePreviewUploadButton_centeredContent__1cwGK","predefined":"LivePreviewUploadButton_predefined__nHzxQ","predefinedActive":"LivePreviewUploadButton_predefinedActive__a2dJ4"};

/***/ }),

/***/ 94027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MockupList_wrapper__PnFB9","listWrapper":"MockupList_listWrapper__f6kDd","myMasonryGridColumn":"MockupList_myMasonryGridColumn__pd0aT","wrapperMasonry":"MockupList_wrapperMasonry__l91rY","myMasonryGrid":"MockupList_myMasonryGrid__K5T_A"};

/***/ }),

/***/ 49021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MockupPlaceholder_wrapper__w7XNV","svg":"MockupPlaceholder_svg__w_4GK","placeholder":"MockupPlaceholder_placeholder__pS4_C","shine":"MockupPlaceholder_shine__inNu7"};

/***/ }),

/***/ 12355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"collection":"Skeleton_collection__Z7mv4","collectionTitle":"Skeleton_collectionTitle__kW7TD","collectionDescription":"Skeleton_collectionDescription__xKfDu","featuredMockups":"Skeleton_featuredMockups__Ji_e6","featuredMockupsHalf":"Skeleton_featuredMockupsHalf__kFXi6"};

/***/ }),

/***/ 18570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"collectionButton":"CollectionButton_collectionButton__yJILv","isolated":"CollectionButton_isolated__8ZLkW","isActive":"CollectionButton_isActive__TXwaD"};

/***/ }),

/***/ 47041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MockupPreview_wrapper__LmJ2U","previewContent":"MockupPreview_previewContent__xtIip","ratioContainer":"MockupPreview_ratioContainer__u0G4j","collectionBtn":"MockupPreview_collectionBtn__Es5X9","adminBtnWrapper":"MockupPreview_adminBtnWrapper__ERIOV","listTitles":"MockupPreview_listTitles__4F3d6","listTitlesInverse":"MockupPreview_listTitlesInverse__3REoj","previewTitle":"MockupPreview_previewTitle__VK_yt","previewTitleInverse":"MockupPreview_previewTitleInverse__92TCx","hover":"MockupPreview_hover__5dZHF","hoverBordered":"MockupPreview_hoverBordered__CU_yI","videoBadges":"MockupPreview_videoBadges__ZXsAJ","mockupPreview":"MockupPreview_mockupPreview__ouMzy","image":"MockupPreview_image__HgwjS","imageBordered":"MockupPreview_imageBordered__6rJIw","livePreview":"MockupPreview_livePreview__vfTMb","opacity":"MockupPreview_opacity___pSwy","loader":"MockupPreview_loader__dRWlx","placeHolderShimmer":"MockupPreview_placeHolderShimmer__cO_mN","adminBtn":"MockupPreview_adminBtn__0nN48","adminBtnInverse":"MockupPreview_adminBtnInverse__stwGx","isLazy":"MockupPreview_isLazy__47h5K","blurhash":"MockupPreview_blurhash__kl8Ce","videoLoader":"MockupPreview_videoLoader__PxAjN","posterHidden":"MockupPreview_posterHidden__9sT_C"};

/***/ }),

/***/ 39268:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badges":"PreviewBadges_badges__Yg6YC","badge":"PreviewBadges_badge__BqqM_","scheduledBadge":"PreviewBadges_scheduledBadge__TmGaq"};

/***/ }),

/***/ 17763:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"Searchbar_searchContainer__nC7wC","open":"Searchbar_open__kT9Bx","wrapper":"Searchbar_wrapper__iZLmP","selectOptions":"Searchbar_selectOptions__lZbsd","icon":"Searchbar_icon__yA660","close":"Searchbar_close__vVMub","input":"Searchbar_input___5dsb","selector":"Searchbar_selector__MJJpm","selectOption":"Searchbar_selectOption__sLw9B","selected":"Searchbar_selected__qYXjl","searchOption":"Searchbar_searchOption__yMkvp","notResults":"Searchbar_notResults__qrPsd","divider":"Searchbar_divider__tj4wL"};

/***/ }),

/***/ 12221:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"BannerFullWidth_content__au9_V","btn":"BannerFullWidth_btn__zKnWz"};

/***/ }),

/***/ 51639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BfBanner_wrapper__yzcde","left":"BfBanner_left__uObg_","right":"BfBanner_right__osWA6","subtitle":"BfBanner_subtitle__kedpj","center":"BfBanner_center__5f1mN","close":"BfBanner_close__P1z7i"};

/***/ }),

/***/ 48056:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"Skeleton_skeletonWrapper__2zMTT"};

/***/ }),

/***/ 7863:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customerTestimonials":"CustomerTestimonials_customerTestimonials__z_3aI","single":"CustomerTestimonials_single__wKxVL","testimonialCol":"CustomerTestimonials_testimonialCol__iwJXR","testimonialBox":"CustomerTestimonials_testimonialBox__HD9Jz","inverse":"CustomerTestimonials_inverse__dWV4a","testimonialAvatar":"CustomerTestimonials_testimonialAvatar__IXyqf","testimonialAvatarImg":"CustomerTestimonials_testimonialAvatarImg__MBU6Q","testimonialAvatarPerson":"CustomerTestimonials_testimonialAvatarPerson__xdzy4","testimonialAvatarName":"CustomerTestimonials_testimonialAvatarName___YM_p","testimonialAvatarPosition":"CustomerTestimonials_testimonialAvatarPosition__jl_no","trustpilot":"CustomerTestimonials_trustpilot__qCtXK"};

/***/ }),

/***/ 88611:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"FeatureGrid_grid__uSjTv","gridSingle":"FeatureGrid_gridSingle__D_m4_"};

/***/ }),

/***/ 6181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"FeatureList_item__43JP9","icon":"FeatureList_icon__hZ_lr","contentNotAvailable":"FeatureList_contentNotAvailable__rFf3W"};

/***/ }),

/***/ 15908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"HelpscoutButton_button__zzYhC","active":"HelpscoutButton_active__UoTji"};

/***/ }),

/***/ 26865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topWrapper":"HomepageHeader_topWrapper__JL30l","bottomWrapper":"HomepageHeader_bottomWrapper__3i20y","row":"HomepageHeader_row__9Q2VL","content":"HomepageHeader_content__SY3it","title":"HomepageHeader_title__rn2Gf","titleSmaller":"HomepageHeader_titleSmaller__V_cyd","titleSmallest":"HomepageHeader_titleSmallest__2R743","searchTitle":"HomepageHeader_searchTitle__gTUvs","mockupsWrapper":"HomepageHeader_mockupsWrapper__jut6k","mockupsFirstRow":"HomepageHeader_mockupsFirstRow__8W7CQ","mockupsSecondRow":"HomepageHeader_mockupsSecondRow__O9_lL","mockupsEmptyTopRow":"HomepageHeader_mockupsEmptyTopRow__raQzc","mockupsEmptyBottomRow":"HomepageHeader_mockupsEmptyBottomRow__XHMoL","searchWrap":"HomepageHeader_searchWrap__C1aCN","filtersWrap":"HomepageHeader_filtersWrap__n_5B2"};

/***/ }),

/***/ 23176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"InstagramFeed_titleWrapper__MvUmd","description":"InstagramFeed_description__nYql_","grid":"InstagramFeed_grid__mSBth","item":"InstagramFeed_item__7l2s6","image":"InstagramFeed_image__1lswm"};

/***/ }),

/***/ 93565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IntegrationsOverview_wrapper__C89sz","iconWrapper":"IntegrationsOverview_iconWrapper__IqxG6","icon":"IntegrationsOverview_icon__LjR4X"};

/***/ }),

/***/ 98012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LargeDescription_wrapper__bgLdt","description":"LargeDescription_description__1h1O8","descriptionBlue":"LargeDescription_descriptionBlue__U2sLH LargeDescription_description__1h1O8"};

/***/ }),

/***/ 72293:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Masonry_wrapper__Nq9Ek","col":"Masonry_col___qib1","colMiddle":"Masonry_colMiddle__whtTo","image":"Masonry_image__LrWBX","imageWithShadow":"Masonry_imageWithShadow__13X49"};

/***/ }),

/***/ 99940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionTitle_wrapper__PICaV"};

/***/ }),

/***/ 98614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"ShortDescription_title__Pfm2i","description":"ShortDescription_description__q6yQ8","titleGrey":"ShortDescription_titleGrey__p92MP ShortDescription_title__Pfm2i","titleBlue":"ShortDescription_titleBlue__yB9lI ShortDescription_title__Pfm2i","descriptionBlue":"ShortDescription_descriptionBlue__LJMzQ ShortDescription_description__q6yQ8","icon":"ShortDescription_icon__yNxgY"};

/***/ }),

/***/ 20291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollectionModal_wrapper__IGLaK","left":"CollectionModal_left__KGIT_","right":"CollectionModal_right__F4BwE","buttonsGroup":"CollectionModal_buttonsGroup__JU0y8","wrapperForm":"CollectionModal_wrapperForm__4ivH5","disabled":"CollectionModal_disabled__Vv9BI","inputModal":"CollectionModal_inputModal__3KDWu","messages":"CollectionModal_messages__tbafo","error":"CollectionModal_error__oZMZp","success":"CollectionModal_success__o_tZt"};

/***/ }),

/***/ 72961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputLarge":"Login_inputLarge__Ybm3u","fullPageFormArea":"Login_fullPageFormArea__qnWrr","errorIcon":"Login_errorIcon__FX1Gk","inputLabel":"Login_inputLabel__lR1K_","inputLabelInner":"Login_inputLabelInner___a_kO","inputIconWrapper":"Login_inputIconWrapper__FlCZ4","error":"Login_error__uCL2U","button":"Login_button__ykbKs","inputIcon":"Login_inputIcon__WVcIW","inputIconRight":"Login_inputIconRight__58g9O","resendIcon":"Login_resendIcon__AJvKJ","link":"Login_link__uqKUx","formFooter":"Login_formFooter__w4ZZR","devider":"Login_devider__FHtw3","fieldsWrapper":"Login_fieldsWrapper__TC0we","loginCenter":"Login_loginCenter__4Fk_C","loginFormWrapper":"Login_loginFormWrapper___m9zV","loginHeader":"Login_loginHeader__4oPWH","loginHeaderTitle":"Login_loginHeaderTitle__uiJuV","loginHeaderSubtitle":"Login_loginHeaderSubtitle__8NxUH","loginFooter":"Login_loginFooter__cSmla","loginButton":"Login_loginButton__nMBwK","federatedLoginButton":"Login_federatedLoginButton___uSJE","centeredOneLiner":"Login_centeredOneLiner__3z_3S","signupButton":"Login_signupButton__4W4OA","iconRight":"Login_iconRight__WxKcF","loginSplitButtons":"Login_loginSplitButtons__hgEXC","loginError":"Login_loginError__hgPfb","loginNote":"Login_loginNote__3EYSa","loginPasswordResetBtn":"Login_loginPasswordResetBtn__TvDtr","signupLink":"Login_signupLink__xlJUA","loginSuccess":"Login_loginSuccess__1rao2","loginFormTwoCols":"Login_loginFormTwoCols__5Oxv1","btn":"Login_btn__50ZUn","loginFormThreeCols":"Login_loginFormThreeCols__o4FyG"};

/***/ }),

/***/ 13895:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notificationCenter":"NotificationCenter_notificationCenter__NrAry","notificationCenterBtn":"NotificationCenter_notificationCenterBtn__G5Ah4","label":"NotificationCenter_label__JaYUv","notificationCenterDropdownContent":"NotificationCenter_notificationCenterDropdownContent__WegaW","notificationCenterHeader":"NotificationCenter_notificationCenterHeader__olfRY","notificationCenterInner":"NotificationCenter_notificationCenterInner__z0XhU","notificationCenterScroll":"NotificationCenter_notificationCenterScroll__YGZ6c","notificationItem":"NotificationCenter_notificationItem__BQPDz","notificationHeader":"NotificationCenter_notificationHeader___ysLW","notification-highlight":"NotificationCenter_notification-highlight__9C_hv","notificationTtitle":"NotificationCenter_notificationTtitle__8WAZr","notificationDate":"NotificationCenter_notificationDate__vY1hg","notificationContent":"NotificationCenter_notificationContent__BERFJ","notificationImage":"NotificationCenter_notificationImage__fDvJC","notificationVideo":"NotificationCenter_notificationVideo__xO4AD","notificationCenterReadMore":"NotificationCenter_notificationCenterReadMore__EHF_p","badge":"NotificationCenter_badge__goUgP"};

/***/ }),

/***/ 77664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgradeBtn":"UpgradeBtn_upgradeBtn__kWnLw"};

/***/ }),

/***/ 87721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserAvatar_wrapper__mziAc","icon":"UserAvatar_icon__78j57","image":"UserAvatar_image__CgCbo"};

/***/ }),

/***/ 15514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserMenu_wrapper__Ovsi0","dropdown":"UserMenu_dropdown__XuEQB","dropdownItem":"UserMenu_dropdownItem__cECTN","logoutBtn":"UserMenu_logoutBtn__A1Hag","count":"UserMenu_count__z8K5N","upgradeLink":"UserMenu_upgradeLink__9L6NV","upgradeBtn":"UserMenu_upgradeBtn__3PTOS","userName":"UserMenu_userName__93d3Q"};

/***/ }),

/***/ 9151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserTrialExpiration_wrapper__V5WRh","upgradeButton":"UserTrialExpiration_upgradeButton__Yzej2"};

/***/ }),

/***/ 11903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"userTrialSliderTrack":"UserTrialSlider_userTrialSliderTrack__2PsUu","userTrialSlider":"UserTrialSlider_userTrialSlider__APgA9"};

/***/ }),

/***/ 37984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertsContainer_container__0sY6J container-large"};

/***/ }),

/***/ 71372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"Homepage_row__gzZD0","rowLargeMargin":"Homepage_rowLargeMargin__pgrMV Homepage_row__gzZD0","rowNoMargin":"Homepage_rowNoMargin__INf1L Homepage_row__gzZD0","rowBlue":"Homepage_rowBlue__1oibu Homepage_row__gzZD0","rowVideo":"Homepage_rowVideo__D6fG2 Homepage_row__gzZD0","half":"Homepage_half__MNm8F","contentLeft":"Homepage_contentLeft__f57Rr Homepage_half__MNm8F","contentRight":"Homepage_contentRight__cN_Dt Homepage_half__MNm8F","imageWrapper":"Homepage_imageWrapper__2SiDV Homepage_half__MNm8F","largeImage":"Homepage_largeImage__zPuAR","absoluteHalf":"Homepage_absoluteHalf__UBNxA","absoluteHalfOffset":"Homepage_absoluteHalfOffset__U5NX8","introVideo":"Homepage_introVideo__9zwmo"};

/***/ }),

/***/ 70563:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputLarge":"LoginPage_inputLarge__6KuWl","fullPageFormArea":"LoginPage_fullPageFormArea__EleDf","errorIcon":"LoginPage_errorIcon__jIW6Z","inputLabel":"LoginPage_inputLabel__asFIx","inputLabelInner":"LoginPage_inputLabelInner__IWgyq","inputIconWrapper":"LoginPage_inputIconWrapper__S5wjN","error":"LoginPage_error__TiRgM","button":"LoginPage_button__Z4yoI","inputIcon":"LoginPage_inputIcon__zDC8W","inputIconRight":"LoginPage_inputIconRight__fv6zz","resendIcon":"LoginPage_resendIcon__BeBnu","link":"LoginPage_link__j8Je_","formFooter":"LoginPage_formFooter__ZgzVy","devider":"LoginPage_devider__1I3gA","fieldsWrapper":"LoginPage_fieldsWrapper__jzBbG","loginCenter":"LoginPage_loginCenter__Zfx7e","loginFormWrapper":"LoginPage_loginFormWrapper__iy5u4","loginHeader":"LoginPage_loginHeader__T_Al3","loginHeaderTitle":"LoginPage_loginHeaderTitle__74BID","loginHeaderSubtitle":"LoginPage_loginHeaderSubtitle__n9ZsN","loginFooter":"LoginPage_loginFooter__fmg3P","loginButton":"LoginPage_loginButton__QE14t","federatedLoginButton":"LoginPage_federatedLoginButton__eCyYc","centeredOneLiner":"LoginPage_centeredOneLiner__k_YXP","signupButton":"LoginPage_signupButton__wt_mj","iconRight":"LoginPage_iconRight__z9j1f","loginSplitButtons":"LoginPage_loginSplitButtons__RuTAg","loginError":"LoginPage_loginError__VLwP1","loginNote":"LoginPage_loginNote__8aHSc","loginPasswordResetBtn":"LoginPage_loginPasswordResetBtn__zH0nh","signupLink":"LoginPage_signupLink__HA9FF","loginSuccess":"LoginPage_loginSuccess__QmcLR","loginFormTwoCols":"LoginPage_loginFormTwoCols__MqVs1","btn":"LoginPage_btn__iiXLw","loginFormThreeCols":"LoginPage_loginFormThreeCols__9rozk","loginContainer":"LoginPage_loginContainer__tjs9v","pageSlit":"LoginPage_pageSlit__X7flq","loginCol":"LoginPage_loginCol__7L0oP","signUpCta":"LoginPage_signUpCta__6xuQR","logoArea":"LoginPage_logoArea__gtjog","bottomWrapper":"LoginPage_bottomWrapper__5ih2m","bottomCta":"LoginPage_bottomCta__uFlsz","sep":"LoginPage_sep__YN9FD","testimonialCol":"LoginPage_testimonialCol__erfRn"};

/***/ }),

/***/ 24142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputLarge":"Forms_inputLarge__ncseJ","fullPageFormArea":"Forms_fullPageFormArea__dzUPI","errorIcon":"Forms_errorIcon__yQ0FG","inputLabel":"Forms_inputLabel__uP_7z","inputLabelInner":"Forms_inputLabelInner__Yje4W","inputIconWrapper":"Forms_inputIconWrapper__kjECk","error":"Forms_error__D_vNR","button":"Forms_button__b_Zdn","inputIcon":"Forms_inputIcon__EnVUo","inputIconRight":"Forms_inputIconRight__1GlHE","resendIcon":"Forms_resendIcon__tvqpL","link":"Forms_link__8NjUx","formFooter":"Forms_formFooter__DkqMp","devider":"Forms_devider__eiRKz","fieldsWrapper":"Forms_fieldsWrapper__MK7D5"};

/***/ }),

/***/ 28453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./af.json": 15567,
	"./am.json": 44138,
	"./ar-AE.json": 94677,
	"./ar.json": 79793,
	"./as.json": 48407,
	"./ast.json": 34315,
	"./az.json": 67471,
	"./be.json": 33374,
	"./bg.json": 12884,
	"./bn.json": 88168,
	"./br.json": 63805,
	"./bs-Cyrl.json": 91647,
	"./bs.json": 16752,
	"./ca.json": 98742,
	"./ccp.json": 30930,
	"./ce.json": 40471,
	"./chr.json": 57754,
	"./cs.json": 58993,
	"./cy.json": 39977,
	"./da.json": 18929,
	"./de.json": 53128,
	"./dsb.json": 42875,
	"./dz.json": 88493,
	"./ee.json": 5976,
	"./el.json": 52622,
	"./en-001.json": 86988,
	"./en-150.json": 54845,
	"./en-AG.json": 79033,
	"./en-AI.json": 76857,
	"./en-AT.json": 34230,
	"./en-AU.json": 13714,
	"./en-BB.json": 2900,
	"./en-BE.json": 85051,
	"./en-BM.json": 6628,
	"./en-BS.json": 4998,
	"./en-BW.json": 31641,
	"./en-BZ.json": 5251,
	"./en-CA.json": 68932,
	"./en-CC.json": 97965,
	"./en-CH.json": 39504,
	"./en-CK.json": 79491,
	"./en-CM.json": 45784,
	"./en-CX.json": 42206,
	"./en-CY.json": 90269,
	"./en-DE.json": 6069,
	"./en-DG.json": 94854,
	"./en-DK.json": 72125,
	"./en-DM.json": 48080,
	"./en-ER.json": 49477,
	"./en-FI.json": 89263,
	"./en-FJ.json": 733,
	"./en-FK.json": 6781,
	"./en-FM.json": 45646,
	"./en-GB.json": 7002,
	"./en-GD.json": 9196,
	"./en-GG.json": 18539,
	"./en-GH.json": 47919,
	"./en-GI.json": 91306,
	"./en-GM.json": 27500,
	"./en-GY.json": 35726,
	"./en-HK.json": 89955,
	"./en-IE.json": 29774,
	"./en-IL.json": 30682,
	"./en-IM.json": 32679,
	"./en-IN.json": 25206,
	"./en-IO.json": 35755,
	"./en-JE.json": 18182,
	"./en-JM.json": 66134,
	"./en-KE.json": 81084,
	"./en-KI.json": 84609,
	"./en-KN.json": 44390,
	"./en-KY.json": 81736,
	"./en-LC.json": 85746,
	"./en-LR.json": 19067,
	"./en-LS.json": 90522,
	"./en-MG.json": 46230,
	"./en-MO.json": 86845,
	"./en-MS.json": 91737,
	"./en-MT.json": 7146,
	"./en-MU.json": 73408,
	"./en-MW.json": 30669,
	"./en-MY.json": 5704,
	"./en-NA.json": 42222,
	"./en-NF.json": 83832,
	"./en-NG.json": 49031,
	"./en-NL.json": 47077,
	"./en-NR.json": 86119,
	"./en-NU.json": 91803,
	"./en-NZ.json": 66172,
	"./en-PG.json": 92395,
	"./en-PH.json": 78928,
	"./en-PK.json": 96343,
	"./en-PN.json": 37194,
	"./en-PW.json": 71418,
	"./en-RW.json": 19639,
	"./en-SB.json": 12455,
	"./en-SC.json": 58917,
	"./en-SD.json": 59532,
	"./en-SE.json": 79052,
	"./en-SG.json": 65275,
	"./en-SH.json": 72428,
	"./en-SI.json": 55597,
	"./en-SL.json": 78965,
	"./en-SS.json": 97440,
	"./en-SX.json": 28599,
	"./en-SZ.json": 41260,
	"./en-TC.json": 85618,
	"./en-TK.json": 19540,
	"./en-TO.json": 74818,
	"./en-TT.json": 61365,
	"./en-TV.json": 68399,
	"./en-TZ.json": 75784,
	"./en-UG.json": 20359,
	"./en-VC.json": 1225,
	"./en-VG.json": 72949,
	"./en-VU.json": 79794,
	"./en-WS.json": 53030,
	"./en-ZA.json": 15202,
	"./en-ZM.json": 80968,
	"./en-ZW.json": 19578,
	"./en.json": 67907,
	"./es-AR.json": 89641,
	"./es-MX.json": 13306,
	"./es-PY.json": 86779,
	"./es-SV.json": 95686,
	"./es-US.json": 72863,
	"./es.json": 49039,
	"./et.json": 13454,
	"./eu.json": 44974,
	"./fa.json": 7650,
	"./fi.json": 55962,
	"./fil.json": 13591,
	"./fo.json": 9163,
	"./fr-CA.json": 44943,
	"./fr.json": 93601,
	"./fur.json": 35165,
	"./fy.json": 89775,
	"./ga.json": 13734,
	"./gd.json": 84671,
	"./gl.json": 61867,
	"./gu.json": 36036,
	"./he.json": 13450,
	"./hi.json": 80178,
	"./hr.json": 63049,
	"./hsb.json": 74812,
	"./hu.json": 5994,
	"./hy.json": 7759,
	"./ia.json": 31695,
	"./id.json": 17079,
	"./is.json": 24631,
	"./it.json": 40604,
	"./ja.json": 93886,
	"./jgo.json": 76504,
	"./jv.json": 25378,
	"./ka.json": 79548,
	"./kea.json": 33236,
	"./kk.json": 27531,
	"./kl.json": 28546,
	"./km.json": 64029,
	"./kn.json": 98117,
	"./ko.json": 30497,
	"./kok.json": 987,
	"./ksh.json": 83176,
	"./ku.json": 4320,
	"./ky.json": 60387,
	"./lb.json": 71202,
	"./lkt.json": 40717,
	"./lo.json": 56881,
	"./lt.json": 70291,
	"./lv.json": 20337,
	"./mk.json": 21219,
	"./ml.json": 76413,
	"./mn.json": 6978,
	"./mr.json": 33456,
	"./ms.json": 78233,
	"./mt.json": 21205,
	"./my.json": 99093,
	"./mzn.json": 32460,
	"./nb.json": 33672,
	"./ne.json": 24153,
	"./nl.json": 30344,
	"./nn.json": 71277,
	"./or.json": 77156,
	"./pa.json": 45720,
	"./pl.json": 73552,
	"./ps.json": 70785,
	"./pt-AO.json": 83519,
	"./pt-CH.json": 78245,
	"./pt-CV.json": 64718,
	"./pt-GQ.json": 15821,
	"./pt-GW.json": 25829,
	"./pt-LU.json": 16251,
	"./pt-MO.json": 37703,
	"./pt-MZ.json": 86530,
	"./pt-PT.json": 67446,
	"./pt-ST.json": 61582,
	"./pt-TL.json": 65151,
	"./pt.json": 1824,
	"./qu.json": 32228,
	"./ro.json": 98546,
	"./ru.json": 57692,
	"./sah.json": 26224,
	"./sd.json": 5674,
	"./se-FI.json": 26959,
	"./se.json": 27468,
	"./si.json": 10364,
	"./sk.json": 10540,
	"./sl.json": 53472,
	"./so.json": 60449,
	"./sq.json": 21883,
	"./sr-Latn.json": 32079,
	"./sr.json": 90505,
	"./sv.json": 7111,
	"./sw.json": 62255,
	"./ta.json": 29434,
	"./te.json": 80991,
	"./th.json": 42181,
	"./ti.json": 49934,
	"./tk.json": 44545,
	"./to.json": 41086,
	"./tr.json": 19562,
	"./ug.json": 38213,
	"./uk.json": 89595,
	"./ur-IN.json": 10797,
	"./ur.json": 6363,
	"./uz-Cyrl.json": 82507,
	"./uz.json": 87012,
	"./vi.json": 82946,
	"./wae.json": 98912,
	"./yi.json": 92397,
	"./yue-Hans.json": 36160,
	"./yue.json": 56416,
	"./zh-Hans-HK.json": 92874,
	"./zh-Hans-MO.json": 69250,
	"./zh-Hans-SG.json": 20645,
	"./zh-Hant-HK.json": 15801,
	"./zh-Hant-MO.json": 75047,
	"./zh-Hant.json": 39290,
	"./zh.json": 50588,
	"./zu.json": 85625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28453;

/***/ }),

/***/ 227:
/***/ (function(module) {

module.exports = "/_next/static/images/gradientBgWithSymbol-75fd68f238c1eed58b7754d6c31b586c.jpg";

/***/ }),

/***/ 34988:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41ODQgMUMxMS45NTggMSAxMi4zMTY3IDEuMTQ4NzEgMTIuNTgxIDEuNDEzMzdMMTIuNTg3IDEuNDE5MzdDMTIuODUxNyAxLjY4MzY3IDEzLjAwMDQgMi4wNDIzNSAxMy4wMDA0IDIuNDE2MzdDMTMuMDAwNCAyLjc5MDQgMTIuODUxNyAzLjE0OTA4IDEyLjU4NyAzLjQxMzM3TDggOC4wMDAzN0w1IDkuMDAwMzdMNiA2LjAwMDM3TDEwLjU4NyAxLjQxMzM3QzEwLjg1MTMgMS4xNDg3MSAxMS4yMSAxIDExLjU4NCAxWk0zIDExLjAwMDRIMTBWOS4wMDAzN0gxMlYxMi4wMDA0QzEyIDEyLjU1MjcgMTEuNTUyMyAxMy4wMDA0IDExIDEzLjAwMDRIMkMxLjQ0NzcyIDEzLjAwMDQgMSAxMi41NTI3IDEgMTIuMDAwNFYzLjAwMDM3QzEgMi40NDgwOSAxLjQ0NzcyIDIuMDAwMzcgMiAyLjAwMDM3SDVWNC4wMDAzN0gzVjExLjAwMDRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ 79190:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 37851:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy41OTA2IDAuNDA5NDA2QzEzLjA0NDYgLTAuMTM2NDY5IDEyLjE1OTQgLTAuMTM2NDY5IDExLjYxMzQgMC40MDk0MDZMNy4wMDg3NiA1LjAxNDAzTDIuNDA0MTMgMC40MDk0MDZDMS44NTU0NiAtMC4xMjA1MTQgMC45ODMzMyAtMC4xMTI5MzYgMC40NDM5NTUgMC40MjY0MzlDLTAuMDk1NDE5NyAwLjk2NTgxNCAtMC4xMDI5OTggMS44Mzc5NSAwLjQyNjkyMiAyLjM4NjYxTDUuMDMxNTUgNi45OTEyNEwwLjQyNjkyMiAxMS41OTU5QzAuMDYzNDIyMiAxMS45NDY5IC0wLjA4MjM1OTggMTIuNDY2OCAwLjA0NTYwNyAxMi45NTU3QzAuMTczNTc0IDEzLjQ0NDYgMC41NTUzNzUgMTMuODI2NCAxLjA0NDI2IDEzLjk1NDRDMS41MzMxNSAxNC4wODI0IDIuMDUzMDUgMTMuOTM2NiAyLjQwNDEzIDEzLjU3MzFMNy4wMDg3NiA4Ljk2ODQ1TDExLjYxMzQgMTMuNTczMUMxMi4xNjIxIDE0LjEwMyAxMy4wMzQyIDE0LjA5NTQgMTMuNTczNiAxMy41NTZDMTQuMTEyOSAxMy4wMTY3IDE0LjEyMDUgMTIuMTQ0NSAxMy41OTA2IDExLjU5NTlMOC45ODU5NyA2Ljk5MTI0TDEzLjU5MDYgMi4zODY2MUMxNC4xMzY1IDEuODQwNTcgMTQuMTM2NSAwLjk1NTQ0NSAxMy41OTA2IDAuNDA5NDA2WiIgZmlsbD0iI0ZGMDAxRiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 21194:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkgKDUxMDAyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5BIENvcHk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iV2ViLS0tRnJlZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IldlYi0tLUZyZWUtLS1WeXBpcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0Mi4wMDAwMDAsIC0zNzYuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJCYWRnZS0tLVByZW1pdW0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM0Mi4wMDAwMDAsIDM3Ni4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJBLUNvcHkiPgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJCdXR0b24iIGZpbGw9IiNGNkM0MjMiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjIiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTAsOCBDOS4yNzEsOCA4LjU4OSw4LjE5OSA4LDguNTQxIEw4LDcgQzgsNS44OTcgOC44OTcsNSAxMCw1IEMxMS4xMDMsNSAxMiw1Ljg5NyAxMiw3IEwxMyw3IEMxMyw1LjM0NTUgMTEuNjU0NSw0IDEwLDQgQzguMzQ1NSw0IDcsNS4zNDU1IDcsNyBMNyw5LjM2MyBDNi4zNzk1LDEwLjA2OCA2LDEwLjk4OTUgNiwxMiBDNiwxNC4yMDU1IDcuNzk0NSwxNiAxMCwxNiBDMTIuMjA1NSwxNiAxNCwxNC4yMDU1IDE0LDEyIEMxNCw5Ljc5NDUgMTIuMjA1NSw4IDEwLDggWiBNMTAuNSwxMi45MDggTDEwLjUsMTQgTDkuNSwxNCBMOS41LDEyLjkwOCBDOC45MTk1LDEyLjcwMSA4LjUsMTIuMTUxIDguNSwxMS41IEM4LjUsMTAuNjczIDkuMTczLDEwIDEwLDEwIEMxMC44MjcsMTAgMTEuNSwxMC42NzMgMTEuNSwxMS41IEMxMS41LDEyLjE1MSAxMS4wODA1LDEyLjcwMSAxMC41LDEyLjkwOCBaIiBpZD0iU2hhcGUiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNiIgZmlsbD0iI0Y2QzQyMyIgeD0iMTEiIHk9IjYiIHdpZHRoPSIyIiBoZWlnaHQ9IjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 72608:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 12083:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 98429:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgODAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTIuMiAoNjcxNDUpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkljb24gLyBNZWRpdW0gLyBCYWRnZSAvIFNjaGVkdWxlZDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJJY29uLS8tTWVkaXVtLS8tQmFkZ2UtLy1TY2hlZHVsZWQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IGlkPSJCdXR0b24iIGZpbGw9IiMwMDQxRkYiIHg9IjAiIHk9IjAiIHdpZHRoPSI4MCIgaGVpZ2h0PSIyMCIgcng9IjIiPjwvcmVjdD4KICAgICAgICA8cGF0aCBkPSJNMjMuMzMsNi45MyBDMjQuMzEsNi45MyAyNS4yOSw3LjIzIDI1Ljk5LDcuNjkgTDI1LjM4LDkgQzI0LjY0LDguNTYgMjMuNzYsOC4yOCAyMy4yLDguMjggQzIyLjY3LDguMjggMjIuMzEsOC40NyAyMi4zMSw4Ljg1IEMyMi4zMSwxMC4xNCAyNi4wNCw5LjQyIDI2LjAzLDExLjk0IEMyNi4wMywxMy4zMSAyNC44NCwxNC4wNSAyMy4yOSwxNC4wNSBDMjIuMTQsMTQuMDUgMjAuOTksMTMuNjEgMjAuMiwxMi45NCBMMjAuODMsMTEuNjUgQzIxLjU1LDEyLjI5IDIyLjU3LDEyLjcgMjMuMzEsMTIuNyBDMjMuOTYsMTIuNyAyNC4zNSwxMi40NiAyNC4zNSwxMi4wMyBDMjQuMzUsMTAuNzEgMjAuNjIsMTEuNDggMjAuNjIsOSBDMjAuNjIsNy43MyAyMS43MSw2LjkzIDIzLjMzLDYuOTMgWiBNMjkuNDEsOC41NyBDMzAuNDQsOC41NyAzMS4yNiw4Ljk4IDMxLjc0LDkuNyBMMzAuNywxMC40NSBDMzAuNDEsMTAuMDkgMzAsOS44NyAyOS40Nyw5Ljg4IEMyOC43Miw5Ljg4IDI4LjE5LDEwLjQ2IDI4LjE5LDExLjMyIEMyOC4xOSwxMi4xOSAyOC43MiwxMi43OCAyOS40NywxMi43OCBDMzAuMDIsMTIuNzggMzAuNDUsMTIuNTcgMzAuNzIsMTIuMTUgTDMxLjc4LDEyLjg3IEMzMS4zMywxMy42MiAzMC40OSwxNC4wNiAyOS4zOSwxNC4wNiBDMjcuNzYsMTQuMDYgMjYuNjUsMTIuOTYgMjYuNjUsMTEuMzMgQzI2LjY1LDkuNjggMjcuNzYsOC41NyAyOS40MSw4LjU3IFogTTM2LjE5LDguNTYgQzM3LjQsOC41NiAzOC4xNyw5LjM2IDM4LjE3LDEwLjYyIEwzOC4xNywxNCBMMzYuNjMsMTQgTDM2LjYzLDExLjA3IEMzNi42MywxMC4zOSAzNi4yMyw5Ljk3IDM1LjU3LDkuOTcgQzM0LjgsOS45OCAzNC4zMywxMC41NiAzNC4zMywxMS4zNSBMMzQuMzMsMTQgTDMyLjc5LDE0IEwzMi43OSw2LjU4IEwzNC4zMyw2LjU4IEwzNC4zMyw5LjU3IEMzNC43MSw4LjkgMzUuMzUsOC41NyAzNi4xOSw4LjU2IFogTTQxLjgsOC41NyBDNDMuNjksOC41NyA0NC41Nyw5LjgyIDQ0LjQ0LDExLjc4IEw0MC41OCwxMS43OCBDNDAuNzYsMTIuNDYgNDEuMjgsMTIuODYgNDEuOTcsMTIuODYgQzQyLjQ4LDEyLjg2IDQyLjk2LDEyLjY2IDQzLjMzLDEyLjI5IEw0NC4xNCwxMy4xMSBDNDMuNiwxMy43MSA0Mi44MSwxNC4wNiA0MS44NCwxNC4wNiBDNDAuMTIsMTQuMDYgMzkuMDMsMTIuOTYgMzkuMDMsMTEuMzMgQzM5LjAzLDkuNjcgNDAuMTYsOC41NyA0MS44LDguNTcgWiBNNDAuNTUsMTAuODcgTDQzLDEwLjg3IEM0Mi45OCwxMC4xNiA0Mi41Miw5LjcgNDEuODEsOS43IEM0MS4xMyw5LjcgNDAuNjcsMTAuMTYgNDAuNTUsMTAuODcgWiBNNTAuNzcsNi41OCBMNTAuNzcsMTQgTDQ5LjI0LDE0IEw0OS4yNCwxMy4yMSBDNDguODYsMTMuNzYgNDguMjgsMTQuMDYgNDcuNTQsMTQuMDYgQzQ2LjAxLDE0LjA2IDQ1LDEyLjk1IDQ1LDExLjI5IEM0NSw5LjY1IDQ2LDguNTYgNDcuNSw4LjU2IEM0OC4yNiw4LjU2IDQ4Ljg1LDguODYgNDkuMjQsOS40MSBMNDkuMjQsNi41OCBMNTAuNzcsNi41OCBaIE00Ny45LDEyLjgyIEM0OC42OSwxMi44MiA0OS4yNCwxMi4yMSA0OS4yNCwxMS4zMyBDNDkuMjQsMTAuNDUgNDguNjksOS44NCA0Ny45LDkuODQgQzQ3LjEsOS44NCA0Ni41NSwxMC40NiA0Ni41NCwxMS4zMyBDNDYuNTUsMTIuMjEgNDcuMDksMTIuODIgNDcuOSwxMi44MiBaIE01Ny40Miw4LjYyIEw1Ny40MiwxNCBMNTUuODksMTQgTDU1Ljg5LDEzLjA1IEM1NS41MiwxMy43MyA1NC45LDE0LjA2IDU0LjA5LDE0LjA2IEM1Mi45LDE0LjA2IDUyLjE1LDEzLjI3IDUyLjE1LDEyIEw1Mi4xNSw4LjYyIEw1My42OSw4LjYyIEw1My42OSwxMS41NiBDNTMuNjksMTIuMjQgNTQuMDgsMTIuNjUgNTQuNywxMi42NSBDNTUuNDQsMTIuNjQgNTUuODksMTIuMDYgNTUuODksMTEuMjggTDU1Ljg5LDguNjIgTDU3LjQyLDguNjIgWiBNNjAuNSwxNCBMNTguOTYsMTQgTDU4Ljk2LDYuNTggTDYwLjUsNi41OCBMNjAuNSwxNCBaIE02NC4zNSw4LjU3IEM2Ni4yNCw4LjU3IDY3LjEyLDkuODIgNjYuOTksMTEuNzggTDYzLjEzLDExLjc4IEM2My4zMSwxMi40NiA2My44MywxMi44NiA2NC41MiwxMi44NiBDNjUuMDMsMTIuODYgNjUuNTEsMTIuNjYgNjUuODgsMTIuMjkgTDY2LjY5LDEzLjExIEM2Ni4xNSwxMy43MSA2NS4zNiwxNC4wNiA2NC4zOSwxNC4wNiBDNjIuNjcsMTQuMDYgNjEuNTgsMTIuOTYgNjEuNTgsMTEuMzMgQzYxLjU4LDkuNjcgNjIuNzEsOC41NyA2NC4zNSw4LjU3IFogTTYzLjEsMTAuODcgTDY1LjU1LDEwLjg3IEM2NS41MywxMC4xNiA2NS4wNyw5LjcgNjQuMzYsOS43IEM2My42OCw5LjcgNjMuMjIsMTAuMTYgNjMuMSwxMC44NyBaIE03My4zMiw2LjU4IEw3My4zMiwxNCBMNzEuNzksMTQgTDcxLjc5LDEzLjIxIEM3MS40MSwxMy43NiA3MC44MywxNC4wNiA3MC4wOSwxNC4wNiBDNjguNTYsMTQuMDYgNjcuNTUsMTIuOTUgNjcuNTUsMTEuMjkgQzY3LjU1LDkuNjUgNjguNTUsOC41NiA3MC4wNSw4LjU2IEM3MC44MSw4LjU2IDcxLjQsOC44NiA3MS43OSw5LjQxIEw3MS43OSw2LjU4IEw3My4zMiw2LjU4IFogTTcwLjQ1LDEyLjgyIEM3MS4yNCwxMi44MiA3MS43OSwxMi4yMSA3MS43OSwxMS4zMyBDNzEuNzksMTAuNDUgNzEuMjQsOS44NCA3MC40NSw5Ljg0IEM2OS42NSw5Ljg0IDY5LjEsMTAuNDYgNjkuMDksMTEuMzMgQzY5LjEsMTIuMjEgNjkuNjQsMTIuODIgNzAuNDUsMTIuODIgWiIgaWQ9IlNjaGVkdWxlZCIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgIDxwYXRoIGQ9Ik05LjM3NSwxNSBDOS4yMTUsMTUgOS4wNTUsMTQuOTM4NzUgOC45MzMxMjUsMTQuODE2ODc1IEw3LjY4MzEyNSwxMy41NjY4NzUgTDguNTY2ODc1LDEyLjY4MzEyNSBMOS4zNzUsMTMuNDkxMjUgTDExLjQzMzEyNSwxMS40MzMxMjUgTDEyLjMxNjg3NSwxMi4zMTY4NzUgTDkuODE2ODc1LDE0LjgxNjg3NSBDOS42OTUsMTQuOTM4NzUgOS41MzUsMTUgOS4zNzUsMTUgWiBNMTQuMzc1LDYuMjUgQzE0LjcyLDYuMjUgMTUsNi41MyAxNSw2Ljg3NSBMMTUsMTQuMzc1IEMxNSwxNC43MiAxNC43MiwxNSAxNC4zNzUsMTUgTDEzLjEyNSwxNSBMMTMuMTI1LDEzLjc1IEwxMy43NSwxMy43NSBMMTMuNzUsOS4zNzUgTDYuMjUsOS4zNzUgTDYuMjUsMTMuNzUgTDYuODc1LDEzLjc1IEw2Ljg3NSwxNSBMNS42MjUsMTUgQzUuMjgsMTUgNSwxNC43MiA1LDE0LjM3NSBMNSw2Ljg3NSBDNSw2LjUzIDUuMjgsNi4yNSA1LjYyNSw2LjI1IEw2Ljg3NSw2LjI1IEw2Ljg3NSw1IEw4Ljc1LDUgTDguNzUsNi4yNSBMMTEuMjUsNi4yNSBMMTEuMjUsNSBMMTMuMTI1LDUgTDEzLjEyNSw2LjI1IEwxNC4zNzUsNi4yNSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 94463:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzVweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMzUgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDQuMSAoNDE0NTUpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkJhZGdlX05ldzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCYWRnZV9OZXciPgogICAgICAgICAgICA8cmVjdCBpZD0iQnV0dG9uIiBmaWxsPSIjNEZDQTMyIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHg9IjAiIHk9IjAiIHdpZHRoPSIzNSIgaGVpZ2h0PSIyMCIgcng9IjIiPjwvcmVjdD4KICAgICAgICAgICAgPHBhdGggZD0iTTEzLjExLDEzIEwxMy4xMSw2IEwxMS42MSw2IEwxMS42MSwxMC41IEw4LjIxLDYgTDYuNzcsNiBMNi43NywxMyBMOC4yOCwxMyBMOC4yOCw4LjUxIEwxMS42NywxMyBMMTMuMTEsMTMgWiBNMTYuOTMsNy41NyBDMTguODIsNy41NyAxOS43LDguODIgMTkuNTcsMTAuNzggTDE1LjcxLDEwLjc4IEMxNS44OSwxMS40NiAxNi40MSwxMS44NiAxNy4xLDExLjg2IEMxNy42MSwxMS44NiAxOC4wOSwxMS42NiAxOC40NiwxMS4yOSBMMTkuMjcsMTIuMTEgQzE4LjczLDEyLjcxIDE3Ljk0LDEzLjA2IDE2Ljk3LDEzLjA2IEMxNS4yNSwxMy4wNiAxNC4xNiwxMS45NiAxNC4xNiwxMC4zMyBDMTQuMTYsOC42NyAxNS4yOSw3LjU3IDE2LjkzLDcuNTcgWiBNMTUuNjgsOS44NyBMMTguMTMsOS44NyBDMTguMTEsOS4xNiAxNy42NSw4LjcgMTYuOTQsOC43IEMxNi4yNiw4LjcgMTUuOCw5LjE2IDE1LjY4LDkuODcgWiBNMjcsMTMgTDI4Ljk2LDcuNjIgTDI3LjQ0LDcuNjIgTDI2LjI2LDExLjQ3IEwyNS4wOCw3LjYyIEwyMy41Nyw3LjYyIEwyMi40MSwxMS40NyBMMjEuMjEsNy42MiBMMTkuNjQsNy42MyBMMjEuNjEsMTMgTDIzLjE1LDEzIEwyNC4zLDkuNDUgTDI1LjQ2LDEzIEwyNywxMyBaIiBpZD0iTmV3IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 25754:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTIuMSAoNjcwNDgpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPlNoYXBlPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IldlYi0tLU1haW4iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIG9wYWNpdHk9IjAuMzk3Mjc0OTI2Ij4KICAgICAgICA8ZyBpZD0iQkYtLS1CYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjU3LjAwMDAwMCwgLTcuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTE2NjUsNyBDMTY2MC41ODE3Miw3IDE2NTcsMTAuNTgxNzIyIDE2NTcsMTUgQzE2NTcsMTkuNDE4Mjc4IDE2NjAuNTgxNzIsMjMgMTY2NSwyMyBDMTY2OS40MTgyOCwyMyAxNjczLDE5LjQxODI3OCAxNjczLDE1IEMxNjcyLjk4NzE4LDEwLjU4NzA0MTEgMTY2OS40MTI5Niw3LjAxMjgxNTE1IDE2NjUsNyBaIE0xNjY4LjMsMTcuMzU3MzMzMyBMMTY2Ny4zNTczMywxOC4zIEwxNjY1LDE1Ljk0MjY2NjcgTDE2NjIuNjQyNjcsMTguMyBMMTY2MS43LDE3LjM1NzMzMzMgTDE2NjQuMDU3MzMsMTUgTDE2NjEuNywxMi42NDI2NjY3IEwxNjYyLjY0MjY3LDExLjcgTDE2NjUsMTQuMDU3MzMzMyBMMTY2Ny4zNTczMywxMS43IEwxNjY4LjMsMTIuNjQyNjY2NyBMMTY2NS45NDI2NywxNSBMMTY2OC4zLDE3LjM1NzMzMzMgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 68839:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 22078:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 37684:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 50331:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBARXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAMqADAAQAAAABAAAAMgAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAMgAyAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAwMDAwMDBgMDBggGBgYICwgICAgLDgsLCwsLDhAODg4ODg4QEBAQEBAQEBQUFBQUFBcXFxcXGhoaGhoaGhoaGv/bAEMBBAQEBwYHCwYGCxsSDxIbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbG//dAAQABP/aAAwDAQACEQMRAD8A/VB3SJDJIQqqMkngADua+WvjR+0D/wAIZZC08NBTcTkhJpBkADqyqf0zn6V6X8Rdfk3DQbRsDAaYjvnkL/U/hX5wftQ3c1pqmkKB8hidsjrkGuWtUbvCJvSgrqUjq9V1j4lePrE3+o3FxfRMfljikKg45xgnGPoK53wV4I+Kl14jjvNMFzp/lSBmKu0eF9yCK9N+D+opB4StJr1XZpBuVVGSc9PxNfS+heL9L1bSZrqwSV2tyUaLaA5YHGBzjrxXnUINOR7FVLlieI2P7RnjvwJ4gfRvF0I1K2ifZKpws8eO6OOGBHIDDn1FfbXhXxZoPjTRYte8Ozie3l4yOGRh1V16qw7g/Xpg18K+IrVPFPiS7voLULFcwQsC2Cc4YEg49q6b4Qxal8OPEnmCVvsF4QlzEfuj+649CpP4jIr06EpW948WuoxlZM+5qKOvIoroMj//0PrjV52vtRnu36yOzfhnj9K8s+I3w8h8c6WtuYfMYJtyv3hg5Br1m9tWt7iSF+CjFT+Br588XfHG40jUV0TwiiPLvEJmbDfMxx8o6cHua8mUoq/Oe9lmDr15/wCzpab32t5m18HPs+naXDoepx5a3IQEjBDIcDPuK9Im1rTNI8crpqvHCsybpBwAc9OnA59e5r5Y0/4hLBq0us3BkaGK5kiuCmNwcH75A7MDmvcbVfAVzYjxNHfwPa7d8peQ7z7cfeJPY96xg5JuDOmEYP3r9Ct8U/FF1YeLhb6Ns/d26KwHU8k9PQZrzb/hN/Ezvg7cV846j4vl1/xhda5bNJHH5rRwLuOQqk4FfVv7PvxB0u314eHPF9vBc2984WKedFZopTwoLMPut09jg+tenSxCTUGjPE8MVZ4d4ujK+l7f5fI+s9B+I0/9h2X2lA0n2eLeeeW2DJ/Otb/hYx/55L+tehLoujqoVbWEAcABF/wpf7G0n/n2i/74H+Fdd0fLck+5/9H7I+N14ng7RrvxHj5JUKr7SMMf/X/Ovyn0jVjd+N9Oglbg3SHn0GT/ADr9vPGHhHRPHXhy68L+IY/MtbpNrYOGUjlXQ9mU8g/0r8hvil+z14++DvjC21tIpNR0RbhSt/CmQiscfvlGTGRnkn5T2OeBw1MP+85+h9RlmZU6eDqUFpN/irafcZ1x4gs/AHiddRvo2mstQG2WNBuPmR9OD1yCR+Fbep2FjJFfeKTbrbeXGXCAYCEjIHpkDr7/AErL1TTB4g17TYIQJD5/2rbjptzuDf7r9fatP4kypY+CryBJP9bgfUZySfrXqKhFSlVSPnVWcowo+Z4j4cj2xLK/LMOB9ev5n9K+h/hb4Tv/ABx4mtPD1huHmyfvJVH+rjTl3/4COB6nA715b8JPhr41+I0iW/hezefcwDzkbYYV9Xc8DjnHU9ga/XT4R/CTRvhTof2K1b7RezAfaLkjBYj+FR2QH8SeT2A8iFJzld7H6RjM7pYHDcsHebWi7eb/AK1PWUUIgQZ4GOadRRXon5lc/9L9UqQgMCrDIPUUtFAHyb8avDvh/TdQa806xtreZ7clpIokRmJYZJYAE5rw/wAB6Fomva/a2OuWdvewPc4aO4jWVCN68FXBBFfRHx3/ANeP+vb/ANmrwz4W/wDI02f/AF9f+zrXVH+GxL4kfoFY2FhpdqljpkEdvBGMJFEoRFHoFUACrdFFcqNKnxMKKKKCD//Z"

/***/ }),

/***/ 25586:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 22646:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 74484:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 81744:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 94595:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 4456:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 35158:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBARXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAZKADAAQAAAABAAAAZAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAZABkAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAwMDAwMDBgMDBggGBgYICwgICAgLDgsLCwsLDhAODg4ODg4QEBAQEBAQEBQUFBQUFBcXFxcXGhoaGhoaGhoaGv/bAEMBBAQEBwYHCwYGCxsSDxIbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbG//dAAQAB//aAAwDAQACEQMRAD8A/VKiignHJoAKhlmWJC3XFZdhqX9omcoAEilaIY5zt4Jpuqyyw2TvCjO2OAoyatR1syOdcvMjmtT1u+83yvOEKnOAOOnXnrVbT/EllbbnuLjzMHaxLZxxmvIfHU+tQaYLpnQtyVVSAz7hgEbuxGQR1yOhr4u13xnceex0+4eJ+jKG4+nt9P1rslBJWsefGcm+a590+MPjdpej2sxsR5syMAqeob7uOeh7nt+IrwTUf2kvGSyR/wBnSJG4JY4UPGy+m0jII+vPP0Hyfd6vfXke+e5WFV4LOc/l1JrltT8SRKhOnu7nu4XYv5c1NlsjVOW7P0A8O/taXdpMF8XWkU9uTnzbY7XUfQkq2PT5frX1b4J+I3g34hWRvfCl7Hc7B+8iztlj/wB9DyPr0PYmvwkl1u9kJYseRg1Z0HxV4h8M6tDrnh+6ls7uFt0csbYIPcehB7g5BHBFZypxexpCpJbn9BNFfJv7PX7TOmfFJE8LeKfLtNfRTtC/LHdBRktH6OByyfivGQv1lXO1bRnSnfUKKKKQz//Q/VLpyawL3V40jYxEHA4JNUfF2rnTrEQRHEkxx9FHX8+leZS307x4ByD6V0UqSa5mc1aq0+WJr+GbuTRPOto5A0buXO/oCepHpXN/Er4qS+G9JaS2dIi4zHIOQ2CQV54B789ahu0um0y4+zDdIY2wM4zx0z2r4G+IU2tXl0y3Ec5XJADoMfge/wCVbTcb8zRhSjKygnZGP4p8ea9rtw/2i/lkjBOBnaME+i4FeevHBO+FDSSE9epH5mtyz8K60+y7v7aS3t5IzJGzgjzFBxkZ7ZqaXSBbxkkeXEu7cR1J9K5Z4j3rN6nfDDe5e2hyN3HaBha7A8rdy27H5cVy8tk8s52ZZQfwrUbU7O0kYJGd7k5JPb0qlJ4g+zeaLXGZvvjGffj0rW5yW12MyRhCxULgk/UU2eKQweYoOFPWmQaiY5PMkUMegB6D3qzcahJfqsTdR3HGfc0XG73I9Mnv7C9i1GwkeCeB1kikjba6upyGUjkEHoRX7O/s7fGWP4teEANTZV1jTwsd6gAG/P3ZlHo+OQOjZ7Yr8XJiYVCv94dcHg//AF69X+B3xSuPhl8RrPxEzMbVmEF2o53W8hAfjvt4Ye6is5K5pCVtT9z6KjhliniWeBg6OAysDkEHkEH0NSVkbn//0e9+Nvx31uz+It9oGlukdnZSC3MhGTlAPMP4OWH4Vztj8dPL0F7l8NcK+AGJ+cdBj09a+OvFOu3mreKNS1aeQk3V5POe/MkjN/WqkN25RUkJBOTkVrGTSsROEZM/Rj4Z/FsappzHViHlViSQR36DFexx+HvDepuL66tV3t8xQ9OfUe9flL4R8UTeHtSEokIAcSANypIORkV93/Dr4mweILpI2k3SSnnH6/h6Valcy5bM1/ivpkWqa3brGNscFsse0cD7xOB9M18rfEhW0fTZJUQhCeeOrGvVfH/xb13wX4/utJ8QWCSafMVa2kBwzRkD5gTwSCCCK2NQm8G/E/Qja2rY3DJGAGU/jXizc41XUmtLnvJQlRVOD1Pznurhppd1VSCBuNe2+NfhRdeGreW63ZQN8hx/CfWvFyr7TEw5HavUhUU1dHjzpOD5WRCRFOWqxFcBCTjPevbvAtnqo1K00Lw3bRLJejM1zLEk2BwDkOp2ovoOuee1U/iz4AfR9Tk1LR4EWONUF8kA/dxTnIJVeoRiMgdulZLELm5DpngWqftLnjpk8wEE8dce9RB/LzjrjFV8kUFsnmt7nIon7e/steM38a/BXSrm4ffPYBrCU+8Bwn4+UUzX0NX4w/BH4yal8PfClxotkxVZbx5zg45aONf/AGWvYv8Ahp/Xf+eh/wC+qixdz//S+N71Ht72S1l5aORlOfUEjmq7tL9/P4e1er/GTwNqHhz4j+IoDC4t4dRlZXA+UJMxkjBPbKMK8mUlCQ/0qk7kyi1uV/MZjk+v419Mfs93X/FTCJjyFyHPavmORkY4PBFenfCPUZoPG9lGZ2t42f52Q4wo5Oc9sVadtWZyTeiPsX41+FG8b6vYWlrJGotlIkLnjk7iP0rkfBHgBPDDC8WZjvJLKT8o/wB32rc8R63p95K+uaZcRMA+5493zY7/AJCvPtU8cPpV+9qCWT+E+xrwHOpUm10Z9U6NOEFbdHoXxDvtMbw7cWl3g5Q4z1zivjv4eaXYXviF/wC0RuiQE8/WvWLu/m8VSmOVjs6cVHo3hOLSNTaWEblkHb17g11U/ci4tnn1VzzjK2xf8WeHJda1mCPwZYC3g022Wae5DFB5jH5TuJxwoHT8ayPEfiJGv9Qg8wTJcxqZCOQXOfz9axNY8Z+LfC2ptp1jdMIF3+UjfMqiTrhTkVyWjxT6hdN5zAmU5Zm9+9EYP4pG8qq5eWJ5jdxGGZk9DVYKTwBmvreH4NaNe2gmDmWRh2NS6J8ELa2f7Rcq788elayx1OK1PN+pzb0Pn/w74T1XVrFrqBJAocrwD6A/1re/4QDW/wC7L+R/wr9Ufgn8MdJg8Gs9/CB5tzI0YwPuBVX/ANCU169/wrnw1/zxH5CqjiZNJqInQinZyP/T9y/ay8NaVp1kdfggxca48dpNKM4LxKSue2di4H+7X5f6oxS4MWMFeD9a/e/x74N07x74XuPDmogYkAaJyP8AVyryjD6Hr6gkd6/FD4oeB9X8F+Irmx1SExsshB4yAfr6HqD3FZwSjJ+ZrVm5xin00PJXMh+9X0n+zX4eXVfEl1qd1CJLe3i2ksMjex4H5V83GXcdvXFfTHwR+Jfg/wAEaVcafrPnLNcSh98a7lxjGMdeK2lGUk+UwjKMWnPY9B+N3hPw1oNvYajpGlx2wkut1zPDlchRwhwcANnP4Vy9xHonim1+0aUwZl4KnqvtX1jbX+neI/Dz3mlCG/jmiZoklAKO2PlVgemT1zXwGuo3WjeKLye4jW1n85luLeNQiI2eVCjgAe1efODvZ6NHq0qml4u6Z3mj240uXypexrr21G1aMkYz2wa5m6EUlp9suG2gjORXkWr+KXhnK2j5Cnisox52azkorU6D4mLH5kVwPvOcCuf0GK7adRCOfSuOvNXu9TnWS8ctt+6Owr2HwXPZSFZLkYIHGeAfxraouSFjKlLmk2ey+GLvULKNWuFOB1Br2TR9ft9QMdoiEyMwRQByzNwAB6mvNtKvbeZAhAx0r3/4G+GoNe1+bxR5WbLTWMUMrdJbno+z1WIcFu7nA+6a81UHVlyo6p1VTXMz6m0PThpOkW+nDGYowGx03dW/XNatFFe8kkrI8Nu7uz//1P1Sr50/aF+E194+8LT6h4TiibWYY8IsgGJkHVMngPj7hPHY8cj6LopOKe402tj+da+s7ywvZdP1KF4LiJ2jkidSrq6nBVlOCCD1FFtYXV3L5UUfPbnGT6D3r9pfjF+zp4M+LBOrlRYayqgLexqD5gHRZl43jsDww9ccV+dnj74SeM/hjI0XiWwb7MGwl3CC9u3oQ4Hyk9gwDe1dtHlm7NnHWUor3S/+znc6vpnidtEuBcRx3ELyPFICY8pjDA+tVfjnb2PhXx1Nqc1qxXUoxIJOxkAAP48DiuE0nxtrvh27S4s52G0/KxPX2NfQumePvBPxV05fDXjuGMSEjaxO0bvUMOVNPG4PmftKWqtquv8AwSMDjuROlW0d9H0/4B8j6j4sv9aVNPtwxzgBR3NeiaN+z1431i2XUNUlgsInXePMJZsYzyBwOPevsLQ/hn4E8MtHLpWnQCRDlZWUO/1DGvN/2jPF02h+FI9Fs3KzapJ5RIPIhXBf88hfoTXjqprywVj2uRvWbPjrU/DdppGqtZ2l7HfRqAfNjBVTn0B5/GvQLC+s7a3iSDAI+8DXkMEOq6rq0Fho0MtzcyNiOKFC7uT2CqCTwOgr76+Df7I/iTWTFrnxTB021yGFjG2Z5B/tkZEQPpkv2+U81c4OSRcKkKbaQ74NeBNZ+It8DbhrfTITi4usdDj7kZPVz+S9T2B/RbRdG0zw9pNvomjQrBa2qCOKNegUe/Uk9STyTyeaXR9G0rw/pkOjaJbx2trAu2OKMYVR/iepJ5J5PNaVXSpKC0OatWc2FFFFamJ//9X9UqKKKACo5oYriJoJ1V0cEMrDIIPUEHgipKKAPAfF37Mfwb8Xu9xPpf2GeTrLYOYPx2DMWffZX59fFr4PeHPh3qjW2h3N44UnBneNjx/uxrX7B1+an7S//Idf6tXVQm+5yV4rsZv7P/iDVtejl0fVZjLFbj92T94DPTPpX0zefs3fDz4h6rFr/i5726+zII47YTCOHB+Yn5FV8k9fnr5N/Zn/AOQjefT+tfpf4W/49H+q/wAhWOMilXdl0Nsvk3h1d9X+ZT8I/DvwN4Ct/s3g/SrawBG1niQeYwH9+Q5dv+BMa7OiiszUKKKKACiiigD/2Q=="

/***/ }),

/***/ 18902:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 74585:
/***/ (function(module) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 80020:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMTEgMTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkgKDUxMDAyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5BcnRib2FyZDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJBcnRib2FyZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFjdGl2ZSIgZmlsbD0iI0RCREJEQiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTkuMzUsNy41IEM5LjM1LDkuMzE1IDExLDkuNzU1IDExLDEwLjggQzExLDExLjczNSA4Ljg1NSwxMi40NSA1LjUsMTIuNDUgQzIuMTQ1LDEyLjQ1IDAsMTEuNzM1IDAsMTAuOCBDMCw5Ljc1NSAxLjY1LDkuMzE1IDEuNjUsNy41IEMxLjY1LDYuNjIgMS42NSw1Ljg1IDEuNjUsNS44NSBDMS42NSwzLjcwNSAzLjM1NSwyIDUuNSwyIEM3LjY0NSwyIDkuMzUsMy43MDUgOS4zNSw1Ljg1IEM5LjM1LDUuODUgOS4zNSw2LjYyIDkuMzUsNy41IFogTTUuNSwxMy41NSBDNi4yMTUsMTMuNTUgNi44MiwxMy40OTUgNy40MjUsMTMuNDQgQzcuMDk1LDE0LjE1NSA2LjMyNSwxNC42NSA1LjUsMTQuNjUgQzQuNjc1LDE0LjY1IDMuOTYsMTQuMTU1IDMuNTc1LDEzLjQ0IEM0LjE4LDEzLjQ5NSA0Ljc4NSwxMy41NSA1LjUsMTMuNTUgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 48070:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMTEgMTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5ICg1MTAwMikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+QXJ0Ym9hcmQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBY3RpdmUiPgogICAgICAgICAgICA8cGF0aCBkPSJNOS4zNSw3LjUgQzkuMzUsOS4zMTUgMTEsOS43NTUgMTEsMTAuOCBDMTEsMTEuNzM1IDguODU1LDEyLjQ1IDUuNSwxMi40NSBDMi4xNDUsMTIuNDUgMCwxMS43MzUgMCwxMC44IEMwLDkuNzU1IDEuNjUsOS4zMTUgMS42NSw3LjUgQzEuNjUsNi42MiAxLjY1LDUuODUgMS42NSw1Ljg1IEMxLjY1LDMuNzA1IDMuMzU1LDIgNS41LDIgQzcuNjQ1LDIgOS4zNSwzLjcwNSA5LjM1LDUuODUgQzkuMzUsNS44NSA5LjM1LDYuNjIgOS4zNSw3LjUgWiBNNS41LDEzLjU1IEM2LjIxNSwxMy41NSA2LjgyLDEzLjQ5NSA3LjQyNSwxMy40NCBDNy4wOTUsMTQuMTU1IDYuMzI1LDE0LjY1IDUuNSwxNC42NSBDNC42NzUsMTQuNjUgMy45NiwxNC4xNTUgMy41NzUsMTMuNDQgQzQuMTgsMTMuNDk1IDQuNzg1LDEzLjU1IDUuNSwxMy41NSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiNGRjAwMUYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 44160:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy44MjgxIDMuODcxNzVDMTMuOTM2IDIuOTg2NjMgMTIuNzU3OCAyLjU4MzQ1IDEyLjMwMDggMy4zNDkwOEwxMS4xOTczIDUuMTk3NzZDMTAuOTgzOSA1LjU1NTIxIDEwLjQ2NjEgNS41NTUyMSAxMC4yNTI3IDUuMTk3NzZMNy44NTgzOSAxLjE4NjdDNy41MzgzMiAwLjY1MDUxNSA2Ljc2MTY4IDAuNjUwNTE3IDYuNDQxNjEgMS4xODY3TDQuMDQ3MjYgNS4xOTc3NkMzLjgzMzg4IDUuNTU1MjEgMy4zMTYxMiA1LjU1NTIxIDMuMTAyNzQgNS4xOTc3NkwxLjk5OTIgMy4zNDkwOEMxLjU0MjE2IDIuNTgzNDUgMC4zNjM5OTYgMi45ODY2MyAwLjQ3MTg3IDMuODcxNzVMMS4xOTE2NyA5Ljc3Nzc4QzEuMTkxNjcgMTAuNDUyOCAxLjU5MTgxIDExIDIuMDg1NDIgMTFIMTIuMjE0NkMxMi43MDgyIDExIDEzLjEwODMgMTAuNDUyOCAxMy4xMDgzIDkuNzc3NzhMMTMuODI4MSAzLjg3MTc1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cgo="

/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 38126:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"o_":12300,"Ll":2700}');

/***/ })

}]);